(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This helper contains parameters that track actions across pages
 * when appended to request URLs
 */

var URLTrackingParams = exports.URLTrackingParams = {
  //Tracking used for the nav search
  FROM_SEARCH_PARAM: "from_search=true",
  SEARCH_RANK_PARAM: "rank",
  SEARCH_IDENTIFIER_PARAM: "qid",

  // Interactions with the nav search that redirect to book#show should
  // include this param for tracking purposes:
  // https://w.amazon.com/index.php/Goodreads/Teams/Discovery/Metrics/Search#desktop_web
  BOOK_SHOW_INTERACTION_PARAM: "ac=1",

  // Tracking refs used for the nav bar discussions pane
  DISCUSSIONS_PANE_DISCUSSION: "nav_bar_discussions_pane_discussion"
};

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*eslint-disable camelcase*/
var TRACKED_CLASSES = exports.TRACKED_CLASSES = {
  // If you change the click_type here, please make sure to also change dfp_entry.rb
  //
  // The classes listed here are all classes tracked, other than the "more"
  // class found in mobile.

  // Book Ads
  book_image: {
    dfp: true,
    pmet: { click_type: "book_image" }
  },
  book_title: {
    dfp: true,
    pmet: { click_type: "book_title" }
  },
  author_link: {
    dfp: true,
    pmet: { click_type: "author_name" }
  },
  full_content_link: {
    dfp: true,
    pmet: { click_type: "body_click" }
  },
  user_profile: {
    dfp: true,
    pmet: { click_type: "social" }
  },
  want_to_read_button: {
    dfp: true,
    pmet: { click_type: "wtr_button" }
  },

  // Custom Ads
  sponsored_update_body_image: {
    dfp: true,
    pmet: { click_type: "image" }
  },
  cta_link: {
    dfp: true,
    pmet: { click_type: "cta_click" }
  },
  sponsored_label: {
    dfp: true,
    pmet: { click_type: "sponsored" }
  },

  // Other click tracking
  newsfeed_caret_not_interested: {
    dfp: false,
    pmet: { click_type: "not_interested" }
  },
  newsfeed_caret_help: {
    dfp: false,
    pmet: { click_type: "why" }
  },
  newsfeed_caret: {
    dfp: false,
    pmet: { click_type: "caret" }
  },

  // Desktop-Only
  user_rating_star: {
    dfp: true,
    pmet: { click_type: "rating" }
  },
  preview_book: {
    dfp: true,
    pmet: { click_type: "preview" }
  },
  sponsored_update_body_title_link: {
    dfp: true,
    pmet: { click_type: "sponsored_title" }
  }
};

var TRACKED_CLASSES_AUDIBLE = exports.TRACKED_CLASSES_AUDIBLE = {
  AEP_Desktop_Browse_Image: {
    dfp: true,
    pmet: { pmet_click_tid: "AEP_Desktop_Browse_Image" }
  },
  AEP_Desktop_Browse_Title: {
    dfp: true,
    pmet: { pmet_click_tid: "AEP_Desktop_Browse_Title" }
  },
  AEP_Desktop_Browse_ExploreButton: {
    dfp: true,
    pmet: { pmet_click_tid: "AEP_Desktop_Browse_ExploreButton" }
  },
  AEP_Desktop_Browse_SponsoredBy: {
    dfp: true,
    pmet: { pmet_click_tid: "AEP_Desktop_Browse_SponsoredBy" }
  },
  AEP_Desktop_Video_ExternalLink: {
    pmet: { pmet_click_tid: "AEP_Desktop_Video_ExternalLink",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_BookImage: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_BookImage",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_BookTitle: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_BookTitle",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_AuthorLink: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_AuthorLink",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_WantToRead: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_WantToRead",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_Stars: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_Stars",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_BookDescription: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_BookDescription",
      no_redirect: true }
  },
  AEP_Desktop_Sponsored_BookExternalLink: {
    pmet: { pmet_click_tid: "AEP_Desktop_Sponsored_BookExternalLink",
      no_redirect: true }
  },
  AEP_Desktop_Carousel_BookImage: {
    pmet: { pmet_click_tid: "AEP_Desktop_Carousel_BookImage",
      no_redirect: true }
  },
  AEP_Desktop_Carousel_WantToRead: {
    pmet: { pmet_click_tid: "AEP_Desktop_Carousel_WantToRead",
      no_redirect: true }
  },
  AEP_Mobile_Carousel_BookImage: {
    pmet: { pmet_click_tid: "AEP_Mobile_Carousel_BookImage",
      no_redirect: true }
  },
  AEP_Mobile_Carousel_WantToRead: {
    pmet: { pmet_click_tid: "AEP_Mobile_Carousel_WantToRead",
      no_redirect: true }
  },
  AEP_Mobile_Carousel_BookTitle: {
    pmet: { pmet_click_tid: "AEP_Mobile_Carousel_BookTitle",
      no_redirect: true }
  },
  AEP_Mobile_Carousel_Author: {
    pmet: { pmet_click_tid: "AEP_Mobile_Carousel_Author",
      no_redirect: true }
  }

};

var TRACKED_CLASSES_PREMIUM_CAMPAIGN = exports.TRACKED_CLASSES_PREMIUM_CAMPAIGN = {
  fcm_blog_title: {
    dfp: true,
    pmet: { click_type: "fcm_blog_title" }
  },
  fcm_blog_image: {
    dfp: true,
    pmet: { click_type: "fcm_blog_image" }
  },
  fcm_blog_button: {
    dfp: true,
    pmet: { click_type: "fcm_blog_button" }
  },
  fcm_book_author: {
    dfp: true,
    pmet: { click_type: "fcm_book_author" }
  },
  fcm_book_image: {
    dfp: true,
    pmet: { click_type: "fcm_book_image" }
  },
  fcm_book_title: {
    dfp: true,
    pmet: { click_type: "fcm_book_title" }
  },
  fcm_book_button: {
    dfp: true,
    pmet: { click_type: "fcm_book_button" }
  },
  fcm_book_description: {
    dfp: true,
    pmet: { click_type: "fcm_book_description" }
  },
  fcm_giveaway_author: {
    dfp: true,
    pmet: { click_type: "fcm_giveaway_author" }
  },
  fcm_giveaway_button: {
    dfp: true,
    pmet: { click_type: "fcm_giveaway_button" }
  },
  fcm_giveaway_image: {
    dfp: true,
    pmet: { click_type: "fcm_giveaway_image" }
  },
  fcm_giveaway_title: {
    dfp: true,
    pmet: { click_type: "fcm_giveaway_title" }
  },
  fcm_list_button: {
    dfp: true,
    pmet: { click_type: "fcm_list_button" }
  },
  fcm_list_books: {
    dfp: true,
    pmet: { click_type: "fcm_list_books" }
  },
  fcm_list_title: {
    dfp: true,
    pmet: { click_type: "fcm_list_title" }
  },
  fcm_genre_title: {
    dfp: true,
    pmet: { click_type: "fcm_genre_title" }
  },
  fcm_genre_image: {
    dfp: true,
    pmet: { click_type: "fcm_genre_image" }
  },
  fcm_genre_button: {
    dfp: true,
    pmet: { click_type: "fcm_genre_button" }
  }
};
/*eslint-enable*/

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchApstagBids = exports.requestCreative = undefined;
exports.requestCreativeForAdSlot = requestCreativeForAdSlot;
exports.defineSlot = defineSlot;
exports.enableServices = enableServices;
exports.dimensionsExplode = dimensionsExplode;
exports.validateA9Sizes = validateA9Sizes;
exports.getA9Sizes = getA9Sizes;
exports.slotToHash = slotToHash;
exports.lazyLoadOnView = lazyLoadOnView;
exports.lazyLoadInit = lazyLoadInit;
exports.adSlotsDefined = adSlotsDefined;

var _google_ads_store = require("../../react_stores/google_ads_store");

var _google_ads_actions = require("../../react_actions/google_ads_actions");

var _google_ads_actions2 = _interopRequireDefault(_google_ads_actions);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

// Lazy load expand controls when we start loading ads before they become viewable
// The default from lazysizes is 370 which is too sensitive for our ads metrics
var LAZY_LOAD_EXPAND = 200;

var A9_SIZES = ["300x250", "728x90", "970x90", "320x50"];

// googletag helper methods
var allGptSlots = function allGptSlots() {
  return window.googletag.pubads().getSlots();
};
var getIdFromGptSlot = function getIdFromGptSlot(slot) {
  return slot.getSlotElementId();
};
var refreshSlots = function refreshSlots(slots) {
  return window.googletag.pubads().refresh(slots);
};

/*
 * This method defines the behavior after DFP indicates that a slot has finished
 * rendering. Here we track impressions. If the slot is a native ad, we will call
 * `attachServedNativeAdAttributesAndTracking` to insert the native creative.
 */
var attachCallbacksAfterSlotRender = function attachCallbacksAfterSlotRender(adId, params) {
  window.googletag.pubads().addEventListener("slotRenderEnded", function (event) {
    if (event.slot.getSlotId().getDomId() === adId) {
      if (event.isEmpty) {
        _google_ads_actions2.default.removeAdSlot(adId);
        _google_ads_actions2.default.trackImpression({ slotId: adId, impressionCode: _google_ads_store.ImpressionCode.empty });
      } else {
        var iframe = $j(params.googleHookSelector).find("iframe[id^=\"google_ads_iframe_\"]");
        var creative = iframe.contents().find(params.creativeSelector);
        var adUnit = event.slot.getAdUnitPath().split("/", 3)[2];

        /** Ad element to track in CSA */
        var impressionElement = document.getElementById("" + adId);

        if (params.isNativeAd) {
          var sponsoredId = creative.data("id");
          var clickUrl = creative.data("url");

          if (sponsoredId && clickUrl) {
            _google_ads_actions2.default.attachServedNativeAdAttributesAndTracking({
              slotId: adId,
              campaignId: event.campaignId,
              lineItemId: event.lineItemId,
              creative: creative,
              sponsoredId: sponsoredId,
              impressionCode: _google_ads_store.ImpressionCode.success,
              dfpUrl: creative.data("url"),
              adUnit: adUnit,
              impressionElement: impressionElement
            });
          } else {
            _google_ads_actions2.default.trackImpression({ slotId: adId, impressionCode: _google_ads_store.ImpressionCode.empty });
          }
        } else {
          _google_ads_actions2.default.attachServedBannerAdAttributesAndTracking({ slotId: adId,
            campaignId: event.campaignId,
            lineItemId: event.lineItemId,
            creative: creative,
            impressionCode: _google_ads_store.ImpressionCode.success,
            delayImpressionTracking: params.delayImpressionTracking,
            impressionElement: impressionElement
          });
        }
        if (params.dimensions === "160x600") {
          $j(".mainContentContainer").addClass("adSkinEnabled");
        }
      }
    }
  });
};

/**
* This method is responsible for attaching an event listener to the ad slot and
* for calling `display` on it. If the ad is lazy loaded, it will additionally
* define and refresh the slot.
*
* @param adId (required) id used by google to find the ad on the page
* @param params (required) contains information about the ad slot
        googleHookSelector (required) used to find the iframe within ad div
        creativeSelector (required) used to find the creatixve ID in the iframe
        dimensions (required) used to add styling to ad units
        isNativeAd (required) check if ad unit is native and look for sponsored update
        deviceType (optional) only used for poll requests to track device type
        delayImpressionTracking (optional) delay impression tracking
              until ad is viewed in navbar
*/
var requestCreative = exports.requestCreative = function requestCreative(adId) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  var googletag = window.googletag;

  attachCallbacksAfterSlotRender(adId, params);
  _google_ads_actions2.default.hasAttachedDfpCallbackForSlot(adId);

  if (params.lazyLoadedNewsfeedAd) {
    // For lazy loaded newsfeed ads, manually define the slot and refresh it
    // after calling googletag.display. We do this here to ensure that
    // the above listener is defined first.
    var ad = params.lazyLoadedNewsfeedAd;
    var slot = window.googletag.defineSlot("/4215/" + ad.name, ad.dimensions, adId);
    if (!slot) return;
    slot.addService(window.googletag.pubads());
    googletag.display(adId);
    refreshSlots([slot]);
  } else if (params.isLazyLoaded) {
    var creativeSize = dimensionsExplode(params.dimensions);
    var slot = googletag.defineSlot(params.path, creativeSize, adId);
    if (!slot) return;

    // Override forceSafeFrame for native ads
    if (params.isNativeAd) {
      slot.setConfig({
        safeFrame: {
          forceSafeFrame: false
        }
      });
    }

    slot.addService(googletag.pubads());
    var slotHash = [{
      slotID: adId, slotName: params.path, sizes: [creativeSize]
    }];
    // A9 only allows the following ad slot sizes
    // 300x250, 728x90, 970x90 and 320x50
    var a9Sizes = getA9Sizes(params.dimensions);
    var a9Hash = _lodash2.default.isEmpty(a9Sizes) ? [] : [slotToHash(params.path, adId, a9Sizes)];
    fetchApstagBids(slotHash, a9Hash);
  } else {
    googletag.cmd.push(function () {
      googletag.display(adId);
    });
  }
};

/**
 * Request Creative callback for ad slot
 * and mark ad as requested
 *
 */
function requestCreativeForAdSlot(adId) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  _google_ads_actions2.default.requestCreativeForSlot(adId, params);
}

/**
 * Define Ad Slot for ad units defined in dfp ads resources.
 * All ad units are defined when the store is initialized for
 * roadblock ads
 *
 * @param adId (required) add Id to the slot for googletags callback
 * @param slotPath (required) define path for ad unit
 * (i.e. /4215/goodr.book.show.300x250)
 * @param dimension (required) slot size (e.g. "300x250"). For multi-size ads,
 * this should be an array of slot sizes (e.g. ["970x66", "970x90", "970x250"])
 */
function defineSlot(adId, slotPath, dimension, adSizeMapping) {
  var isNativeAd = arguments.length <= 4 || arguments[4] === undefined ? false : arguments[4];

  if (window.googletag && window.googletag.cmd) {
    window.googletag.cmd.push(function () {
      var googletag = window.googletag;
      // If this is a multiple-sized ad slot, pass DFP an array of the eligible
      // slot sizes
      var creativeSize = dimensionsExplode(dimension);
      var slot = undefined;

      if (adSizeMapping) {
        var _ret = (function () {
          var mapping = googletag.sizeMapping();
          _lodash2.default.map(adSizeMapping, function (pair) {
            var pairingArray = _lodash2.default.map(pair, function (val) {
              var splitStr = val.split("x");
              return splitStr[0] ? [parseInt(splitStr[0]), parseInt(splitStr[1])] : [];
            });
            mapping = mapping.addSize(pairingArray[0], pairingArray[1]);
          });
          slot = googletag.defineSlot(slotPath, creativeSize, adId);
          if (!slot) return {
              v: undefined
            };
          slot.defineSizeMapping(mapping.build()).setCollapseEmptyDiv(true);
        })();

        if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
      } else {
        slot = googletag.defineSlot(slotPath, creativeSize, adId);
        if (!slot) return;
      }

      // Override forceSafeFrame for native ads
      if (isNativeAd) {
        slot.setConfig({
          safeFrame: {
            forceSafeFrame: false
          }
        });
      }

      slot.addService(googletag.pubads());
    });
  }
}

function enableServices() {
  if (window.googletag && window.googletag.cmd) {
    window.googletag.cmd.push(function () {
      var googletag = window.googletag;
      googletag.enableServices();
    });
  }
}

function dimensionsExplode(dimensions) {
  var dimensionsArray = undefined;
  if (Array.isArray(dimensions)) {
    dimensionsArray = _lodash2.default.map(dimensions, function (val) {
      var splitStr = val.split("x");
      return [parseInt(splitStr[0]), parseInt(splitStr[1])];
    });
  } else {
    var splitStr = dimensions.split("x");
    dimensionsArray = [parseInt(splitStr[0]), parseInt(splitStr[1])];
  }
  return dimensionsArray;
}

// A9 only allows the following ad slot sizes
// 300x250, 728x90, 970x90 and 320x50
function validateA9Sizes(val) {
  if (A9_SIZES.includes(val)) {
    return true;
  } else {
    return false;
  }
}

// Dimensions is either an array of sizes for the ad
// slot or one size represented as a string.
function getA9Sizes(dimensions) {
  var dimensionsArray = [];
  if (Array.isArray(dimensions)) {
    var validA9Dimensions = _lodash2.default.filter(dimensions, function (val) {
      return validateA9Sizes(val);
    });
    dimensionsArray = _lodash2.default.map(validA9Dimensions, function (val) {
      var splitStr = val.split("x");
      return [parseInt(splitStr[0]), parseInt(splitStr[1])];
    });
  } else {
    if (validateA9Sizes(dimensions)) {
      var splitStr = dimensions.split("x");
      dimensionsArray = [[parseInt(splitStr[0]), parseInt(splitStr[1])]];
    }
  }
  return dimensionsArray;
}

// This function converts an ad object (from the Google Ads Store data)
// into a hash compatible with the apstag library.
function slotToHash(ad, adId) {
  var a9Sizes = arguments.length <= 2 || arguments[2] === undefined ? [] : arguments[2];

  // Prepare slot data for apstag

  var dimensions = Array.isArray(ad.dimensions) ? ad.dimensions : [ad.dimensions];
  var dimensionsMapped = _lodash2.default.isEmpty(a9Sizes) ? _lodash2.default.map(dimensions, function (val) {
    var splitStr = val.split("x");
    return [parseInt(splitStr[0]), parseInt(splitStr[1])];
  }) : a9Sizes;
  return {
    slotID: adId,
    slotName: ad.path,
    sizes: dimensionsMapped
  };
}

// This function takes an array of slot hashes (outputs from slotToHash) and
// submits them to apstag, which returns bids on those slots from A9. These bids
// are added to the targeting values of the slots, and a
// googletag.pubads().refresh() request is made for all slots passed in.
//
// NOTE: ADS WILL NOT DISPLAY PROPERLY UNTIL THIS FUNCTION IS CALLED FOR THE
// SLOTS TO BE DISPLAYED!
var fetchApstagBids = exports.fetchApstagBids = function fetchApstagBids(gptSlots, apsSlots) {
  var googletag = window.googletag;
  if (googletag && googletag.cmd) {
    googletag.cmd.push(function () {
      var apstag = window.apstag;
      if (Array.isArray(gptSlots) && gptSlots.length) {
        // If apstag isn't loaded or no aps slots, refresh directly without A9 bids
        if (!apstag || _lodash2.default.isEmpty(apsSlots)) {
          googletag.cmd.push(function () {
            return checkCallbacksAndRefresh(gptSlots);
          });
        } else {
          apstag.fetchBids({
            slots: apsSlots
          }, function () {
            googletag.cmd.push(function () {
              return checkCallbacksAndRefresh(gptSlots);
            });
          });
        }
      }
    });
  }
};

var checkCallbacksAndRefresh = function checkCallbacksAndRefresh(apsSlots) {
  var apstag = window.apstag;
  var apsSlotIds = apsSlots.map(function (apsSlot) {
    return apsSlot.slotID;
  });
  var gptSlots = allGptSlots().filter(function (gptSlot) {
    return apsSlotIds.includes(getIdFromGptSlot(gptSlot));
  });
  new Promise(function (resolve, reject) {
    return _google_ads_actions2.default.checkCallbacksAttached(resolve, reject, apsSlotIds);
  }).then(function () {
    if (apstag) {
      apstag.setDisplayBids();
    }
    refreshSlots(gptSlots);
  }).catch(function () {
    return null;
  });
};

// This is here because jQuery can't be stubbed directly in tests.
function lazyLoadOnView(callback) {
  $j(document).on("lazybeforeunveil", callback);
}

// Set Lazyload params on google ad store initialization
function lazyLoadInit() {
  window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.expand = LAZY_LOAD_EXPAND;
}

function adSlotsDefined() {
  var googletag = window.googletag;
  return typeof googletag === "function" && googletag.pubads().getSlots().length > 0;
}

},{"../../react_actions/google_ads_actions":28,"../../react_stores/google_ads_store":196,"lodash":"lodash"}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_ERROR_MESSAGE = undefined;
exports.httpRequest = httpRequest;
exports.httpPost = httpPost;
exports.httpDelete = httpDelete;
exports.httpGet = httpGet;

var _default_auth_failure_handler = require("./default_auth_failure_handler");

var _lodash = require("lodash");

/**
 * Make an ajax request for the provided url. The returned promise
 * may never be fulfilled and will instead redirect the browser
 * to an authentication page if the URL requires that the user is
 * signed in and they are currently not signed in.
 *
 * If you want the user to be successfully returned to your
 * page, look into setting session[:jumpto] in your controller
 * action. :return_url and other mechanisms do not work generically.
 *
 * TODO-GR-44007: replace jQuery as underlying library
 *
 * @param url - Required. String URL for the desired resource
 * @param options
 *        options.method = "GET" (default), "POST", "DELETE"
 *        all other options are passed along unchanged to jQuery.ajax
 *        see https://api.jquery.com/jQuery.ajax/ for API. For example, pass
 *        {contentType: "json"} to have response parsed as JSON and returned
 *        as an Object. Pass a `data` key with your request arguments.
 * @return jQuery.Promise
 *         will resolve with the same arguments as the done/success callback
 *         or reject with the same arguments as the fail callback
 */
function httpRequest(url) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  options = (0, _lodash.merge)({}, options, { type: options.method });
  options = (0, _lodash.omit)(options, "method");

  var deferred = $j.Deferred();
  var jQueryPromise = $j.ajax(url, options);

  jQueryPromise.done(deferred.resolve);

  jQueryPromise.fail(function (jqXHR, textStatus, errorThrown) {
    if ((0, _default_auth_failure_handler.redirectOnAuthFailure)(jqXHR)) {
      return; // never fulfill or reject because we just want the redirect to go through
    } else {
        deferred.reject(jqXHR, textStatus, errorThrown);
      }
  });

  return deferred.promise();
}

/**
 * convenience method for httpRequest with the desired
 * method of POST. see doc for httpRequest for complete
 * details.
 *
 * @param url
 * @param options
 * @return {jQuery.Promise}
 */
function httpPost(url) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return httpRequest(url, (0, _lodash.merge)({}, options, { method: "POST" }));
}

/**
 * convenience method for httpRequest with the desired
 * method of DELETE. see doc for httpRequest for complete
 * details.

 * @param url
 * @param options
 * @return {jQuery.Promise}
 */
function httpDelete(url) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return httpRequest(url, (0, _lodash.merge)({}, options, { method: "DELETE" }));
}

/**
 * convenience method for httpRequest with the desired
 * method of GET. see doc for httpRequest for complete
 * details.
 *
 * @param url
 * @param options
 * @return {jQuery.Promise}
 */
function httpGet(url) {
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return httpRequest(url, (0, _lodash.merge)({}, options, { method: "GET" }));
}

var DEFAULT_ERROR_MESSAGE = exports.DEFAULT_ERROR_MESSAGE = "Something went wrong with your request. Please\n  try again later.";

},{"./default_auth_failure_handler":5,"lodash":"lodash"}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectOnAuthFailure = redirectOnAuthFailure;

var _env_utils = require("../env_utils");

/**
 * If we receive a 403, redirect.
 *
 * Port of the Flight mixin app/assets/javascripts/components/mixins/auth_redirect.js
 *
 * @param jqXHR
 * @returns {boolean} true if it was a 403 and will be redirected. false otherwise.
 *                    if true, it's best not to try to execute any more code since it
 *                    may not have time to run before window.unload
 */
function redirectOnAuthFailure(jqXHR) {
  if (jqXHR && jqXHR.status === 403) {
    var data = jqXHR.responseJSON;
    if (data.redirect) {
      (0, _env_utils.setLocationUrl)(data.redirect);
      return true;
    }
  }
  return false;
}

},{"../env_utils":13}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BOOK_ORIGINS = exports.BOOK_ORIGINS = {
  CURRENTLY_READING_WIDGET: "currently-reading-widget",
  UPDATE_READING_PROGRESS: "hp_status_editor"
};

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appendQuery = require("append-query");

var _appendQuery2 = _interopRequireDefault(_appendQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

  /**
   * Opens child window for sharing on external social platforms
   * 
   * @param baseUrl - url to connect to platform
   * @param options - object of url parameters that send share item data to social window
   * @param windowSpecs - position and dimensions of child window
   */

  openSocialShareWindow: function openSocialShareWindow(baseUrl, options, windowSpecs) {
    var socialShareUrl = (0, _appendQuery2.default)(baseUrl, options);
    var shareWindowPosition = "left=" + windowSpecs.left + ", top=" + windowSpecs.top;
    var shareWindowDimensions = "width=" + windowSpecs.width + ", height=" + windowSpecs.height;
    var shareWindowSpecs = shareWindowPosition + ", " + shareWindowDimensions + ", menubar=no, scrollbar=no";
    window.open(socialShareUrl, "_blank", shareWindowSpecs);
  }
};

},{"append-query":"append-query"}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACKING_URLS = undefined;
exports.trackClick = trackClick;
exports.trackView = trackView;
exports.trackNavEngage = trackNavEngage;
exports.trackNavEngageClick = trackNavEngageClick;

var _ajax_helper = require("./ajax/ajax_helper");

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Helper module for making AJAX posts to track_controller from React
 */

var TRACKING_URLS = exports.TRACKING_URLS = {
  CLICK: "/track/track_click",
  MOBILE_SETTINGS: "/track/track_mobile_settings"
};

/*
 * Track event via AJAX post to the tracking url
 * Format the type and metric labels to comply with the action's expectation
 * The url param value must be a url in TRACKING_URLS
 */
function track(type, url, metric) {
  switch (url) {
    case TRACKING_URLS.CLICK:
      (0, _ajax_helper.httpPost)(url, {
        data: {
          feature: type + "_" + metric
        }
      });
      break;
    case TRACKING_URLS.MOBILE_SETTINGS:
      (0, _ajax_helper.httpPost)(url, {
        data: {
          type: type,
          metric: metric
        }
      });
      break;
    default:
      break;
  }
}

function trackClick(url, metric) {
  track("click", url, metric);
}

function trackView(url, metric) {
  track("view", url, metric);
}

/*
 * Track engagement with header/nav feature
 * Namespace nav engagement metrics with Nav prefix
 * Do not use for onClick events; use trackNavEngageClick
 */
function trackNavEngage(feature) {
  track("Nav", TRACKING_URLS.CLICK, feature);
}

/*
 * Track clicks on header/nav feature
 * Handle link targets, so AJAX is fired before navigation
 */
function trackNavEngageClick(e, feature) {
  if (e && e.target) {
    var target = e.target;
    if (target.tagName === "A" && !e.defaultPrevented) {
      e.preventDefault();
      trackNavEngage(feature);
      _env_utils2.default.setLocationUrl(target.href);
    } else {
      trackNavEngage(feature);
    }
  }
}

},{"../modules/env_utils":13,"./ajax/ajax_helper":4}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VARIANTS = exports.VARIANTS = {
  DEFAULT: "default",
  DARK_BG: "darkBg"
};

},{}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleDataTracking = handleDataTracking;

var _data_tracking_actions = require("../../react_actions/data_tracking/data_tracking_actions");

var _data_tracking_actions2 = _interopRequireDefault(_data_tracking_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isTrackingEnabled = function isTrackingEnabled(sourceElement) {
  return sourceElement.getAttribute("data-tracking-enabletracking") === "true";
};

/**
 * This function is a JavaScript DOM event listener implementation to handle any type of
 * user interaction on a DOM Element. The listener is attached by
 * react_mixins/tracking_data_attributes_mixin.js mixin for components with
 * `trackingOptions.enableTracking` prop set to true. The listener will trigger a react action when
 * it first encounters data-tracking-enabletracking="true" data attribute within the source element.
 *
 * @param event Object - JavaScript event object
 */
function handleDataTracking(event) {
  var source = event.target;
  var trackingRootNode = event.currentTarget;

  var dataTrackingEnabled = false;

  if (source === trackingRootNode) {
    dataTrackingEnabled = isTrackingEnabled(source);
  } else {
    //when clicked on one of the child elements of trackingRootNode element.
    while (trackingRootNode.contains(source)) {
      dataTrackingEnabled = isTrackingEnabled(source);
      if (dataTrackingEnabled) {
        break;
      }
      source = source.parentNode;
    }
  }

  if (dataTrackingEnabled) {
    _data_tracking_actions2.default.trackClickEvent(event, source);
  }
}

},{"../../react_actions/data_tracking/data_tracking_actions":24}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromNow = fromNow;
exports.getFormattedDate = getFormattedDate;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Refer to moment docs for default duration.humanize thresholds
// http://momentjs.com/docs/*/customization/relative-time-threshold/
/**
 * A util library to support custom date functions.
 */
_moment2.default.relativeTimeThreshold("s", 60);
_moment2.default.relativeTimeThreshold("m", 60);
_moment2.default.relativeTimeThreshold("h", 24);
_moment2.default.relativeTimeThreshold("d", 25);
_moment2.default.relativeTimeThreshold("M", 10);

_moment2.default.locale("en-abbreviated", { // Define custom relative time formats
  relativeTime: {
    future: "in %s",
    past: "%s",
    s: "Just now",
    m: "1m",
    mm: "%dm",
    h: "1h",
    hh: "%dh",
    d: "1d",
    dd: "%dd",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
  }
});
_moment2.default.locale("en"); // Reset to default

/**
 * Returns relative time
 * Refer to http://momentjs.com/docs/ for more on Relativetime settings
 *
 * @param pastTime Date - A JavaScript date
 * @param currentTime moment - (Optional) if passed calculates the relative from
 * that moment. Default is moment() which is now
 * @param mockPastTime moment - (Optional) only used as di for tests
 *
 * @returns String - relative time from now in the below format
 *
 * Just Now = under a minute ago
 * 1m = 1 minute, for use in 1-59 minutes
 * 1h = 1 hour, for use in 1-23 hours
 * 1d = 1 day, for use in 1-6 days
 * 1w = 1 week, for use in anything under a month
 * 15 Mar = day and month, for use or anything older than a month
 * 15 Mar 12 = anything in previous year
 */
function fromNow(pastTime) {
  var currentTime = arguments.length <= 1 || arguments[1] === undefined ? (0, _moment2.default)() : arguments[1];
  var mockPastTime = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  currentTime.locale("en-abbreviated");
  if (mockPastTime !== null) {
    pastTime = mockPastTime;
  } else {
    pastTime = (0, _moment2.default)(pastTime).locale("en-abbreviated");
  }

  var pastDays = currentTime.diff(pastTime, "days");
  var pastMonths = currentTime.diff(pastTime, "months");
  var pastDaysPrecise = currentTime.diff(pastTime, "days", true);
  var relativeWeekThreshold = 6.5; // 6.5 days is considered a week

  if (_lodash2.default.inRange(pastMonths, 1, 13)) {
    // under a year
    return currentTime.subtract(pastDays, "days").format("DD MMM");
  } else if (pastMonths > 12) {
    // over a year
    return currentTime.subtract(pastDays, "days").format("DD MMM YY");
  } else if (_lodash2.default.inRange(pastDays, 7, 28)) {
    // under a month
    return Math.ceil(pastDays / 7) + "w";
  } else if (pastDaysPrecise >= relativeWeekThreshold && pastDaysPrecise <= 28) {
    // same as above but handles a special case where > 6.5 days should be "1w" instead of "7d"
    return Math.round(pastDaysPrecise / relativeWeekThreshold) + "w";
  } else {
    // under a week uses moment relative threshold configuration above
    return pastTime.fromNow();
  }
}

/**
 * Returns a formatted date
 * Refer to http://momentjs.com/docs/#/parsing/string/ for details on parsing
 *
 * @param date String
 * @param format String - deisred output format, defaults to YYYY-MM-DD
 * @return String - date string in the specified format
 */
function getFormattedDate(date) {
  var format = arguments.length <= 1 || arguments[1] === undefined ? "YYYY-MM-DD" : arguments[1];

  if (date) {
    var parsedDate = (0, _moment2.default)(date);
    return parsedDate.format(format);
  }
  return "";
}

},{"lodash":"lodash","moment":"moment"}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkIconClassnames = exports.getExclusiveShelfType = exports.SHELF_TYPES = exports.DEFAULT_SHELVES = undefined;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_SHELVES = exports.DEFAULT_SHELVES = {
  READ: {
    name: "read",
    displayName: "Read"
  },
  CURRENTLY_READING: {
    name: "currently-reading",
    displayName: "Currently Reading"
  },
  WANT_TO_READ: {
    name: "to-read",
    displayName: "Want to Read"
  },
  DID_NOT_FINISH: {
    name: "did-not-finish",
    displayName: "Did Not Finish"
  }
};

var SHELF_TYPES = exports.SHELF_TYPES = {
  DEFAULT: "defaultShelves",
  CUSTOM_EXCLUSIVE: "customExclusiveShelves",
  NONEXCLUSIVE: "nonExclusiveShelves"
};

var getExclusiveShelfType = exports.getExclusiveShelfType = function getExclusiveShelfType(shelfName) {
  if (shelfName === DEFAULT_SHELVES.READ.name || shelfName === DEFAULT_SHELVES.CURRENTLY_READING.name || shelfName === DEFAULT_SHELVES.WANT_TO_READ.name || shelfName === DEFAULT_SHELVES.DID_NOT_FINISH.name) {
    return SHELF_TYPES.DEFAULT;
  } else {
    return SHELF_TYPES.CUSTOM_EXCLUSIVE;
  }
};

// returns check icon style that matches exclusive shelf
var checkIconClassnames = exports.checkIconClassnames = function checkIconClassnames(shelfName) {
  return (0, _classnames2.default)({
    "wantToReadButton__checkIcon--toRead": shelfName === DEFAULT_SHELVES.WANT_TO_READ.name,
    "wantToReadButton__checkIcon--currentlyReading": shelfName === DEFAULT_SHELVES.CURRENTLY_READING.name,
    "wantToReadButton__checkIcon--read": shelfName === DEFAULT_SHELVES.READ.name,
    "wantToReadButton__checkIcon--didNotFinish": shelfName === DEFAULT_SHELVES.DID_NOT_FINISH.name,
    "wantToReadButton__checkIcon--other": shelfName && getExclusiveShelfType(shelfName) === SHELF_TYPES.CUSTOM_EXCLUSIVE
  });
};

},{"classnames":"classnames"}],13:[function(require,module,exports){
"use strict";

/**
 * Environment specific utility module to support shared code. Its using commonJS style exports instead
 * of ES6 exports as its used in gulpfile.js which is not ES6 yet.
 */
module.exports = {
  PRODUCTION: "production",
  DEVELOPMENT: "development",
  TEST: "test",

  /**
   * Returns true if DOM is available for rendering.
   * @return {boolean}
   */
  hasDom: function hasDom() {
    return !!window.document;
  },

  /**
   * Returns true if there is no DOM available for rendering.
   * @return {boolean}
   */
  domUnavailable: function domUnavailable() {
    return !this.hasDom();
  },
  isDevelopment: function isDevelopment() {
    return "production" === this.DEVELOPMENT;
  },
  getCurrentPath: function getCurrentPath() {
    if (window && window.location) {
      return window.encodeURIComponent(window.location.pathname + window.location.search);
    }
  },

  /**
   * Sets window location href to the given url. Why a separate method? To easily test it as its
   * not trivial to mock object attributes in unit testing.
   *
   * @param url String - new location url
   */
  setLocationUrl: function setLocationUrl(url) {
    if (window) {
      window.location.href = url;
    }
  },
  getLocationUrl: function getLocationUrl() {
    if (window && window.location) {
      return window.location.href;
    }
  },

  // Another window.location accessor, to make stubbing in tests easier.
  getLocationPathname: function getLocationPathname() {
    if (window && window.location) {
      return window.location.pathname;
    }
  },
  getUserAgent: function getUserAgent() {
    if (window && window.navigator) {
      return window.navigator.userAgent;
    }
    return "";
  }
};

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

exports.default = {

  /*
    Reports an error.
    Always logs the error and message to the console.
    It used to send to bugsnag but no longer.
     params
      - error: the error with relevant stack trace.
      - message: friendly title for searching
   */

  notifyException: function notifyException(error, message) {
    if (error) {
      if (window.console && (0, _lodash.isFunction)(window.console.error)) {
        window.console.error(message, error.stack); //eslint-disable-line no-console
      }
    } else if (window.console && (0, _lodash.isFunction)(window.console.warn)) {
        window.console.warn("Attempted to notifyException without providing error,\n                           message: " + message);
      }
  },

  /**
   * Notify a user of an error. Currently just uses the browser's alert dialog
   * but may eventually use a custom, stylized dialog.
   *
   * @param message (required) text to show the user
   */
  notifyUser: function notifyUser(message) {
    if (window && (0, _lodash.isFunction)(window.alert)) {
      window.alert(message);
    }
  }
};

},{"lodash":"lodash"}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KEYCODES = {
  enter: 13,
  escape: 27,
  space: 32,
  leftArrow: 37,
  upArrow: 38,
  rightArrow: 39,
  downArrow: 40
};

exports.default = {
  isEnter: function isEnter(keyCode) {
    return keyCode === KEYCODES.enter;
  },
  isEscape: function isEscape(keyCode) {
    return keyCode === KEYCODES.escape;
  },
  isSpace: function isSpace(keyCode) {
    return keyCode === KEYCODES.space;
  },
  isArrowLeft: function isArrowLeft(keyCode) {
    return keyCode === KEYCODES.leftArrow;
  },
  isArrowUp: function isArrowUp(keyCode) {
    return keyCode === KEYCODES.upArrow;
  },
  isArrowRight: function isArrowRight(keyCode) {
    return keyCode === KEYCODES.rightArrow;
  },
  isArrowDown: function isArrowDown(keyCode) {
    return keyCode === KEYCODES.downArrow;
  },
  isDropdownOpenerKey: function isDropdownOpenerKey(keyCode) {
    return this.isEnter(keyCode) || this.isSpace(keyCode) || this.isArrowDown(keyCode);
  },
  isDefaultOpenerKey: function isDefaultOpenerKey(keyCode) {
    return this.isEnter(keyCode) || this.isSpace(keyCode);
  },
  isDefaultCloserKey: function isDefaultCloserKey(keyCode) {
    return this.isEscape(keyCode);
  },

  KEYCODES: KEYCODES
};

},{}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ICON_SIZES = exports.ICON_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};

var ICON_SHAPES = exports.ICON_SHAPES = {
  CIRCLE: "circular",
  ROUND_SQUARE: "roundSquare",
  RECTANGULAR: "rectangular"
};

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImages = getImages;
/**
 * gr_image_registry.js.erb stores Rails-generated image paths in window.
 * This module serves as an interface to those image paths; JavaScript code under app/gulp
 * should import this module rather than try to access `window` directly.
 *
 * refer to:
 * /rails-root/app/assets/javascripts/shared_all_formats/gr_image_registry.js.erb
 * @returns {*}
 */

function getImages() {
  // window.GrImageRegistry is not available to server side rendering and throws
  // JS errors when accessing images from the object. Returning an empty object to avoid those
  // server side errors.
  return window.GrImageRegistry || {};
}

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acknowledgeEvent = acknowledgeEvent;
/**
 * Acknowledge event for Touch Not Ready (TNR) metrics
 * If an event is acknowledged, the TNR count should not be incremented
 * The custom ACK count for the element should be incremented
 * See custom_touch_not_ready.js
 * The native browser event must be accessed from React's SyntheticEvent wrapper
 *
 * References:
 * https://w.amazon.com/bin/view/Latency/Projects/TouchNotReady/DeveloperDocs
 * https://reactjs.org/docs/events.html
 */

function acknowledgeEvent(event) {
  // Only acknowledge if native event available and TNR library loaded
  if (event && event.nativeEvent && event.nativeEvent.acknowledge) {
    event.nativeEvent.acknowledge(event.currentTarget);
  }
}

},{}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var astralLength = exports.astralLength = function astralLength(string) {
  return string.replace(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, "_").length;
};

var countWords = exports.countWords = function countWords(text) {
  return text ? text.split(" ").length : 0;
};

},{}],20:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This module is a JS version of ruby's #to_sentence method, which converts an
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             array to a comma-separated sentence where the last element is joined by a
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             connector word.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  toSentence: function toSentence(items) {
    var lastWordConnector = arguments.length <= 1 || arguments[1] === undefined ? "and" : arguments[1];

    var sentence = [];
    var numItems = items.length;
    switch (numItems) {
      case 0:
        return "";
      case 1:
        sentence.push(items[0]);
        break;
      case 2:
        sentence.push(items[0]);
        sentence.push(" " + lastWordConnector + " ");
        sentence.push(items[1]);
        break;
      default:
        _lodash2.default.each(items.slice(0, -1), function (item) {
          sentence.push(item);
          sentence.push(", ");
        });
        sentence.push(lastWordConnector + " ");
        sentence.push(items[numItems - 1]); // last item
        break;
    }
    return _jsx("span", {}, void 0, sentence);
  },
  sentenceJoin: function sentenceJoin(items) {
    var separator = arguments.length <= 1 || arguments[1] === undefined ? ", " : arguments[1];

    var sentence = [];
    _lodash2.default.each(items.slice(0, -1), function (item) {
      sentence.push(item);
      sentence.push(separator);
    });
    sentence.push(items[items.length - 1]);
    return _jsx("span", {}, void 0, sentence);
  }
};

},{"lodash":"lodash"}],21:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return _reflux2.default.createActions([
  // selects a specific result based on mouse movement
  "selectSpecificResult",
  // selects the next active result index based on arrow key input
  "selectNextResult",
  // selects the previous active result index based on arrow key input
  "selectPreviousResult",
  // queries the search controller for search results based on user input
  "search",
  // hides searching spinner and shows the results
  "searchResultsFound",
  // either shows/hides the results based on the input
  "setShowResultsContainer"]);
};

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"reflux":"reflux"}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getACopyClickedHandler = exports.getACopyClosed = exports.getACopyLoadedSuccess = exports.GET_A_COPY_ACTIONS = undefined;

var _ajax_helper = require("../../modules/ajax/ajax_helper");

var GET_A_COPY_ACTIONS = exports.GET_A_COPY_ACTIONS = {
  LOADED_SUCCESS: "GET_A_COPY_LOADED_SUCCESS",
  INTERSTITIAL_CLOSED: "GET_A_COPY_INTERSTITIAL_CLOSED"
};

var getACopyLoadedSuccess = exports.getACopyLoadedSuccess = function getACopyLoadedSuccess(data) {
  return {
    type: GET_A_COPY_ACTIONS.LOADED_SUCCESS,
    data: data
  };
};

var getACopyClosed = exports.getACopyClosed = function getACopyClosed() {
  return {
    type: GET_A_COPY_ACTIONS.INTERSTITIAL_CLOSED
  };
};

var getACopyClickedHandler = exports.getACopyClickedHandler = function getACopyClickedHandler(getACopyDataUrl) {
  return function (dispatch) {
    (0, _ajax_helper.httpGet)(getACopyDataUrl).done(function (data) {
      dispatch(getACopyLoadedSuccess(data));
    });
  };
};

},{"../../modules/ajax/ajax_helper":4}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["updatePreference"]);

},{"reflux":"reflux"}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions([
// expect event object with additional trackingOptions object
"trackClickEvent"]);

},{"reflux":"reflux"}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions([
/*
 * Indicates a user has changed their favorite genres
 * required arg: array of favorited genre strings
 *                This should be the complete set of their favorite genres,
 *                even if they were previously favorited.
*/
"changeFavoriteGenres"]);

},{"reflux":"reflux"}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["selectFavoriteGenre", "deselectFavoriteGenre", "submitSelectedGenres"]);

},{"reflux":"reflux"}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["displayError", "requestFeaturedBooks", "trackMenuImpression"]);

},{"reflux":"reflux"}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions([
// accepts a single string arg that is the contents of the message
"requestCreativeForSlot", "displayCreativeForSlot", "removeAdSlot", "trackImpression", "attachServedNativeAdAttributesAndTracking", "attachServedBannerAdAttributesAndTracking", "hasAttachedDfpCallbackForSlot", "checkCallbacksAttached"]);

},{"reflux":"reflux"}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOGGLE_SEARCH = exports.TOGGLE_SEARCH = "TOGGLE_SEARCH";

var toggleSearch = exports.toggleSearch = function toggleSearch(searchIsActive) {
  return {
    type: TOGGLE_SEARCH,
    searchIsActive: searchIsActive
  };
};

},{}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["openModal", "closeModal"]);

},{"reflux":"reflux"}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions({
  loadMoreUpdates: {},
  newsfeedItemsLoaded: { sync: true },
  updateNativeAdSlot: {},
  userNotInterested: {},
  undoUserNotInterested: {},
  hideStory: {},
  previewBook: {},
  setUpdatesFeedPreferences: {}
});

},{"reflux":"reflux"}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["loadError", "loadNotifications", "requestNotifications"]);

},{"reflux":"reflux"}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["updateProgress", "closeUpdateProgressForm", "openUpdateProgressForm", "refreshReadingSessions", "shelveBookSuccess", "loadAllReadingSessions"]);

},{"reflux":"reflux"}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions({
  updateSharingTextInputValue: { sync: true },
  submitShare: {},
  openShareModal: {}
});

},{"reflux":"reflux"}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions({
  addShelvings: {},
  bookShelved: {},
  bookUnshelved: {},
  shelveBook: {},
  toggleNonExclusiveShelving: {},
  rateBook: { children: ["newBook", "failed"] },
  unshelveBook: {}
});

},{"reflux":"reflux"}],36:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["deselectTab", // Could result in no tabs being activated
"selectTab"]);

},{"reflux":"reflux"}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["userAgentGainsTouch", "userAgentLosesTouch"]);

},{"reflux":"reflux"}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["userNotInterested", "undoUserNotInterested", "isFlashMessageForBook", "closeFlashMessage", "addBookIDToState"]);

},{"reflux":"reflux"}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["addNonExclusiveShelf", "removeNonExclusiveShelf"]);

},{"reflux":"reflux"}],40:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reflux2.default.createActions(["openAddShelfTextbox", "closeAddShelfTextbox", "updateShelfNameFilter", "updateShelves"]);

},{"reflux":"reflux"}],41:[function(require,module,exports){
"use strict";

require("./_polyfills");

var _dom_ready_initializers = require("./_dom_ready_initializers");

var _dom_ready_initializers2 = _interopRequireDefault(_dom_ready_initializers);

var _public_actions = require("./_public_actions");

var _public_actions2 = _interopRequireDefault(_public_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.ReactActions = _public_actions2.default;

// initialize any routines that are required to execute on DOM Ready
_dom_ready_initializers2.default.initializeModernizrTouchCheck();

},{"./_dom_ready_initializers":42,"./_polyfills":43,"./_public_actions":44}],42:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  /**
   * Initializes modernizr touch check on DOM Ready
   */
  initializeModernizrTouchCheck: function initializeModernizrTouchCheck() {
    document.addEventListener("DOMContentLoaded", function () {
      if (Modernizr && Modernizr.touchevents) {
        window.ReactActions.UserAgentCapabilitiesActions.userAgentGainsTouch();
      } else {
        window.ReactActions.UserAgentCapabilitiesActions.userAgentLosesTouch();
      }
    });
  }
};

},{}],43:[function(require,module,exports){
"use strict";

var _objectAssign = require("object-assign");

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("../react_isomorphic/shims/Array.prototype.find");

window.Object.assign = _objectAssign2.default;

},{"../react_isomorphic/shims/Array.prototype.find":180,"object-assign":"object-assign"}],44:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _user_agent_capabilities_actions = require("../react_actions/user_agent_capabilities_actions");

var _user_agent_capabilities_actions2 = _interopRequireDefault(_user_agent_capabilities_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  UserAgentCapabilitiesActions: _user_agent_capabilities_actions2.default
};

},{"../react_actions/user_agent_capabilities_actions":37}],45:[function(require,module,exports){
"use strict";

require("./_common");

var _global = require("../react_isomorphic/global");

var _series_show = require("../react_isomorphic/series_show");

var _site_header = require("../react_isomorphic/site_header");

window.ReactComponents = Object.assign({}, _global.GlobalComponents, _site_header.HeaderComponents, _series_show.SeriesShowComponents);

window.ReactStores = Object.assign({}, _global.GlobalStores, _site_header.HeaderStores);

},{"../react_isomorphic/global":178,"../react_isomorphic/series_show":179,"../react_isomorphic/site_header":181,"./_common":41}],46:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _google_ads_store = require("../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _google_ad_helper = require("../../modules/ads/google_ad_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var BLOCK_CLASS_NAME = "googleBannerAd";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GoogleBannerAd",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.ads[this.props.adId];
  })],

  propTypes: {
    adId: _react2.default.PropTypes.string.isRequired,
    className: _react2.default.PropTypes.string,
    delayImpressionTracking: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      delayImpressionTracking: false
    };
  },
  getStoreState: function getStoreState() {
    return this.state.googleAdsStore;
  },
  componentDidMount: function componentDidMount() {
    var adId = this.props.adId;
    if (this.getStoreState()) {
      var params = {
        googleHookSelector: this.refs.googleHook,
        creativeSelector: this.getStoreState().creativeSelector,
        dimensions: this.getStoreState().dimensions,
        isNativeAd: this.getStoreState().isNativeAd,
        delayImpressionTracking: this.props.delayImpressionTracking,
        isLazyLoaded: this.getStoreState().isLazyLoaded,
        path: this.getStoreState().path
      };
      if (this.getStoreState().isLazyLoaded) {
        (0, _google_ad_helper.lazyLoadOnView)((function (event) {
          if (event.target.id === this.adId) {
            (0, _google_ad_helper.requestCreativeForAdSlot)(this.adId, this.params);
          }
        }).bind({ adId: adId, params: params }));
      } else {
        (0, _google_ad_helper.requestCreativeForAdSlot)(this.props.adId, params);
      }
    }
  },
  getWidthFromDimensions: function getWidthFromDimensions(dimensionsStr) {
    return parseInt(dimensionsStr.split("x")[0]);
  },
  getBannerAdSizingStyle: function getBannerAdSizingStyle(dimensions) {
    var _this = this;

    var width = undefined;
    if (Array.isArray(dimensions)) {
      var _Math;

      // Per DFP recommendations regarding multi-size ads, we should set the
      // width to the widest creative to avoid ads being cropped.
      width = (_Math = Math).max.apply(_Math, _toConsumableArray(dimensions.map(function (x) {
        return _this.getWidthFromDimensions(x);
      })));
    } else {
      width = this.getWidthFromDimensions(dimensions);
    }
    return { width: width, height: "auto" };
  },
  render: function render() {
    if (this.getStoreState()) {
      var classes = (0, _classnames2.default)(this.props.className, BLOCK_CLASS_NAME, {
        lazyload: this.getStoreState().isLazyLoaded
      });
      return _react2.default.createElement("div", { className: classes,
        id: this.props.adId,
        style: this.getBannerAdSizingStyle(this.getStoreState().dimensions),
        ref: "googleHook" });
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/google_ad_helper":3,"../../react_stores/google_ads_store":196,"../gr_component_factory":87,"classnames":"classnames","react":"react","reflux":"reflux"}],47:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _google_ads_store = require("../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _featured_content_module = require("../featured_content_module");

var _featured_content_module2 = _interopRequireDefault(_featured_content_module);

var _google_ad_helper = require("../../modules/ads/google_ad_helper");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BLOCK_CLASS_NAME = "googleFeaturedContentModule";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GoogleFeaturedContentModule",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.nativeAds[this.props.adId];
  })],

  propTypes: {
    adId: React.PropTypes.string.isRequired,
    trackingOptions: React.PropTypes.shape({
      enableTracking: React.PropTypes.bool,
      adId: React.PropTypes.string
    }).isRequired,
    isMobile: React.PropTypes.bool,
    hasBottomBorder: React.PropTypes.bool,
    isInline: React.PropTypes.bool
  },

  defaultProps: {
    isMobile: false,
    isInline: false,
    hasBottomBorder: false
  },

  getStoreState: function getStoreState() {
    return this.state.googleAdsStore;
  },
  componentDidMount: function componentDidMount() {
    if (this.getStoreState() && !this.getStoreState().creative) {
      var params = {
        googleHookSelector: this.refs.googleHook,
        creativeSelector: this.getStoreState().creativeSelector,
        dimensions: this.getStoreState().dimensions,
        isNativeAd: this.getStoreState().isNativeAd,
        path: this.getStoreState().path
      };
      (0, _google_ad_helper.requestCreativeForAdSlot)(this.props.adId, params);
    }
  },
  renderCreative: function renderCreative() {
    var creative = this.getStoreState().creative;
    return _jsx(_featured_content_module2.default, {
      type: creative.type,
      resource: creative.resource,
      sponsorName: creative.sponsorName,
      isSponsored: creative.isSponsored,
      isMobile: this.props.isMobile,
      isInline: this.props.isInline,
      hasBottomBorder: this.props.hasBottomBorder
    });
  },
  render: function render() {
    if (this.getStoreState()) {
      var className = (0, _classnames2.default)(BLOCK_CLASS_NAME, this.getStoreState().className);
      var creativeBody = this.getStoreState().creative ? this.renderCreative() : null;
      return _jsx("div", {}, void 0, creativeBody, React.createElement("div", { className: className, id: this.props.adId, ref: "googleHook" }));
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/google_ad_helper":3,"../../react_stores/google_ads_store":196,"../featured_content_module":83,"../gr_component_factory":87,"classnames":"classnames","reflux":"reflux"}],48:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _google_ads_store = require("../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _page_skin = require("../page_skin");

var _page_skin2 = _interopRequireDefault(_page_skin);

var _google_ad_helper = require("../../modules/ads/google_ad_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GooglePageSkin",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.nativeAds[this.props.adId];
  })],

  propTypes: {
    adId: React.PropTypes.string.isRequired,
    image: React.PropTypes.string,
    trackingOptions: React.PropTypes.shape({
      enableTracking: React.PropTypes.bool,
      adId: React.PropTypes.string
    }).isRequired
  },

  getStoreState: function getStoreState() {
    return this.state.googleAdsStore;
  },
  componentDidMount: function componentDidMount() {
    if (this.getStoreState() && !this.getStoreState().creative) {
      var params = {
        googleHookSelector: this.refs.googleHook,
        creativeSelector: this.getStoreState().creativeSelector,
        dimensions: this.getStoreState().dimensions,
        isNativeAd: this.getStoreState().isNativeAd,
        path: this.getStoreState().path
      };
      (0, _google_ad_helper.requestCreativeForAdSlot)(this.props.adId, params);
    }
  },
  renderCreative: function renderCreative() {
    return _jsx(_page_skin2.default, {
      imageUrl: this.getStoreState().creative.image_url,
      backgroundColor: this.getStoreState().creative.background_color
    });
  },
  render: function render() {
    if (this.getStoreState()) {
      var classes = this.getStoreState().className;
      var creativeBody = this.getStoreState().creative ? this.renderCreative() : null;
      return _jsx("div", {
        className: "pageskinContainer"
      }, void 0, creativeBody, React.createElement("div", { className: classes, id: this.props.adId, ref: "googleHook" }));
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/google_ad_helper":3,"../../react_stores/google_ads_store":196,"../gr_component_factory":87,"../page_skin":120,"reflux":"reflux"}],49:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // Google ad store connection to native ads
// This component calls request native ad which pull the native ad id from the iframe
// and requests the native ad from ajax_native_ad in dfp_controller

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _google_ads_store = require("../../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _native_ad_body = require("./native_ad_body");

var _native_ad_body2 = _interopRequireDefault(_native_ad_body);

var _google_ad_helper = require("../../../modules/ads/google_ad_helper");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GoogleNativeAd",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.nativeAds[this.props.adId];
  })],

  propTypes: {
    adId: React.PropTypes.string.isRequired,
    trackingOptions: React.PropTypes.shape({
      enableTracking: React.PropTypes.bool,
      adId: React.PropTypes.string
    }).isRequired,
    className: React.PropTypes.string,
    signedIn: React.PropTypes.bool,
    allowBehavioralTargeting: React.PropTypes.bool,
    isMobile: React.PropTypes.bool,
    isNewsfeed: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isMobile: false,
      isNewsfeed: true,
      signedIn: true
    };
  },
  getStoreState: function getStoreState() {
    return this.state.googleAdsStore;
  },
  componentDidMount: function componentDidMount() {
    if (this.getStoreState() && !this.getStoreState().creative) {
      var params = {
        googleHookSelector: this.refs.googleHook,
        creativeSelector: this.getStoreState().creativeSelector,
        dimensions: this.getStoreState().dimensions,
        isNativeAd: this.getStoreState().isNativeAd,
        lazyLoadedNewsfeedAd: this.getStoreState().lazyLoadedNewsfeedAd,
        path: this.getStoreState().path,
        isLazyLoaded: this.getStoreState().isLazyLoaded
      };
      if (this.getStoreState().lazyLoadedNewsfeedAd || this.getStoreState().isLazyLoaded) {
        (0, _google_ad_helper.lazyLoadOnView)((function (event) {
          if (event.target.id === this.adId) {
            (0, _google_ad_helper.requestCreativeForAdSlot)(this.adId, this.params);
          }
        }).bind({ adId: this.props.adId, params: params }));
      } else {
        (0, _google_ad_helper.requestCreativeForAdSlot)(this.props.adId, params);
      }
    }
  },
  render: function render() {
    if (this.getStoreState()) {
      // IMPORTANT: We must keep the googleHook div visible in order to preserve
      //            viewable impressions!
      var googleHookClasses = (0, _classnames2.default)("googleNativeAd__googleHook", this.getStoreState().className, "lazyload");
      var nativeAdClasses = (0, _classnames2.default)("googleNativeAd", this.props.className);
      var nativeAdBody = this.getStoreState().creative ? _jsx(_native_ad_body2.default, {
        creative: this.getStoreState().creative,
        adId: this.props.adId,
        deviceType: this.getStoreState().deviceType,
        signedIn: this.props.signedIn,
        allowBehavioralTargeting: this.props.allowBehavioralTargeting,
        isMobile: this.props.isMobile,
        isNewsfeed: this.props.isNewsfeed
      }) : null;
      return _jsx("div", {
        className: nativeAdClasses
      }, void 0, React.createElement(
        "div",
        { className: googleHookClasses, id: this.props.adId, ref: "googleHook" },
        nativeAdBody
      ));
    } else {
      return null;
    }
  }
});

},{"../../../modules/ads/google_ad_helper":3,"../../../react_stores/google_ads_store":196,"../../gr_component_factory":87,"./native_ad_body":51,"classnames":"classnames","reflux":"reflux"}],50:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _google_ads_store = require("../../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _google_native_ad = require("./google_native_ad");

var _google_native_ad2 = _interopRequireDefault(_google_native_ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NativeAd",

  mixins: [_reflux2.default.connectFilter(_google_ads_store2.default, "googleAdsStore", function (adsStoreState) {
    return adsStoreState.nativeAds[this.props.adId];
  })],

  propTypes: {
    adId: _react2.default.PropTypes.string.isRequired,
    trackingOptions: _react2.default.PropTypes.shape({
      enableTracking: _react2.default.PropTypes.bool,
      adId: _react2.default.PropTypes.string
    }).isRequired,
    className: _react2.default.PropTypes.string,
    signedIn: _react2.default.PropTypes.bool,
    allowBehavioralTargeting: _react2.default.PropTypes.bool,
    isMobile: _react2.default.PropTypes.bool,
    isNewsfeed: _react2.default.PropTypes.bool
  },

  getAdsStoreState: function getAdsStoreState() {
    return this.state.googleAdsStore;
  },
  getDefaultProps: function getDefaultProps() {
    return {
      signedIn: true,
      isMobile: false,
      isNewsfeed: true
    };
  },
  render: function render() {
    if (!this.getAdsStoreState()) {
      return null;
    }
    return _react2.default.createElement(_google_native_ad2.default, this.props);
  }
}); // Entry point for native ads

},{"../../../react_stores/google_ads_store":196,"../../gr_component_factory":87,"./google_native_ad":49,"react":"react","reflux":"reflux"}],51:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _user_not_interested_store = require("../../../react_stores/user_not_interested_store");

var _user_not_interested_store2 = _interopRequireDefault(_user_not_interested_store);

var _user_not_interested_actions = require("../../../react_actions/user_not_interested_actions");

var _user_not_interested_actions2 = _interopRequireDefault(_user_not_interested_actions);

var _native_book_ad = require("./native_book_ad");

var _native_book_ad2 = _interopRequireDefault(_native_book_ad);

var _native_flex_ad = require("./native_flex_ad");

var _native_flex_ad2 = _interopRequireDefault(_native_flex_ad);

var _user_not_interested_message = require("./user_not_interested_message");

var _user_not_interested_message2 = _interopRequireDefault(_user_not_interested_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NativeAdBody",

  mixins: [_reflux2.default.connect(_user_not_interested_store2.default, "userNotInterestedStore")],

  propTypes: {
    adId: React.PropTypes.string,
    creative: React.PropTypes.object.isRequired,
    adDeviceType: React.PropTypes.string,
    signedIn: React.PropTypes.bool,
    allowBehavioralTargeting: React.PropTypes.bool,
    isMobile: React.PropTypes.bool,
    isNewsfeed: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isNewsfeed: true,
      isMobile: false,
      signedIn: true
    };
  },
  getUserNotInterestedStoreState: function getUserNotInterestedStoreState() {
    return this.state.userNotInterestedStore;
  },
  render: function render() {
    if (this.props.creative && this.props.creative.book) {
      var bookId = this.props.creative.book.bookId;
      if (this.getUserNotInterestedStoreState()[bookId]) {
        if (this.getUserNotInterestedStoreState()[bookId].isClosed) {
          return null;
        } else if (this.getUserNotInterestedStoreState()[bookId].isFlashMessage) {
          return _jsx(_user_not_interested_message2.default, {
            id: this.props.adId,
            isNewsfeed: this.props.isNewsfeed,
            className: this.props.className,
            creative: this.props.creative
          });
        }
      } else {
        _user_not_interested_actions2.default.addBookIDToState(bookId);
      }
    }
    if (this.props.creative && this.props.creative.book) {
      return _jsx(_native_book_ad2.default, {
        isNewsfeed: this.props.isNewsfeed,
        isMobile: this.props.isMobile,
        creative: this.props.creative,
        adDeviceType: this.props.adDeviceType,
        signedIn: this.props.signedIn,
        allowBehavioralTargeting: this.props.allowBehavioralTargeting,
        id: this.props.adId
      });
    } else {
      return _jsx(_native_flex_ad2.default, {
        id: this.props.adId,
        creative: this.props.creative,
        signedIn: this.props.signedIn,
        allowBehavioralTargeting: this.props.allowBehavioralTargeting,
        isNewsfeed: this.props.isNewsfeed,
        isMobile: this.props.isMobile
      });
    }
  }
});

},{"../../../react_actions/user_not_interested_actions":38,"../../../react_stores/user_not_interested_store":204,"../../gr_component_factory":87,"./native_book_ad":54,"./native_flex_ad":56,"./user_not_interested_message":58,"reflux":"reflux"}],52:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeAdCaret = undefined;

var _react = require("react");

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _dropdown = require("../../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _user_not_interested_actions = require("../../../react_actions/user_not_interested_actions");

var _user_not_interested_actions2 = _interopRequireDefault(_user_not_interested_actions);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NativeAdCaret = exports.NativeAdCaret = (function (_Component) {
  _inherits(NativeAdCaret, _Component);

  function NativeAdCaret(props) {
    _classCallCheck(this, NativeAdCaret);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NativeAdCaret).call(this, props));
  }

  _createClass(NativeAdCaret, [{
    key: "renderNotInterested",
    value: function renderNotInterested() {
      var _this2 = this;

      if (this.props.book && this.props.signedIn) {
        var notInterButtonAction = function notInterButtonAction() {
          return _user_not_interested_actions2.default.userNotInterested(_this2.props.book.bookId);
        };
        var notInterButton = _jsx("button", {
          className: "gr-buttonAsLink nativeAdCaretMenu__button",
          onClick: notInterButtonAction
        }, void 0, "I’m not interested in this book");
        return _jsx(_click_tracking_wrapper2.default, {
          children: notInterButton,
          trackingOptions: _click_tracking_helper.TRACKED_CLASSES.newsfeed_caret_not_interested
        });
      } else {
        return null;
      }
    }
  }, {
    key: "caretList",
    value: function caretList() {
      var whyAmISeeingThisLink = _jsx("a", {
        className: "nativeAdCaretMenu__link",
        href: this.props.helpLink
      }, void 0, "Why am I seeing this?");
      return _jsx("div", {
        className: "nativeAdCaretMenu"
      }, void 0, this.renderNotInterested(), (0, _lodash.map)(this.props.additionalLinks, function (link) {
        return _jsx("div", {
          className: "nativeAdCaretMenu__button"
        }, link, "link");
      }), _jsx(_click_tracking_wrapper2.default, {
        children: whyAmISeeingThisLink,
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES.newsfeed_caret_help
      }));
    }
  }, {
    key: "render",
    value: function render() {
      return _jsx("div", {
        className: "nativeAdCaret"
      }, void 0, _jsx(_dropdown2.default, {
        trigger: _jsx("div", {
          className: "nativeAdCaret nativeAdCaret__image",
          "aria-label": "Sponsored item options"
        }),
        triggerEventType: _dropdown2.default.TriggerEventTypes.CLICK,
        bemModifiers: "caret",
        children: this.caretList()
      }));
    }
  }]);

  return NativeAdCaret;
})(_react.Component);

NativeAdCaret.propTypes = {
  book: _gr_prop_types2.default.book(),
  helpLink: _react.PropTypes.string,
  updateId: _react.PropTypes.string,
  additionalLinks: _react.PropTypes.arrayOf(_react.PropTypes.elements),
  signedIn: _react.PropTypes.bool
};

NativeAdCaret.defaultProps = {
  trackingOptions: _click_tracking_helper.TRACKED_CLASSES.newsfeed_caret,
  signedIn: true
};

exports.default = NativeAdCaret;

},{"../../../modules/ads/click_tracking_helper":2,"../../../react_actions/user_not_interested_actions":38,"../../click_tracking_wrapper":70,"../../dropdown":75,"../../shared/gr_prop_types":146,"lodash":"lodash","react":"react"}],53:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeAdSponsoredLabel = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NativeAdSponsoredLabel = exports.NativeAdSponsoredLabel = (function (_Component) {
  _inherits(NativeAdSponsoredLabel, _Component);

  function NativeAdSponsoredLabel(props) {
    _classCallCheck(this, NativeAdSponsoredLabel);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NativeAdSponsoredLabel).call(this, props));
  }

  _createClass(NativeAdSponsoredLabel, [{
    key: "render",
    value: function render() {
      var sponsoredLabel = this.props.sponsoredBy ? "Sponsored by " : "Sponsored";
      var sponsoredFooter = _jsx("div", {
        className: "nativeAd__sponsoredLabel"
      }, void 0, _jsx("span", {
        className: "googleNativeAd__sponsoredBadgeIcon"
      }), _jsx("span", {
        className: "googleNativeAd__sponsoredLabel"
      }, void 0, sponsoredLabel), _jsx("a", {
        target: "_blank",
        href: this.props.sponsoredUrl,
        className: "gr-hyperlink"
      }, void 0, this.props.sponsoredBy));
      return _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES.sponsored_label,
        children: sponsoredFooter
      });
    }
  }]);

  return NativeAdSponsoredLabel;
})(_react.Component);

NativeAdSponsoredLabel.propTypes = {
  sponsoredBy: _react2.default.PropTypes.string,
  sponsoredUrl: _react2.default.PropTypes.string
};

exports.default = NativeAdSponsoredLabel;

},{"../../../modules/ads/click_tracking_helper":2,"../../click_tracking_wrapper":70,"react":"react"}],54:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeBookAd = undefined;

var _react = require("react");

var _native_book_ad_header = require("./native_book_ad_header");

var _native_book_ad_header2 = _interopRequireDefault(_native_book_ad_header);

var _book = require("../../book");

var _book2 = _interopRequireDefault(_book);

var _book_with_wtr_button = require("../../book_with_wtr_button");

var _book_with_wtr_button2 = _interopRequireDefault(_book_with_wtr_button);

var _preview_book = require("../../preview_book/preview_book");

var _preview_book2 = _interopRequireDefault(_preview_book);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _book_description = require("../../book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _community_rating = require("../../community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _shape_icon = require("../../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _user_icon = require("../../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

var _native_ad_caret = require("./native_ad_caret");

var _native_ad_caret2 = _interopRequireDefault(_native_ad_caret);

var _native_ad_sponsored_label = require("./native_ad_sponsored_label");

var _native_ad_sponsored_label2 = _interopRequireDefault(_native_ad_sponsored_label);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NativeBookAd = exports.NativeBookAd = (function (_Component) {
  _inherits(NativeBookAd, _Component);

  function NativeBookAd(props) {
    _classCallCheck(this, NativeBookAd);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NativeBookAd).call(this, props));
  }

  _createClass(NativeBookAd, [{
    key: "isDesktopNewsfeed",
    value: function isDesktopNewsfeed() {
      return this.props.isNewsfeed && !this.props.isMobile;
    }
  }, {
    key: "isMobileNewsfeed",
    value: function isMobileNewsfeed() {
      return this.props.isNewsfeed && this.props.isMobile;
    }
  }, {
    key: "renderBookDescription",
    value: function renderBookDescription() {
      var previewBook = !this.props.isMobile ? _jsx(_preview_book2.default, {
        book: this.props.creative.book
      }) : null;
      if (this.props.creative.customText) {
        return _jsx("div", {
          className: "gr-book__description u-marginTopXSmall"
        }, void 0, React.createElement(_expandable_html2.default, this.props.creative.customText), _jsx("div", {
          className: "u-paddingTopSmall"
        }, void 0, previewBook));
      } else {
        return _jsx("div", {}, void 0, _jsx(_book_description2.default, {
          className: "u-marginTopXSmall",
          bookDescription: this.props.creative.book.description
        }), _jsx("div", {
          className: "u-paddingTopSmall"
        }, void 0, previewBook));
      }
    }
  }, {
    key: "renderLearnMoreButton",
    value: function renderLearnMoreButton() {
      var bookLink = _jsx("a", {
        href: this.props.creative.book.bookUrl,
        rel: "noopener noreferrer",
        className: "gr-button u-marginTopMedium"
      }, void 0, "Learn More");
      return _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES.cta_link,
        children: bookLink
      });
    }
  }, {
    key: "renderBook",
    value: function renderBook() {
      var bodyContainerClassnames = (0, _classnames2.default)({
        "gr-newsfeedItem__body": this.isDesktopNewsfeed(),
        bookAdBody: !this.isDesktopNewsfeed()
      });
      var book = this.props.creative.book;
      if (this.props.signedIn) {
        return _jsx(_book_with_wtr_button2.default, {
          body: this.renderBookDescription(),
          book: book,
          responsiveWtrButton: this.props.isMobile,
          bookClassName: bodyContainerClassnames
        });
      } else {
        return React.createElement(
          _book2.default,
          _extends({}, book, {
            className: bodyContainerClassnames,
            size: _book.VALID_BOOK_SIZES.LARGE }),
          this.props.isMobile ? _jsx(_community_rating2.default, {
            rating: parseFloat(book.avgRating),
            displayAvgRatingText: false,
            ratingsCount: book.ratingsCount,
            size: _community_rating2.default.ICON_SIZES.MEDIUM
          }) : null,
          this.renderBookDescription(),
          this.renderLearnMoreButton()
        );
      }
    }
  }, {
    key: "renderCaret",
    value: function renderCaret() {
      return _jsx("div", {
        className: "googleNativeAd__caret"
      }, void 0, _jsx(_native_ad_caret2.default, {
        book: this.props.creative.book,
        helpLink: this.props.creative.helpLink,
        updateId: this.props.id,
        signedIn: this.props.signedIn
      }));
    }
  }, {
    key: "renderIconBody",
    value: function renderIconBody() {
      if (this.props.creative.firstFriend) {
        return _jsx(_user_icon2.default, {
          user: this.props.creative.firstFriend,
          size: _shape_icon_values.ICON_SIZES.MEDIUM
        });
      } else {
        return _jsx(_shape_icon2.default, {
          imageUrl: this.props.creative.defaultIcon,
          size: _shape_icon_values.ICON_SIZES.MEDIUM,
          imageAlt: "Sponsored Newsfeed Item Icon",
          border: true
        });
      }
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      return _jsx("div", {
        className: "gr-newsfeedItem__headerIcon gr-mediaBox__media gr-mediaBox__media--marginSmall"
      }, void 0, this.renderIconBody());
    }
  }, {
    key: "render",
    value: function render() {
      var sponsoredLine = _jsx(_native_ad_sponsored_label2.default, {
        sponsoredBy: this.props.creative.sponsoredBy,
        sponsoredUrl: this.props.creative.sponsoredUrl
      });

      var bodyClasses = (0, _classnames2.default)("gr-mediaBox", {
        "feedItem feedItem--ad": this.isMobileNewsfeed(),
        "gr-newsfeedItem gr-mediaBox": this.isDesktopNewsfeed(),
        "googleNativeAd__item ": !this.isDesktopNewsfeed()
      });
      var bookClasses = (0, _classnames2.default)({
        nativeAd__newsfeedBody: this.isDesktopNewsfeed()
      });
      return React.createElement(
        "div",
        { className: bodyClasses, ref: "nativeAd" },
        this.isDesktopNewsfeed() && this.renderIcon(),
        _jsx("div", {
          className: "u-marginBottomSmall"
        }, void 0, this.renderCaret(), _jsx("div", {
          className: "nativeAd__headerText"
        }, void 0, _jsx(_native_book_ad_header2.default, {
          creative: this.props.creative,
          signedIn: this.props.signedIn,
          allowBehavioralTargeting: this.props.allowBehavioralTargeting
        })), this.props.creative.isSponsored ? sponsoredLine : null, _jsx("div", {
          className: bookClasses
        }, void 0, this.renderBook()))
      );
    }
  }]);

  return NativeBookAd;
})(_react.Component);

NativeBookAd.propTypes = {
  isNewsfeed: _react.PropTypes.bool,
  isMobile: _react.PropTypes.bool,
  creative: _react.PropTypes.shape().isRequired,
  adDeviceType: _react.PropTypes.string,
  signedIn: _react.PropTypes.bool,
  allowBehavioralTargeting: React.PropTypes.bool,
  id: _react.PropTypes.string
};

exports.default = NativeBookAd;

},{"../../../modules/ads/click_tracking_helper":2,"../../../modules/shape_icon_values":16,"../../book":61,"../../book_description":63,"../../book_with_wtr_button":64,"../../click_tracking_wrapper":70,"../../community_rating":72,"../../preview_book/preview_book":123,"../../shape_icon":141,"../../user/user_icon":167,"../../user_content/expandable_html":169,"./native_ad_caret":52,"./native_ad_sponsored_label":53,"./native_book_ad_header":55,"classnames":"classnames","react":"react"}],55:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _user_profile_link = require("../../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NativeBookAdHeader",

  propTypes: {
    creative: _gr_prop_types2.default.creative().isRequired,
    signedIn: React.PropTypes.bool,
    allowBehavioralTargeting: React.PropTypes.bool
  },

  // Setting default to true for signed in homepage newsfeed
  getDefaultProps: function getDefaultProps() {
    return {
      signedIn: true
    };
  },
  renderLink: function renderLink(text, url) {
    return _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--bold",
      href: url
    }, void 0, text);
  },
  renderFriendHeader: function renderFriendHeader() {
    var firstFriend = _lodash2.default.head(this.props.creative.topFriends);
    return _jsx("span", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, _jsx(_user_profile_link2.default, {
      user: firstFriend
    }), this.renderHeaderText(), " ", this.props.creative.friendActionText);
  },
  renderHeaderText: function renderHeaderText() {
    if (this.props.creative.numAdditionalFriends === 1) {
      return _jsx("span", {}, void 0, " and ", _jsx(_user_profile_link2.default, {
        user: this.props.creative.topFriends[1]
      }));
    } else if (this.props.creative.numAdditionalFriends > 1) {
      return _jsx("span", {}, void 0, " and ", this.renderLink(this.props.creative.numAdditionalFriends + " other friends", this.props.creative.book.bookUrl + "#friendReviews"));
    } else {
      return null;
    }
  },
  renderSimilarBook: function renderSimilarBook() {
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText gr-newsfeedItem__headerText--truncateWithEllipsis"
    }, void 0, "This is similar to ", this.renderLink(this.props.creative.similarBook.title, this.props.creative.similarBook.bookUrl));
  },
  renderGenres: function renderGenres() {
    var topGenre = _lodash2.default.head(this.props.creative.genres);
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, "This book has been shelved by members as ", this.renderLink(topGenre.genre, topGenre.url), this.props.creative.genres.length > 1 ? _jsx("span", {}, void 0, " and ", this.renderLink(this.props.creative.genres[1].genre, this.props.creative.genres[1].url)) : null);
  },
  renderDefault: function renderDefault() {
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, "Based on your reading preferences, you might enjoy");
  },
  renderSignedOutText: function renderSignedOutText() {
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, "Recommended");
  },
  renderContextualHeader: function renderContextualHeader() {
    return _jsx("div", {
      className: "gr-newsfeedItem__headerText"
    }, void 0, this.props.creative.headerText);
  },
  render: function render() {
    if (this.props.creative.headerText) {
      return this.renderContextualHeader();
    } else if (!this.props.allowBehavioralTargeting) {
      return this.renderSignedOutText();
    } else if (!this.props.signedIn) {
      return this.renderSignedOutText();
    } else if (this.props.creative.topFriends) {
      return this.renderFriendHeader();
    } else if (this.props.creative.similarBook) {
      return this.renderSimilarBook();
    } else if (this.props.creative.genres) {
      return this.renderGenres();
    } else {
      return this.renderDefault();
    }
  }
});

},{"../../gr_component_factory":87,"../../shared/gr_prop_types":146,"../../user/user_profile_link":168,"lodash":"lodash"}],56:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NativeFlexAd = undefined;

var _react = require("react");

var _native_flex_ad_body = require("./native_flex_ad_body");

var _native_flex_ad_body2 = _interopRequireDefault(_native_flex_ad_body);

var _shape_icon = require("../../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _shape_icon_values = require("../../../modules/shape_icon_values");

var _native_ad_caret = require("./native_ad_caret");

var _native_ad_caret2 = _interopRequireDefault(_native_ad_caret);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _native_ad_sponsored_label = require("./native_ad_sponsored_label");

var _native_ad_sponsored_label2 = _interopRequireDefault(_native_ad_sponsored_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NativeFlexAd = exports.NativeFlexAd = (function (_Component) {
  _inherits(NativeFlexAd, _Component);

  function NativeFlexAd(props) {
    _classCallCheck(this, NativeFlexAd);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(NativeFlexAd).call(this, props));
  }

  _createClass(NativeFlexAd, [{
    key: "getHeaderText",
    value: function getHeaderText() {
      return {
        __html: this.props.creative.headerText
      };
    }
  }, {
    key: "renderCaret",
    value: function renderCaret() {
      return _jsx("div", {
        className: "googleNativeAd__caret"
      }, void 0, _jsx(_native_ad_caret2.default, {
        helpLink: this.props.creative.helpLink,
        updateId: this.props.id,
        signedIn: this.props.signedIn
      }));
    }
  }, {
    key: "isDesktopNewsfeed",
    value: function isDesktopNewsfeed() {
      return this.props.isNewsfeed && !this.props.isMobile;
    }
  }, {
    key: "isMobileNewsfeed",
    value: function isMobileNewsfeed() {
      return this.props.isNewsfeed && this.props.isMobile;
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      return _jsx("div", {
        className: "gr-newsfeedItem__headerIcon gr-mediaBox__media gr-mediaBox__media--marginSmall"
      }, void 0, _jsx(_shape_icon2.default, {
        imageUrl: this.props.creative.defaultIcon,
        size: _shape_icon_values.ICON_SIZES.MEDIUM,
        imageAlt: "Sponsored Item Icon",
        border: true
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var bodyClassNames = (0, _classnames2.default)({
        "gr-newsfeedItem__body nativeAd__newsfeedBody": this.isDesktopNewsfeed()
      });
      var sponsoredLine = _jsx(_native_ad_sponsored_label2.default, {
        sponsoredBy: this.props.creative.sponsoredBy,
        sponsoredUrl: this.props.creative.sponsoredUrl
      });

      var bodyClasses = (0, _classnames2.default)("gr-mediaBox", {
        "gr-newsfeedItem gr-mediaBox": this.isDesktopNewsfeed(),
        "googleNativeAd__item ": !this.isDesktopNewsfeed(),
        "feedItem feedItem--ad": this.isMobileNewsfeed()
      });
      return React.createElement(
        "div",
        { className: bodyClasses, ref: "nativeAd" },
        this.isDesktopNewsfeed() && this.renderIcon(),
        _jsx("div", {
          className: "u-marginBottomSmall"
        }, void 0, this.renderCaret(), _jsx("div", {
          className: "nativeAd__headerText"
        }, void 0, _jsx("div", {
          className: "gr-newsfeedItem__headerText",
          dangerouslySetInnerHTML: this.getHeaderText()
        })), this.props.creative.isSponsored ? sponsoredLine : null, _jsx(_native_flex_ad_body2.default, {
          creative: this.props.creative,
          bodyClassNames: bodyClassNames
        }))
      );
    }
  }]);

  return NativeFlexAd;
})(_react.Component);

NativeFlexAd.propTypes = {
  id: _react.PropTypes.string,
  creative: _react.PropTypes.shape().isRequired,
  signedIn: _react.PropTypes.bool,
  isNewsfeed: _react.PropTypes.bool,
  isMobile: _react.PropTypes.bool
};

exports.default = NativeFlexAd;

},{"../../../modules/shape_icon_values":16,"../../shape_icon":141,"./native_ad_caret":52,"./native_ad_sponsored_label":53,"./native_flex_ad_body":57,"classnames":"classnames","react":"react"}],57:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _click_tracking_wrapper = require("../../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _expandable_html = require("../../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _click_tracking_helper = require("../../../modules/ads/click_tracking_helper");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "NativeFlexAdBody",

  propTypes: {
    creative: _gr_prop_types2.default.creative().isRequired,
    bodyClassNames: _react2.default.PropTypes.string
  },

  renderImage: function renderImage() {
    var bodyImageClasses = (0, _classnames2.default)("gr-mediaBox__media", this.withBemModifiers("flexAdBody__image"));
    var bodyImage = _jsx("a", {
      target: this.props.creative.externalLink ? "_blank" : "_self",
      rel: "noopener noreferrer",
      href: this.props.creative.updateUrl,
      className: "flexAdBody__imageLink"
    }, void 0, _jsx("img", {
      alt: this.props.creative.title,
      className: bodyImageClasses,
      src: this.props.creative.image
    }));
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.sponsored_update_body_image,
      children: bodyImage
    });
  },
  renderExploreButton: function renderExploreButton() {
    var micrositeLink = _jsx("a", {
      target: this.props.creative.externalLink ? "_blank" : "_self",
      rel: "noopener noreferrer",
      href: this.props.creative.callToActionUrl,
      className: "gr-button u-marginTopMedium gr-microsite-link"
    }, void 0, this.props.creative.callToActionText);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.cta_link,
      children: micrositeLink
    });
  },
  render: function render() {
    var bodyClasses = (0, _classnames2.default)(this.props.bodyClassNames, "gr-mediaBox", "flexAdBody");
    var bodyTitleLinkClasses = (0, _classnames2.default)("flexAdBody__titleLink", "gr-hyperlink", "gr-hyperlink--naked");
    var titleLink = _jsx("a", {
      target: this.props.creative.externalLink ? "_blank" : "_self",
      rel: "noopener noreferrer",
      href: this.props.creative.updateUrl,
      className: bodyTitleLinkClasses
    }, void 0, this.props.creative.title);
    return _jsx("div", {
      className: bodyClasses
    }, void 0, this.renderImage(), _jsx("div", {
      className: "gr-mediaBox__desc"
    }, void 0, _jsx("div", {
      className: "flexAdBody__title"
    }, void 0, _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.sponsored_update_body_title_link,
      children: titleLink
    })), _jsx("div", {
      className: "flexAdBody__description"
    }, void 0, _react2.default.createElement(_expandable_html2.default, this.props.creative.description)), this.renderExploreButton()));
  }
});

},{"../../../modules/ads/click_tracking_helper":2,"../../click_tracking_wrapper":70,"../../gr_component_factory":87,"../../shared/gr_prop_types":146,"../../user_content/expandable_html":169,"classnames":"classnames","react":"react"}],58:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserNotInterestedMessage = undefined;

var _react = require("react");

var _close_button = require("../../close_button");

var _close_button2 = _interopRequireDefault(_close_button);

var _user_not_interested_actions = require("../../../react_actions/user_not_interested_actions");

var _user_not_interested_actions2 = _interopRequireDefault(_user_not_interested_actions);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserNotInterestedMessage = exports.UserNotInterestedMessage = (function (_Component) {
  _inherits(UserNotInterestedMessage, _Component);

  function UserNotInterestedMessage(props) {
    _classCallCheck(this, UserNotInterestedMessage);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(UserNotInterestedMessage).call(this, props));
  }

  _createClass(UserNotInterestedMessage, [{
    key: "renderUndoButton",
    value: function renderUndoButton(book) {
      var _this2 = this;

      return _jsx("button", {
        className: "gr-buttonAsLink",
        onClick: function onClick() {
          _user_not_interested_actions2.default.undoUserNotInterested(book.bookId, _this2.props.id);
        }
      }, void 0, "Undo");
    }
  }, {
    key: "render",
    value: function render() {
      var book = this.props.creative.book;
      if (this.props.isNewsfeed) {
        var userNotInterestedMessage = _jsx("span", {
          className: "gr-newsfeedItem__flashMessage--body"
        }, void 0, "Thanks! We won't recommend", " ", _jsx("a", {
          href: book.bookUrl
        }, void 0, book.title), " ", "again!", " ", this.renderUndoButton(book));
        return _jsx("div", {
          className: "gr-newsfeedItem gr-newsfeedItem__flashMessage",
          role: "alert"
        }, void 0, _jsx("div", {
          className: "gr-newsfeedItem__close"
        }, void 0, _jsx(_close_button2.default, {
          action: function action() {
            _user_not_interested_actions2.default.closeFlashMessage(book.bookId);
          }
        })), userNotInterestedMessage);
      } else {
        var userNotInterestedMessage = _jsx("span", {
          className: "userNotInterested__message"
        }, void 0, "Thanks! We won't recommend", " ", _jsx("a", {
          href: book.bookUrl
        }, void 0, book.title), " ", "again!", " ", this.renderUndoButton(book));
        var userNotInterestedClassname = (0, _classnames2.default)(this.props.className, "userNotInterested");
        return _jsx("div", {
          className: userNotInterestedClassname,
          role: "alert"
        }, void 0, _jsx("div", {
          className: "userNotInterested__close"
        }, void 0, _jsx(_close_button2.default, {
          action: function action() {
            _user_not_interested_actions2.default.closeFlashMessage(book.bookId);
          }
        })), userNotInterestedMessage);
      }
    }
  }]);

  return UserNotInterestedMessage;
})(_react.Component);

UserNotInterestedMessage.propTypes = {
  id: _react.PropTypes.string,
  isNewsfeed: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  creative: _react.PropTypes.shape()
};

exports.default = UserNotInterestedMessage;

},{"../../../react_actions/user_not_interested_actions":38,"../../close_button":71,"classnames":"classnames","react":"react"}],59:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("react");

var _google_ads_store = require("../../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _google_banner_ad = require("./google_banner_ad");

var _google_banner_ad2 = _interopRequireDefault(_google_banner_ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* Built for MW-39, this is component attempts to generalize the wrapper
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               around the Google 300x250 ad that we originally built for the series page
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               (series#show). It will probably eventually be just one of multiple ad wrappers.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               It will throw warnings if pre-rendered on the server, because the GoogleBannerAd
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               that it renders will render differently on the server (b/c cannot load ads
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               server-side).
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               This is intended to be (one of) our top-level entry point(s) to loading ads on
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               a responsive page.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var ResponsivePageAdContainer = (function (_React$Component) {
  _inherits(ResponsivePageAdContainer, _React$Component);

  function ResponsivePageAdContainer(props) {
    _classCallCheck(this, ResponsivePageAdContainer);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ResponsivePageAdContainer).call(this, props));

    _this.state = { googleAdsStore: null };
    return _this;
  }

  _createClass(ResponsivePageAdContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.unsubscribe = _google_ads_store2.default.listen(function (storeState) {
        if (storeState.ads[_this2.props.googleBannerAd.adId]) {
          _this2.setState({ googleAdsStore: storeState.ads[_this2.props.googleBannerAd.adId] });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unsubscribe();
    }
  }, {
    key: "render",
    value: function render() {
      // Try to only show "advertisement" label when the ad actually appears.
      return _jsx("div", {
        className: "responsivePageInlineAdContainer"
      }, void 0, this.props.showAdvertisementLabel && this.state.googleAdsStore && this.state.googleAdsStore.creative && _jsx("div", {
        className: "responsivePageAdLabel"
      }, void 0, "advertisement"), React.createElement(_google_banner_ad2.default, this.props.googleBannerAd));
    }
  }]);

  return ResponsivePageAdContainer;
})(React.Component);

ResponsivePageAdContainer.defaultProps = { showAdvertisementLabel: true };

ResponsivePageAdContainer.propTypes = {
  googleBannerAd: React.PropTypes.object.isRequired,
  showAdvertisementLabel: React.PropTypes.bool
};

exports.default = ResponsivePageAdContainer;

},{"../../react_stores/google_ads_store":196,"./google_banner_ad":46,"react":"react"}],60:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUTHOR_BADGE_SIZES = {
  SMALL: "small",
  LARGE: "large"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AuthorBadge",

  statics: {
    AUTHOR_BADGE_SIZES: AUTHOR_BADGE_SIZES
  },

  propTypes: {
    size: React.PropTypes.oneOf([AUTHOR_BADGE_SIZES.SMALL, AUTHOR_BADGE_SIZES.LARGE]),
    isGoodreadsAuthor: _react.PropTypes.bool.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      size: AUTHOR_BADGE_SIZES.SMALL
    };
  },
  getClasses: function getClasses() {
    return (0, _classnames2.default)("gr-icon", {
      "gr-icon--authorBadge": this.props.size === AUTHOR_BADGE_SIZES.SMALL,
      "gr-icon--authorBadgeLarge": this.props.size === AUTHOR_BADGE_SIZES.LARGE
    });
  },
  renderBadge: function renderBadge() {
    return _jsx("span", {
      className: this.getClasses(),
      title: "Goodreads Author"
    });
  },
  render: function render() {
    return this.props.isGoodreadsAuthor ? this.renderBadge() : null;
  }
});

},{"../gr_component_factory":87,"classnames":"classnames","react":"react"}],61:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VALID_BOOK_SIZES = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _author_badge = require("./author/author_badge");

var _author_badge2 = _interopRequireDefault(_author_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VALID_BOOK_SIZES = exports.VALID_BOOK_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Book",

  propTypes: {
    imageUrl: _react2.default.PropTypes.string.isRequired,
    bookUrl: _react2.default.PropTypes.string.isRequired,
    bookCoverUrl: _react2.default.PropTypes.string, // if book cover should link somewhere besides book page
    title: _react2.default.PropTypes.string.isRequired,
    size: _react2.default.PropTypes.oneOf(_lodash2.default.values(VALID_BOOK_SIZES)),
    titleSize: _react2.default.PropTypes.oneOf(_lodash2.default.values(VALID_BOOK_SIZES)),
    author: _gr_prop_types2.default.author(),
    mediaBoxModifier: _react2.default.PropTypes.string,
    className: _react2.default.PropTypes.string,
    sponsored: _react2.default.PropTypes.bool,
    bookImageTrackingData: _react2.default.PropTypes.object,
    bookTitleTrackingData: _react2.default.PropTypes.object,
    authorLinkTrackingData: _react2.default.PropTypes.object,
    label: _react2.default.PropTypes.element
  },
  getDefaultProps: function getDefaultProps() {
    return {
      size: VALID_BOOK_SIZES.MEDIUM,
      bookImageTrackingData: _click_tracking_helper.TRACKED_CLASSES.book_image,
      bookTitleTrackingData: _click_tracking_helper.TRACKED_CLASSES.book_title,
      authorLinkTrackingData: _click_tracking_helper.TRACKED_CLASSES.author_link
    };
  },
  render: function render() {
    var bookClasses = (0, _classnames2.default)("gr-mediaBox", "gr-book--" + this.props.size, this.withBemModifiers("gr-book"), this.props.className);
    var bookImageClasses = (0, _classnames2.default)("gr-mediaBox__media", this.withBemModifiers("gr-book__image"), { "gr-book__image--large": this.props.size === VALID_BOOK_SIZES.LARGE });
    var titleSize = this.props.titleSize == null ? this.props.size : this.props.titleSize;
    var bookTitleLinkClasses = (0, _classnames2.default)(this.withBemModifiers("gr-book__titleLink"), { "gr-book__titleLink--large": titleSize === VALID_BOOK_SIZES.LARGE }, "gr-hyperlink gr-hyperlink--naked");
    var bookTitleClasses = (0, _classnames2.default)(this.withBemModifiers("gr-book__title"));
    var mediaBoxClasses = this.withBemModifiers("gr-mediaBox__desc", this.props.mediaBoxModifier);
    var bookImage = _jsx("img", {
      alt: this.props.title,
      className: bookImageClasses,
      src: this.props.imageUrl
    });
    var bookLink = _jsx("a", {
      href: this.props.bookUrl,
      className: bookTitleLinkClasses
    }, void 0, this.props.title);
    return _jsx("div", {
      className: bookClasses
    }, void 0, _jsx("a", {
      href: this.props.bookCoverUrl || this.props.bookUrl
    }, void 0, _jsx(_click_tracking_wrapper2.default, {
      children: bookImage,
      trackingOptions: this.props.bookImageTrackingData
    })), _jsx("div", {
      className: mediaBoxClasses
    }, void 0, this.props.label, _jsx("div", {
      className: bookTitleClasses
    }, void 0, _jsx(_click_tracking_wrapper2.default, {
      children: bookLink,
      trackingOptions: this.props.bookTitleTrackingData
    })), this.renderAuthorLink(), _jsx("div", {
      className: "gr-book__additionalContent"
    }, void 0, this.props.children)));
  },
  renderAuthorLink: function renderAuthorLink() {
    var authorSize = this.props.titleSize == null ? this.props.size : this.props.titleSize;
    var bookAuthorClasses = (0, _classnames2.default)(this.withBemModifiers("gr-book__author"), { "gr-book__author--large": authorSize === VALID_BOOK_SIZES.LARGE });

    if (this.props.author) {
      var authorLink = _jsx("a", {
        href: this.props.author.profileUrl,
        className: "gr-book__authorLink gr-hyperlink gr-hyperlink--naked"
      }, void 0, this.props.author.name);

      return _jsx("div", {
        className: bookAuthorClasses
      }, void 0, "by ", _jsx(_click_tracking_wrapper2.default, {
        children: authorLink,
        trackingOptions: this.props.authorLinkTrackingData
      }), _react2.default.createElement(_author_badge2.default, this.props.author));
    } else {
      return _jsx("div", {
        className: bookAuthorClasses
      }, void 0, "by deleted author");
    }
  }
});

},{"../modules/ads/click_tracking_helper":2,"./author/author_badge":60,"./click_tracking_wrapper":70,"./gr_component_factory":87,"./shared/gr_prop_types":146,"classnames":"classnames","lodash":"lodash","react":"react"}],62:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CTA_TEXT_SIGNED_OUT = exports.CTA_TEXT_SIGNED_IN = undefined;

var _react = require("react");

var _shape_icon_values = require("../../modules/shape_icon_values");

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _user_rating = require("../user_rating");

var _user_rating2 = _interopRequireDefault(_user_rating);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _user_profile_link = require("../user/user_profile_link");

var _user_profile_link2 = _interopRequireDefault(_user_profile_link);

var _write_a_review_button = require("../review/write_a_review_button");

var _write_a_review_button2 = _interopRequireDefault(_write_a_review_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               title: Review Cta
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               This component displays the review Cta to the user to prompt them to leave a
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               review or rating on a book. 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `bookId`: Book ID
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `user`: Current user
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `destinationPath`: The destination Url on clicking on the write a review button or rating widget
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `bookTitle`: Title of the book
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `actionType`: The Clickstream metric for the write a review button click
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `ratingClickstreamRef`: The ref tag for the Clickstream rating action context
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var CTA_TEXT_SIGNED_IN = exports.CTA_TEXT_SIGNED_IN = " start your review of ";
var CTA_TEXT_SIGNED_OUT = exports.CTA_TEXT_SIGNED_OUT = "Start your review of ";

var ReviewCta = (function (_Component) {
  _inherits(ReviewCta, _Component);

  function ReviewCta(props) {
    _classCallCheck(this, ReviewCta);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(ReviewCta).call(this, props));
  }

  _createClass(ReviewCta, [{
    key: "goToDestination",
    value: function goToDestination() {
      window.location.assign(this.props.destinationPath);
    }
  }, {
    key: "render",
    value: function render() {
      return _jsx("div", {
        className: "reviewCta"
      }, void 0, _jsx("div", {
        className: "reviewCta__left"
      }, void 0, _jsx(_user_icon2.default, {
        user: this.props.user,
        shape: _shape_icon_values.ICON_SHAPES.RECTANGULAR
      })), _jsx("div", {
        className: "reviewCta__right"
      }, void 0, _jsx("div", {
        className: "u-marginLeftXSmall reviewCta__label"
      }, void 0, _jsx(_user_profile_link2.default, {
        className: "reviewCta__userProfileLink",
        user: this.props.user
      }), this.props.user.viewableName ? CTA_TEXT_SIGNED_IN : CTA_TEXT_SIGNED_OUT, this.props.bookTitle), _jsx("div", {
        className: "reviewCta__controls"
      }, void 0, _jsx(_user_rating2.default, {
        bookId: this.props.bookId,
        starSize: _user_rating.STAR_SIZES.MEDIUM,
        handleClick: this.goToDestination.bind(this),
        displayLabel: false,
        clickstreamRef: this.props.ratingClickstreamRef
      }), _jsx(_write_a_review_button2.default, {
        destinationPath: this.props.destinationPath,
        actionType: this.props.actionType,
        bookId: this.props.bookId,
        className: "reviewCta__writeButton"
      }))));
    }
  }]);

  return ReviewCta;
})(_react.Component);

exports.default = ReviewCta;

ReviewCta.propTypes = {
  bookId: _react.PropTypes.string.isRequired,
  user: _react.PropTypes.object.isRequired,
  destinationPath: _react.PropTypes.string.isRequired,
  bookTitle: _react.PropTypes.string.isRequired,
  actionType: _react.PropTypes.string,
  ratingClickstreamRef: _react.PropTypes.string
};

},{"../../modules/shape_icon_values":16,"../modal":118,"../modal_trigger":119,"../review/write_a_review_button":131,"../user/user_icon":167,"../user/user_profile_link":168,"../user_rating":173,"react":"react"}],63:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _truncated_html = require("./user_content/truncated_html");

var _truncated_html2 = _interopRequireDefault(_truncated_html);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookDescription",

  propTypes: {
    bookDescription: _gr_prop_types2.default.bookDescription().isRequired,
    className: React.PropTypes.string,
    bookDescriptionTargetingData: React.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      bookDescription: {
        html: "",
        truncated: false,
        fullContentUrl: ""
      }
    };
  },
  render: function render() {
    var cx = (0, _classnames2.default)(this.props.className, "gr-book__description");
    var description = this.props.bookDescription;
    return _jsx("div", {
      className: cx
    }, void 0, description.html ? React.createElement(_truncated_html2.default, _extends({}, description, {
      fullContentText: "Continue reading",
      bookDescriptionTargetingData: this.props.bookDescriptionTargetingData })) : null, this.props.children);
  }
});

},{"./gr_component_factory":87,"./shared/gr_prop_types":146,"./user_content/truncated_html":172,"classnames":"classnames"}],64:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _book = require("./book");

var _book2 = _interopRequireDefault(_book);

var _want_to_read_button = require("./want_to_read/want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

var _lodash = require("lodash");

var _community_rating = require("./community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookWithWTRButton",

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired,
    body: React.PropTypes.element,
    bookSize: React.PropTypes.oneOf((0, _lodash.values)(_book.VALID_BOOK_SIZES)),
    bookClassName: React.PropTypes.string,
    responsiveWtrButton: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      bookSize: _book.VALID_BOOK_SIZES.LARGE,
      responsiveWtrButton: false
    };
  },
  renderBookBody: function renderBookBody() {
    return this.props.body ? this.props.body : null;
  },
  renderCommunityRating: function renderCommunityRating() {
    var book = this.props.book;
    return _jsx(_community_rating2.default, {
      rating: parseFloat(book.avgRating),
      displayAvg: false,
      displayAvgRatingText: false,
      ratingsCount: book.ratingsCount,
      size: _community_rating2.default.ICON_SIZES.MEDIUM
    });
  },
  renderWtrButton: function renderWtrButton() {
    return _jsx(_want_to_read_button2.default, {
      bookTitle: this.props.book.title,
      uniqueId: (0, _lodash.random)(1000000).toString(),
      bookId: this.props.book.bookId,
      withModalShelvingMenu: this.props.responsiveWtrButton,
      showStars: !this.props.responsiveWtrButton,
      readOnlyStars: this.props.readOnlyStars
    });
  },
  render: function render() {
    return React.createElement(
      _book2.default,
      _extends({ className: this.props.bookClassName }, this.props.book, { size: this.props.bookSize }),
      this.props.responsiveWtrButton && this.renderCommunityRating(),
      this.renderWtrButton(),
      this.renderBookBody()
    );
  }
});

},{"./book":61,"./community_rating":72,"./gr_component_factory":87,"./shared/gr_prop_types":146,"./want_to_read/want_to_read_button":174,"lodash":"lodash"}],65:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetACopyButton = undefined;

var _react = require("react");

var _reactRedux = require("react-redux");

var _get_a_copy_store = require("../../react_stores/buy_buttons/get_a_copy_store");

var _get_a_copy_store2 = _interopRequireDefault(_get_a_copy_store);

var _get_a_copy_actions = require("../../react_actions/buy_buttons/get_a_copy_actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GetACopyButton = exports.GetACopyButton = function GetACopyButton(_ref) {
  var getACopyDataUrl = _ref.getACopyDataUrl;
  var getACopyClickedHandler = _ref.getACopyClickedHandler;
  return _jsx("div", {}, void 0, _jsx("button", {
    className: "gr-button gr-button--fullWidth u-paddingTopTiny u-paddingBottomTiny u-defaultType",
    onClick: function onClick() {
      return getACopyClickedHandler(getACopyDataUrl);
    }
  }, void 0, "Get a copy"));
};

GetACopyButton.propTypes = {
  getACopyDataUrl: _react.PropTypes.string.isRequired,
  getACopyClickedHandler: _react.PropTypes.func.isRequired
};

var stateToProps = function stateToProps() {
  return {};
};
var dispatchToProps = function dispatchToProps(dispatch) {
  return {
    getACopyClickedHandler: function getACopyClickedHandler(dataUrl) {
      return dispatch((0, _get_a_copy_actions.getACopyClickedHandler)(dataUrl));
    }
  };
};

var ConnectedButton = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(GetACopyButton);

var ButtonWithProviderRoot = function ButtonWithProviderRoot(props) {
  return _jsx(_reactRedux.Provider, {
    store: _get_a_copy_store2.default
  }, void 0, React.createElement(ConnectedButton, props));
};

exports.default = ButtonWithProviderRoot;

},{"../../react_actions/buy_buttons/get_a_copy_actions":22,"../../react_stores/buy_buttons/get_a_copy_store":191,"react":"react","react-redux":"react-redux"}],66:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _book = require("../book");

var _book2 = _interopRequireDefault(_book);

var _community_rating = require("../community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

var _glide_button = require("./glide_button");

var _glide_button2 = _interopRequireDefault(_glide_button);

var _get_a_copy_link = require("./get_a_copy_link");

var _get_a_copy_link2 = _interopRequireDefault(_get_a_copy_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GetACopyInterstitial = function GetACopyInterstitial(_ref) {
  var book = _ref.book;
  var bookLinks = _ref.bookLinks;
  var glideButton = _ref.glideButton;
  var onCloseHandler = _ref.onCloseHandler;
  return _jsx(_modal2.default, {
    id: "GetACopyInterstitial",
    onCloseHandler: onCloseHandler,
    showByDefault: true,
    centered: true,
    bemModifiers: "small"
  }, void 0, _jsx("h3", {
    className: "gr-h3 gr-h3--noTopMargin"
  }, void 0, "Get a Copy"), React.createElement(
    _book2.default,
    _extends({}, book, {
      className: "u-paddingBottomSmall u-bottomGrayBorder u-marginBottomSmall",
      size: "large" }),
    _jsx(_community_rating2.default, {
      rating: parseFloat(book.avgRating),
      displayAvg: true,
      displayAvgRatingText: false,
      size: "medium"
    })
  ), _jsx("div", {
    className: "u-textAlignCenter"
  }, void 0, _jsx("p", {
    className: "gr-metaText gr-metaText--upper u-fontSizeDefault"
  }, void 0, "Available At:"), glideButton ? React.createElement(_glide_button2.default, _extends({}, glideButton, { bookId: book.bookId })) : null, bookLinks.map(function (link) {
    return React.createElement(_get_a_copy_link2.default, _extends({ key: link.name }, link));
  }), _jsx("p", {
    className: "u-fontSizeDefault"
  }, void 0, _jsx("a", {
    href: book.moreStoresUrl
  }, void 0, "More store options"))));
};

GetACopyInterstitial.propTypes = {
  book: _react.PropTypes.shape(_book2.default.propTypes).isRequired,
  bookLinks: _react.PropTypes.array.isRequired,
  glideButton: _react.PropTypes.object,
  onCloseHandler: _react.PropTypes.func
};

exports.default = GetACopyInterstitial;

},{"../book":61,"../community_rating":72,"../modal":118,"./get_a_copy_link":68,"./glide_button":69,"react":"react"}],67:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConditionalInterstitial = undefined;

var _reactRedux = require("react-redux");

var _get_a_copy_store = require("../../react_stores/buy_buttons/get_a_copy_store");

var _get_a_copy_store2 = _interopRequireDefault(_get_a_copy_store);

var _get_a_copy_actions = require("../../react_actions/buy_buttons/get_a_copy_actions");

var _get_a_copy_interstitial = require("./get_a_copy_interstitial");

var _get_a_copy_interstitial2 = _interopRequireDefault(_get_a_copy_interstitial);

var _react = require("react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConditionalInterstitial = exports.ConditionalInterstitial = function ConditionalInterstitial(_ref) {
  var interstitial = _ref.interstitial;
  var onClose = _ref.onClose;
  return interstitial ? React.createElement(_get_a_copy_interstitial2.default, _extends({}, interstitial, {
    onCloseHandler: onClose })) : _jsx("noscript", {});
};

ConditionalInterstitial.propTypes = {
  interstitial: _react.PropTypes.shape({
    book: _react.PropTypes.object,
    bookLinks: _react.PropTypes.array,
    glideButton: _react.PropTypes.object
  }),
  onClose: _react.PropTypes.func
};

var stateToProps = function stateToProps(state) {
  return {
    interstitial: state.activeGetACopyInterstitial
  };
};

var dispatchToProps = function dispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      return dispatch((0, _get_a_copy_actions.getACopyClosed)());
    }
  };
};

var ConnectedInterstitial = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(ConditionalInterstitial);

var GetACopyInterstitialWrapper = function GetACopyInterstitialWrapper() {
  return _jsx(_reactRedux.Provider, {
    store: _get_a_copy_store2.default
  }, void 0, _jsx(ConnectedInterstitial, {}));
};

exports.default = GetACopyInterstitialWrapper;

},{"../../react_actions/buy_buttons/get_a_copy_actions":22,"../../react_stores/buy_buttons/get_a_copy_store":191,"./get_a_copy_interstitial":66,"react":"react","react-redux":"react-redux"}],68:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var GetACopyLink = function GetACopyLink(_ref) {
  var name = _ref.name;
  var url = _ref.url;
  return _jsx("div", {
    className: "u-marginBottomTiny"
  }, void 0, _jsx("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "gr-button gr-button--fullWidth"
  }, void 0, name));
};

GetACopyLink.propTypes = {
  name: _react.PropTypes.string.isRequired,
  url: _react.PropTypes.string.isRequired
};

exports.default = GetACopyLink;

},{"react":"react"}],69:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _get_a_copy_link = require("./get_a_copy_link");

var _get_a_copy_link2 = _interopRequireDefault(_get_a_copy_link);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlideButton = function GlideButton(_ref) {
  var price = _ref.price;
  var url = _ref.url;
  var bookId = _ref.bookId;

  function handleClick() {
    (0, _ajax_helper.httpPost)("/track/track_clickstream", {
      data: {
        hit_type: "actionOnly",
        action_type: "bb_click-amazon"
      }
    });
  }
  return _jsx("div", {
    onClick: handleClick
  }, void 0, _jsx(_get_a_copy_link2.default, {
    name: "Kindle Store " + price,
    url: url
  }));
};

GlideButton.propTypes = {
  price: _react.PropTypes.string.isRequired,
  url: _react.PropTypes.string.isRequired,
  bookId: _react.PropTypes.string.isRequired
};

exports.default = GlideButton;

},{"../../modules/ajax/ajax_helper":4,"./get_a_copy_link":68,"react":"react"}],70:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*doc
---
title: Click Tracking Wrapper
name: click_tracking_wrapper
category: React
---

Wrappers an object in order to attach click tracking options to component

See also [tracking_data_attributes_mixin].

You can pass in children such as links or buttons that will report to dfp and pmet.

```rails_example
<%= react_component 'ReactComponents.StyleGuideExampleComponentWrapper',
                        componentName: 'ReactComponents.ClickTrackingWrapper',
                        propsToEval: {
                          children: "React.createElement('a', {href: '#'}, 'Random author name');"
                        },
                        trackingOptions: {
                          dfp: true,
                          pmet: {
                            click_type: "author_name"
                          }
                        }
                    %>
```
*/
exports.default = _gr_component_factory2.default.createClass({
  displayName: "ClickTrackingWrapper",

  propTypes: {
    trackingOptions: _react2.default.PropTypes.shape({
      dfp: _react2.default.PropTypes.bool,
      pmet: _react2.default.PropTypes.object.isRequired
    }).isRequired,
    children: _react2.default.PropTypes.element.isRequired
  },

  render: function render() {
    return this.props.children;
  }
});

},{"./gr_component_factory":87,"react":"react"}],71:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _image_registry = require("../modules/shared/image_registry");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _close_button_values = require("../modules/close_button_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CloseButton",

  propTypes: {
    action: _react2.default.PropTypes.func.isRequired,
    variant: _react2.default.PropTypes.oneOf([_close_button_values.VARIANTS.DEFAULT, _close_button_values.VARIANTS.DARK_BG])
  },

  getDefaultProps: function getDefaultProps() {
    return { variant: _close_button_values.VARIANTS.DEFAULT };
  },
  render: function render() {
    var cx = (0, _classnames2.default)("gr-iconButton", this.props.className);
    var buttonImage = undefined;
    if (this.props.variant === _close_button_values.VARIANTS.DARK_BG) {
      buttonImage = (0, _image_registry.getImages)().closeIcons.darkBackground;
    } else {
      buttonImage = (0, _image_registry.getImages)().closeIcon;
    }
    return _jsx("button", {
      type: "button",
      className: cx,
      onClick: this.props.action
    }, void 0, _jsx("img", {
      alt: "Dismiss",
      src: buttonImage
    }));
  }
});

},{"../modules/close_button_values":9,"../modules/shared/image_registry":17,"./gr_component_factory":87,"classnames":"classnames","react":"react"}],72:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This component renders a line of basic book details/stats.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             The component always includes an average star rating,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             and optionally includes avg rating text, ratings count,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             text reviews count, publication date, and editions count.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _dot_separated_elements = require("./dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
var MAX_RATING = 5;
exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommunityRating",

  statics: {
    ICON_SIZES: ICON_SIZES
  },
  propTypes: {
    rating: _react2.default.PropTypes.number.isRequired,
    size: _react2.default.PropTypes.oneOf([ICON_SIZES.SMALL, ICON_SIZES.MEDIUM, ICON_SIZES.LARGE]),
    displayAvg: _react2.default.PropTypes.bool,
    displayAvgRatingText: _react2.default.PropTypes.bool,
    ratingsCount: _react2.default.PropTypes.number,
    textReviewsCount: _react2.default.PropTypes.number,
    publication: _react2.default.PropTypes.shape({
      toBePublished: _react2.default.PropTypes.bool,
      date: _react2.default.PropTypes.string
    }),
    editions: _react2.default.PropTypes.shape({
      countString: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string
    }),
    className: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      displayAvg: false,
      size: ICON_SIZES.SMALL
    };
  },
  wrapperClasses: function wrapperClasses() {
    return (0, _classnames2.default)("communityRating__starsWrapper", {
      "communityRating__starsWrapper--small": this.props.size === ICON_SIZES.SMALL,
      "communityRating__starsWrapper--medium": this.props.size === ICON_SIZES.MEDIUM,
      "communityRating__starsWrapper--large": this.props.size === ICON_SIZES.LARGE
    });
  },
  starClasses: function starClasses() {
    return (0, _classnames2.default)("communityRating__stars", {
      "communityRating__stars--small": this.props.size === ICON_SIZES.SMALL,
      "communityRating__stars--medium": this.props.size === ICON_SIZES.MEDIUM,
      "communityRating__stars--large": this.props.size === ICON_SIZES.LARGE
    });
  },

  // Emulate behavior in application_helper.rb, adjusted for SVG sizing
  getRoundedRating: function getRoundedRating(rating) {
    var flooredRating = Math.floor(rating);
    if (rating === flooredRating) {
      return rating;
    }
    if (rating - flooredRating < 0.5) {
      return flooredRating + 0.45;
    } else {
      return flooredRating + 0.6;
    }
  },
  renderRating: function renderRating() {
    var roundedRating = this.getRoundedRating(this.props.rating);
    var starsStyle = {
      width: roundedRating / MAX_RATING * 100 + "%"
    };
    var ratingStarsLabel = "Rated " + this.props.rating.toFixed(2) + " of " + MAX_RATING;

    var displayAvgRatingText = this.props.displayAvgRatingText === null ? this.props.displayAvg : this.props.displayAvgRatingText;

    return _jsx("span", {}, void 0, _jsx("div", {
      className: this.wrapperClasses()
    }, void 0, _jsx("div", {
      className: this.starClasses(),
      style: starsStyle,
      "aria-label": ratingStarsLabel
    })), this.props.displayAvg ? _jsx("span", {
      className: "gr-metaText"
    }, void 0, this.props.rating.toFixed(2), displayAvgRatingText ? " avg. rating" : "") : null);
  },
  renderRatingsCount: function renderRatingsCount() {
    return _jsx("span", {
      className: "gr-metaText u-inlineBlock"
    }, void 0, this.props.ratingsCount.toLocaleString(), " Ratings");
  },
  renderTextReviewsCount: function renderTextReviewsCount() {
    return _jsx("span", {
      className: "gr-metaText u-inlineBlock"
    }, void 0, this.props.textReviewsCount.toLocaleString(), " Reviews");
  },
  renderPublicationDate: function renderPublicationDate() {
    return _jsx("span", {
      className: "gr-metaText u-inlineBlock"
    }, void 0, (this.props.publication.toBePublished ? "expected publication" : "published") + " " + this.props.publication.date);
  },
  renderEditionsCount: function renderEditionsCount() {
    return _jsx("span", {
      className: "gr-metaText"
    }, void 0, _jsx("a", {
      className: "gr-hyperlink gr-hyperlink--naked u-inlineBlock",
      href: this.props.editions.url
    }, void 0, this.props.editions.countString));
  },
  render: function render() {
    var ratingClassName = (0, _classnames2.default)("communityRating", this.props.className);
    var ratingStarsLabel = "Rated " + this.props.rating.toFixed(2) + " of " + MAX_RATING;

    var elements = [this.renderRating()];

    if (this.props.ratingsCount) {
      elements.push(this.renderRatingsCount());
    }

    if (this.props.textReviewsCount) {
      elements.push(this.renderTextReviewsCount());
    }

    if (this.props.publication && this.props.publication.date) {
      elements.push(this.renderPublicationDate());
    }

    if (this.props.editions && this.props.editions.countString) {
      elements.push(this.renderEditionsCount());
    }

    return _jsx("div", {
      className: ratingClassName,
      "aria-label": ratingStarsLabel
    }, void 0, _jsx(_dot_separated_elements2.default, {
      elements: elements
    }));
  }
});

},{"./dot_separated_elements":73,"./gr_component_factory":87,"classnames":"classnames","react":"react"}],73:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "DotSeparatedElements",

  propTypes: {
    elements: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.element, _react2.default.PropTypes.string])).isRequired,
    separator: _react2.default.PropTypes.element
  },

  getDefaultProps: function getDefaultProps() {
    return {
      separator: _jsx("span", {}, void 0, " · ")
    };
  },
  joinElementsWithSeparator: function joinElementsWithSeparator() {
    var _this = this;

    var elements = (0, _lodash.compact)(this.props.elements);
    return (0, _lodash.transform)(elements, function (result, element, index) {
      result.push(element);
      if (index + 1 !== elements.length) {
        result.push(_this.props.separator);
      }
    });
  },
  render: function render() {
    return _jsx("span", {
      className: this.props.className
    }, void 0, (0, _lodash.map)(this.joinElementsWithSeparator(), function (element, index) {
      return _jsx("span", {}, index, element);
    }));
  }
});

},{"./gr_component_factory":87,"lodash":"lodash","react":"react"}],74:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Drop Down List
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: drop_down_list
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This is a basic menu list component that will take in arbitrary component
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           children and display them in a list view. If the number of children is > the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           passed in maxListItems prop, the children will be appropriately truncated, and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           a "More" link will appear that will link to a passed in moreURL prop.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           PROPS:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           OPTIONAL - moreLinkURL - url for the "More" link to redirect to. Does not display
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    the "More" link if no URL is passed in.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      moreLinkText - display text for the link. Defaults to "More"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "DropDownList",

  propTypes: {
    showMoreLink: _react2.default.PropTypes.bool,
    moreLinkURL: _react2.default.PropTypes.string,
    moreLinkText: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return { showMoreLink: false,
      moreLinkURL: null,
      moreLinkText: "…More" };
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.props.children, this.props.showMoreLink && this.props.moreLinkURL !== null ? _jsx("a", {
      className: "dropDownList__listItem--moreLink",
      href: this.props.moreLinkURL
    }, void 0, this.props.moreLinkText) : null);
  }
});

},{"./gr_component_factory":87,"react":"react"}],75:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Dropdown
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: dropdown
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           A dropdown component. Includes a trigger and content area.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           NOTE: We tried to make Dropdown a single reusable component for anything with
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           dropdown-style interaction. Unfortunately, because of special styling and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           interaction cases (e.g., navbar menus, "want to read" button),
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           it ended up a giant pile of special cases and logic forks. It's now an unwieldy mess.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           PROPS:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           REQUIRED - trigger: element that will trigger the dropdown to open
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      triggerEventType: the event that will open the dropdown (e.g. click, hover)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Note: On touch devices the component will render as if you
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        had specified triggerEventType of "click"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           OPTIONAL - tooltipText: text to render as a `title` attribute on the trigger
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   element
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```rails_example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           <%= react_component 'ReactComponents.Dropdown',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   trigger: 'Browse ▾',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   triggerEventType: 'hover',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   children: 'Link item one' } %>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

/* react-onclickoutside is a deprecated package that should not be used for new
   code. Instead of having an outside click close a module, there should be an
   explicit close affordances in the spec. */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _hover_intent = require("../react_mixins/hover_intent");

var _hover_intent2 = _interopRequireDefault(_hover_intent);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _keys = require("../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _user_agent_capabilities_store = require("../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _touch_not_ready_helper = require("../modules/shared/touch_not_ready_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TriggerEventTypes = {
  HOVER: "hover",
  CLICK: "click"
};

var alignments = {
  LEFT: "left",
  RIGHT: "right"
};

var mouseOverDelay = 100;
var mouseOutDelay = mouseOverDelay;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Dropdown",

  mixins: [_hover_intent2.default, _reactOnclickoutside2.default, _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  propTypes: {
    alignment: _react2.default.PropTypes.oneOf(_lodash2.default.values(alignments)),
    fallbackUrl: _react2.default.PropTypes.string,
    onShowCallback: _react2.default.PropTypes.func,
    tooltipText: _react2.default.PropTypes.string,
    trigger: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element]).isRequired,
    triggerEventType: _react2.default.PropTypes.oneOf(_lodash2.default.values(TriggerEventTypes))
  },

  statics: {
    TriggerEventTypes: TriggerEventTypes
  },

  getTriggerEventType: function getTriggerEventType() {
    if (this.state.userAgentCapabilities.touch) {
      return TriggerEventTypes.CLICK;
    }
    return this.props.triggerEventType;
  },
  getInitialState: function getInitialState() {
    return {
      dropdownOpen: false
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      triggerEventType: TriggerEventTypes.CLICK,
      alignment: alignments.LEFT
    };
  },
  hide: function hide() {
    this.setState({ dropdownOpen: false });
  },
  show: function show() {
    this.setState({ dropdownOpen: true });
    if (this.props.onShowCallback) {
      this.props.onShowCallback();
    }
  },
  toggle: function toggle(ev) {
    if (this.props.children) {
      ev.preventDefault();
    }
    this.state.dropdownOpen ? this.hide() : this.show();
  },
  openList: function openList(ev) {
    if (_keys2.default.isDropdownOpenerKey(ev.keyCode)) {
      ev.preventDefault();
      if (_keys2.default.isArrowDown(ev.keyCode)) {
        this.show();
      } else {
        this.toggle(ev);
      }
    } else if (_keys2.default.isDefaultCloserKey(ev.keyCode)) {
      ev.preventDefault();
      this.hide();
    }
  },
  handleClickOutside: function handleClickOutside() {
    // On touch devices that display dropdown components, touch gestures such as
    // panning and zooming trigger this event listener. We disabled hiding in
    // this listener for touch devices because hiding the dropdown on touch
    // gestures is disruptive.
    if (!this.state.userAgentCapabilities.touch) {
      this.hide();
    }
  },
  handleMouseEnter: function handleMouseEnter() {
    this.onEnterIntent(this.show, mouseOverDelay);
  },
  handleMouseLeave: function handleMouseLeave() {
    this.onLeaveIntent(this.hide, mouseOutDelay);
  },
  handleTriggerClick: function handleTriggerClick(event) {
    (0, _touch_not_ready_helper.acknowledgeEvent)(event);
    // After hovering to open the dropdown, don't close on click
    if (this.state.dropdownOpen && this.props.triggerEventType === TriggerEventTypes.HOVER && this.state.userAgentCapabilities.touch !== true) {
      event.preventDefault();
      return;
    } else {
      this.toggle(event);
    }
  },
  triggerClasses: function triggerClasses() {
    return (0, _classnames2.default)(this.withBemModifiers(["dropdown__trigger"]), { "dropdown__trigger--buttonReset": _lodash2.default.isUndefined(this.props.fallbackUrl) }, { "dropdown__trigger--triggerEventTypeHover": this.props.triggerEventType === TriggerEventTypes.HOVER }, { "dropdown__trigger--personalNav": this.props.isInPersonalNav === "true" }, { "dropdown__trigger--personalNavActive": this.props.isInPersonalNav === "true" && this.state.dropdownOpen });
  },
  renderTriggerButton: function renderTriggerButton() {
    return _jsx("button", {
      className: this.triggerClasses(),
      "aria-haspopup": "true",
      "aria-expanded": this.state.dropdownOpen,
      onClick: this.handleTriggerClick,
      onKeyDown: this.openList,
      title: this.props.tooltipText,
      "data-ux-click": this.props.isInPersonalNav === "true"
    }, void 0, this.props.trigger);
  },
  renderTriggerLink: function renderTriggerLink() {
    return _jsx("a", {
      className: this.triggerClasses(),
      href: this.props.fallbackUrl,
      onClick: this.handleTriggerClick,
      onKeyDown: this.openList,
      role: "button",
      "aria-haspopup": "true",
      "aria-expanded": this.state.dropdownOpen,
      title: this.props.tooltipText,
      "data-ux-click": this.props.isInPersonalNav === "true"
    }, void 0, this.props.trigger);
  },
  render: function render() {
    var dropdownClasses = (0, _classnames2.default)(this.withBemModifiers("dropdown"));
    var dropdownShowOption = this.props.bemModifiers === "authorModule" || this.props.bemModifiers === "friendFollowModuleMobile" ? { "dropdown__menu--showMobile": this.state.dropdownOpen } : { "dropdown__menu--show": this.state.dropdownOpen };
    var dropdownContentsClasses = (0, _classnames2.default)(this.withBemModifiers("dropdown__menu"), "gr-box gr-box--withShadowLarge", dropdownShowOption);
    var trigger = _lodash2.default.isUndefined(this.props.fallbackUrl) ? this.renderTriggerButton() : this.renderTriggerLink();
    var dropdownContents = _jsx("div", {
      className: dropdownContentsClasses,
      role: "menu"
    }, void 0, this.props.children);

    switch (this.getTriggerEventType()) {
      case TriggerEventTypes.HOVER:
        return _jsx("div", {
          className: dropdownClasses,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        }, void 0, trigger, dropdownContents);
      case TriggerEventTypes.CLICK:
        return _jsx("div", {
          className: dropdownClasses
        }, void 0, trigger, dropdownContents);
    }
  }
});

},{"../modules/keys":15,"../modules/shared/touch_not_ready_helper":18,"../react_mixins/hover_intent":186,"../react_stores/user_agent_capabilities_store":203,"./gr_component_factory":87,"classnames":"classnames","lodash":"lodash","react":"react","react-onclickoutside":"react-onclickoutside","reflux":"reflux"}],76:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: "error_message.js",

  propTypes: {
    componentName: _react2.default.PropTypes.string.isRequired
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-errorMessage"
    }, void 0, "There was an issue rendering ", this.props.componentName);
  }
});

},{"react":"react"}],77:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _genre_checkbox = require("./genre_checkbox");

var _genre_checkbox2 = _interopRequireDefault(_genre_checkbox);

var _modal_actions = require("./../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _favorite_genres_form_actions = require("../react_actions/favorite_genres_form_actions");

var _favorite_genres_form_actions2 = _interopRequireDefault(_favorite_genres_form_actions);

var _favorite_genres_form_store = require("../react_stores/favorite_genres_form_store");

var _favorite_genres_form_store2 = _interopRequireDefault(_favorite_genres_form_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FavoriteGenresForm",

  mixins: [_reflux2.default.connect(_favorite_genres_form_store2.default, "favoriteGenresFormStore")],

  propTypes: {
    favoriteGenres: _react2.default.PropTypes.array,
    genres: _react2.default.PropTypes.array.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      favoriteGenres: []
    };
  },
  onSubmit: function onSubmit(event) {
    _favorite_genres_form_actions2.default.submitSelectedGenres();
    _modal_actions2.default.closeModal();
    event.preventDefault();
  },
  renderGenreCheckboxes: function renderGenreCheckboxes() {
    var _this = this;

    return _jsx("div", {
      className: "gr-genresForm__checkBoxes"
    }, void 0, _lodash2.default.map(this.props.genres, function (genre) {
      return _jsx(_genre_checkbox2.default, {
        genre: genre.name,
        isFavorited: _lodash2.default.includes(_this.state.favoriteGenresFormStore.selectedGenres, genre.name)
      }, genre.name);
    }));
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-genresForm"
    }, void 0, _jsx("div", {
      className: "gr-genresForm__title"
    }, void 0, "Follow Your Favorite Genres"), _jsx("div", {
      className: "gr-genresForm__description"
    }, void 0, "We use your favorite genres to make better book recommendations and tailor what you see in your Updates feed."), _jsx("form", {
      action: "/user/edit_fav_genres",
      "data-remote": "true",
      method: "post"
    }, void 0, this.renderGenreCheckboxes(), _jsx("button", {
      type: "submit",
      onClick: this.onSubmit,
      className: "gr-button gr-button--large"
    }, void 0, "Save")));
  }
});

},{"../react_actions/favorite_genres_form_actions":26,"../react_stores/favorite_genres_form_store":193,"./../react_actions/modal_actions":30,"./genre_checkbox":86,"./gr_component_factory":87,"lodash":"lodash","react":"react","reflux":"reflux"}],78:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _dot_separated_elements = require("./dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var READ_MORE = "Read More";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedContentBlog",
  propTypes: {
    blog: _react2.default.PropTypes.shape({
      likeCount: _react2.default.PropTypes.number.isRequired,
      commentCount: _react2.default.PropTypes.number.isRequired,
      imageUrl: _react2.default.PropTypes.string.isRequired,
      blogUrl: _react2.default.PropTypes.string.isRequired,
      title: _react2.default.PropTypes.string.isRequired
    }).isRequired,
    isMobile: _react2.default.PropTypes.bool,
    isInline: _react2.default.PropTypes.bool
  },

  defaultProps: {
    isMobile: false,
    isInline: false
  },

  renderImage: function renderImage() {
    var linkClassName = (0, _classnames2.default)("featuredContentImageBody__imageLink", {
      "featuredContentImageBody__imageLink--inline": this.props.isInline
    });
    var imageClassName = (0, _classnames2.default)("featuredContentImageBody__image", {
      featuredContentImageBody__imageMobile: this.props.isMobile
    });
    if (this.props.blog.imageUrl) {
      var bodyImage = _jsx("a", {
        className: linkClassName,
        href: this.props.blog.blogUrl
      }, void 0, _jsx("img", {
        className: imageClassName,
        src: this.props.blog.imageUrl,
        alt: "" + this.props.blog.title
      }));
      return _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_blog_image,
        children: bodyImage
      });
    } else {
      return null;
    }
  },
  renderTitle: function renderTitle() {
    var titleClass = (0, _classnames2.default)("featuredContentImageBody__title", {
      "featuredContentImageBody__title--mobile": this.props.isMobile,
      "featuredContentImageBody__title--inline": this.props.isInline
    });
    var titleLink = _jsx("a", {
      href: this.props.blog.blogUrl,
      className: titleClass
    }, void 0, this.props.blog.title);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_blog_title,
      children: titleLink
    });
  },
  renderLikesText: function renderLikesText(text) {
    return _jsx("span", {
      className: "gr-metaText featuredContentImageBody__likes"
    }, void 0, text, " likes");
  },
  renderCommentsText: function renderCommentsText(text) {
    return _jsx("span", {
      className: "gr-metaText featuredContentImageBody__comments"
    }, void 0, text, " comments");
  },
  renderReadMore: function renderReadMore() {
    var readMoreClassName = (0, _classnames2.default)("gr-button", "featuredContentImageBody__button", {
      "featuredContentImageBody__button--mobile": this.props.isMobile,
      "featuredContentImageBody__button--inline": this.props.isInline
    });
    var readMore = _jsx("a", {
      href: this.props.blog.blogUrl,
      className: readMoreClassName
    }, void 0, READ_MORE);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_blog_button,
      children: readMore
    });
  },
  renderLikesAndComments: function renderLikesAndComments() {
    return _jsx("div", {
      className: "featuredContentImageBody__likesAndComments"
    }, void 0, this.renderLikesAndCommentsText());
  },
  renderLikesAndCommentsText: function renderLikesAndCommentsText() {
    var blog = this.props.blog;
    var likesText = this.renderLikesText(blog.likeCount);
    var commentsText = this.renderCommentsText(blog.commentCount);
    if (blog.likeCount && blog.commentCount) {
      return _jsx(_dot_separated_elements2.default, {
        elements: [likesText, commentsText]
      });
    } else if (blog.likeCount) {
      return likesText;
    } else if (blog.commentCount) {
      return commentsText;
    } else {
      return null;
    }
  },
  render: function render() {
    if (this.props.isInline) {
      return _jsx("div", {
        className: "featuredContentImageBody--inline genreFeatureContainer"
      }, void 0, this.renderImage(), _jsx("div", {}, void 0, this.renderTitle(), this.renderLikesAndComments(), this.renderReadMore()));
    } else {
      return _jsx("div", {
        className: "featuredContentImageBody genreFeatureContainer"
      }, void 0, this.renderTitle(), this.renderImage(), this.renderLikesAndComments(), this.renderReadMore());
    }
  }
});

},{"../modules/ads/click_tracking_helper":2,"./click_tracking_wrapper":70,"./dot_separated_elements":73,"./gr_component_factory":87,"classnames":"classnames","react":"react"}],79:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _book = require("./book");

var _book2 = _interopRequireDefault(_book);

var _book_description = require("./book_description");

var _book_description2 = _interopRequireDefault(_book_description);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedContentBook",
  propTypes: {
    book: _react2.default.PropTypes.object.isRequired,
    isMobile: _react2.default.PropTypes.bool,
    isInline: _react2.default.PropTypes.bool
  },

  defaultProps: {
    isMobile: false,
    isInline: false
  },

  renderImage: function renderImage() {
    var bookImage = _jsx("img", {
      alt: this.props.book.title,
      src: this.props.book.imageUrl,
      className: (0, _classnames2.default)("featuredContentBook__imageMobile")
    });
    var bodyImage = _jsx("a", {
      href: this.props.book.bookCoverUrl || this.props.book.bookUrl,
      className: (0, _classnames2.default)("featuredContentBook__imageLinkMobile")
    }, void 0, bookImage);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_book_image,
      children: bodyImage
    });
  },
  renderDescription: function renderDescription() {
    if (this.props.book.description) {
      return _jsx(_book_description2.default, {
        bookDescription: this.props.book.description,
        className: (0, _classnames2.default)("featuredContentBook__description"),
        bookDescriptionTargetingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_book_description
      });
    } else {
      return null;
    }
  },
  renderLearnMore: function renderLearnMore() {
    var classesObject = (0, _classnames2.default)("gr-button", "featuredContentBook__button", {
      "featuredContentBook__button--mobile": this.props.isMobile,
      "featuredContentBook__button--inline": this.props.isInline
    });
    var learnMore = _jsx("a", {
      href: this.props.book.bookUrl,
      className: classesObject
    }, void 0, "Learn more");
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_book_button,
      children: learnMore
    });
  },
  render: function render() {
    if (this.props.isMobile) {
      return _jsx("div", {
        className: (0, _classnames2.default)("featuredContentBook", "featuredContentBook--mobile")
      }, void 0, this.renderImage(), this.renderDescription(), this.renderLearnMore());
    } else {
      return _jsx("div", {
        className: "featuredContentBook"
      }, void 0, _react2.default.createElement(
        _book2.default,
        _extends({}, this.props.book, {
          bookImageTrackingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_book_image,
          bookTitleTrackingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_book_title,
          authorLinkTrackingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_book_author }),
        this.renderDescription(),
        this.renderLearnMore()
      ));
    }
  }
});

},{"../modules/ads/click_tracking_helper":2,"./book":61,"./book_description":63,"./click_tracking_wrapper":70,"./gr_component_factory":87,"classnames":"classnames","react":"react"}],80:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LEARN_MORE = "Learn More";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedContentGenre",
  propTypes: {
    genre: _react2.default.PropTypes.shape({
      imageUrl: _react2.default.PropTypes.string.isRequired,
      genreUrl: _react2.default.PropTypes.string.isRequired,
      tagline: _react2.default.PropTypes.string.isRequired
    }).isRequired,
    isMobile: _react2.default.PropTypes.bool,
    isInline: _react2.default.PropTypes.bool
  },

  defaultProps: {
    isMobile: false,
    isInline: false
  },

  renderImage: function renderImage() {
    var imageClassName = (0, _classnames2.default)("featuredContentImageBody__image", {
      featuredContentImageBody__imageMobile: this.props.isMobile
    });
    var linkClassName = (0, _classnames2.default)("featuredContentImageBody__imageLink", {
      "featuredContentImageBody__imageLink--inline": this.props.isInline
    });
    if (this.props.genre.imageUrl) {
      var bodyImage = _jsx("a", {
        className: linkClassName,
        href: this.props.genre.genreUrl
      }, void 0, _jsx("img", {
        className: imageClassName,
        src: this.props.genre.imageUrl,
        alt: "" + this.props.genre.tagline
      }));
      return _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_genre_image,
        children: bodyImage
      });
    } else {
      return null;
    }
  },
  renderTitle: function renderTitle() {
    var titleClass = this.props.isMobile ? (0, _classnames2.default)("featuredContentImageBody__title", "featuredContentImageBody__title--mobile") : "featuredContentImageBody__title";
    var titleLink = _jsx("a", {
      href: this.props.genre.genreUrl,
      className: titleClass
    }, void 0, this.props.genre.tagline);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_genre_title,
      children: titleLink
    });
  },
  renderCTAButton: function renderCTAButton() {
    var ctaLinkClassNames = (0, _classnames2.default)("gr-button gr-microsite-link", { featuredContentImageBody__button: this.props.isMobile,
      "u-marginTopMedium": !this.props.isInline });
    var ctaLink = _jsx("a", {
      href: this.props.genre.genreUrl,
      className: ctaLinkClassNames
    }, void 0, LEARN_MORE);
    return _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_genre_button,
      children: ctaLink
    });
  },
  render: function render() {
    if (this.props.isInline) {
      return _jsx("div", {
        className: "featuredContentImageBody--inline genreFeatureContainer"
      }, void 0, this.renderImage(), _jsx("div", {}, void 0, this.renderTitle(), this.renderCTAButton()));
    } else {
      return _jsx("div", {
        className: "featuredContentImageBody genreFeatureContainer"
      }, void 0, this.renderTitle(), this.renderImage(), this.props.isMobile ? this.renderCTAButton() : null);
    }
  }
});

},{"../modules/ads/click_tracking_helper":2,"./click_tracking_wrapper":70,"./gr_component_factory":87,"classnames":"classnames","react":"react"}],81:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _book = require("./book");

var _book2 = _interopRequireDefault(_book);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _relative_time = require("./time/relative_time");

var _relative_time2 = _interopRequireDefault(_relative_time);

var _expandable_html = require("./user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedContentGiveaway",
  propTypes: {
    giveaway: _react2.default.PropTypes.shape({
      book: _react2.default.PropTypes.object.isRequired,
      description: _gr_prop_types2.default.expandableHtml().isRequired,
      endAt: _react2.default.PropTypes.string.isRequired,
      giveawayUrl: _react2.default.PropTypes.string.isRequired
    }).isRequired,
    isMobile: _react2.default.PropTypes.bool
  },

  defaultProps: {
    isMobile: false
  },

  render: function render() {
    var giveaway = this.props.giveaway;
    return _jsx("div", {
      className: "featuredContentGiveaway"
    }, void 0, _react2.default.createElement(
      _book2.default,
      _extends({}, giveaway.book, { bookImageTrackingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_giveaway_image,
        bookTitleTrackingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_giveaway_title,
        authorLinkTrackingData: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_giveaway_author,
        bemModifiers: this.props.isMobile ? "mobile" : "" }),
      _react2.default.createElement(_expandable_html2.default, _extends({}, giveaway.description, { className: "featuredContentGiveaway__description" })),
      _jsx("div", {
        className: "featuredContentGiveaway__expiration gr-metaText"
      }, void 0, "Ends ", _jsx(_relative_time2.default, {
        time: giveaway.endAt,
        longFormat: true
      })),
      _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_giveaway_button
      }, void 0, _jsx("a", {
        href: giveaway.giveawayUrl,
        className: "gr-button"
      }, void 0, "Learn more"))
    ));
  }
});

},{"../modules/ads/click_tracking_helper":2,"./book":61,"./click_tracking_wrapper":70,"./gr_component_factory":87,"./shared/gr_prop_types":146,"./time/relative_time":166,"./user_content/expandable_html":169,"react":"react"}],82:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedContentList",
  propTypes: {
    list: _react2.default.PropTypes.shape({
      listUrl: _react2.default.PropTypes.string.isRequired,
      title: _react2.default.PropTypes.string.isRequired,
      topBooksCovers: _react2.default.PropTypes.array.isRequired
    }).isRequired,
    isMobile: _react2.default.PropTypes.bool,
    isInline: _react2.default.PropTypes.bool
  },

  defaultProps: {
    isMobile: false,
    isInline: false
  },

  renderBookCovers: function renderBookCovers() {
    var _this = this;

    var bookCoverImageClassName = this.props.isMobile ? "featuredContentList__bookCoverImage--allowOverlap" : "featuredContentList__bookCoverImage--noOverlap";
    var bookCoverClassName = (0, _classnames2.default)("featuredContentList__bookCovers", { "featuredContentList__bookCovers--inline": this.props.isInline });

    return _jsx("div", {
      className: bookCoverClassName
    }, void 0, _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_list_books
    }, void 0, _jsx("a", {
      href: this.props.list.listUrl
    }, void 0, (0, _lodash.map)(this.props.list.topBooksCovers, function (bookCoverUrl) {
      return _jsx("div", {
        className: "featuredContentList__bookCoverContainer"
      }, bookCoverUrl, _jsx("img", {
        src: bookCoverUrl,
        alt: _this.props.list.title,
        className: bookCoverImageClassName
      }));
    }))));
  },
  renderCTA: function renderCTA() {
    if (this.props.isMobile) {
      return _jsx(_click_tracking_wrapper2.default, {
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_list_button
      }, void 0, _jsx("a", {
        className: "gr-button gr-button--fullWidth u-marginBottomSmall u-marginTopSmall",
        href: this.props.list.listUrl
      }, void 0, "View list"));
    } else {
      return null;
    }
  },
  render: function render() {
    var list = this.props.list;
    var fcmListClassNames = (0, _classnames2.default)("featuredContentList", { "featuredContentList--inline": this.props.isInline });
    var fcmListTitleClassNames = (0, _classnames2.default)("u-bold featuredContentList__title", { "featuredContentList__title--inline": this.props.isInline });
    var fcmListDetailsContainerClassNames = (0, _classnames2.default)("u-bold featuredContentList__listDetailsContainer", { "featuredContentList__listDetailsContainer--inline": this.props.isInline });
    var fcmListDetailsClassNames = (0, _classnames2.default)("u-bold featuredContentList__listDetails", { "featuredContentList__listDetails--inline": this.props.isInline });
    return _jsx("div", {
      className: fcmListClassNames
    }, void 0, this.renderBookCovers(), _jsx(_click_tracking_wrapper2.default, {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES_PREMIUM_CAMPAIGN.fcm_list_title
    }, void 0, _jsx("a", {
      href: list.listUrl,
      className: fcmListTitleClassNames
    }, void 0, list.title)), _jsx("div", {
      className: fcmListDetailsContainerClassNames
    }, void 0, _jsx("div", {
      className: fcmListDetailsClassNames
    }, void 0, list.numBooks.toLocaleString(), " books · ", list.numVoters.toLocaleString(), " voters")), this.renderCTA());
  }
});

},{"../modules/ads/click_tracking_helper":2,"./click_tracking_wrapper":70,"./gr_component_factory":87,"classnames":"classnames","lodash":"lodash","react":"react"}],83:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _featured_content_blog = require("./featured_content_blog");

var _featured_content_blog2 = _interopRequireDefault(_featured_content_blog);

var _featured_content_book = require("./featured_content_book");

var _featured_content_book2 = _interopRequireDefault(_featured_content_book);

var _featured_content_list = require("./featured_content_list");

var _featured_content_list2 = _interopRequireDefault(_featured_content_list);

var _featured_content_genre = require("./featured_content_genre");

var _featured_content_genre2 = _interopRequireDefault(_featured_content_genre);

var _featured_content_giveaway = require("./featured_content_giveaway");

var _featured_content_giveaway2 = _interopRequireDefault(_featured_content_giveaway);

var _sponsored_footer = require("./sponsored_footer");

var _sponsored_footer2 = _interopRequireDefault(_sponsored_footer);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedContentModule",
  propTypes: {
    type: _react2.default.PropTypes.string.isRequired,
    resource: _react2.default.PropTypes.object.isRequired,
    sponsorName: _react2.default.PropTypes.string,
    isSponsored: _react2.default.PropTypes.bool,
    isMobile: _react2.default.PropTypes.bool,
    hasBottomBorder: _react2.default.PropTypes.bool,
    isInline: _react2.default.PropTypes.bool
  },

  defaultProps: {
    isMobile: false,
    isInline: false,
    hasBottomBorder: false
  },

  headerText: function headerText() {
    switch (this.props.type) {
      case "Blog":
        return "Featured Blog Post";
      case "Book":
        return "Featured Book";
      case "Giveaway":
        return "Featured Giveaway";
      case "List":
        return "Featured List";
      case "Genre":
        return "Featured Genre";
      default:
        return "Featured Content";
    }
  },
  renderContent: function renderContent() {
    switch (this.props.type) {
      case "Blog":
        return this.renderBlog();
      case "Book":
        return this.renderBook();
      case "Giveaway":
        return this.renderGiveaway();
      case "List":
        return this.renderList();
      case "Genre":
        return this.renderGenre();
      default:
        return null;
    }
  },
  renderHeader: function renderHeader() {
    if (this.props.isMobile) {
      return _jsx("h3", {
        className: "gr-h3"
      }, void 0, this.headerText());
    } else {
      var headerClassNames = (0, _classnames2.default)("featuredContentModule__header", {
        "featuredContentModule__header--inline": this.props.isInline
      });
      return _jsx("div", {
        className: headerClassNames
      }, void 0, this.headerText());
    }
  },
  renderFooter: function renderFooter() {
    if (this.props.isSponsored) {
      return _jsx(_sponsored_footer2.default, {
        isSponsored: true,
        sponsoredName: this.props.sponsorName
      });
    } else {
      return null;
    }
  },
  renderBlog: function renderBlog() {
    return _jsx(_featured_content_blog2.default, {
      blog: this.props.resource,
      isMobile: this.props.isMobile,
      isInline: this.props.isInline
    });
  },
  renderBook: function renderBook() {
    return _jsx(_featured_content_book2.default, {
      book: this.props.resource,
      isMobile: this.props.isMobile,
      isInline: this.props.isInline
    });
  },
  renderGiveaway: function renderGiveaway() {
    return _jsx(_featured_content_giveaway2.default, {
      giveaway: this.props.resource,
      isMobile: this.props.isMobile
    });
  },
  renderList: function renderList() {
    return _jsx(_featured_content_list2.default, {
      list: this.props.resource,
      isMobile: this.props.isMobile,
      isInline: this.props.isInline
    });
  },
  renderGenre: function renderGenre() {
    return _jsx(_featured_content_genre2.default, {
      genre: this.props.resource,
      isMobile: this.props.isMobile,
      isInline: this.props.isInline
    });
  },
  render: function render() {
    var moduleClasses = (0, _classnames2.default)("featuredContentModule", {
      "featuredContentModule--mobile": this.props.isMobile,
      "featuredContentModule--inline": this.props.isInline
    });
    var borderClass = "";
    if (this.props.isMobile) {
      if (this.props.hasBottomBorder) {
        borderClass = "featuredContentBorder__underline";
      } else {
        borderClass = "featuredContentBorder__overline";
      }
    }
    return _jsx("div", {
      className: borderClass
    }, void 0, _jsx("section", {
      className: moduleClasses
    }, void 0, this.renderHeader(), this.renderContent(), this.renderFooter()));
  }
});

},{"./featured_content_blog":78,"./featured_content_book":79,"./featured_content_genre":80,"./featured_content_giveaway":81,"./featured_content_list":82,"./gr_component_factory":87,"./sponsored_footer":162,"classnames":"classnames","react":"react"}],84:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _close_button = require("./close_button");

var _close_button2 = _interopRequireDefault(_close_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Should be kept in sync with ApplicationController::FLASH_MESSAGE_TYPES
var validCategories = {
  ERROR: "error",
  INFO: "info",
  NOTICE_DEPRECATED: "notice",
  SUCCESS: "success",
  WARNING: "warning"
};

exports.default = _react2.default.createClass({
  displayName: "FlashMessage",
  propTypes: {
    category: _react2.default.PropTypes.oneOf((0, _lodash.values)(validCategories)),
    message: _react2.default.PropTypes.string.isRequired,
    dismissable: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      undismissable: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      isVisible: true
    };
  },
  componentDidMount: function componentDidMount() {
    // Set focus to the flash message when it mounts so VoiceOver announces it
    if (this.state.isVisible && this.flashMessageRef) {
      this.flashMessageRef.focus();
    }
  },
  hideMessage: function hideMessage() {
    this.setState({ isVisible: false });
  },
  flashMessageMarkup: function flashMessageMarkup() {
    return { __html: this.props.message };
  },
  renderCloseButton: function renderCloseButton() {
    if (!this.props.undismissable) {
      return _jsx(_close_button2.default, {
        action: this.hideMessage,
        className: "gr-flashMessage__dismissButton"
      });
    }
  },
  render: function render() {
    var _this = this;

    var _props = this.props;
    var category = _props.category;
    var message = _props.message;

    var props = _objectWithoutProperties(_props, ["category", "message"]);

    if (!(0, _lodash.isEmpty)(this.props.message)) {
      var cx = (0, _classnames2.default)("gr-flashMessage", {
        "gr-flashMessage--dismissed": !this.state.isVisible,
        "gr-flashMessage--error": category === validCategories.ERROR,
        "gr-flashMessage--info": category === validCategories.INFO,
        "gr-flashMessage--warning": category === validCategories.WARNING,
        "gr-flashMessage--success": category === validCategories.SUCCESS
      });

      return _react2.default.createElement(
        "div",
        { className: cx,
          role: "alert",
          tabIndex: -1,
          ref: function ref(_ref) {
            _this.flashMessageRef = _ref;
          } },
        _jsx("span", {
          dangerouslySetInnerHTML: this.flashMessageMarkup()
        }),
        this.renderCloseButton()
      );
    } else {
      return null;
    }
  }
});

},{"./close_button":71,"classnames":"classnames","lodash":"lodash","react":"react"}],85:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _appendQuery = require("append-query");

var _appendQuery2 = _interopRequireDefault(_appendQuery);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _pagination_links = require("./pagination_links");

var _pagination_links2 = _interopRequireDefault(_pagination_links);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FullPagePaginationControls",

  propTypes: {
    currentPageNumber: _react2.default.PropTypes.number.isRequired,
    numWorks: _gr_prop_types2.default.naturalNumber.isRequired,
    perPage: _gr_prop_types2.default.naturalNumber.isRequired
  },

  goToPage: function goToPage(destinationPage) {
    window.location.href = (0, _appendQuery2.default)(window.location.href, {
      page: destinationPage,
      per_page: this.props.perPage
    });
  },
  render: function render() {
    return _jsx(_pagination_links2.default, {
      asButtons: true,
      changePageAction: this.goToPage,
      currentPageNumber: this.props.currentPageNumber,
      perPage: this.props.perPage,
      totalSize: this.props.numWorks
    });
  }
});

},{"./gr_component_factory":87,"./pagination_links":121,"./shared/gr_prop_types":146,"append-query":"append-query","react":"react"}],86:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _favorite_genres_form_actions = require("../react_actions/favorite_genres_form_actions");

var _favorite_genres_form_actions2 = _interopRequireDefault(_favorite_genres_form_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GenreCheckbox",

  propTypes: {
    genre: _react2.default.PropTypes.string,
    isFavorited: _react2.default.PropTypes.bool.isRequired
  },

  onCheckboxChange: function onCheckboxChange() {
    if (this.props.isFavorited) {
      _favorite_genres_form_actions2.default.deselectFavoriteGenre(this.props.genre);
    } else {
      _favorite_genres_form_actions2.default.selectFavoriteGenre(this.props.genre);
    }
  },
  render: function render() {
    var genreLabelClasses = (0, _classnames2.default)("gr-genresForm__genreLabel", { "gr-genresForm__genreLabel--selected": this.props.isFavorited });
    return _jsx("label", {
      className: genreLabelClasses
    }, void 0, _jsx("input", {
      name: "favorites[" + this.props.genre + "]",
      type: "hidden",
      value: "false"
    }), _react2.default.createElement("input", { name: "favorites[" + this.props.genre + "]", type: "checkbox", value: "true",
      "data-genre": this.props.genre, ref: "checkbox",
      defaultChecked: this.props.isFavorited, onChange: this.onCheckboxChange }), _jsx("span", {
      className: "u-verticalAlignMiddle u-marginLeftTiny"
    }, void 0, this.props.genre));
  }
});

},{"../react_actions/favorite_genres_form_actions":26,"./gr_component_factory":87,"classnames":"classnames","react":"react"}],87:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _bem_modifiers = require("../react_mixins/bem_modifiers");

var _bem_modifiers2 = _interopRequireDefault(_bem_modifiers);

var _deploy_service = require("../react_mixins/deploy_service");

var _deploy_service2 = _interopRequireDefault(_deploy_service);

var _reactAddonsPureRenderMixin = require("react-addons-pure-render-mixin");

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _tracking_data_attributes_mixin = require("../react_mixins/tracking_data_attributes_mixin");

var _tracking_data_attributes_mixin2 = _interopRequireDefault(_tracking_data_attributes_mixin);

var _error_message = require("./error_message");

var _error_message2 = _interopRequireDefault(_error_message);

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _gr_error_reporting = require("../modules/gr_error_reporting");

var _gr_error_reporting2 = _interopRequireDefault(_gr_error_reporting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_MIXINS = [_reactAddonsPureRenderMixin2.default, _bem_modifiers2.default, _deploy_service2.default, _tracking_data_attributes_mixin2.default];

/**
 * A factory that creates React class
 *
 * Params:
 * spec: object - React component definition. The definition expects `render`
 * function and `displayName` attribute. If not an error will be thrown.
 * options: {
 *   showErrorMessage: boolean - if true, shows an error message
 * }
 */

var DEFAULT_OPTIONS = {
  showErrorMessage: "production" === _env_utils2.default.DEVELOPMENT
};

var wrapRenderFunction = function wrapRenderFunction(spec, options) {
  var originalRender = spec.render;
  options = (0, _lodash.merge)({}, DEFAULT_OPTIONS, options);
  spec.render = function () {
    try {
      return originalRender.apply(this, arguments);
    } catch (error) {
      _gr_error_reporting2.default.notifyException(error, "Failed to render " + spec.displayName);
      if (options.showErrorMessage) {
        return _jsx(_error_message2.default, {
          componentName: spec.displayName
        });
      } else {
        return null;
      }
    }
  };
};

// throw an error if a valid component name. The component name is useful for debugging.
var validateComponentNameRequired = function validateComponentNameRequired(componentName) {
  if ((0, _lodash.isEmpty)(componentName)) {
    throw new Error("GrError: Missing component name. Please " + "make sure `displayName` attribute is defined while creating a React class " + "using GrComponentFactory.createClass.");
  }
};

var addMixins = function addMixins(spec) {
  var mixins = spec.mixins || [];
  spec.mixins = mixins.concat(DEFAULT_MIXINS);
};

var getComponentSpec = function getComponentSpec(spec, options) {
  addMixins(spec);
  // If we are in a test environment (TEST var set in gulpfile), do not catch
  // rendering errors in components
  if ("production" !== _env_utils2.default.TEST) {
    wrapRenderFunction(spec, options);
  }
  return spec;
};

exports.default = {
  createClass: function createClass(spec) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    validateComponentNameRequired(spec.displayName);
    return _react2.default.createClass(getComponentSpec(spec, options));
  }
};

},{"../modules/env_utils":13,"../modules/gr_error_reporting":14,"../react_mixins/bem_modifiers":182,"../react_mixins/deploy_service":183,"../react_mixins/tracking_data_attributes_mixin":187,"./error_message":76,"lodash":"lodash","react":"react","react-addons-pure-render-mixin":"react-addons-pure-render-mixin"}],88:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           React Component: PreviewBroadcast
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           React Component for previewing group broadcast message, rendered in group/broadcast.html.erb.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           props: previewBroadcastURL - route for group#preview_broadcast
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PreviewBroadcast",

  propTypes: {
    previewBroadcastURL: _react2.default.PropTypes.string.isRequired
  },

  getInitialState: function getInitialState() {
    return { fetching: false };
  },
  requestPreview: function requestPreview(subject, body) {
    var _this = this;

    (0, _ajax_helper.httpRequest)(this.props.previewBroadcastURL, {
      method: "GET",
      data: {
        message: {
          subject: subject,
          body: body
        }
      }
    }).done(function (data) {
      _this.setState({ modalHTML: { __html: data }, fetching: false });
    }).fail(function () {
      _this.setState({ modalHTML: { __html: "<div>There was an error processing your request.</div>" }, fetching: false });
    });
  },

  // gets subject and body, send AJAX request to group#preview_broadcast for GR specific inline html
  // handling. Sets fetching to true to prevent modal from opening before response
  // is received + replaces "preview" link to loading gif.
  handlePreview: function handlePreview() {
    var _this2 = this;

    var body = document.getElementById("message_body").value;
    var subject = document.getElementById("message_subject").value;
    this.setState({ fetching: true }, function () {
      return _this2.requestPreview(subject, body);
    });
  },
  renderModal: function renderModal() {
    if (this.state.fetching) {
      return null;
    } else {
      return _jsx(_modal2.default, {
        id: "previewBroadcast",
        centered: true,
        bemModifiers: "previewBroadcast"
      }, void 0, _jsx("div", {
        className: "modalMessageBox"
      }, void 0, _jsx("h3", {
        className: "modalMessageBox__headerText"
      }, void 0, "Message Preview"), _jsx("div", {
        dangerouslySetInnerHTML: this.state.modalHTML
      })));
    }
  },
  renderModalTrigger: function renderModalTrigger() {
    if (this.state.fetching) {
      return _jsx(_spinner2.default, {
        isSmall: true
      });
    } else {
      return _jsx(_modal_trigger2.default, {
        id: "previewBroadcast"
      }, void 0, _jsx("button", {
        className: "gr-buttonAsLink previewBroadcast__linkText",
        onClick: this.handlePreview
      }, void 0, "(preview)"));
    }
  },
  render: function render() {
    var modal = this.renderModal();
    var modalTrigger = this.renderModalTrigger();
    return _jsx("div", {
      className: "previewBroadcast"
    }, void 0, _jsx("div", {
      className: "previewBroadcast__openPreviewContainer"
    }, void 0, modalTrigger, modal));
  }
});

},{"../../modules/ajax/ajax_helper":4,"../gr_component_factory":87,"../modal":118,"../modal_trigger":119,"../spinner":161,"react":"react"}],89:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

// COMPONENTS

// ACTIONS

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowseMenu = undefined;

var _react = require("react");

var _lodash = require("lodash");

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

var _favorite_genres_pane = require("./favorite_genres_pane");

var _favorite_genres_pane2 = _interopRequireDefault(_favorite_genres_pane);

var _featured_genres = require("./featured_genres");

var _featured_genres2 = _interopRequireDefault(_featured_genres);

var _genre_list = require("./genre_list");

var _genre_list2 = _interopRequireDefault(_genre_list);

var _menu_link = require("../menu_link");

var _menu_link2 = _interopRequireDefault(_menu_link);

var _primary_nav_menu = require("./primary_nav_menu");

var _primary_nav_menu2 = _interopRequireDefault(_primary_nav_menu);

var _featured_genres_actions = require("../../react_actions/featured_genres_actions");

var _featured_genres_actions2 = _interopRequireDefault(_featured_genres_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SpotLight = function SpotLight(_ref) {
  var signedIn = _ref.signedIn;
  var favoriteGenres = _ref.favoriteGenres;
  var genres = _ref.genres;

  var classesWithModifier = function classesWithModifier(modifier) {
    return "siteHeader__spotlight siteHeader__spotlight--" + modifier;
  };

  if (signedIn) {
    if (!(0, _lodash.isEmpty)(favoriteGenres)) {
      return _jsx("div", {
        className: classesWithModifier("browseMenu"),
        onClick: function onClick(e) {
          return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Browse_Spotlight");
        }
      }, void 0, _jsx(_featured_genres2.default, {
        favoriteGenres: favoriteGenres
      }));
    } else {
      return _jsx("div", {
        className: classesWithModifier("withoutSubMenu"),
        onClick: function onClick(e) {
          return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Browse_Spotlight");
        }
      }, void 0, _jsx(_favorite_genres_pane2.default, {
        genres: genres
      }));
    }
  } else {
    return _jsx("div", {
      className: classesWithModifier("withoutSubMenu"),
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Browse_Spotlight");
      }
    }, void 0, _jsx(_genre_list2.default, {
      genres: genres
    }));
  }
};

SpotLight.propTypes = {
  signedIn: _react.PropTypes.bool,
  favoriteGenres: _react.PropTypes.array,
  genres: _react.PropTypes.array.isRequired
};

var BrowseMenu = exports.BrowseMenu = function BrowseMenu(props) {
  return _jsx(_primary_nav_menu2.default, {
    tabName: "siteHeaderBrowseMenu",
    trigger: _jsx("span", {}, void 0, "Browse ▾"),
    fallbackUrl: props.browseUrl,
    bemModifiers: ["siteHeaderBrowseMenu"],
    showingFavoriteGenres: (0, _lodash.isEmpty)(props.favoriteGenres),
    onShowCallback: function onShowCallback() {
      (0, _click_and_view_tracking.trackNavEngage)("BrowseShow");
      _featured_genres_actions2.default.trackMenuImpression();
      _featured_genres_actions2.default.requestFeaturedBooks();
    }
  }, void 0, _jsx("div", {
    className: "siteHeader__browseMenuDropdown"
  }, void 0, _jsx("ul", {
    className: "siteHeader__subNav"
  }, void 0, _jsx(_menu_link2.default, {
    href: props.recommendationsUrl,
    linkText: "Recommendations",
    linkClass: "siteHeader__subNavLink"
  }), _jsx(_menu_link2.default, {
    href: props.choiceAwardsUrl,
    linkText: "Choice Awards",
    linkClass: "siteHeader__subNavLink"
  }), _jsx(_menu_link2.default, {
    href: props.genresIndexUrl,
    linkText: "Genres",
    linkClass: "siteHeader__subNavLink siteHeader__subNavLink--genresIndex"
  }), _jsx(_menu_link2.default, {
    href: props.giveawayUrl,
    linkText: "Giveaways",
    linkClass: "siteHeader__subNavLink"
  }), _jsx(_menu_link2.default, {
    href: props.newReleasesUrl,
    linkText: "New Releases",
    linkClass: "siteHeader__subNavLink"
  }), _jsx(_menu_link2.default, {
    href: props.listUrl,
    linkText: "Lists",
    linkClass: "siteHeader__subNavLink"
  }), _jsx(_menu_link2.default, {
    href: props.exploreUrl,
    linkText: "Explore",
    linkClass: "siteHeader__subNavLink"
  }), _jsx(_menu_link2.default, {
    href: props.newsUrl,
    linkText: "News & Interviews",
    linkClass: "siteHeader__subNavLink"
  })), React.createElement(SpotLight, props)));
};

BrowseMenu.propTypes = {
  adId: _react.PropTypes.string,
  browseUrl: _react.PropTypes.string.isRequired,
  choiceAwardsUrl: _react.PropTypes.string.isRequired,
  genresIndexUrl: _react.PropTypes.string.isRequired,
  exploreUrl: _react.PropTypes.string.isRequired,
  giveawayUrl: _react.PropTypes.string.isRequired,
  listUrl: _react.PropTypes.string.isRequired,
  newReleasesUrl: _react.PropTypes.string.isRequired,
  recommendationsUrl: _react.PropTypes.string.isRequired,
  newsUrl: _react.PropTypes.string.isRequired
};

exports.default = BrowseMenu;

},{"../../modules/click_and_view_tracking":8,"../../react_actions/featured_genres_actions":27,"../menu_link":117,"./favorite_genres_pane":91,"./featured_genres":92,"./genre_list":94,"./primary_nav_menu":103,"lodash":"lodash","react":"react"}],90:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _menu_link = require("../menu_link");

var _menu_link2 = _interopRequireDefault(_menu_link);

var _primary_nav_menu = require("./primary_nav_menu");

var _primary_nav_menu2 = _interopRequireDefault(_primary_nav_menu);

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "CommunityMenu",

  propTypes: {
    communityUrl: _react2.default.PropTypes.string.isRequired,
    featuredAskAuthorUrl: _react2.default.PropTypes.string.isRequired,
    groupsUrl: _react2.default.PropTypes.string.isRequired,
    discussionsUrl: _react2.default.PropTypes.string.isRequired,
    quotesUrl: _react2.default.PropTypes.string.isRequired,
    peopleUrl: _react2.default.PropTypes.string
  },

  renderMenuLink: function renderMenuLink(url, linkText) {
    if (url) {
      return _jsx(_menu_link2.default, {
        href: url,
        linkText: linkText,
        linkClass: "siteHeader__subNavLink"
      });
    } else {
      return null;
    }
  },
  render: function render() {
    var communityTrigger = _jsx("span", {}, void 0, "Community ▾");
    return _jsx(_primary_nav_menu2.default, {
      tabName: "siteHeaderCommunityMenu",
      trigger: communityTrigger,
      fallbackUrl: this.props.communityUrl,
      onShowCallback: function onShowCallback() {
        return (0, _click_and_view_tracking.trackNavEngage)("CommunityShow");
      }
    }, void 0, _jsx("ul", {
      className: "siteHeader__subNav"
    }, void 0, this.renderMenuLink(this.props.groupsUrl, "Groups"), this.renderMenuLink(this.props.discussionsUrl, "Discussions"), this.renderMenuLink(this.props.quotesUrl, "Quotes"), this.renderMenuLink(this.props.featuredAskAuthorUrl, "Ask the Author"), this.renderMenuLink(this.props.peopleUrl, "People")));
  }
});

},{"../../modules/click_and_view_tracking":8,"../gr_component_factory":87,"../menu_link":117,"./primary_nav_menu":103,"react":"react","reflux":"reflux"}],91:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FavoriteGenresPane",

  propTypes: {
    favoriteGenres: _react2.default.PropTypes.array,
    genres: _react2.default.PropTypes.array.isRequired
  },

  render: function render() {
    return _jsx("div", {
      className: "favoriteGenresPane"
    }, void 0, _jsx("div", {
      className: "favoriteGenresPane__title"
    }, void 0, "What do you like to read?"), _jsx("div", {
      className: "favoriteGenresPane__description"
    }, void 0, "Choose your favorite genres to get personalized book recommendations."), _jsx("div", {
      className: "favoriteGenresPane__buttonContainer"
    }, void 0, _jsx(_modal_trigger2.default, {
      id: "favGenres"
    }, void 0, _jsx("button", {
      className: "gr-button gr-button--dark"
    }, void 0, "Choose Favorite Genres"))), _jsx("a", {
      href: "/genres",
      className: "favoriteGenresPane__browseGenres"
    }, void 0, "Browse Genres"));
  }
});

},{"../gr_component_factory":87,"../modal_trigger":119,"react":"react"}],92:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _featured_genres_list = require("./featured_genres_list");

var _featured_genres_list2 = _interopRequireDefault(_featured_genres_list);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _featured_genres_store = require("../../react_stores/featured_genres_store");

var _featured_genres_store2 = _interopRequireDefault(_featured_genres_store);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _tab_content = require("./../tab_content");

var _tab_content2 = _interopRequireDefault(_tab_content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This number should match the $nav-spotlight-min-width variable in
// gr/shared_values/dimensions.scss
var MIN_WIDTH_FOR_SPOTLIGHT_DISPLAY = 1108;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedGenres",

  mixins: [_reflux2.default.connect(_featured_genres_store2.default, "featuredGenres"), _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  render: function render() {
    if (this.state.featuredGenres.featuredGenreBookInfo) {
      return _jsx("div", {
        className: "featuredGenres"
      }, void 0, _jsx("span", {
        className: "featuredGenres__genreList"
      }, void 0, _jsx(_featured_genres_list2.default, {
        genres: _lodash2.default.pluck(this.state.featuredGenres.featuredGenreBookInfo, "genre")
      })));
    } else if (this.state.featuredGenres.errorMessage) {
      return _jsx("span", {}, void 0, this.state.featuredGenres.errorMessage);
    } else {
      return _jsx("div", {
        className: "featuredGenres featuredGenres--sparse"
      }, void 0, _jsx(_spinner2.default, {}));
    }
  }
});

},{"../../react_stores/featured_genres_store":195,"../../react_stores/user_agent_capabilities_store":203,"../gr_component_factory":87,"../spinner":161,"./../tab_content":165,"./featured_genres_list":93,"lodash":"lodash","reflux":"reflux"}],93:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _dropdown = require("../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _tab = require("./../tab");

var _tab2 = _interopRequireDefault(_tab);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_GENRES = 8;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FeaturedGenresList",

  mixins: [_reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  propTypes: {
    adId: _react2.default.PropTypes.string,
    genres: _react2.default.PropTypes.array.isRequired
  },

  onClick: function onClick(ev) {
    ev.preventDefault();
  },
  allGenresLink: function allGenresLink() {
    return _jsx("li", {
      role: "menuitem",
      className: "genreList__genre",
      "aria-label": "All Genres"
    }, "allGenres", _jsx("a", {
      href: "/genres",
      className: "siteHeader__subNavLink"
    }, void 0, "All Genres"));
  },
  renderGenreLink: function renderGenreLink(genre) {
    var cx = (0, _classnames2.default)(["genreList__genreLink", "gr-hyperlink", "gr-hyperlink--naked"]);
    var link = _jsx("a", {
      href: genre.url,
      className: cx
    }, void 0, genre.name);
    if (this.state.userAgentCapabilities.touch === true) {
      return link;
    } else {
      return _jsx(_tab2.default, {
        group: "featuredGenres",
        name: "featuredGenre-" + genre.name,
        triggerEventType: _dropdown2.default.TriggerEventTypes.HOVER
      }, void 0, link);
    }
  },
  renderFavoritesList: function renderFavoritesList() {
    var _this = this;

    var numGenres = MAX_GENRES;
    return _jsx("div", {
      className: "featuredGenres__list genreList genreList--sidebar"
    }, void 0, _jsx("div", {
      className: "siteHeader__title siteHeader__heading"
    }, void 0, _jsx("span", {
      className: "featuredGenres__listTitle"
    }, void 0, "Favorite Genres")), _jsx("ul", {}, void 0, (0, _lodash.map)((0, _lodash.take)(this.props.genres, numGenres), function (genre, index) {
      return _jsx("li", {
        role: "menuitem",
        className: "genreList__genre",
        "aria-label": genre.name
      }, genre.name, _this.renderGenreLink(genre));
    }), this.allGenresLink()));
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.renderFavoritesList());
  }
});

},{"../../react_stores/user_agent_capabilities_store":203,"../dropdown":75,"../gr_component_factory":87,"./../tab":164,"classnames":"classnames","lodash":"lodash","react":"react","reflux":"reflux"}],94:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "GenreList",

  renderMoreGenresLink: function renderMoreGenresLink() {
    return _jsx("li", {
      role: "menuitem",
      className: "genreList__genre"
    }, void 0, _jsx("a", {
      href: "/genres",
      className: "genreList__genreLink gr-hyperlink gr-hyperlink--naked"
    }, void 0, "More Genres"));
  },
  render: function render() {
    var _this = this;

    var GENRES_IN_COLUMN = 10;
    // Generate columns of genres as sub-arrays
    var genreArrays = [];
    var genreCopy = this.props.genres.slice(0);
    while (genreArrays.length * GENRES_IN_COLUMN < this.props.genres.length) {
      genreArrays.push(genreCopy.splice(0, GENRES_IN_COLUMN));
    }
    var columnsCount = genreArrays.length;
    return _jsx("div", {
      className: "genreListContainer"
    }, void 0, _jsx("div", {
      className: "siteHeader__heading siteHeader__title"
    }, void 0, "Genres"), _lodash2.default.map(genreArrays, function (genreList, col) {
      return _jsx("ul", {
        className: "genreList"
      }, "genreList" + col, _lodash2.default.map(genreList, function (genre) {
        return _jsx("li", {
          role: "menuitem",
          className: "genreList__genre"
        }, genre.name, _jsx("a", {
          href: genre.url,
          className: "genreList__genreLink gr-hyperlink gr-hyperlink--naked"
        }, void 0, genre.name));
      }), columnsCount === col + 1 ? _this.renderMoreGenresLink() : null);
    }));
  }
});

},{"../gr_component_factory":87,"lodash":"lodash"}],95:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

// COMPONENTS

// REDUCER

// CONSTANTS

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cookies = require("../shared/cookies");

var _cookies2 = _interopRequireDefault(_cookies);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _reduxLogger = require("redux-logger");

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _lodash = require("lodash");

var _touch_not_ready_helper = require("../../modules/shared/touch_not_ready_helper");

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

var _favorite_genres_form = require("../favorite_genres_form");

var _favorite_genres_form2 = _interopRequireDefault(_favorite_genres_form);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _personal_nav = require("./personal_nav");

var _personal_nav2 = _interopRequireDefault(_personal_nav);

var _personal_nav_drawer = require("./personal_nav_drawer");

var _personal_nav_drawer2 = _interopRequireDefault(_personal_nav_drawer);

var _primary_nav_menus = require("./primary_nav_menus");

var _primary_nav_menus2 = _interopRequireDefault(_primary_nav_menus);

var _profile_menu_jewel = require("./profile_menu_jewel");

var _profile_menu_jewel2 = _interopRequireDefault(_profile_menu_jewel);

var _header_logo = require("./header_logo");

var _header_logo2 = _interopRequireDefault(_header_logo);

var _search_toggle = require("../search/search_toggle");

var _search_toggle2 = _interopRequireDefault(_search_toggle);

var _nav_search = require("./nav_search");

var _nav_search2 = _interopRequireDefault(_nav_search);

var _primary_nav_separate_line = require("./primary_nav_separate_line");

var _primary_nav_separate_line2 = _interopRequireDefault(_primary_nav_separate_line);

var _header_reducer = require("../../react_reducers/header/header_reducer");

var _header_reducer2 = _interopRequireDefault(_header_reducer);

var _env_utils = require("../../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var middlewares = [];
if (_env_utils2.default.isDevelopment() && _env_utils2.default.hasDom()) {
  middlewares.push((0, _reduxLogger2.default)());
}

var store = (0, _redux.createStore)(_header_reducer2.default, {}, _redux.applyMiddleware.apply(undefined, middlewares));

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Header",

  getInitialState: function getInitialState() {
    return { scrolling: false, userLikelyHasAccount: false };
  },

  propTypes: {
    adId: _react2.default.PropTypes.string,
    autocomleteUrl: _react2.default.PropTypes.string,
    browseUrl: _react2.default.PropTypes.string,
    choiceAwardsUrl: _react2.default.PropTypes.string,
    communityUrl: _react2.default.PropTypes.string,
    discussionsUrl: _react2.default.PropTypes.string,
    favoriteGenres: _react2.default.PropTypes.array,
    friendIconUrl: _react2.default.PropTypes.string,
    genres: _react2.default.PropTypes.array.isRequired,
    genresIndexUrl: _react2.default.PropTypes.string,
    exploreUrl: _react2.default.PropTypes.string,
    giveawayUrl: _react2.default.PropTypes.string,
    groupsUrl: _react2.default.PropTypes.string,
    featuredAskAuthorUrl: _react2.default.PropTypes.string,
    helpUrl: _react2.default.PropTypes.string,
    homeUrl: _react2.default.PropTypes.string,
    listUrl: _react2.default.PropTypes.string,
    logo: _react2.default.PropTypes.shape({
      imageUrl: _react2.default.PropTypes.string,
      clickthroughUrl: _react2.default.PropTypes.string,
      altText: _react2.default.PropTypes.string
    }),
    messageIconUrl: _react2.default.PropTypes.string,
    myBooksUrl: _react2.default.PropTypes.string,
    myFriendsUrl: _react2.default.PropTypes.string,
    myGroupsUrl: _react2.default.PropTypes.string,
    myQuotesUrl: _react2.default.PropTypes.string,
    myReadingChallengeUrl: _react2.default.PropTypes.string,
    myRecsUrl: _react2.default.PropTypes.string,
    name: _react2.default.PropTypes.string,
    newReleasesUrl: _react2.default.PropTypes.string,
    notificationIconUrl: _react2.default.PropTypes.string,
    peopleUrl: _react2.default.PropTypes.string,
    preferences: _react2.default.PropTypes.object,
    profileImage: _react2.default.PropTypes.string,
    profileUrl: _react2.default.PropTypes.string,
    quotesUrl: _react2.default.PropTypes.string,
    recommendationsUrl: _react2.default.PropTypes.string,
    signedIn: _react2.default.PropTypes.bool,
    searchPath: _react2.default.PropTypes.string,
    signInUrl: _react2.default.PropTypes.string,
    signInWithReturnUrl: _react2.default.PropTypes.bool,
    signUpUrl: _react2.default.PropTypes.string,
    tempFriendRequestCount: _react2.default.PropTypes.number,
    tempUnreadMessageCount: _react2.default.PropTypes.number,
    topFullImage: _react2.default.PropTypes.shape({
      clickthroughUrl: _react2.default.PropTypes.string,
      altText: _react2.default.PropTypes.string,
      backgroundColor: _react2.default.PropTypes.string,
      xs: _react2.default.PropTypes.object,
      md: _react2.default.PropTypes.object
    }),
    iOSDownloadUrl: _react2.default.PropTypes.string,
    androidDownloadUrl: _react2.default.PropTypes.string,
    mobviousDeviceType: _react2.default.PropTypes.string,
    showAppDownloadButton: _react2.default.PropTypes.bool
  },

  componentDidMount: function componentDidMount() {
    // See also ApplicationHelper#set_sign_in_user_cookies
    if (_cookies2.default.get("likely_has_account") === "true") {
      this.setState({ userLikelyHasAccount: true });
    }
  },
  handleScrollBegin: function handleScrollBegin() {
    this.setState({ scrolling: true });
  },
  handleScrollEnd: function handleScrollEnd() {
    this.setState({ scrolling: false });
  },
  handleProfileModalTriggerClick: function handleProfileModalTriggerClick(e) {
    (0, _touch_not_ready_helper.acknowledgeEvent)();
    e.preventDefault();
    (0, _click_and_view_tracking.trackNavEngageClick)(e, "ProfileModalTrigger");
  },
  getMobileOS: function getMobileOS() {
    if (this.props.mobviousDeviceType !== "mobile") {
      return "desktop";
    }
    var userAgent = _env_utils2.default.getUserAgent();
    if (/iPhone|iPod/.test(userAgent)) {
      return "ios";
    }
    if (/Android/.test(userAgent)) {
      return "android";
    }
    return "desktop";
  },
  render: function render() {
    return _jsx(_reactRedux.Provider, {
      store: store
    }, void 0, _jsx("header", {}, void 0, this.renderTopFullImage(), _jsx("div", {
      className: "siteHeader__topLine gr-box gr-box--withShadow"
    }, void 0, _jsx("div", {
      className: "siteHeader__contents"
    }, void 0, _jsx("div", {
      className: "siteHeader__topLevelItem siteHeader__topLevelItem--searchIcon"
    }, void 0, _jsx(_search_toggle2.default, {
      toggleType: _search_toggle.SEARCH_TOGGLE_TYPES.ICON
    })), _react2.default.createElement(_header_logo2.default, this.props.logo), _jsx("nav", {
      className: "siteHeader__primaryNavInline"
    }, void 0, _react2.default.createElement(_primary_nav_menus2.default, this.props)), _react2.default.createElement(_nav_search2.default, this.props), this.props.signedIn ? this.renderPersonalNav() : this.renderLoginLinks(), this.renderProfileDrawerTrigger(), this.renderModals(), this.renderPersonalNavDrawer())), _react2.default.createElement(_primary_nav_separate_line2.default, this.props)));
  },
  renderPersonalNav: function renderPersonalNav() {
    return _jsx("div", {
      className: "siteHeader__personal"
    }, void 0, _react2.default.createElement(_personal_nav2.default, this.props));
  },
  renderPersonalNavDrawer: function renderPersonalNavDrawer() {
    return _react2.default.createElement(_personal_nav_drawer2.default, this.props);
  },
  renderProfileDrawerTrigger: function renderProfileDrawerTrigger() {
    var _this = this;

    if (this.props.signedIn) {
      var user = {
        viewableName: this.props.name,
        profileImage: this.props.profileImage,
        profileUrl: this.props.profileUrl
      };
      return _jsx("div", {
        className: "siteHeader__topLevelItem siteHeader__topLevelItem--profileIcon"
      }, void 0, _jsx("span", {
        className: "headerPersonalNav",
        "data-ux-click": true,
        onClick: function onClick(e) {
          return _this.handleProfileModalTriggerClick(e);
        }
      }, void 0, _jsx(_modal_trigger2.default, {
        id: _personal_nav_drawer.personalNavDrawerModalId
      }, void 0, _react2.default.createElement(_profile_menu_jewel2.default, _extends({}, this.props, { user: user })))));
    } else {
      var buttonClass = (0, _classnames2.default)("gr-button", "gr-button--dark");
      var mobileOS = this.getMobileOS();

      // Show app download button for mobile devices (gated behind weblab)
      if (this.props.showAppDownloadButton && mobileOS === "ios" && this.props.iOSDownloadUrl) {
        return _jsx("div", {
          className: "siteHeader__topLevelItem siteHeader__topLevelItem--signUp"
        }, void 0, _jsx("a", {
          href: this.props.iOSDownloadUrl,
          className: buttonClass,
          rel: "nofollow",
          onClick: function onClick(e) {
            return (0, _click_and_view_tracking.trackNavEngageClick)(e, "AppDownloadIOS");
          }
        }, void 0, "Get App"));
      } else if (this.props.showAppDownloadButton && mobileOS === "android" && this.props.androidDownloadUrl) {
        return _jsx("div", {
          className: "siteHeader__topLevelItem siteHeader__topLevelItem--signUp"
        }, void 0, _jsx("a", {
          href: this.props.androidDownloadUrl,
          className: buttonClass,
          rel: "nofollow",
          onClick: function onClick(e) {
            return (0, _click_and_view_tracking.trackNavEngageClick)(e, "AppDownloadAndroid");
          }
        }, void 0, "Get App"));
      } else if (this.state.userLikelyHasAccount) {
        return _jsx("div", {
          className: "siteHeader__topLevelItem siteHeader__topLevelItem--signUp"
        }, void 0, _jsx("a", {
          href: this.getSignInUrl(),
          className: buttonClass,
          rel: "nofollow",
          onClick: function onClick(e) {
            return (0, _click_and_view_tracking.trackNavEngageClick)(e, "SignIn");
          }
        }, void 0, "Sign in"));
      } else {
        return _jsx("div", {
          className: "siteHeader__topLevelItem siteHeader__topLevelItem--signUp"
        }, void 0, _jsx("a", {
          href: this.props.signUpUrl,
          className: buttonClass,
          rel: "nofollow",
          onClick: function onClick(e) {
            return (0, _click_and_view_tracking.trackNavEngageClick)(e, "SignUp");
          }
        }, void 0, "Sign up"));
      }
    }
  },
  getSignInUrl: function getSignInUrl() {
    var currentPath = _env_utils2.default.getCurrentPath();
    if (this.props.signInWithReturnUrl) {
      return this.props.signInUrl + "?returnurl=" + currentPath;
    } else {
      return this.props.signInUrl;
    }
  },
  renderLoginLinks: function renderLoginLinks() {
    return _jsx("ul", {
      className: "siteHeader__personal"
    }, void 0, _jsx("li", {
      className: "siteHeader__topLevelItem siteHeader__topLevelItem--signedOut"
    }, void 0, _jsx("a", {
      href: this.getSignInUrl(),
      rel: "nofollow",
      className: "siteHeader__topLevelLink",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, "SignIn");
      }
    }, void 0, "Sign In")), _jsx("li", {
      className: "siteHeader__topLevelItem siteHeader__topLevelItem--signedOut"
    }, void 0, _jsx("a", {
      href: this.props.signUpUrl,
      rel: "nofollow",
      className: "siteHeader__topLevelLink",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Join");
      }
    }, void 0, "Join")));
  },
  renderModals: function renderModals() {
    if (this.props.signedIn) {
      return _jsx(_modal2.default, {
        id: "favGenres"
      }, void 0, _jsx(_favorite_genres_form2.default, {
        favoriteGenres: this.props.favoriteGenres,
        genres: this.props.genres
      }));
    } else {
      return null;
    }
  },
  renderTopFullImage: function renderTopFullImage() {
    if (!(0, _lodash.isEmpty)(this.props.topFullImage)) {
      return _jsx("div", {
        className: "siteHeader__topFullImageContainer",
        style: { backgroundColor: this.props.topFullImage.backgroundColor }
      }, void 0, _jsx("a", {
        className: "siteHeader__topFullImageLink",
        href: this.props.topFullImage.clickthroughUrl
      }, void 0, _jsx("picture", {}, void 0, _jsx("source", {
        media: "(min-width: 768px)",
        srcSet: this.props.topFullImage.md["1x"] + " 1x, " + this.props.topFullImage.md["2x"] + " 2x"
      }), _jsx("img", {
        alt: this.props.topFullImage.altText,
        className: "siteHeader__topFullImage",
        src: this.props.topFullImage.xs["1x"],
        srcSet: this.props.topFullImage.xs["2x"] + " 2x"
      }))));
    }
  }
});

},{"../../modules/click_and_view_tracking":8,"../../modules/env_utils":13,"../../modules/shared/touch_not_ready_helper":18,"../../react_reducers/header/header_reducer":189,"../favorite_genres_form":77,"../gr_component_factory":87,"../modal":118,"../modal_trigger":119,"../search/search_toggle":137,"../shared/cookies":145,"./header_logo":96,"./nav_search":98,"./personal_nav":101,"./personal_nav_drawer":102,"./primary_nav_menus":104,"./primary_nav_separate_line":105,"./profile_menu_jewel":107,"classnames":"classnames","lodash":"lodash","react":"react","react-redux":"react-redux","redux":"redux","redux-logger":"redux-logger"}],96:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomDoodleLogo = exports.DefaultLogo = undefined;

var _react = require("react");

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

var DefaultLogo = exports.DefaultLogo = function DefaultLogo(_ref) {
  var clickthroughUrl = _ref.clickthroughUrl;
  var altText = _ref.altText;
  return _jsx("a", {
    href: clickthroughUrl,
    className: "siteHeader__logo",
    "aria-label": altText,
    title: altText,
    onClick: function onClick(e) {
      return (0, _click_and_view_tracking.trackNavEngageClick)(e, "HeaderLogo");
    }
  });
};

DefaultLogo.propTypes = {
  clickthroughUrl: _react.PropTypes.string,
  altText: _react.PropTypes.string
};

var CustomDoodleLogo = exports.CustomDoodleLogo = function CustomDoodleLogo(_ref2) {
  var imageUrl = _ref2.imageUrl;
  var clickthroughUrl = _ref2.clickthroughUrl;
  var altText = _ref2.altText;
  return _jsx("a", {
    href: clickthroughUrl,
    className: "siteHeader__logo siteHeader__logo--doodle",
    onClick: function onClick(e) {
      return (0, _click_and_view_tracking.trackNavEngageClick)(e, "HeaderLogo");
    }
  }, void 0, _jsx("picture", {}, void 0, _jsx("img", {
    src: imageUrl,
    alt: altText
  })));
};

CustomDoodleLogo.propTypes = _extends({}, DefaultLogo.propTypes, {
  imageUrl: _react.PropTypes.string
});

var HeaderLogo = function HeaderLogo(props) {
  return props.imageUrl ? React.createElement(CustomDoodleLogo, props) : React.createElement(DefaultLogo, props);
};

exports.default = HeaderLogo;

},{"../../modules/click_and_view_tracking":8,"react":"react"}],97:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _header = require("./header");

var _header2 = _interopRequireDefault(_header);

var _current_user_store = require("../../react_stores/current_user_store");

var _current_user_store2 = _interopRequireDefault(_current_user_store);

var _favorite_genres_store = require("../../react_stores/favorite_genres_store");

var _favorite_genres_store2 = _interopRequireDefault(_favorite_genres_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "HeaderStoreConnector",

  mixins: [_reflux2.default.connect(_current_user_store2.default, "currentUser"), _reflux2.default.connect(_favorite_genres_store2.default, "favoriteGenres")],

  render: function render() {
    var currentUser = this.state.currentUser.currentUser;
    var signedIn = !_lodash2.default.isEmpty(currentUser);
    var props = {
      adId: this.state.favoriteGenres.adId,
      signedIn: signedIn,
      genres: this.state.favoriteGenres.allGenres,
      favoriteGenres: this.state.favoriteGenres.favoriteGenres
    };
    if (signedIn) {
      _lodash2.default.merge(props, currentUser);
    }
    _lodash2.default.merge(props, this.props);

    return React.createElement(_header2.default, props);
  }
});

},{"../../react_stores/current_user_store":192,"../../react_stores/favorite_genres_store":194,"../gr_component_factory":87,"./header":95,"lodash":"lodash","reflux":"reflux"}],98:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _url_tracking_params = require("../../analytics/url_tracking_params");

var _env_utils = require("../../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _book_search = require("../search/book_search");

var _book_search2 = _interopRequireDefault(_book_search);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({

  displayName: "NavSearch",

  propTypes: {
    autocompleteUrl: _react2.default.PropTypes.string,
    autoFocus: _react2.default.PropTypes.bool,
    searchPath: _react2.default.PropTypes.string,
    bemModifiers: _react2.default.PropTypes.string,
    signedIn: _react2.default.PropTypes.bool,
    mobviousDeviceType: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return { autoFocus: false, bemModifiers: "navbar" };
  },
  onSearchSelection: function onSearchSelection(result) {
    var url = result.bookUrl + "?" + _url_tracking_params.URLTrackingParams.BOOK_SHOW_INTERACTION_PARAM + "&" + _url_tracking_params.URLTrackingParams.FROM_SEARCH_PARAM;
    if (result.qid !== null) {
      url = url.concat("&" + _url_tracking_params.URLTrackingParams.SEARCH_IDENTIFIER_PARAM + "=" + result.qid);
      if (result.rank !== null && result.rank > 0) {
        url = url.concat("&" + _url_tracking_params.URLTrackingParams.SEARCH_RANK_PARAM + "=" + result.rank);
      }
    }
    _env_utils2.default.setLocationUrl(url);
  },
  render: function render() {
    // Note: The BookSearch component is also called by add_book_search, which has a different onChooseResult action.
    //       These should probably be separated into two separate components, with some shared styles and UI logic.
    return _jsx(_book_search2.default, {
      autoFocus: this.props.autoFocus,
      bemModifiers: this.props.bemModifiers,
      searchPath: this.props.searchPath,
      autocompleteUrl: this.props.autocompleteUrl,
      signedIn: this.props.signedIn,
      deviceType: this.props.mobviousDeviceType,
      onChooseResult: this.onSearchSelection
    });
  }
});

},{"../../analytics/url_tracking_params":1,"../../modules/env_utils":13,"../gr_component_factory":87,"../search/book_search":133,"react":"react"}],99:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _lodash = require("lodash");

var _image_registry = require("../../modules/shared/image_registry");

var _to_sentence = require("../../modules/to_sentence");

var _to_sentence2 = _interopRequireDefault(_to_sentence);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _relative_time = require("../time/relative_time");

var _relative_time2 = _interopRequireDefault(_relative_time);

var _shape_icon = require("../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Notification",

  mixins: [_to_sentence2.default],

  propTypes: {
    notification: React.PropTypes.object.isRequired
  },

  userLink: function userLink(user, notification) {
    if (notification && notification.resource && typeof notification.resource.url === 'string' && notification.resource.url.toLowerCase().includes("choiceawards")) {
      return _jsx("a", {
        href: user.profileUrl,
        className: "u-defaultType"
      }, user.profileUrl, _jsx("b", {}, void 0));
    } else {
      return _jsx("a", {
        href: user.profileUrl,
        className: "u-defaultType"
      }, user.profileUrl, _jsx("b", {}, void 0, user.viewableName));
    }
  },
  userLinks: function userLinks(notification) {
    var _this = this;

    var userLinks = (0, _lodash.map)(notification.actors, function (user) {
      return _this.userLink(user, notification);
    });
    return notification.moreActors ? this.sentenceJoin(userLinks) : this.toSentence(userLinks);
  },
  renderActorIcon: function renderActorIcon(notification) {
    if (!notification.actor) {
      return _jsx(_shape_icon2.default, {
        imageUrl: (0, _image_registry.getImages)().notificationFromGRIcon || "",
        imageAlt: "Goodreads Notification"
      });
    } else {
      return _jsx(_user_icon2.default, {
        user: notification.actor
      });
    }
  },
  renderNewNotificationFlag: function renderNewNotificationFlag(notification) {
    if (!notification.viewed) {
      return _jsx("small", {
        className: "gr-smallAlert u-marginRightTiny"
      }, void 0, "New");
    }
  },
  renderHistoryMessage: function renderHistoryMessage(notification) {
    if (notification.historyMessage) {
      return _jsx("small", {
        className: "gr-notification__historyMessage"
      }, void 0, notification.historyMessage);
    }
  },
  render: function render() {
    var notification = this.props.notification;

    if (notification.error) {
      return null;
    }

    return _jsx("div", {
      className: "gr-mediaBox gr-notification"
    }, void 0, _jsx("div", {
      className: "gr-mediaBox__media u-marginRightMedium"
    }, void 0, this.renderActorIcon(notification)), _jsx("div", {
      className: "gr-mediaBox__desc u-defaultType"
    }, void 0, this.userLinks(notification), !notification.actor || notification.moreActors ? "" : notification.directlyAddressed ? ", " : " ", notification.body + " ", notification.resource ? _jsx("a", {
      className: "gr-hyperlink",
      href: notification.resource.url
    }, void 0, notification.resource.text) : null, _jsx("div", {}, void 0, this.renderNewNotificationFlag(notification), _jsx("small", {}, void 0, _jsx(_relative_time2.default, {
      time: notification.createdAt,
      longFormat: true
    }))), _jsx("div", {}, void 0, this.renderHistoryMessage(notification))));
  }
});

},{"../../modules/shared/image_registry":17,"../../modules/to_sentence":20,"../gr_component_factory":87,"../shape_icon":141,"../time/relative_time":166,"../user/user_icon":167,"lodash":"lodash"}],100:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _dropdown = require("../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _notifications_store = require("../../react_stores/notifications_store");

var _notifications_store2 = _interopRequireDefault(_notifications_store);

var _notifications_actions = require("../../react_actions/notifications_actions");

var _notifications_actions2 = _interopRequireDefault(_notifications_actions);

var _notification = require("./notification");

var _notification2 = _interopRequireDefault(_notification);

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Notifications",

  mixins: [_reflux2.default.connect(_notifications_store2.default, "notificationsStore")],

  propTypes: {
    notificationIconUrl: _react2.default.PropTypes.string.isRequired,
    withDropdowns: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return { withDropdowns: true };
  },
  getStoreState: function getStoreState() {
    return this.state.notificationsStore;
  },
  generateKey: function generateKey(notification) {
    if (notification.actor) {
      return "" + notification.actor.profileUrl + notification.createdAt;
    } else if (notification.resource) {
      return "" + notification.resource.url + notification.createdAt;
    } else {
      return "" + notification.body + notification.createdAt;
    }
  },
  notificationsCountString: function notificationsCountString() {
    var state = this.getStoreState();
    return state.unreadCount + (state.unreadCountMore ? "+" : "");
  },
  dropdownShowCallback: function dropdownShowCallback() {
    (0, _click_and_view_tracking.trackNavEngage)("NotificationsShow");
    _notifications_actions2.default.requestNotifications();
  },
  renderNotificationList: function renderNotificationList() {
    var _this = this;

    var state = this.getStoreState();
    var notifications = state.notifications;
    if (state.errorOccurred) {
      return _jsx("div", {
        className: "dropdown__container\n                        gr-notifications\n                        gr-notifications--sparse"
      }, void 0, _jsx("span", {}, void 0, "An error occurred loading your notifications"));
    } else if (_lodash2.default.isUndefined(notifications)) {
      return _jsx("div", {
        className: "dropdown__container\n                        gr-notifications\n                        gr-notifications--sparse"
      }, void 0, _jsx(_spinner2.default, {}));
    } else if (_lodash2.default.isEmpty(notifications)) {
      return _jsx("div", {
        className: "dropdown__container\n                        gr-notifications\n                        gr-notifications--sparse"
      }, void 0, _jsx("span", {}, void 0, "No notifications"));
    } else {
      return _jsx("section", {
        className: "dropdown__container"
      }, void 0, _jsx("a", {
        className: "u-displayBlock gr-hyperlink gr-hyperlink--noUnderline",
        href: "/notifications",
        onClick: function onClick(e) {
          return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Notifications_ViewAll");
        }
      }, void 0, _jsx("div", {
        className: "siteHeader__dropdownHeading"
      }, void 0, _jsx("h3", {
        className: "siteHeader__heading siteHeader__dropdownHeader"
      }, void 0, "Notifications"), _jsx("span", {}, void 0, "View all notifications"))), _jsx("div", {
        className: "gr-notifications gr-box gr-box--forceScrollBar",
        onClick: function onClick(e) {
          return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Notifications_List");
        }
      }, void 0, _lodash2.default.map(notifications, function (notification) {
        return _jsx(_notification2.default, {
          notification: notification
        }, _this.generateKey(notification));
      })));
    }
  },
  render: function render() {
    var _this2 = this;

    var state = this.getStoreState();
    var notificationIcon = _jsx("span", {
      className: "headerPersonalNav__icon\n                       headerPersonalNav__icon--notifications",
      "aria-label": "Notifications"
    }, void 0, state.unreadCount > 0 ? _jsx("span", {
      className: "headerPersonalNav__flag"
    }, void 0, this.notificationsCountString()) : null);

    if (this.props.withDropdowns) {
      return _jsx("div", {}, void 0, _jsx(_dropdown2.default, {
        trigger: notificationIcon,
        triggerEventType: _dropdown2.default.TriggerEventTypes.CLICK,
        fallbackUrl: this.props.notificationIconUrl,
        tooltipText: "Notifications",
        onShowCallback: function onShowCallback() {
          return _this2.dropdownShowCallback();
        },
        bemModifiers: "notifications",
        isInPersonalNav: "true"
      }, void 0, this.renderNotificationList()));
    } else {
      return _jsx("a", {
        href: this.props.notificationIconUrl,
        className: "headerPersonalNav",
        onClick: function onClick(e) {
          return (0, _click_and_view_tracking.trackNavEngageClick)(e, "NotificationsLink");
        }
      }, void 0, notificationIcon);
    }
  }
});

},{"../../modules/click_and_view_tracking":8,"../../react_actions/notifications_actions":32,"../../react_stores/notifications_store":198,"../dropdown":75,"../gr_component_factory":87,"../spinner":161,"./notification":99,"lodash":"lodash","react":"react","reflux":"reflux"}],101:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

// COMPONENTS

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _appendQuery = require("append-query");

var _appendQuery2 = _interopRequireDefault(_appendQuery);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

var _url_tracking_params = require("../../analytics/url_tracking_params");

var _dropdown = require("../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _notifications = require("./notifications");

var _notifications2 = _interopRequireDefault(_notifications);

var _profile_menu = require("./profile_menu");

var _profile_menu2 = _interopRequireDefault(_profile_menu);

var _profile_menu_jewel = require("./profile_menu_jewel");

var _profile_menu_jewel2 = _interopRequireDefault(_profile_menu_jewel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PersonalNav",

  propTypes: {
    author: _react2.default.PropTypes.shape({
      id: _react2.default.PropTypes.number,
      editProfileUrl: _react2.default.PropTypes.string,
      profileUrl: _react2.default.PropTypes.string,
      dashboardUrl: _react2.default.PropTypes.string,
      listAGiveawayUrl: _react2.default.PropTypes.string
    }),
    commentsUrl: _react2.default.PropTypes.string,
    discussionsUrl: _react2.default.PropTypes.string,
    editFavGenresUrl: _react2.default.PropTypes.string,
    includeProfileMenu: _react2.default.PropTypes.bool,
    groupInvitesCount: _react2.default.PropTypes.number,
    messageIconUrl: _react2.default.PropTypes.string,
    myFriendsUrl: _react2.default.PropTypes.string,
    myQuotesUrl: _react2.default.PropTypes.string,
    myReadingChallengeUrl: _react2.default.PropTypes.string,
    name: _react2.default.PropTypes.string,
    pendingRecsCount: _react2.default.PropTypes.number,
    preferences: _react2.default.PropTypes.object,
    profileEditUrl: _react2.default.PropTypes.string,
    profileImage: _react2.default.PropTypes.string,
    profileUrl: _react2.default.PropTypes.string,
    signOutUrl: _react2.default.PropTypes.string,
    tempFriendRequestCount: _react2.default.PropTypes.number,
    tempUnreadMessageCount: _react2.default.PropTypes.number,
    withDropdowns: _react2.default.PropTypes.bool },

  // Does not affect profile menu. See also includeProfileMenu.
  getDefaultProps: function getDefaultProps() {
    return { includeProfileMenu: true, withDropdowns: true };
  },
  trackClickIncludeDropdownsSuffix: function trackClickIncludeDropdownsSuffix(e, prefix) {
    var trackingFeatureName = this.props.withDropdowns ? prefix + "_WithDropdowns" : prefix + "_WithoutDropdowns";
    (0, _click_and_view_tracking.trackNavEngageClick)(e, trackingFeatureName);
  },
  render: function render() {
    var _this = this;

    var groupDiscussionTrigger = _jsx("span", {
      className: "headerPersonalNav__icon headerPersonalNav__icon--discussions",
      "aria-label": "My group discussions"
    }, void 0);
    var messageTrigger = _jsx("span", {
      className: "headerPersonalNav__icon headerPersonalNav__icon--inbox",
      "aria-label": "Inbox"
    }, void 0, this.props.tempUnreadMessageCount > 0 ? _jsx("span", {
      className: "headerPersonalNav__flag"
    }, void 0, this.props.tempUnreadMessageCount) : null);

    var friendRequestTrigger = _jsx("span", {
      className: "headerPersonalNav__icon headerPersonalNav__icon--friendRequests",
      "aria-label": "Friend Requests"
    }, void 0, this.props.tempFriendRequestCount > 0 ? _jsx("span", {
      className: "headerPersonalNav__flag"
    }, void 0, this.props.tempFriendRequestCount) : null);

    return _jsx("ul", {
      className: "personalNav"
    }, void 0, _jsx("li", {
      className: "personalNav__listItem"
    }, void 0, this.renderNotifications()), _jsx("li", {
      className: "personalNav__listItem",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, "DiscussionsLink");
      }
    }, void 0, _jsx("a", {
      href: (0, _appendQuery2.default)(this.props.discussionsUrl, { discussion_filter: "groups",
        ref: _url_tracking_params.URLTrackingParams.DISCUSSIONS_PANE_DISCUSSION }),
      title: "My group discussions",
      className: "headerPersonalNav"
    }, void 0, groupDiscussionTrigger)), _jsx("li", {
      className: "personalNav__listItem",
      onClick: function onClick(e) {
        return _this.trackClickIncludeDropdownsSuffix(e, "MessagesLink");
      }
    }, void 0, _jsx("a", {
      href: this.props.messageIconUrl,
      title: "Messages",
      className: "headerPersonalNav"
    }, void 0, messageTrigger)), _jsx("li", {
      className: "personalNav__listItem",
      onClick: function onClick(e) {
        return _this.trackClickIncludeDropdownsSuffix(e, "FriendsLink");
      }
    }, void 0, _jsx("a", {
      href: this.props.friendIconUrl,
      title: "Friends",
      className: "headerPersonalNav"
    }, void 0, friendRequestTrigger)), this.renderProfileMenu());
  },
  renderNotifications: function renderNotifications() {
    return _jsx(_notifications2.default, {
      notificationIconUrl: this.props.notificationIconUrl,
      preferences: this.props.preferences,
      withDropdowns: this.props.withDropdowns
    });
  },
  renderProfileName: function renderProfileName() {
    // limit of 23 characters is about the width of the dropdown menu
    // visually approved by @ericf and @ohyes
    var name = this.props.name;
    if (name.length > 23) {
      name = name.substring(0, 22) + "…";
    }
    return _jsx("span", {
      className: "siteHeader__subNavLink gr-h3 gr-h3--noMargin"
    }, void 0, " ", name, " ");
  },
  renderProfileMenu: function renderProfileMenu() {
    if (this.props.includeProfileMenu === true) {
      var user = { viewableName: this.props.name,
        profileImage: this.props.profileImage,
        profileUrl: this.props.profileUrl };
      var profileIcon = _react2.default.createElement(_profile_menu_jewel2.default, _extends({}, this.props, { user: user, showNotificationsFlag: false }));
      var profileUrl = _lodash2.default.size(this.props.author) === 0 ? this.props.profileUrl : this.props.author.profileUrl;

      return _jsx("li", {
        className: "personalNav__listItem"
      }, void 0, _jsx(_dropdown2.default, {
        trigger: profileIcon,
        fallbackUrl: profileUrl,
        bemModifiers: "profileMenu",
        isInPersonalNav: "true",
        onShowCallback: function onShowCallback() {
          return (0, _click_and_view_tracking.trackNavEngage)("ProfileShow");
        }
      }, void 0, _jsx("div", {
        className: "siteHeader__subNav siteHeader__subNav--profile gr-box gr-box--withShadowLarge"
      }, void 0, this.renderProfileName(), _react2.default.createElement(_profile_menu2.default, _extends({}, this.props, { profileUrl: profileUrl })))));
    } else {
      return null;
    }
  }
});

},{"../../analytics/url_tracking_params":1,"../../modules/click_and_view_tracking":8,"../dropdown":75,"../gr_component_factory":87,"./notifications":100,"./profile_menu":106,"./profile_menu_jewel":107,"append-query":"append-query","lodash":"lodash","react":"react"}],102:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalNavDrawerModalId = undefined;

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _personal_nav = require("./personal_nav");

var _personal_nav2 = _interopRequireDefault(_personal_nav);

var _profile_menu = require("./profile_menu");

var _profile_menu2 = _interopRequireDefault(_profile_menu);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _shape_icon_values = require("../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var personalNavDrawerModalId = exports.personalNavDrawerModalId = "personalNavDrawerModal";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PersonalNavDrawer",

  render: function render() {
    var userIconUserProp = { viewableName: this.props.name,
      profileImage: this.props.profileImage,
      profileUrl: this.props.profileUrl };
    return _jsx(_modal2.default, {
      asDrawer: true,
      id: personalNavDrawerModalId
    }, void 0, _jsx("div", {
      className: "personalNavDrawer"
    }, void 0, _jsx("div", {
      className: "personalNavDrawer__personalNavContainer"
    }, void 0, React.createElement(_personal_nav2.default, _extends({}, this.props, {
      includeProfileMenu: false,
      withDropdowns: false }))), _jsx("div", {
      className: "personalNavDrawer__profileAndLinksContainer"
    }, void 0, _jsx("div", {
      className: "personalNavDrawer__profileContainer gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter"
    }, void 0, _jsx("div", {
      className: "gr-mediaFlexbox__media"
    }, void 0, _jsx(_user_icon2.default, {
      user: userIconUserProp,
      size: _shape_icon_values.ICON_SIZES.LARGE
    })), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("a", {
      href: this.props.profileUrl,
      className: "gr-hyperlink gr-hyperlink--bold"
    }, void 0, this.props.name), _jsx("div", {
      className: "u-displayBlock"
    }, void 0, _jsx("a", {
      href: this.props.profileUrl,
      className: "gr-hyperlink gr-hyperlink--naked"
    }, void 0, "View profile")))), _jsx("div", {
      className: "personalNavDrawer__profileMenuContainer"
    }, void 0, React.createElement(_profile_menu2.default, this.props)))));
  }
});

},{"../../modules/shape_icon_values":16,"../gr_component_factory":87,"../modal":118,"../user/user_icon":167,"./personal_nav":101,"./profile_menu":106}],103:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Component to implement the "Browse" and "Community" menus in the responsive
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           navbar, and possibly other similar menus in the future.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Requires a "tabName" prop, similar to the "name" prop of Tab, to identify this
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           menu among all navbar menus.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Originally forked from Dropdown.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRIMARY_NAV_MENU_TAB_GROUP = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _keys = require("../../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _tab_actions = require("../../react_actions/tab_actions");

var _tab_actions2 = _interopRequireDefault(_tab_actions);

var _tabs_store = require("../../react_stores/tabs_store");

var _tabs_store2 = _interopRequireDefault(_tabs_store);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _touch_not_ready_helper = require("../../modules/shared/touch_not_ready_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PRIMARY_NAV_MENU_TAB_GROUP = exports.PRIMARY_NAV_MENU_TAB_GROUP = "siteHeaderPrimaryNav";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Dropdown",

  mixins: [_reactOnclickoutside2.default, _reflux2.default.connect(_tabs_store2.default, "tabsStore"), _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  propTypes: {
    fallbackUrl: _react2.default.PropTypes.string,
    onShowCallback: _react2.default.PropTypes.func,
    tabName: _react2.default.PropTypes.string.isRequired,
    tooltipText: _react2.default.PropTypes.string,
    showingFavoriteGenres: _react2.default.PropTypes.bool,
    trigger: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element]).isRequired
  },

  hide: function hide() {
    _tab_actions2.default.deselectTab(this.props.tabName, PRIMARY_NAV_MENU_TAB_GROUP);
  },
  isMenuActive: function isMenuActive() {
    return this.props.tabName === this.state.tabsStore[PRIMARY_NAV_MENU_TAB_GROUP];
  },
  show: function show() {
    _tab_actions2.default.selectTab(this.props.tabName, PRIMARY_NAV_MENU_TAB_GROUP);
    if (this.props.onShowCallback) {
      this.props.onShowCallback();
    }
  },
  toggle: function toggle(ev) {
    (0, _touch_not_ready_helper.acknowledgeEvent)(ev);
    if (this.props.children) {
      ev.preventDefault();
    }
    this.isMenuActive() ? this.hide() : this.show();
  },
  openList: function openList(ev) {
    if (_keys2.default.isDropdownOpenerKey(ev.keyCode)) {
      ev.preventDefault();
      if (_keys2.default.isArrowDown(ev.keyCode)) {
        this.show();
      } else {
        this.toggle(ev);
      }
    } else if (_keys2.default.isDefaultCloserKey(ev.keyCode)) {
      ev.preventDefault();
      this.hide();
    }
  },
  handleClickOutside: function handleClickOutside() {
    // On touch devices that display dropdown components, touch gestures such as
    // panning and zooming trigger this event listener. We disabled hiding in
    // this listener for touch devices because hiding the dropdown on touch
    // gestures is disruptive.
    if (!this.state.userAgentCapabilities.touch) {
      this.hide();
    }
  },
  triggerClasses: function triggerClasses() {
    return (0, _classnames2.default)(this.withBemModifiers(["primaryNavMenu__trigger"]), { "primaryNavMenu__trigger--buttonReset": _lodash2.default.isUndefined(this.props.fallbackUrl) }, { "primaryNavMenu__trigger--active": this.isMenuActive() });
  },
  renderTriggerButton: function renderTriggerButton() {
    return _jsx("button", {
      className: this.triggerClasses(),
      "aria-haspopup": "true",
      "aria-expanded": this.isMenuActive(),
      onClick: this.toggle,
      onKeyDown: this.openList,
      title: this.props.tooltipText,
      "data-ux-click": true
    }, void 0, this.props.trigger);
  },
  renderTriggerLink: function renderTriggerLink() {
    return _jsx("a", {
      className: this.triggerClasses(),
      href: this.props.fallbackUrl,
      onClick: this.toggle,
      onKeyDown: this.openList,
      role: "button",
      "aria-haspopup": "true",
      "aria-expanded": this.isMenuActive(),
      title: this.props.tooltipText,
      "data-ux-click": true
    }, void 0, this.props.trigger);
  },
  render: function render() {
    /* Setting "ignore-react-onclickoutside" prevents a bug I was seeing where
       the menu was closing unexpectedly when clicking on the menu. (Should
       only close on clicks outside.) This *shouldn't* be necessary, but it
       fixes the problem, so I am going to run with it.
       Ref: https://github.com/Pomax/react-onclickoutside/tree/v4.5.0#marking-elements-as-skip-over-this-one-during-the-event-loop */
    var dropdownClasses = (0, _classnames2.default)(this.withBemModifiers("primaryNavMenu"), "ignore-react-onclickoutside");

    var dropdownContentsClasses = (0, _classnames2.default)("primaryNavMenu__menu", { "primaryNavMenu__menu--show": this.isMenuActive() }, "gr-box gr-box--withShadowLarge", { "wide": this.props.showingFavoriteGenres });

    var trigger = _lodash2.default.isUndefined(this.props.fallbackUrl) ? this.renderTriggerButton() : this.renderTriggerLink();
    var dropdownContents = _jsx("div", {
      className: dropdownContentsClasses,
      role: "menu"
    }, void 0, this.props.children);

    return _jsx("div", {
      className: dropdownClasses
    }, void 0, trigger, dropdownContents);
  }
});

},{"../../modules/keys":15,"../../modules/shared/touch_not_ready_helper":18,"../../react_actions/tab_actions":36,"../../react_stores/tabs_store":202,"../../react_stores/user_agent_capabilities_store":203,"../gr_component_factory":87,"classnames":"classnames","lodash":"lodash","react":"react","react-onclickoutside":"react-onclickoutside","reflux":"reflux"}],104:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

// COMPONENTS

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

var _community_menu = require("./community_menu");

var _community_menu2 = _interopRequireDefault(_community_menu);

var _browse_menu = require("./browse_menu");

var _browse_menu2 = _interopRequireDefault(_browse_menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PrimaryNavMenus",

  propTypes: {
    adId: _react2.default.PropTypes.string,
    browseUrl: _react2.default.PropTypes.string,
    choiceAwardsUrl: _react2.default.PropTypes.string,
    communityUrl: _react2.default.PropTypes.string,
    discussionsUrl: _react2.default.PropTypes.string,
    favoriteGenres: _react2.default.PropTypes.array,
    featuredAskAuthorUrl: _react2.default.PropTypes.string,
    genres: _react2.default.PropTypes.array.isRequired,
    giveawayUrl: _react2.default.PropTypes.string,
    exploreUrl: _react2.default.PropTypes.string,
    groupsUrl: _react2.default.PropTypes.string,
    homeUrl: _react2.default.PropTypes.string,
    listUrl: _react2.default.PropTypes.string,
    myBooksUrl: _react2.default.PropTypes.string,
    newReleasesUrl: _react2.default.PropTypes.string,
    peopleUrl: _react2.default.PropTypes.string,
    quotesUrl: _react2.default.PropTypes.string,
    recommendationsUrl: _react2.default.PropTypes.string,
    signedIn: _react2.default.PropTypes.bool
  },

  render: function render() {
    return _jsx("ul", {
      role: "menu",
      className: "siteHeader__menuList"
    }, void 0, _jsx("li", {
      className: "siteHeader__topLevelItem siteHeader__topLevelItem--home",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, "Home");
      }
    }, void 0, _jsx("a", {
      href: this.props.homeUrl,
      className: "siteHeader__topLevelLink"
    }, void 0, "Home")), _jsx("li", {
      className: "siteHeader__topLevelItem",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, "MyBooks");
      }
    }, void 0, _jsx("a", {
      href: this.props.myBooksUrl,
      className: "siteHeader__topLevelLink"
    }, void 0, "My Books")), _jsx("li", {
      className: "siteHeader__topLevelItem"
    }, void 0, _react2.default.createElement(_browse_menu2.default, this.props)), _jsx("li", {
      className: "siteHeader__topLevelItem siteHeader__topLevelItem--community"
    }, void 0, _react2.default.createElement(_community_menu2.default, this.props)));
  }
});

},{"../../modules/click_and_view_tracking":8,"../gr_component_factory":87,"./browse_menu":89,"./community_menu":90,"react":"react"}],105:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports.component = undefined;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _primary_nav_menus = require("./primary_nav_menus");

var _primary_nav_menus2 = _interopRequireDefault(_primary_nav_menus);

var _reactHeadroom = require("react-headroom");

var _reactHeadroom2 = _interopRequireDefault(_reactHeadroom);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _search_mobile_nav = require("../search/search_mobile_nav");

var _search_mobile_nav2 = _interopRequireDefault(_search_mobile_nav);

var _tabs_store = require("../../react_stores/tabs_store");

var _tabs_store2 = _interopRequireDefault(_tabs_store);

var _reactRedux = require("react-redux");

var _primary_nav_menu = require("./primary_nav_menu");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var component = exports.component = _gr_component_factory2.default.createClass({
  displayName: "PrimaryNavSeparateLine",

  mixins: [_reflux2.default.connect(_tabs_store2.default, "tabs")],

  propTypes: {
    autocompleteUrl: _react2.default.PropTypes.string.isRequired,
    searchPath: _react2.default.PropTypes.string.isRequired,
    signedIn: _react2.default.PropTypes.bool.isRequired,
    mobviousDeviceType: _react2.default.PropTypes.string,
    searchIsActive: _react2.default.PropTypes.bool,
    adId: _react2.default.PropTypes.string,
    browseUrl: _react2.default.PropTypes.string,
    choiceAwardsUrl: _react2.default.PropTypes.string,
    communityUrl: _react2.default.PropTypes.string,
    discussionsUrl: _react2.default.PropTypes.string,
    favoriteGenres: _react2.default.PropTypes.array,
    featuredAskAuthorUrl: _react2.default.PropTypes.string,
    genres: _react2.default.PropTypes.array.isRequired,
    giveawayUrl: _react2.default.PropTypes.string,
    groupsUrl: _react2.default.PropTypes.string,
    homeUrl: _react2.default.PropTypes.string,
    exploreUrl: _react2.default.PropTypes.string,
    listUrl: _react2.default.PropTypes.string,
    myBooksUrl: _react2.default.PropTypes.string,
    newReleasesUrl: _react2.default.PropTypes.string,
    peopleUrl: _react2.default.PropTypes.string,
    quotesUrl: _react2.default.PropTypes.string,
    recommendationsUrl: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return { searchIsActive: false };
  },
  isNavPinned: function isNavPinned() {
    // Keep the navbar visible if search or a menu is open
    return this.props.searchIsActive || !_lodash2.default.isEmpty(this.state.tabs[_primary_nav_menu.PRIMARY_NAV_MENU_TAB_GROUP]);
  },
  renderDefaultSeparateLine: function renderDefaultSeparateLine() {
    return _jsx("nav", {
      className: "siteHeader__primaryNavSeparateLine gr-box gr-box--withShadow"
    }, void 0, _react2.default.createElement(_primary_nav_menus2.default, this.props));
  },
  renderSearch: function renderSearch() {
    return _react2.default.createElement(_search_mobile_nav2.default, this.props);
  },
  render: function render() {
    return _jsx(_reactHeadroom2.default, {
      disable: this.isNavPinned()
    }, void 0, this.props.searchIsActive ? this.renderSearch() : this.renderDefaultSeparateLine());
  }
});

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return Object.assign({}, ownProps, state);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(component);

},{"../../react_stores/tabs_store":202,"../gr_component_factory":87,"../search/search_mobile_nav":136,"./primary_nav_menu":103,"./primary_nav_menus":104,"lodash":"lodash","react":"react","react-headroom":"react-headroom","react-redux":"react-redux","reflux":"reflux"}],106:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();
// COMPONENTS

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _click_and_view_tracking = require("../../modules/click_and_view_tracking");

var _menu_link = require("../menu_link");

var _menu_link2 = _interopRequireDefault(_menu_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ProfileMenu",

  propTypes: {
    author: _react2.default.PropTypes.shape({
      id: _react2.default.PropTypes.number,
      editProfileUrl: _react2.default.PropTypes.string,
      profileUrl: _react2.default.PropTypes.string,
      dashboardUrl: _react2.default.PropTypes.string,
      listAGiveawayUrl: _react2.default.PropTypes.string
    }),
    commentsUrl: _react2.default.PropTypes.string,
    discussionsUrl: _react2.default.PropTypes.string,
    editFavGenresUrl: _react2.default.PropTypes.string,
    groupInvitesCount: _react2.default.PropTypes.number,
    helpUrl: _react2.default.PropTypes.string,
    myFriendsUrl: _react2.default.PropTypes.string,
    myGroupsUrl: _react2.default.PropTypes.string,
    myQuotesUrl: _react2.default.PropTypes.string,
    myReadingChallengeUrl: _react2.default.PropTypes.string,
    myRecsUrl: _react2.default.PropTypes.string,
    name: _react2.default.PropTypes.string,
    pendingRecsCount: _react2.default.PropTypes.number,
    profileEditUrl: _react2.default.PropTypes.string,
    profileUrl: _react2.default.PropTypes.string,
    readingNotesUrl: _react2.default.PropTypes.string,
    signOutUrl: _react2.default.PropTypes.string
  },

  isAuthor: function isAuthor() {
    return !_lodash2.default.isUndefined(this.props.author);
  },
  groupInvitesMessage: function groupInvitesMessage() {
    var invitesCount = this.props.groupInvitesCount;
    if (invitesCount === 0) {
      return "No invitations";
    } else if (invitesCount === 1) {
      return "1 invitation";
    } else {
      return invitesCount + " invitations";
    }
  },
  renderGroupInvites: function renderGroupInvites() {
    if (this.props.groupInvitesCount > 0) {
      return _jsx("span", {
        className: "gr-smallAlert u-marginLeftXSmall"
      }, void 0, this.groupInvitesMessage());
    }
  },
  renderPendingRecs: function renderPendingRecs() {
    if (this.props.pendingRecsCount > 0) {
      return _jsx("span", {
        className: "gr-smallAlert u-marginLeftXSmall"
      }, void 0, this.props.pendingRecsCount + " new");
    }
  },
  renderAuthorDashboardLink: function renderAuthorDashboardLink() {
    if (this.isAuthor()) {
      return _jsx(_menu_link2.default, {
        href: this.props.author.dashboardUrl,
        linkText: "Author Dashboard",
        linkClass: "siteHeader__subNavLink"
      });
    }
  },
  renderListAGiveawayLink: function renderListAGiveawayLink() {
    if (this.isAuthor()) {
      return _jsx(_menu_link2.default, {
        href: this.props.author.listAGiveawayUrl,
        linkText: "List a Giveaway",
        linkClass: "siteHeader__subNavLink"
      });
    }
  },
  render: function render() {
    var editProfileUrl = !this.isAuthor() ? this.props.profileEditUrl : this.props.author.editProfileUrl;

    return _jsx("ul", {}, void 0, _jsx(_menu_link2.default, {
      linkText: "Profile"
    }, void 0, _jsx("a", {
      href: this.props.profileUrl,
      className: "siteHeader__subNavLink",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, _menu_link.MENU_LINK_TRACKING_PREFIX + "_Profile");
      }
    }, void 0, "Profile")), this.renderAuthorDashboardLink(), this.renderListAGiveawayLink(), _jsx(_menu_link2.default, {
      href: this.props.myFriendsUrl,
      linkText: "Friends",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      linkText: "Groups"
    }, void 0, _jsx("a", {
      href: this.props.myGroupsUrl,
      className: "siteHeader__subNavLink",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, _menu_link.MENU_LINK_TRACKING_PREFIX + "_MyGroups");
      }
    }, void 0, "Groups", this.renderGroupInvites())), _jsx(_menu_link2.default, {
      href: this.props.discussionsUrl,
      linkText: "Discussions",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      href: this.props.commentsUrl,
      linkText: "Comments",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      href: this.props.myReadingChallengeUrl,
      linkText: "Reading Challenge",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      href: this.props.readingNotesUrl,
      linkText: "Kindle Notes & Highlights",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      href: this.props.myQuotesUrl,
      linkText: "Quotes",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      href: this.props.editFavGenresUrl,
      linkText: "Favorite genres",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      linkText: "Friends' recommendations"
    }, void 0, _jsx("a", {
      href: this.props.myRecsUrl,
      className: "siteHeader__subNavLink",
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, _menu_link.MENU_LINK_TRACKING_PREFIX + "_FriendsRecommendations");
      }
    }, void 0, "Friends’ recommendations", this.renderPendingRecs())), _jsx(_menu_link2.default, {
      href: editProfileUrl,
      linkText: "Account settings",
      linkClass: "siteHeader__subNavLink u-topGrayBorder"
    }), _jsx(_menu_link2.default, {
      href: this.props.helpUrl,
      linkText: "Help",
      linkClass: "siteHeader__subNavLink"
    }), _jsx(_menu_link2.default, {
      href: this.props.signOutUrl,
      linkText: "Sign out",
      linkClass: "siteHeader__subNavLink",
      method: "POST"
    }));
  }
});

},{"../../modules/click_and_view_tracking":8,"../gr_component_factory":87,"../menu_link":117,"lodash":"lodash","react":"react"}],107:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _notifications_store = require("../../react_stores/notifications_store");

var _notifications_store2 = _interopRequireDefault(_notifications_store);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _user_icon = require("../user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ProfileMenuJewel",

  mixins: [_reflux2.default.connect(_notifications_store2.default, "notificationsStore")],

  propTypes: {
    notificationIconUrl: _react2.default.PropTypes.string,
    showNotificationsFlag: _react2.default.PropTypes.bool,
    tempFriendRequestCount: _react2.default.PropTypes.number,
    tempUnreadMessageCount: _react2.default.PropTypes.number,
    user: _react2.default.PropTypes.shape({
      viewableName: _react2.default.PropTypes.string.isRequired,
      profileImage: _react2.default.PropTypes.string.isRequired,
      profileUrl: _react2.default.PropTypes.string
    }).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      showNotificationsFlag: true,
      tempFriendRequestCount: 0,
      tempUnreadMessageCount: 0
    };
  },
  notificationsCountString: function notificationsCountString() {
    var state = this.state.notificationsStore;
    return state.unreadCount + this.props.tempFriendRequestCount + this.props.tempUnreadMessageCount + (state.unreadCountMore ? "+" : "");
  },
  render: function render() {
    return _jsx("span", {
      className: "headerPersonalNav__icon"
    }, void 0, this.renderNotificationsCountFlag(), _jsx(_user_icon2.default, {
      user: this.props.user,
      includeLink: false
    }));
  },
  renderNotificationsCountFlag: function renderNotificationsCountFlag() {
    if (this.props.showNotificationsFlag === true) {
      if (this.state.notificationsStore.unreadCount > 0 || this.props.tempFriendRequestCount > 0 || this.props.tempUnreadMessageCount > 0) {
        return _jsx("span", {
          className: "headerPersonalNav__flag"
        }, void 0, this.notificationsCountString());
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
});

},{"../../react_stores/notifications_store":198,"../gr_component_factory":87,"../user/user_icon":167,"react":"react","reflux":"reflux"}],108:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _dot_separated_elements = require("../dot_separated_elements");

var _dot_separated_elements2 = _interopRequireDefault(_dot_separated_elements);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "EditorialBlogThumbnail",
  propTypes: {
    likesCountText: _react2.default.PropTypes.string,
    commentsCountText: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    blogPostUrl: _react2.default.PropTypes.string.isRequired,
    title: _react2.default.PropTypes.string.isRequired,
    header: _react2.default.PropTypes.string.isRequired
  },

  renderBlogLink: function renderBlogLink(text) {
    return _jsx("span", {
      className: "gr-metaText"
    }, void 0, text);
  },
  renderImage: function renderImage() {
    if (this.props.imageUrl) {
      return _jsx("a", {
        href: this.props.blogPostUrl
      }, void 0, _jsx("img", {
        className: "gr-editorialBlogPost__image",
        src: this.props.imageUrl,
        alt: "" + this.props.title
      }));
    } else {
      return null;
    }
  },
  renderLikesAndComments: function renderLikesAndComments() {
    var likesLink = this.renderBlogLink(this.props.likesCountText);
    var commentsLink = this.renderBlogLink(this.props.commentsCountText);
    if (this.props.likesCountText && this.props.commentsCountText) {
      return _jsx(_dot_separated_elements2.default, {
        elements: [likesLink, commentsLink]
      });
    } else if (this.props.likesCountText) {
      return likesLink;
    } else if (this.props.commentsCountText) {
      return commentsLink;
    } else {
      return null;
    }
  },
  render: function render() {
    return _jsx("section", {
      className: "gr-editorialBlogPost"
    }, void 0, _jsx("article", {}, void 0, _jsx("h3", {}, void 0, this.props.header), _jsx("a", {
      href: this.props.blogPostUrl,
      className: "gr-editorialBlogPost__title"
    }, void 0, this.props.title), this.renderImage(), _jsx("div", {
      className: "gr-editorialBlogPost__likesAndComments"
    }, void 0, this.renderLikesAndComments())));
  }
});

},{"../dot_separated_elements":73,"../gr_component_factory":87,"react":"react"}],109:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();
// react-router imports

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.JobsListComponent = undefined;

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _lodash = require("lodash");

var _Router = require("react-router/lib/Router");

var _Router2 = _interopRequireDefault(_Router);

var _RouterContext = require("react-router/lib/RouterContext");

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _Route = require("react-router/lib/Route");

var _Route2 = _interopRequireDefault(_Route);

var _Link = require("react-router/lib/Link");

var _Link2 = _interopRequireDefault(_Link);

var _browserHistory = require("react-router/lib/browserHistory");

var _browserHistory2 = _interopRequireDefault(_browserHistory);

var _match = require("react-router/lib/match");

var _match2 = _interopRequireDefault(_match);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JOBS_BASE_PATH = "/jobs";
var HEADING_TITLE_TEXT = "Find your next job";
var HEADING_SUBTITLE_TEXT = "Want to be part of creating innovative experiences for the largest community of readers? We’re hiring!";
var HEADING_SUBTITLE_NO_JOBS_TEXT = "Sorry, we do not have any open positions at this time. Please check again soon!";
var LOCATION_HEADING_TEXT = "Location City";
var SUBMITTED_APP_TEXT = "Check on a submitted application";
var SUBMITTED_APP_URL = "https://account.amazon.jobs";
var JOB_TITLE_SUBSTRINGS_TO_STRIP = [" - Goodreads", ", Goodreads"];
var BACK_TO_JOBS_TEXT = "Back to all jobs";
var BASIC_QUALS_HEADING_TEXT = "Basic Qualifications:";
var PREF_QUALS_HEADING_TEXT = "Preferred Qualifications:";
var LEGAL_TEXT = "Qualified applicants with criminal histories will be considered in a manner consistent with all applicable local, state and federal laws, including the San Francisco Fair Chance Ordinance.";
var APPLY_BUTTON_TEXT = "Apply now";
var APPLY_URL_EXTENSION = "apply";
var BODY_CLASS = "jobsListBody";

var JobsListComponent = exports.JobsListComponent = _gr_component_factory2.default.createClass({
  displayName: "JobsList",

  getJobs: function getJobs() {
    return this.props.route.jobs;
  },
  getSelectedJobData: function getSelectedJobData() {
    return this.getJobs() ? this.getJobs()[this.props.location.query.id] : null;
  },
  displayableJobTitle: function displayableJobTitle(title) {
    var titleToDisplay = title;
    JOB_TITLE_SUBSTRINGS_TO_STRIP.forEach(function (substring) {
      titleToDisplay = titleToDisplay.replace(substring, "");
    });
    return titleToDisplay;
  },
  renderBackToAllJobsButton: function renderBackToAllJobsButton() {
    return _jsx(_Link2.default, {
      to: JOBS_BASE_PATH
    }, void 0, _jsx("span", {
      className: "gr-hyperlink"
    }, void 0, BACK_TO_JOBS_TEXT));
  },
  renderHeading: function renderHeading() {
    var jobsListHeadingSubtitleClass = (0, _classnames2.default)(this.withBemModifiers("jobsListHeading__subtitle"), { "jobsListHeading__subtitle--jobSelected": this.getSelectedJobData() });
    return _jsx("div", {
      className: "gr-row gr-justify-content-center"
    }, void 0, _jsx("div", {
      className: "gr-col gr-col-md-7 gr-col-lg-8"
    }, void 0, _jsx("h2", {
      className: "gr-marketingPageH2 jobsListHeading__title"
    }, void 0, HEADING_TITLE_TEXT), _jsx("p", {
      className: jobsListHeadingSubtitleClass
    }, void 0, this.getJobs() ? HEADING_SUBTITLE_TEXT : HEADING_SUBTITLE_NO_JOBS_TEXT)));
  },
  renderLocation: function renderLocation(normalizedLocation) {
    var locationClass = (0, _classnames2.default)(this.withBemModifiers("jobsListItem__location"), { "jobsListItem__location--jobSelected": this.getSelectedJobData() });
    return _jsx("div", {
      className: locationClass
    }, void 0, normalizedLocation.replace(", USA", ""));
  },
  renderJobItem: function renderJobItem(id) {
    var job = this.getJobs()[id];
    if (job) {
      return _jsx("div", {
        id: id,
        className: "gr-row jobsListItem"
      }, id, _jsx("div", {
        className: "gr-col gr-col-md-6 gr-col-lg-7 gr-col-md-offset-1"
      }, void 0, _jsx(_Link2.default, {
        to: JOBS_BASE_PATH + "?id=" + id
      }, void 0, _jsx("span", {
        className: "gr-hyperlink gr-d-block jobsListItem__link"
      }, void 0, this.displayableJobTitle(job.title))), _jsx("div", {
        className: "gr-d-block gr-d-md-none"
      }, void 0, this.renderLocation(job.location))), _jsx("div", {
        className: "gr-col gr-col-md-4 gr-col-lg-3 gr-d-none gr-d-md-flex"
      }, void 0, this.renderLocation(job.location)));
    } else {
      return null;
    }
  },
  renderLocationHeading: function renderLocationHeading() {
    return _jsx("div", {
      className: "gr-col gr-col-md-4 gr-col-lg-3 gr-d-none gr-d-md-flex"
    }, void 0, _jsx("h3", {
      className: "gr-h3"
    }, void 0, LOCATION_HEADING_TEXT));
  },
  renderCategoryHeading: function renderCategoryHeading(category) {
    var categoryKeys = Object.keys(this.props.route.categories);
    var isFirstCategoryHeading = category === categoryKeys[0];
    return _jsx("div", {
      className: "gr-row"
    }, void 0, _jsx("div", {
      className: "gr-col gr-col-md-6 gr-col-lg-7 gr-col-md-offset-1"
    }, void 0, _jsx("h3", {
      className: "gr-h3"
    }, void 0, category)), isFirstCategoryHeading && this.renderLocationHeading());
  },
  getJobMarkup: function getJobMarkup(markup) {
    return { __html: markup };
  },
  renderSelectedJob: function renderSelectedJob() {
    var jobData = this.getSelectedJobData();
    var selectedJobTitle = this.displayableJobTitle(jobData.title);
    return _jsx("div", {
      className: "jobsListSelectedJob"
    }, void 0, _jsx("h4", {
      className: "gr-marketingPageH4"
    }, void 0, selectedJobTitle), this.renderLocation(jobData.location), _jsx("p", {
      dangerouslySetInnerHTML: this.getJobMarkup(jobData.description),
      className: "jobsListSelectedJob__description"
    }), _jsx("h5", {
      className: "gr-marketingPageH5"
    }, void 0, BASIC_QUALS_HEADING_TEXT), _jsx("div", {
      dangerouslySetInnerHTML: this.getJobMarkup(jobData.basic_qualifications),
      className: "jobsListSelectedJob__basicQuals"
    }), _jsx("h5", {
      className: "gr-marketingPageH5"
    }, void 0, PREF_QUALS_HEADING_TEXT), _jsx("div", {
      dangerouslySetInnerHTML: this.getJobMarkup(jobData.preferred_qualifications),
      className: "jobsListSelectedJob__preferredQuals"
    }));
  },
  renderCheckJobApp: function renderCheckJobApp() {
    var checkAppClass = (0, _classnames2.default)({ "gr-hyperlink": this.getSelectedJobData() }, { "gr-button gr-button--large gr-button--fullWidth gr-button--teal": !this.getSelectedJobData() });
    return _jsx("a", {
      href: SUBMITTED_APP_URL,
      className: checkAppClass
    }, void 0, SUBMITTED_APP_TEXT);
  },
  renderApplicationButtons: function renderApplicationButtons() {
    var jobData = this.getSelectedJobData();
    return _jsx("div", {
      className: "jobsListSelectedJob__applicationButtons"
    }, void 0, _jsx("div", {
      className: "jobsListApplyButton gr-d-md-inline"
    }, void 0, _jsx("a", {
      href: "" + SUBMITTED_APP_URL + JOBS_BASE_PATH + "/" + jobData.id_icims + "/" + APPLY_URL_EXTENSION,
      className: "gr-button gr-button--large gr-button--teal"
    }, void 0, APPLY_BUTTON_TEXT)), _jsx("div", {
      className: "jobsListCheckJobAppContainer gr-d-md-inline"
    }, void 0, this.renderCheckJobApp()));
  },
  render: function render() {
    var _this = this;

    if (this.getSelectedJobData()) {
      return _jsx("div", {
        className: BODY_CLASS
      }, void 0, this.renderHeading(), _jsx("div", {
        className: "gr-row gr-justify-content-center"
      }, void 0, _jsx("div", {
        className: "gr-col gr-col-md-10 gr-col-lg-8"
      }, void 0, _jsx("div", {
        className: "jobsListBackToAllJobsContainer--top"
      }, void 0, this.renderBackToAllJobsButton()), this.renderSelectedJob(), _jsx("div", {
        className: "jobsListLegalText"
      }, void 0, LEGAL_TEXT), this.renderApplicationButtons(), _jsx("div", {
        className: "jobsListBackToAllJobsContainer--bottom"
      }, void 0, this.renderBackToAllJobsButton()))));
    } else {
      var jobsListCheckJobAppContainerClass = (0, _classnames2.default)("gr-row gr-justify-content-center jobsListCheckJobAppContainer--jobList", { "jobsListCheckJobAppContainer--noJobs": !this.getJobs() });
      return _jsx("div", {
        className: BODY_CLASS
      }, void 0, this.renderHeading(), (0, _lodash.map)(this.props.route.categories, function (jobIds, category) {
        return _jsx("div", {
          className: "jobsListCategory"
        }, category, _this.renderCategoryHeading(category), (0, _lodash.map)(jobIds, function (jobId) {
          return _this.renderJobItem(jobId);
        }));
      }), _jsx("div", {
        className: jobsListCheckJobAppContainerClass
      }, void 0, _jsx("div", {
        className: "gr-col gr-col-10 gr-col-md-6 gr-col-lg-4"
      }, void 0, this.renderCheckJobApp())));
    }
  }
});

var JobsListRouter = function JobsListRouter(props) {
  var routes = React.createElement(_Route2.default, _extends({ path: JOBS_BASE_PATH + "(?id=*)",
    component: JobsListComponent,
    onChange: function onChange() {
      var scrollToElement = document.getElementsByClassName(BODY_CLASS)[0].parentElement;
      if (scrollToElement !== null) {
        scrollToElement.scrollIntoView(true);
      }
    }
  }, props));
  // server side rendering
  if (_env_utils2.default.domUnavailable()) {
    var routeProps = undefined;
    var location = JOBS_BASE_PATH;
    if (props.selectedId) {
      location += "?id=" + props.selectedId;
    }
    (0, _match2.default)({ routes: routes, location: location }, function (_error, _redirectLocation, _routeProps) {
      routeProps = _routeProps;
    });
    return React.createElement(_RouterContext2.default, routeProps);
  } else {
    return _jsx(_Router2.default, {
      history: _browserHistory2.default
    }, void 0, routes);
  }
};

JobsListRouter.propTypes = {
  selectedId: _react.PropTypes.string,
  categories: _react.PropTypes.object,
  jobs: _react.PropTypes.object
};

exports.default = JobsListRouter;

},{"../modules/env_utils":13,"./gr_component_factory":87,"classnames":"classnames","lodash":"lodash","react":"react","react-router/lib/Link":210,"react-router/lib/Route":214,"react-router/lib/Router":216,"react-router/lib/RouterContext":217,"react-router/lib/browserHistory":220,"react-router/lib/match":228}],110:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LibrarianQuiz = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _ajax_helper = require("../../modules/ajax/ajax_helper");

var _env_utils = require("../../modules/env_utils");

var _flash_message = require("../flash_message");

var _flash_message2 = _interopRequireDefault(_flash_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LibrarianQuiz = exports.LibrarianQuiz = (function (_React$Component) {
  _inherits(LibrarianQuiz, _React$Component);

  function LibrarianQuiz(props) {
    _classCallCheck(this, LibrarianQuiz);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(LibrarianQuiz).call(this, props));

    _this.state = _extends({}, _this.props, {
      userAnswers: {},
      gradingInProgress: false
    });

    _this.renderManualLinkBox = _this.renderManualLinkBox.bind(_this);
    _this.gradeQuiz = _this.gradeQuiz.bind(_this);
    _this.addUserAnswer = _this.addUserAnswer.bind(_this);
    _this.renderAnswerRadioInput = _this.renderAnswerRadioInput.bind(_this);
    _this.renderButton = _this.renderButton.bind(_this);
    _this.renderStatusFlashMessage = _this.renderStatusFlashMessage.bind(_this);
    return _this;
  }

  _createClass(LibrarianQuiz, [{
    key: "gradeQuiz",
    value: function gradeQuiz() {
      this.setState({ gradingInProgress: true });
      (0, _ajax_helper.httpPost)("/librarian/submit_quiz", {
        data: { userAnswers: this.state.userAnswers }
      }).done(function (response) {
        (0, _env_utils.setLocationUrl)(response.redirect);
      });
    }
  }, {
    key: "addUserAnswer",
    value: function addUserAnswer(questionId, answerId) {
      var newUserAnswers = this.state.userAnswers;
      newUserAnswers[questionId] = answerId;
      this.setState({ userAnswers: newUserAnswers });
    }
  }, {
    key: "renderStatusFlashMessage",
    value: function renderStatusFlashMessage() {
      if (this.state.statusMessage && !this.state.adminViewing) {
        if (!this.state.passedQuiz) {
          return _jsx(_flash_message2.default, {
            category: "error",
            message: this.state.statusMessage
          });
        } else {
          return _jsx(_flash_message2.default, {
            category: "info",
            message: this.state.statusMessage
          });
        }
      } else {
        return null;
      }
    }
  }, {
    key: "renderAnswerRadioInput",
    value: function renderAnswerRadioInput(question, answerId) {
      var _this2 = this;

      var questionId = question.questionId;
      if (this.state.finishedQuiz) {
        return _jsx("input", {
          name: "quizQuestion" + questionId,
          value: answerId,
          type: "radio",
          checked: question.userAnswer === answerId,
          disabled: true,
          className: "gr-radioButtonGroup__button"
        });
      } else {
        return _jsx("input", {
          name: "quizQuestion" + questionId,
          value: answerId,
          type: "radio",
          onChange: function onChange() {
            _this2.addUserAnswer(questionId, answerId);
          },
          className: "gr-radioButtonGroup__button"
        });
      }
    }
  }, {
    key: "renderManualLinkBox",
    value: function renderManualLinkBox(question) {
      if (this.state.finishedQuiz && !question.isUserAnswerCorrect) {
        return _jsx("div", {
          className: "gr-infoMessageBox"
        }, void 0, "Incorrect answer! Please consult the", " ", _jsx("a", {
          href: question.manualLink,
          className: "gr-hyperlink"
        }, void 0, "Librarian Manual"), " ", "for more information.");
      } else {
        return null;
      }
    }
  }, {
    key: "renderButton",
    value: function renderButton() {
      if (this.state.finishedQuiz) {
        if (this.state.passedQuiz && !this.state.adminViewing) {
          return _jsx("a", {
            className: "gr-button",
            href: "/librarian/apply_librarian"
          }, void 0, "Apply");
        } else {
          return null;
        }
      } else {
        return _jsx("button", {
          className: "gr-button",
          onClick: this.gradeQuiz,
          disabled: this.state.gradingInProgress
        }, void 0, "Submit");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _jsx("div", {}, void 0, this.renderStatusFlashMessage(), (0, _lodash.map)(this.state.attemptAnswers, function (question) {
        return _jsx("fieldset", {
          className: "gr-radioButtonGroup u-marginTopMedium u-marginBottomMedium"
        }, question.questionId, _this3.renderManualLinkBox(question), _jsx("legend", {
          className: "mediumLargeText fullSizeContainer"
        }, void 0, question.questionText), (0, _lodash.map)(question.answers, function (answer, index) {
          return _jsx("label", {
            className: "gr-radioButtonGroup__choice gr-label gr-label--muted"
          }, answer.answerId, _this3.renderAnswerRadioInput(question, answer.answerId), String.fromCharCode(65 + index), ": ", answer.answerText);
        }));
      }), this.renderButton());
    }
  }]);

  return LibrarianQuiz;
})(_react2.default.Component);

LibrarianQuiz.propTypes = {
  finishedQuiz: _react2.default.PropTypes.bool,
  passedQuiz: _react2.default.PropTypes.bool,
  adminViewing: _react2.default.PropTypes.bool,
  statusMessage: _react2.default.PropTypes.string,
  attemptAnswers: _react2.default.PropTypes.array
};

exports.default = LibrarianQuiz;

},{"../../modules/ajax/ajax_helper":4,"../../modules/env_utils":13,"../flash_message":84,"lodash":"lodash","react":"react"}],111:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This component renders a list of items that are vertically divided by gray borders,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             as well as an optional set of headers for the items.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             The item type must be a React component that accepts the children of
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             a ListWithDividers item as props.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Ref: https://w.amazon.com/bin/view/Goodreads/Teams/Mobile_web/Responsive_SeriesList_Components_Refactor/
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectHash = require("object-hash");

var _objectHash2 = _interopRequireDefault(_objectHash);

var _react = require("react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListWithDividers = function ListWithDividers(_ref) {
  var ItemComponentType = _ref.ItemComponentType;
  var items = _ref.items;
  var itemHeaders = _ref.itemHeaders;

  var itemsArray = items.map(function (item, idx) {

    var itemHeader = itemHeaders && itemHeaders[idx] ? _jsx("h3", {
      className: "gr-h3 gr-h3--noBottomMargin"
    }, void 0, itemHeaders[idx]) : null;

    return _jsx("div", {
      className: "listWithDividers__item"
    }, (0, _objectHash2.default)(item), itemHeader, React.createElement(ItemComponentType, item));
  });

  return _jsx("div", {
    className: "listWithDividers"
  }, void 0, itemsArray);
};

ListWithDividers.propTypes = {
  ItemComponentType: _react.PropTypes.func.isRequired,
  items: _react.PropTypes.array.isRequired,
  itemHeaders: _react.PropTypes.array
};

exports.default = ListWithDividers;

},{"object-hash":"object-hash","react":"react"}],112:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MEDIUM_DEVICE_BREAKPOINT = 768;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "AmazonLoginButton",

  getInitialState: function getInitialState() {
    return {
      popup: false
    };
  },

  propTypes: {
    amazonSignInUrl: _react2.default.PropTypes.string.isRequired,
    enabled: _react2.default.PropTypes.bool,
    fullWidth: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      enabled: false,
      fullWidth: false
    };
  },
  componentDidMount: function componentDidMount() {
    this.setState({
      popup: window.innerWidth > MEDIUM_DEVICE_BREAKPOINT });
  },
  // or smaller
  handleButtonPress: function handleButtonPress() {
    if (this.state.popup) {
      window.open(this.props.amazonSignInUrl, "", "width=900,height=540");
    } else {
      window.location.assign(this.props.amazonSignInUrl);
    }
  },
  render: function render() {
    if (this.props.enabled) {
      return _jsx("button", {
        className: "gr-button gr-button--amazon gr-button--auth " + (this.props.fullWidth ? "gr-button--fullWidth" : ""),
        onClick: this.handleButtonPress
      }, void 0, _jsx("div", {
        className: "gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter gr-mediaFlexbox--justifyHorizontalContentCenter"
      }, void 0, _jsx("div", {
        className: "gr-mediaFlexbox__media gr-button--amazon__icon"
      }), _jsx("div", {
        className: "gr-mediaFlexbox__desc"
      }, void 0, "Continue with Amazon")));
    }
    return null;
  }
});

},{"../gr_component_factory":87,"react":"react"}],113:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MEDIUM_DEVICE_BREAKPOINT = 768;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FacebookLoginButton",

  getInitialState: function getInitialState() {
    return {
      popup: false
    };
  },

  propTypes: {
    enabled: _react2.default.PropTypes.bool,
    facebookRedirectUrl: _react2.default.PropTypes.string.isRequired,
    facebookSignInUrl: _react2.default.PropTypes.string.isRequired,
    fullWidth: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      enabled: false,
      fullWidth: false
    };
  },
  componentDidMount: function componentDidMount() {
    this.setState({
      popup: window.innerWidth > MEDIUM_DEVICE_BREAKPOINT });
  },
  // or smaller
  handleButtonPress: function handleButtonPress() {
    if (this.state.popup && typeof $grfb !== "undefined") {
      $grfb.login({
        redirect: this.props.facebookRedirectUrl
      });
    } else {
      window.location.assign(this.props.facebookSignInUrl);
    }
  },
  render: function render() {
    if (this.props.enabled && typeof $grfb !== "undefined") {
      return _jsx("button", {
        className: "gr-button gr-button--facebook gr-button--auth " + (this.props.fullWidth ? "gr-button--fullWidth" : ""),
        onClick: this.handleButtonPress
      }, void 0, _jsx("div", {
        className: "gr-mediaFlexbox gr-mediaFlexbox--alignItemsCenter gr-mediaFlexbox--justifyHorizontalContentCenter"
      }, void 0, _jsx("div", {
        className: "gr-mediaFlexbox__media gr-button--facebook__icon"
      }), _jsx("div", {
        className: "gr-mediaFlexbox__desc"
      }, void 0, "Continue with Facebook")));
    }
    return null;
  }
});

},{"../gr_component_factory":87,"react":"react"}],114:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Renders a Modal inviting the user to sign up or sign in. Aimed at signed out
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           visitors, with server-side business logic checking whether or not it should be
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           displayed, so calls an AJAX endpoint in componentDidMount.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _amazon_login_button = require("../../login/amazon_login_button");

var _amazon_login_button2 = _interopRequireDefault(_amazon_login_button);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _facebook_login_button = require("../../login/facebook_login_button");

var _facebook_login_button2 = _interopRequireDefault(_facebook_login_button);

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal = require("../../modal");

var _modal2 = _interopRequireDefault(_modal);

var _register_button = require("../../login/register_button");

var _register_button2 = _interopRequireDefault(_register_button);

var _service_terms_and_privacy = require("../../login/service_terms_and_privacy");

var _service_terms_and_privacy2 = _interopRequireDefault(_service_terms_and_privacy);

var _ajax_helper = require("../../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "LoginInterstitial",

  propTypes: {
    allowAmazonSignIn: React.PropTypes.bool,
    allowFacebookSignIn: React.PropTypes.bool,
    overrideSignedOutPageCount: React.PropTypes.bool.isRequired,
    path: React.PropTypes.shape({
      termsUrl: React.PropTypes.string.isRequired,
      privacyUrl: React.PropTypes.string.isRequired
    }).isRequired
  },

  componentDidMount: function componentDidMount() {
    var _this = this;

    (0, _ajax_helper.httpGet)("/sign_in_prompt", {
      data: {
        countOverride: this.props.overrideSignedOutPageCount
      } }).done(function (promptValues, responseStatus) {
      if (responseStatus === "success") {
        _this.setState({
          signInUrl: promptValues.signInUrl,
          signUpUrl: promptValues.signUpUrl,
          thirdPartyRedirectUrl: promptValues.thirdPartyRedirectUrl,
          amazonSignInUrl: promptValues.amazonSignInUrl,
          deviceType: promptValues.deviceType,
          facebookSignInUrl: promptValues.facebookSignInUrl,
          isShown: promptValues.showPrompt === true && promptValues.isDelayed === false
        });
        if (promptValues.showPrompt === true && promptValues.isDelayed === true) {
          _this.timer = setTimeout(function () {
            _this.setState({ isShown: true });
          }, 20000);
        }
      } else if (responseStatus === "nocontent") {
        // HTTP 204 means "no prompt"
        _this.setState({ isShown: false });
      }
    }).fail(function () {
      // If call returns other failure, don't show.
      _this.setState({ isShown: false });
    });
  },
  getDefaultProps: function getDefaultProps() {
    return {
      allowAmazonSignIn: false,
      allowFacebookSignIn: false
    };
  },
  getInitialState: function getInitialState() {
    return { isShown: false };
  },
  isResponsive: function isResponsive() {
    // Design decision to show the responsive variant of the pop-up on mobile
    // devices. I think we want to make that the only variant, eventually.
    return this.state.deviceType === "mobile";
  },
  onCloseHandler: function onCloseHandler() {
    (0, _ajax_helper.httpPost)("/track/track_click", {
      data: { feature: "LoginInterstitial:dismiss" }
    });
    if (this.state.deviceType) {
      (0, _ajax_helper.httpPost)("/track/track_click", {
        data: { feature: "LoginInterstitial:" + this.state.deviceType + ":" + ":dismiss" }
      });
    }
  },
  showPopUpBook: function showPopUpBook() {
    return this.state.deviceType === "desktop";
  },
  renderAmazonLoginButton: function renderAmazonLoginButton() {
    if (this.state.amazonSignInUrl) {
      return _jsx("div", {
        className: "loginModal__button"
      }, void 0, _jsx(_amazon_login_button2.default, {
        enabled: this.props.allowAmazonSignIn,
        amazonSignInUrl: this.state.amazonSignInUrl,
        fullWidth: true
      }));
    }
  },
  renderFacebookLoginButton: function renderFacebookLoginButton() {
    if (this.state.facebookSignInUrl) {
      return _jsx("div", {
        className: "loginModal__button"
      }, void 0, _jsx(_facebook_login_button2.default, {
        enabled: this.props.allowFacebookSignIn,
        facebookRedirectUrl: this.state.thirdPartyRedirectUrl,
        facebookSignInUrl: this.state.facebookSignInUrl,
        fullWidth: true
      }));
    }
  },
  renderContent: function renderContent() {
    var containerClasses = (0, _classnames2.default)("loginModal", { "loginModal--responsive": this.isResponsive() });
    var modalContent = _jsx("div", {
      className: containerClasses
    }, void 0, this.showPopUpBook() ? "" : _jsx("div", {
      className: "loginModal__icon",
      alt: "Goodreads"
    }), _jsx("div", {
      className: "loginModal__header"
    }, void 0, _jsx("h3", {
      className: "gr-h3 gr-h3--serif gr-h3--noMargin"
    }, void 0, "Discover & read more")), this.showPopUpBook() ? _jsx("div", {
      className: "loginModal__popUpBook"
    }) : "", _jsx("div", {
      className: "loginModal__body"
    }, void 0, _jsx("span", {
      className: "u-defaultType"
    }, void 0, "Sign up to get better recommendations with a free account."), _jsx("div", {
      className: "loginModal__cta"
    }, void 0, this.renderAmazonLoginButton(), _jsx("div", {
      className: "loginModal__button"
    }, void 0, _jsx(_register_button2.default, {
      fullWidth: true,
      signUpUrl: this.state.signUpUrl
    })), _jsx("span", {
      className: "u-defaultType"
    }, void 0, "Already a member?  ", _jsx("a", {
      href: this.state.signInUrl,
      rel: "nofollow"
    }, void 0, "Sign in"))), _jsx(_service_terms_and_privacy2.default, {
      termsUrl: this.props.path.termsUrl,
      privacyUrl: this.props.path.privacyUrl
    })));
    return modalContent;
  },
  render: function render() {
    if (this.state.isShown) {
      var modal = _jsx(_modal2.default, {
        id: "LoginInterstitial",
        centered: true,
        onCloseHandler: this.onCloseHandler,
        responsive: this.isResponsive(),
        showByDefault: true
      }, void 0, this.renderContent());
      return modal;
    } else {
      return null;
    }
  }
});

},{"../../../modules/ajax/ajax_helper":4,"../../gr_component_factory":87,"../../login/amazon_login_button":112,"../../login/facebook_login_button":113,"../../login/register_button":115,"../../login/service_terms_and_privacy":116,"../../modal":118,"classnames":"classnames"}],115:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "RegisterButton",

  propTypes: {
    fullWidth: _react2.default.PropTypes.bool,
    signUpUrl: _react2.default.PropTypes.string.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      fullWidth: false
    };
  },
  render: function render() {
    var registerButton = _jsx("a", {
      className: "gr-button gr-button--large " + (this.props.fullWidth ? "gr-button--fullWidth" : ""),
      href: this.props.signUpUrl
    }, void 0, "Sign up with email");
    return registerButton;
  }
});

},{"../gr_component_factory":87,"react":"react"}],116:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ServiceTermsAndPrivacy",

  propTypes: {
    privacyUrl: _react2.default.PropTypes.string.isRequired,
    termsUrl: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    var serviceTermsAndPrivacy = _jsx("small", {}, void 0, "By clicking “Sign up” I agree to the Goodreads ", _jsx("a", {
      href: this.props.termsUrl,
      rel: "nofollow",
      target: "_blank"
    }, void 0, "Terms of Service"), " and confirm that I am at least 13 years old.  Read our ", _jsx("a", {
      href: this.props.privacyUrl,
      rel: "nofollow",
      target: "_blank"
    }, void 0, "Privacy Policy"));
    return serviceTermsAndPrivacy;
  }
});

},{"../gr_component_factory":87,"react":"react"}],117:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MENU_LINK_TRACKING_PREFIX = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _lodash = require("lodash");

var _click_and_view_tracking = require("../modules/click_and_view_tracking");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MENU_LINK_TRACKING_PREFIX = exports.MENU_LINK_TRACKING_PREFIX = "MenuLink";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "MenuLink",

  propTypes: {
    href: _react2.default.PropTypes.string,
    linkText: _react2.default.PropTypes.any,
    linkClass: _react2.default.PropTypes.string,
    method: _react2.default.PropTypes.oneOf(["POST", "PUT", "DELETE"])
  },

  getFriendlyMenuLinkTrackingName: function getFriendlyMenuLinkTrackingName(linkText) {
    if (typeof linkText === "string") {
      var camelCaseName = (0, _lodash.camelCase)(linkText);
      var pascalCaseName = camelCaseName[0].toUpperCase() + camelCaseName.slice(1);
      return MENU_LINK_TRACKING_PREFIX + "_" + pascalCaseName;
    } else {
      return MENU_LINK_TRACKING_PREFIX + "_Unknown";
    }
  },
  render: function render() {
    var _this = this;

    return _jsx("li", {
      role: "menuitem " + this.props.linkText,
      className: "menuLink",
      "aria-label": this.props.linkText
    }, void 0, this.props.children ? _jsx("span", {}, void 0, this.props.children) : _jsx("a", {
      href: this.props.href,
      className: this.props.linkClass,
      "data-method": this.props.method,
      onClick: function onClick(e) {
        return (0, _click_and_view_tracking.trackNavEngageClick)(e, _this.getFriendlyMenuLinkTrackingName(_this.props.linkText));
      }
    }, void 0, this.props.linkText));
  }
});

},{"../modules/click_and_view_tracking":8,"./gr_component_factory":87,"lodash":"lodash","react":"react"}],118:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Modal dialog: halt/block other page content, display new content, and force
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             the user to interact with or dismiss that content before doing anything else.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Display options, controlled by props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Default: "Lightbox" style modal window overlaying page
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Centered (centered: true): Center modal window within screen (?). May be
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          combined with Responsive variant. If
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          you're trying to center your contents within the
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          modal area, use your content's markup and
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          styling; Modal is not responsible for
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          styling its contents.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Drawer (asDrawer: true): Display as "drawer" sliding in from side of screen.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Does not make sense combined with Centered or
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        Responsive.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Responsive (responsive: true): Same as Default, but display like drawer at
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              smaller screen sizes. Mutually exclusive with
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              Drawer mode.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _modal_store = require("../react_stores/modal_store");

var _modal_store2 = _interopRequireDefault(_modal_store);

var _modal_actions = require("../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _close_button = require("./close_button");

var _close_button2 = _interopRequireDefault(_close_button);

var _keys = require("../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _lodash = require("lodash");

var _close_button_values = require("../modules/close_button_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Modal",

  mixins: [_reflux2.default.connect(_modal_store2.default, "modalStore")],

  propTypes: {
    asDrawer: _react2.default.PropTypes.bool,
    id: _react2.default.PropTypes.string.isRequired,
    centered: _react2.default.PropTypes.bool,
    showByDefault: _react2.default.PropTypes.bool,

    // This callback is run after the modal is hidden so it currently cannot
    // prevent closure. If you need such functionality, you need to
    // add another specific prop.
    onCloseHandler: _react2.default.PropTypes.func,

    // Provides a pair of Confirm/Cancel buttons that'll fire this callback
    // after user clicks Confirm. Both buttons close the Modal on click.
    onConfirmHandler: _react2.default.PropTypes.func,
    lockBodyScroll: _react2.default.PropTypes.bool,

    responsive: _react2.default.PropTypes.bool
  },

  getCloseButtonVariant: function getCloseButtonVariant() {
    if (this.props.asDrawer) {
      return _close_button_values.VARIANTS.DARK_BG;
    } else {
      return _close_button_values.VARIANTS.DEFAULT;
    }
  },
  getDefaultProps: function getDefaultProps() {
    return {
      asDrawer: false,
      centered: false,
      showByDefault: false,
      lockBodyScroll: true,
      responsive: false
    };
  },
  componentDidMount: function componentDidMount() {
    if (this.props.showByDefault) {
      _modal_actions2.default.openModal(this.props.id);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    this.updateBodyScrollability();
  },

  // prevent body from scrolling when modal is open
  updateBodyScrollability: function updateBodyScrollability() {
    if (this.props.lockBodyScroll && this.isActive()) {
      document.body.classList.add("modalOpened");
    } else if (!this.state.modalStore.currentActiveModal) {
      document.body.classList.remove("modalOpened");
    }
  },
  hide: function hide() {
    _modal_actions2.default.closeModal();
    if (this.props.onCloseHandler && (0, _lodash.isFunction)(this.props.onCloseHandler)) {
      this.props.onCloseHandler();
    }
  },
  isActive: function isActive() {
    return this.state.modalStore.currentActiveModal === this.props.id;
  },
  hideOnOverlayClick: function hideOnOverlayClick(ev) {
    if (ev.target.className.indexOf("modal--overlay") > -1) {
      this.hide();
    }
  },
  hideOnEscape: function hideOnEscape(ev) {
    if (_keys2.default.isDefaultCloserKey(ev.keyCode)) {
      this.hide();
    }
  },
  handleConfirm: function handleConfirm() {
    if (this.props.onConfirmHandler) {
      this.props.onConfirmHandler();
    }
    this.hide();
  },
  renderConfirmButtons: function renderConfirmButtons() {
    // Confirm/Cancel
    return _jsx("div", {
      className: "modal__confirmButtonsContainer"
    }, void 0, _jsx("button", {
      className: "gr-button gr-button--large gr-button--dark u-marginRightMedium",
      "data-testid": "confirm",
      onClick: this.handleConfirm,
      type: "button"
    }, void 0, "Confirm"), _jsx("button", {
      className: "gr-button gr-button--large",
      "data-testid": "cancel",
      onClick: this.hide,
      type: "button"
    }, void 0, "Cancel"));
  },
  render: function render() {
    var modalClass = (0, _classnames2.default)("modal", "modal--overlay", { "modal--show": this.isActive() && !this.props.centered,
      "modal--centered": this.isActive() && this.props.centered,
      "modal--drawer": this.props.asDrawer && !this.props.responsive,
      "modal--responsive": this.props.responsive });
    return _react2.default.createElement(
      "div",
      { className: modalClass, ref: "modalContent", tabIndex: "0",
        onClick: this.hideOnOverlayClick, onKeyDown: this.hideOnEscape },
      this.renderContents()
    );
  },
  renderContents: function renderContents() {
    if (this.props.asDrawer) {
      // In "drawer" mode, close button appears in overlay area, not content area
      return _jsx("div", {}, void 0, _jsx("div", {
        className: "modal__close"
      }, void 0, _jsx(_close_button2.default, {
        action: this.hide,
        variant: this.getCloseButtonVariant()
      })), _jsx("div", {
        className: this.withBemModifiers("modal__content")
      }, void 0, this.props.children));
    } else {
      return _jsx("div", {
        className: this.withBemModifiers("modal__content")
      }, void 0, _jsx("div", {
        className: "modal__close"
      }, void 0, _jsx(_close_button2.default, {
        action: this.hide,
        variant: this.getCloseButtonVariant()
      })), this.props.children, this.props.onConfirmHandler && this.renderConfirmButtons());
    }
  }
});

},{"../modules/close_button_values":9,"../modules/keys":15,"../react_actions/modal_actions":30,"../react_stores/modal_store":197,"./close_button":71,"./gr_component_factory":87,"classnames":"classnames","lodash":"lodash","react":"react","reflux":"reflux"}],119:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal_actions = require("../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _modal_store = require("../react_stores/modal_store");

var _modal_store2 = _interopRequireDefault(_modal_store);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ModalTrigger",

  mixins: [_reflux2.default.connect(_modal_store2.default, "modalStore")],

  propTypes: {
    id: _react2.default.PropTypes.string.isRequired,
    clickHandler: _react2.default.PropTypes.func
  },

  isActive: function isActive() {
    return this.state.modalStore.currentActiveModal === this.props.id;
  },
  openModal: function openModal() {
    if (this.props.clickHandler) {
      this.props.clickHandler();
    }
    _modal_actions2.default.openModal(this.props.id);
  },
  render: function render() {
    return _jsx("a", {
      className: this.withBemModifiers("modalTrigger"),
      onClick: this.openModal,
      role: "button",
      "aria-expanded": this.isActive(),
      "aria-haspopup": true
    }, void 0, this.props.children);
  }
});

},{"../react_actions/modal_actions":30,"../react_stores/modal_store":197,"./gr_component_factory":87,"react":"react","reflux":"reflux"}],120:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PageSkin",
  propTypes: {
    imageUrl: _react2.default.PropTypes.string,
    backgroundColor: _react2.default.PropTypes.string
  },

  render: function render() {
    var divStyle = {};
    if (this.props.imageUrl) {
      divStyle.backgroundImage = "url(" + this.props.imageUrl + ")";
      divStyle.backgroundRepeat = "no-repeat";
      divStyle.backgroundPosition = "center top";
    }
    if (this.props.backgroundColor) {
      divStyle.backgroundColor = this.props.backgroundColor;
    }
    // Add link for background
    return _jsx("div", {
      className: "pageskin",
      style: divStyle
    });
  }
});

},{"./gr_component_factory":87,"react":"react"}],121:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Renders a set of links for pagination: previous, next, plus some direct page
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           links.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Comes in a default (links) flavor and a "buttons" flavor. The "buttons" flavor,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           activated by passing the `asButtons` prop, was created for GR-42011. The two
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           variants are somewhat arbitrary, and might need revision over time...maybe one
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           becomes a "small"/"one line" variant, and the other becomes a "large"/"multiline"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           variant. Or, ideally, we converge on a single way to display pagination.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _pagination_single_page_link = require("./pagination_single_page_link");

var _pagination_single_page_link2 = _interopRequireDefault(_pagination_single_page_link);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PaginationLinks",

  propTypes: {
    asButtons: _react2.default.PropTypes.bool,
    totalSize: _gr_prop_types2.default.naturalNumber.isRequired,
    currentPageNumber: _react2.default.PropTypes.number.isRequired,
    className: _react2.default.PropTypes.string,
    perPage: _gr_prop_types2.default.naturalNumber.isRequired,
    changePageAction: _react2.default.PropTypes.func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return { asButtons: false };
  },
  maxPageNumber: function maxPageNumber() {
    return Math.ceil(this.props.totalSize / this.props.perPage);
  },
  renderLinkToPage: function renderLinkToPage(pageNumber) {
    return _jsx(_pagination_single_page_link2.default, {
      pageNumber: pageNumber,
      currentPageNumber: this.props.currentPageNumber,
      changePageAction: this.props.changePageAction
    }, pageNumber);
  },
  renderPageLinks: function renderPageLinks() {
    var _this = this;

    var numPages = this.maxPageNumber();
    if (numPages !== 1) {
      if (numPages <= 6) {
        return _jsx("span", {
          className: "gr-paginationLinks__pageLinksWrapper"
        }, void 0, _lodash2.default.times(numPages, function (n) {
          return _this.renderLinkToPage(n + 1);
        }));
      } else {
        if (this.props.currentPageNumber <= 3) {
          // Render links for the the first four pages, then ellipsis, then the last page
          return _jsx("span", {
            className: "gr-paginationLinks__pageLinksWrapper"
          }, void 0, _lodash2.default.times(4, function (n) {
            return _this.renderLinkToPage(n + 1);
          }), "…", this.renderLinkToPage(this.maxPageNumber()));
        } else if (this.props.currentPageNumber >= this.maxPageNumber() - 3) {
          // First page, ellipsis, last four pages
          return _jsx("span", {
            className: "gr-paginationLinks__pageLinksWrapper"
          }, void 0, this.renderLinkToPage(1), "…", this.renderLinkToPage(this.maxPageNumber() - 3), this.renderLinkToPage(this.maxPageNumber() - 2), this.renderLinkToPage(this.maxPageNumber() - 1), this.renderLinkToPage(this.maxPageNumber()));
        } else {
          // First page, ellipsis, three middle pages starting from current, ellipsis, last
          return _jsx("span", {
            className: "gr-paginationLinks__pageLinksWrapper"
          }, void 0, this.renderLinkToPage(1), "…", this.renderLinkToPage(this.props.currentPageNumber), this.renderLinkToPage(this.props.currentPageNumber + 1), this.renderLinkToPage(this.props.currentPageNumber + 2), "…", this.renderLinkToPage(this.maxPageNumber()));
        }
      }
    }
  },
  renderPrevLink: function renderPrevLink() {
    if (this.maxPageNumber() === 1) {
      return null;
    } else {
      var cx = (0, _classnames2.default)({
        "gr-paginationLinks__previousLink": !this.props.asButtons,
        "gr-paginationLinks__previousButton": this.props.asButtons,
        "gr-button": this.props.asButtons,
        "gr-button--large": this.props.asButtons
      });
      return _jsx("button", {
        "aria-label": "Previous page",
        className: cx,
        onClick: this.moveToPrevPage,
        disabled: this.props.currentPageNumber === 1
      }, void 0, "← Previous");
    }
  },
  renderNextLink: function renderNextLink() {
    if (this.maxPageNumber() === 1) {
      return null;
    } else {
      var cx = (0, _classnames2.default)({
        "gr-paginationLinks__nextLink": !this.props.asButtons,
        "gr-paginationLinks__nextButton": this.props.asButtons,
        "gr-button": this.props.asButtons,
        "gr-button--large": this.props.asButtons
      });
      return _jsx("button", {
        "aria-label": "Next page",
        className: cx,
        onClick: this.moveToNextPage,
        disabled: this.props.currentPageNumber === this.maxPageNumber()
      }, void 0, "Next →");
    }
  },
  moveToNextPage: function moveToNextPage(event) {
    event.preventDefault();
    this.props.changePageAction(this.props.currentPageNumber + 1);
  },
  moveToPrevPage: function moveToPrevPage(event) {
    event.preventDefault();
    this.props.changePageAction(this.props.currentPageNumber - 1);
  },
  render: function render() {
    var cx = (0, _classnames2.default)("gr-paginationLinks", { "gr-paginationLinks--asButtons": this.props.asButtons }, this.props.className);
    // <div>s around next/prev links so that grid item sizing applied to wrapper
    // instead of the link/buttons themselves
    return _jsx("div", {
      className: cx
    }, void 0, _jsx("span", {
      className: "gr-paginationLinks__previousLinkWrapper"
    }, void 0, this.renderPrevLink()), this.renderPageLinks(), _jsx("span", {
      className: "gr-paginationLinks__nextLinkWrapper"
    }, void 0, this.renderNextLink()));
  }
});

},{"./gr_component_factory":87,"./pagination_single_page_link":122,"./shared/gr_prop_types":146,"classnames":"classnames","lodash":"lodash","react":"react"}],122:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PaginationSinglePageLink",

  propTypes: {
    pageNumber: _react2.default.PropTypes.number,
    currentPageNumber: _react2.default.PropTypes.number,
    changePageAction: _react2.default.PropTypes.func.isRequired
  },

  render: function render() {
    if (this.props.pageNumber === this.props.currentPageNumber) {
      return _jsx("span", {
        "aria-label": this.props.pageNumber + " current page",
        className: "gr-paginationLinks__pageNumLink\n                         gr-paginationLinks__pageNumLink--selected"
      }, void 0, this.props.pageNumber);
    } else {
      return _jsx("button", {
        className: "gr-paginationLinks__pageNumLink",
        onClick: this.jumpToPage
      }, void 0, this.props.pageNumber);
    }
  },
  jumpToPage: function jumpToPage(event) {
    event.preventDefault();
    this.props.changePageAction(this.props.pageNumber);
  }
});

},{"./gr_component_factory":87,"react":"react"}],123:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldDisplayPreviewBookButton = undefined;

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _modal_store = require("../../react_stores/modal_store");

var _modal_store2 = _interopRequireDefault(_modal_store);

var _newsfeed_actions = require("../../react_actions/newsfeed_actions");

var _newsfeed_actions2 = _interopRequireDefault(_newsfeed_actions);

var _report_wrong_book_button = require("./report_wrong_book_button");

var _report_wrong_book_button2 = _interopRequireDefault(_report_wrong_book_button);

var _report_wrong_book_form = require("./report_wrong_book_form");

var _report_wrong_book_form2 = _interopRequireDefault(_report_wrong_book_form);

var _wrong_book_report_acknowledgment = require("./wrong_book_report_acknowledgment");

var _wrong_book_report_acknowledgment2 = _interopRequireDefault(_wrong_book_report_acknowledgment);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _click_tracking_helper = require("../../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shouldDisplayPreviewBookButton = exports.shouldDisplayPreviewBookButton = function shouldDisplayPreviewBookButton(book, userAgentCapabilities) {
  if (userAgentCapabilities && userAgentCapabilities.touch === true) {
    return false;
  }
  return !!book.kcrPreviewUrl;
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PreviewBook",

  mixins: [_reflux2.default.connect(_modal_store2.default, "modalStore"), _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities")],

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.preview_book
    };
  },
  getInitialState: function getInitialState() {
    return {
      previewViewed: false,
      uniqueId: Math.random(1000000)
    };
  },
  getReportWrongBookModalId: function getReportWrongBookModalId() {
    return "report-" + this.props.book.kcrPreviewUrl + this.state.uniqueId;
  },
  getPreviewModalId: function getPreviewModalId() {
    return this.props.book.kcrPreviewUrl + this.state.uniqueId;
  },
  getAcknowledgmentModalId: function getAcknowledgmentModalId() {
    return "acknowledge-" + this.props.book.kcrPreviewUrl + this.state.uniqueId;
  },
  openBookPreview: function openBookPreview() {
    _newsfeed_actions2.default.previewBook();
    this.setState({ previewViewed: true });
  },
  render: function render() {
    var previewBookModalContents = null;
    var wrongBookForm = null;
    var acknowledgmentModal = null;

    var previewModalId = this.getPreviewModalId();
    var reportWrongBookModalId = this.getReportWrongBookModalId();
    var acknowledgmentModalId = this.getAcknowledgmentModalId();

    if (this.state.modalStore.currentActiveModal === previewModalId) {
      previewBookModalContents = _jsx("div", {
        className: "previewBook__container"
      }, void 0, _jsx("div", {
        className: "previewBook__topBanner"
      }, void 0, _jsx("div", {
        className: "previewBook__headerText"
      }, void 0, "Preview - ", _jsx("cite", {}, void 0, this.props.book.title)), _jsx(_report_wrong_book_button2.default, {
        book: this.props.book,
        modalId: reportWrongBookModalId
      })), _jsx("iframe", {
        className: "previewBook__kcrPreview",
        src: this.props.book.kcrPreviewUrl
      }));
    }

    if (this.state.previewViewed) {
      wrongBookForm = _jsx(_report_wrong_book_form2.default, {
        book: this.props.book,
        modalId: reportWrongBookModalId,
        acknowledgmentModalId: acknowledgmentModalId
      });
      acknowledgmentModal = _jsx(_wrong_book_report_acknowledgment2.default, {
        modalId: acknowledgmentModalId
      });
    }
    if (shouldDisplayPreviewBookButton(this.props.book, this.state.userAgentCapabilities)) {
      return _jsx("span", {
        className: "previewBook"
      }, void 0, _jsx(_modal_trigger2.default, {
        id: previewModalId
      }, void 0, _jsx("button", {
        "aria-label": "Preview " + this.props.book.title,
        className: "gr-buttonAsLink\n                             previewBook__openPreview",
        onClick: this.openBookPreview
      }, void 0, "Preview Book")), wrongBookForm, acknowledgmentModal, _jsx(_modal2.default, {
        id: previewModalId,
        bemModifiers: "preview"
      }, void 0, previewBookModalContents));
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/click_tracking_helper":2,"../../react_actions/newsfeed_actions":31,"../../react_stores/modal_store":197,"../../react_stores/user_agent_capabilities_store":203,"../gr_component_factory":87,"../modal":118,"../modal_trigger":119,"../shared/gr_prop_types":146,"./report_wrong_book_button":124,"./report_wrong_book_form":125,"./wrong_book_report_acknowledgment":126,"reflux":"reflux"}],124:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the 'Report Wrong Book' button.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `book`: Book JSON referring to the book this link lets you preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `modalId`: ID of the corresponding modal this button opens (ReportWrongBookForm)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReportWrongBookButton",

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired,
    modalId: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    return _jsx("div", {
      className: "previewBook__reportWrongBookButtonContainer"
    }, void 0, _jsx(_modal_trigger2.default, {
      id: this.props.modalId
    }, void 0, _jsx("button", {
      "aria-label": "This is not the right book.",
      className: "gr-buttonAsLink\n                               previewBook__reportWrongBookButton"
    }, void 0, "Not the book you’re looking for?")));
  }
});

},{"../gr_component_factory":87,"../modal_trigger":119,"../shared/gr_prop_types":146,"react":"react"}],125:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the 'Report Wrong Book' form.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `book`: Book JSON referring to the book this link lets you preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `modalId`: This component expects to be assigned an ID (since it relies on being opened by ReportWrongBookButton)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `acknowledgmentModalId`: The ID of the acknowledgment modal to be displayed if this form is submitted.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_actions = require("../../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FLAG_BOOK_REASONS = {
  wrongBook: "It’s the wrong book",
  wrongEdition: "It’s the wrong edition",
  other: "Other"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ReportWrongBookForm",

  propTypes: {
    book: _gr_prop_types2.default.book().isRequired,
    modalId: _react2.default.PropTypes.string.isRequired,
    acknowledgmentModalId: _react2.default.PropTypes.string.isRequired
  },

  getAuthorString: function getAuthorString() {
    return "by " + this.props.book.authorName;
  },
  showReportAcknowledgement: function showReportAcknowledgement() {
    _modal_actions2.default.openModal(this.props.acknowledgmentModalId);
  },
  closeModal: function closeModal(ev) {
    ev.preventDefault();
    _modal_actions2.default.closeModal();
  },
  renderWrongBookForm: function renderWrongBookForm() {
    var wrongBookOptions = [];

    _lodash2.default.forEach(FLAG_BOOK_REASONS, function (reasonText, reason) {
      wrongBookOptions.push(_jsx("option", {
        value: reason
      }, reason, reasonText));
    });

    return _jsx("form", {
      className: "previewBook__reportWrongBookForm",
      action: "/kindle_book_mapping_flags",
      "data-remote": "true",
      method: "post"
    }, void 0, "We’d love your help. Let us know what’s wrong with this preview of ", _jsx("cite", {}, void 0, this.props.book.title), this.props.book.authorName ? this.getAuthorString() : "", ".", _jsx("br", {}), _jsx("input", {
      type: "hidden",
      name: "kindle_book_mapping_flag[book_id]",
      value: this.props.book.bookId
    }), _jsx("div", {
      className: "gr-formInputContainer"
    }, void 0, _jsx("label", {
      className: "gr-label",
      htmlFor: "kindle_book_mapping_flag_reason"
    }, void 0, "Problem"), _jsx("select", {
      name: "kindle_book_mapping_flag[reason]",
      id: "kindle_book_mapping_flag_reason"
    }, void 0, wrongBookOptions)), _jsx("div", {
      className: "gr-formInputContainer"
    }, void 0, _jsx("label", {
      className: "gr-label",
      htmlFor: "kindle_book_mapping_flag_other_reason"
    }, void 0, "Details (if other)"), _jsx("input", {
      name: "kindle_book_mapping_flag[other_reason]",
      id: "kindle_book_mapping_flag_other_reason"
    })), _jsx("button", {
      className: "gr-button gr-button--modalPrimaryLeft",
      type: "submit",
      onClick: this.showReportAcknowledgement
    }, void 0, "Report Problem"), _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.closeModal,
      type: "button"
    }, void 0, "Cancel"));
  },
  render: function render() {
    return _jsx(_modal2.default, {
      id: this.props.modalId
    }, void 0, _jsx("h2", {}, void 0, "See a Problem?"), this.renderWrongBookForm());
  }
});

},{"../../react_actions/modal_actions":30,"../gr_component_factory":87,"../modal":118,"../shared/gr_prop_types":146,"lodash":"lodash","react":"react"}],126:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the acknowledgment after reporting a wrong book preview.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `modalId`: This component expects to be assigned an ID (since it relies on
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        being opened by submitting a wrong book report from the book preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        modal)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_actions = require("../../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WrongBookReportAcknowledgment",

  propTypes: {
    modalId: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    return _jsx("div", {
      className: "previewBook__wrongBookReportAcknowledgment"
    }, void 0, _jsx(_modal2.default, {
      id: this.props.modalId
    }, void 0, "Thanks for telling us about the problem.", _jsx("div", {}, void 0, _jsx("button", {
      className: "gr-button",
      onClick: _modal_actions2.default.closeModal
    }, void 0, "Close"))));
  }
});

},{"../../react_actions/modal_actions":30,"../gr_component_factory":87,"../modal":118,"react":"react"}],127:[function(require,module,exports){
"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _qualtrics_survey_modal = require("./qualtrics_survey_modal");

var _qualtrics_survey_modal2 = _interopRequireDefault(_qualtrics_survey_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Wrapper component of QualtricsSurveyModal. Adds a couple event listeners
// onto the book show page's nonReact WTR button that fire when a user clicks
// WTR via button or dropdown.
// Note that all it does is render the child modal, which has its own rendering
// logic.
// Also note that this is pretty hacky due to interaction between React and
// nonReact components - pls no copy

var BookShowSurveyModal = (function (_Component) {
  _inherits(BookShowSurveyModal, _Component);

  function BookShowSurveyModal(props) {
    _classCallCheck(this, BookShowSurveyModal);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(BookShowSurveyModal).call(this, props));

    _this.state = { renderModal: false };

    _this.handleWTR = _this.handleWTR.bind(_this);
    return _this;
  }

  _createClass(BookShowSurveyModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var button = document.getElementById(this.props.buttonId);
      if (!button) return null;
      // there are two event listeners to add on the WTR button:
      // 1. when the user clicks WTR on the WTR button
      // 2. when the user clicks WTR on the WTR dropdown
      var nodes = button.querySelectorAll("button.wtrExclusiveShelf[value='to-read'], button.wtrToRead[type='submit']");
      [].concat(_toConsumableArray(nodes)).forEach(function (node) {
        return node.addEventListener("click", _this2.handleWTR);
      });
    }
  }, {
    key: "handleWTR",
    value: function handleWTR() {
      var _this3 = this;

      // Hack: set a timeout so you can see that WTR click did something.
      if (!this.state.renderModal) {
        setTimeout(function () {
          return _this3.setState({ renderModal: true });
        }, 2500);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.renderModal ? React.createElement(_qualtrics_survey_modal2.default, this.props) : null;
    }
  }]);

  return BookShowSurveyModal;
})(_react.Component);

exports.default = BookShowSurveyModal;

BookShowSurveyModal.propTypes = {
  buttonId: _react.PropTypes.string.isRequired
};

},{"./qualtrics_survey_modal":129,"react":"react"}],128:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _book_show_survey_modal = require("./book_show_survey_modal");

var _book_show_survey_modal2 = _interopRequireDefault(_book_show_survey_modal);

var _qualtrics_survey_modal = require("./qualtrics_survey_modal");

var _qualtrics_survey_modal2 = _interopRequireDefault(_qualtrics_survey_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SURVEY_MAP = {
  signed_in_book_show: _book_show_survey_modal2.default
}; // maps which qualtrics survey goes to which page

var QualtricsSurvey = function QualtricsSurvey(props) {
  var Component = SURVEY_MAP[props.type] || _qualtrics_survey_modal2.default;
  return React.createElement(Component, props);
};

QualtricsSurvey.propTypes = {
  type: _react.PropTypes.oneOf(Object.keys(SURVEY_MAP))
};

exports.default = QualtricsSurvey;

},{"./book_show_survey_modal":127,"./qualtrics_survey_modal":129,"react":"react"}],129:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUALTRICS_COOKIE = undefined;

var _react = require("react");

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _cookies = require("../shared/cookies");

var _cookies2 = _interopRequireDefault(_cookies);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               React component that renders a survey prompt in a Modal that shows by default,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               and then renders a Qualtrics survey in an iframe if user consents.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var QUALTRICS_COOKIE = exports.QUALTRICS_COOKIE = "hide_qualtrics_survey";

var QualtricsSurveyModal = (function (_Component) {
  _inherits(QualtricsSurveyModal, _Component);

  function QualtricsSurveyModal(props) {
    _classCallCheck(this, QualtricsSurveyModal);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(QualtricsSurveyModal).call(this, props));

    _this.state = { isShown: false };
    return _this;
  }

  _createClass(QualtricsSurveyModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isShown = this.shouldShow();
      if (isShown) {
        (0, _ajax_helper.httpPost)("/track/track", {
          data: { tid: "QualtricsSurveyModal:" + (this.props.type || "default") }
        });
        this.setState({ isShown: isShown });
      }
    }
  }, {
    key: "shouldShow",
    value: function shouldShow() {
      // No repeat showings before a certain time period
      if (_cookies2.default.get(QUALTRICS_COOKIE)) {
        return false;
      }
      // If user is signed out, make sure they've seen the login interstitial
      // before prompting a survey.
      if (this.props.signedOut) {
        return !!_cookies2.default.get("blocking_sign_in_interstitial");
      }
      return true;
    }
  }, {
    key: "onCloseHandler",
    value: function onCloseHandler() {
      _cookies2.default.set(QUALTRICS_COOKIE, true, 90);
    }
  }, {
    key: "renderSurvey",
    value: function renderSurvey() {
      return _jsx("div", {
        className: "qualtricsSurvey"
      }, void 0, _jsx("iframe", {
        className: "qualtricsSurvey__iframe",
        src: this.props.qualtricsUrl
      }));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.isShown) {
        return null;
      }

      return _jsx(_modal2.default, {
        id: "QualtricsSurveyModal",
        showByDefault: true,
        onCloseHandler: this.onCloseHandler
      }, void 0, this.renderSurvey());
    }
  }]);

  return QualtricsSurveyModal;
})(_react.Component);

QualtricsSurveyModal.propTypes = {
  signedOut: _react.PropTypes.bool.isRequired,
  qualtricsUrl: _react.PropTypes.string.isRequired,
  type: _react.PropTypes.string
};

exports.default = QualtricsSurveyModal;

},{"../../modules/ajax/ajax_helper":4,"../modal":118,"../shared/cookies":145,"react":"react"}],130:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _expandable_html = require("./user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _community_rating = require("./community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

var _author_badge = require("./author/author_badge");

var _author_badge2 = _interopRequireDefault(_author_badge);

var _want_to_read_button = require("./want_to_read/want_to_read_button");

var _want_to_read_button2 = _interopRequireDefault(_want_to_read_button);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _react = require("react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /*
                                                                                                                                                                                                                               This component renders a book with a responsive layout.
                                                                                                                                                                                                                             
                                                                                                                                                                                                                               It includes primary content (title, author, CommunityRating),
                                                                                                                                                                                                                               optional secondary content (expandable description),
                                                                                                                                                                                                                               and optional actions content (WantToReadButton).
                                                                                                                                                                                                                             
                                                                                                                                                                                                                               Wrapper components should be created to specify options for
                                                                                                                                                                                                                               the ResponsiveBook in different contexts (see SeriesBook).
                                                                                                                                                                                                                             
                                                                                                                                                                                                                               Ref: https://w.amazon.com/bin/view/Goodreads/Teams/Mobile_web/Responsive_SeriesList_Components_Refactor/
                                                                                                                                                                                                                             */

var ResponsiveBook = function ResponsiveBook(_ref) {
  var book = _ref.book;
  var communityRatingOptions = _ref.communityRatingOptions;
  var displayableTitle = _ref.displayableTitle;
  var includeDescription = _ref.includeDescription;
  var includeWTRButton = _ref.includeWTRButton;
  var readOnlyStars = _ref.readOnlyStars;

  var props = _objectWithoutProperties(_ref, ["book", "communityRatingOptions", "displayableTitle", "includeDescription", "includeWTRButton", "readOnlyStars"]);

  var title = displayableTitle ? displayableTitle : book.title;

  var authorLink = book.author ? _jsx("span", {
    itemProp: "name"
  }, void 0, _jsx("a", {
    itemProp: "url",
    href: book.author.profileUrl,
    className: "gr-hyperlink gr-hyperlink--naked"
  }, void 0, book.author.name), _jsx(_author_badge2.default, {
    isGoodreadsAuthor: book.author.isGoodreadsAuthor
  })) : "deleted author";

  var ratingsCount = communityRatingOptions.displayRatingsCount ? book.ratingsCount : null;
  var textReviewsCount = communityRatingOptions.displayTextReviewsCount ? book.textReviewsCount : null;
  var publication = communityRatingOptions.displayPublicationDate ? { toBePublished: book.toBePublished, date: book.publicationDate } : null;
  var editions = communityRatingOptions.displayEditionsCount ? { countString: book.editions, url: book.editionsUrl } : null;

  var primary = _jsx("div", {
    className: "u-paddingBottomXSmall"
  }, void 0, _jsx("a", {
    className: "gr-h3 gr-h3--serif gr-h3--noMargin",
    href: book.bookUrl,
    itemProp: "url"
  }, void 0, _jsx("span", {
    itemProp: "name"
  }, void 0, title)), _jsx("div", {
    className: "u-paddingBottomTiny"
  }, void 0, "by ", _jsx("span", {
    itemProp: "author",
    itemScope: true,
    itemType: "http://schema.org/Person"
  }, void 0, authorLink)), communityRatingOptions.displayRating && _jsx(_community_rating2.default, {
    rating: parseFloat(book.avgRating),
    size: _community_rating2.default.ICON_SIZES.MEDIUM,
    displayAvg: true,
    displayAvgRatingText: communityRatingOptions.displayAvgRatingText,
    ratingsCount: ratingsCount,
    textReviewsCount: textReviewsCount,
    publication: publication,
    editions: editions
  }));

  var secondary = _jsx("div", {}, void 0, React.createElement(_expandable_html2.default, book.description));

  var actions = _jsx(_want_to_read_button2.default, {
    bookTitle: title,
    uniqueId: Math.random(1000000).toString(),
    bookId: book.bookId,
    withModalShelvingMenu: true,
    showStars: _want_to_read_button.ALWAYS_DISPLAY_STARS_PROP,
    readOnlyStars: readOnlyStars
  });

  return _jsx("div", {
    className: "responsiveBook",
    itemScope: true,
    itemType: "http://schema.org/Book"
  }, void 0, _jsx("div", {
    className: "objectLockupContent"
  }, void 0, _jsx("div", {
    className: "objectLockupContent__media"
  }, void 0, _jsx("div", {
    className: "responsiveBook__media"
  }, void 0, _jsx("a", {
    href: book.bookUrl
  }, void 0, _jsx("img", {
    src: book.imageUrl,
    alt: title,
    className: "gr-box--withShadow responsiveBook__img",
    itemProp: "image"
  })))), primary, _jsx("div", {
    className: "objectLockupContent__secondary"
  }, void 0, includeDescription && secondary, props.children), includeWTRButton && _jsx("div", {
    className: "objectLockupContent__actions u-paddingTopXSmall"
  }, void 0, actions)));
};

ResponsiveBook.propTypes = {
  book: _gr_prop_types2.default.book({
    avgRating: _react.PropTypes.number
  }).isRequired,
  communityRatingOptions: _react.PropTypes.shape({
    displayRating: _react.PropTypes.bool,
    displayAvgRatingText: _react.PropTypes.bool,
    displayRatingsCount: _react.PropTypes.bool,
    displayTextReviewsCount: _react.PropTypes.bool,
    displayPublicationDate: _react.PropTypes.bool,
    displayEditionsCount: _react.PropTypes.bool
  }).isRequired,
  displayableTitle: _react.PropTypes.string,
  includeDescription: _react.PropTypes.bool,
  includeWTRButton: _react.PropTypes.bool,
  readOnlyStars: _react.PropTypes.bool
};

exports.default = ResponsiveBook;

},{"./author/author_badge":60,"./community_rating":72,"./shared/gr_prop_types":146,"./user_content/expandable_html":169,"./want_to_read/want_to_read_button":174,"react":"react"}],131:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WRITE_A_REVIEW = undefined;

var _react = require("react");

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               title: Write a review button
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               This component displays the "Write a review" button and also redirects to the destinationPath
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               on button click.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               In addition, if an actionType metric is provided, the event will be fired off to Clickstream.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `destinationPath`: The destination Url on clicking on the WTR button or rating widget
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `bookId`: Clickstream event metadata
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * `actionType`: The Clickstream metric for the WTR button click
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */

var WRITE_A_REVIEW = exports.WRITE_A_REVIEW = "Write a review";

var WriteAReviewButton = (function (_Component) {
  _inherits(WriteAReviewButton, _Component);

  function WriteAReviewButton(props) {
    _classCallCheck(this, WriteAReviewButton);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(WriteAReviewButton).call(this, props));
  }

  _createClass(WriteAReviewButton, [{
    key: "handleButtonClick",
    value: function handleButtonClick() {
      var _this2 = this;

      if (this.props.actionType && this.props.bookId) {
        var ratePostUrl = "/review/rateable";
        var ratePostData = {
          id: this.props.bookId
        };
        (0, _ajax_helper.httpGet)(ratePostUrl, {
          data: ratePostData
        }).done(function (promptValues, responseStatus) {
          if (responseStatus === "success") {
            (0, _ajax_helper.httpPost)("/track/track_clickstream", {
              data: {
                action_type: _this2.props.actionType,
                book_id: _this2.props.bookId
              }
            });
            window.location.assign(_this2.props.destinationPath);
          } else {
            if (xhr.status === 403 && xhr.getResponseHeader("errorType") === "frozen") {
              window.alert("This book has temporary limitations on submitting ratings and reviews. This may be because we've detected unusual behavior that doesn't follow our review guidelines.");
            } else if (xhr.status !== 403) {
              window.alert("There was an error saving your rating, please try again.");
            }
          }
        }).fail(function () {
          window.alert("There was an error saving your rating, please try again.");
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var classNames = "gr-button u-marginTopBottomXSmall " + this.props.className;
      return _jsx("button", {
        className: classNames,
        onClick: this.handleButtonClick.bind(this)
      }, void 0, WRITE_A_REVIEW);
    }
  }]);

  return WriteAReviewButton;
})(_react.Component);

exports.default = WriteAReviewButton;

WriteAReviewButton.propTypes = {
  destinationPath: _react.PropTypes.string.isRequired
};

},{"../../modules/ajax/ajax_helper":4,"react":"react"}],132:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _google_ad_helper = require("../modules/ads/google_ad_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ScrollTracker",

  propTypes: {
    trackedEventId: _react2.default.PropTypes.string.isRequired,
    viewportExpansion: _react2.default.PropTypes.number
  },

  getDefaultProps: function getDefaultProps() {
    return {
      viewportExpansion: 0
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    (0, _google_ad_helper.lazyLoadOnView)(function (event) {
      if (event.target.id === _this.props.trackedEventId) {
        $j.post("/track/track", {
          tid: _this.props.trackedEventId
        });
      }
    });
  },
  render: function render() {
    return _jsx("div", {
      id: this.props.trackedEventId,
      className: "lazyload",
      "data-expand": "" + this.props.viewportExpansion
    });
  }
});

},{"../modules/ads/google_ad_helper":3,"./gr_component_factory":87,"react":"react"}],133:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();
/* react-onclickoutside is a deprecated package that should not be used for new
   code. Instead of having an outside click close a module, there should be an
   explicit close affordances in the spec. */

// STORE

// COMPONENTS

// MIXINS

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _keys = require("../../modules/keys");

var _keys2 = _interopRequireDefault(_keys);

var _book_search_store_factory = require("../../react_stores/book_search_store_factory");

var _book_search_store_factory2 = _interopRequireDefault(_book_search_store_factory);

var _book_search_results = require("./book_search_results");

var _book_search_results2 = _interopRequireDefault(_book_search_results);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _factory_store_mixin = require("../../react_mixins/factory_store_mixin");

var _factory_store_mixin2 = _interopRequireDefault(_factory_store_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DELAYED_SEARCH_MS = 300;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookSearch",

  mixins: [_reactOnclickoutside2.default, _reflux2.default.ListenerMixin, (0, _factory_store_mixin2.default)(_book_search_store_factory2.default)],

  propTypes: {
    autoFocus: _react2.default.PropTypes.bool,
    onChooseResult: _react2.default.PropTypes.func.isRequired,
    maxResults: _react2.default.PropTypes.number,
    shelfName: _react2.default.PropTypes.string,
    searchPath: _react2.default.PropTypes.string.isRequired,
    closeAfterResultChosen: _react2.default.PropTypes.bool,
    autocompleteUrl: _react2.default.PropTypes.string.isRequired,
    signedIn: _react2.default.PropTypes.bool,
    deviceType: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      autoFocus: false,
      maxResults: 5,
      closeAfterResultChosen: false
    };
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    this.delayedSearch = _lodash2.default.debounce(function (event) {
      _this.actions.search(event.target.value, _this.props.autocompleteUrl);
    }, DELAYED_SEARCH_MS);
    this.signedInStr = this.props.signedIn ? "SignedIn" : "SignedOut";
  },
  hide: function hide() {
    this.actions.setShowResultsContainer(false);
  },
  show: function show() {
    this.actions.setShowResultsContainer(true);
  },
  handleClickOutside: function handleClickOutside() {
    this.hide();
  },
  handleSearch: function handleSearch(event) {
    this.setState({ searchBoxValue: event.target.value });

    if (!_lodash2.default.isEmpty(event.target.value)) {
      event.persist();
      this.delayedSearch(event);
    } else {
      this.hide();
    }
  },
  handleClick: function handleClick(event) {
    if (!_lodash2.default.isEmpty(this.state.query)) {
      this.handleSearch(event);
    }
  },
  handleChoice: function handleChoice(book) {
    $j.post("/track/track_click", {
      feature: "NavSearch:" + this.props.deviceType + ":" + this.signedInStr + ":suggestion_click",
      pmet_value: book.rank
    });

    this.props.onChooseResult(book);
    if (this.props.closeAfterResultChosen) {
      this.hide();
    }
  },

  // Note: This method manipulates a datastore of the book objects, marking one as "active," which triggers
  //       book_search_result (which is listening) to add a special class. Only problem is that we don't know
  //       which link element is currently selected, so we can't trigger a click on the active one when a user
  //       presses Enter. Which is why the current method does a hard window.location move when an item is
  //       activated, which is all kinds of wrong. The implementation of this entire component set prevents
  //       normal browser behavior, and for that reason this should be re-engineered from the ground up. -Joey
  handleKeyPress: function handleKeyPress(event) {
    var maxResults = Math.min(this.props.maxResults, this.state.results.length);
    if (_keys2.default.isEnter(event.keyCode)) {
      if (this.state.activeResult !== null) {
        this.handleChoice(this.state.activeResult);
        event.preventDefault();
      } else if (_lodash2.default.isEmpty(event.target.value)) {
        event.preventDefault();
      }
    } else if (_keys2.default.isArrowDown(event.keyCode)) {
      this.actions.selectNextResult(maxResults);
    } else if (_keys2.default.isArrowUp(event.keyCode)) {
      this.actions.selectPreviousResult(maxResults);
    } else if (_keys2.default.isEscape(event.keyCode)) {
      this.hide();
    }
  },
  logSubmit: function logSubmit() {
    $j.post("/track/track_click", { feature: "NavSearch:" + this.props.deviceType + ":" + this.signedInStr + ":see_all_click" });
  },
  renderInputIcon: function renderInputIcon() {
    var searchSpinnerClasses = this.withBemModifiers("searchBox__icon", "loadingSpinner");
    var searchIconClasses = (0, _classnames2.default)("searchBox__icon--magnifyingGlass gr-iconButton", this.withBemModifiers("searchBox__icon"));
    if (this.state.showLoadingSpinner) {
      return _jsx("span", {
        className: searchSpinnerClasses
      }, void 0, _jsx(_spinner2.default, {}));
    } else {
      return _jsx("button", {
        type: "submit",
        className: searchIconClasses,
        "aria-label": "Search"
      });
    }
  },
  renderResultsContainer: function renderResultsContainer() {
    if (!_lodash2.default.isEmpty(this.state.query)) {
      return _react2.default.createElement(_book_search_results2.default, _extends({}, this.props, this.state, {
        onChooseResult: this.handleChoice,
        mouseoverAction: this.actions.selectSpecificResult
      }));
    }
  },
  render: function render() {
    var searchBoxClasses = (0, _classnames2.default)(this.withBemModifiers("searchBox"));
    var searchInputClasses = (0, _classnames2.default)(this.withBemModifiers("searchBox__input"));

    return _jsx("div", {
      acceptCharset: "UTF-8",
      className: searchBoxClasses,
      onKeyDown: this.handleKeyPress
    }, void 0, _jsx("form", {
      autoComplete: "off",
      action: this.props.searchPath,
      className: "searchBox__form",
      role: "search",
      "aria-label": "Search for books to add to your shelves",
      onSubmit: this.logSubmit
    }, void 0, _jsx("input", {
      className: searchInputClasses,
      autoComplete: "off",
      autoFocus: this.props.autoFocus,
      name: "q",
      type: "text",
      placeholder: "Search books",
      "aria-label": "Search books",
      onFocus: this.show,
      onClick: this.handleClick,
      onChange: this.handleSearch,
      value: this.state.searchBoxValue,
      "aria-controls": "searchResults"
    }), _jsx("input", {
      type: "hidden",
      name: "qid",
      value: this.state.results.length > 0 ? this.state.results[0].qid : ""
    }), this.renderInputIcon(), this.state.showResultsContainer ? this.renderResultsContainer() : null));
  }
});

},{"../../modules/keys":15,"../../react_mixins/factory_store_mixin":184,"../../react_stores/book_search_store_factory":190,"../gr_component_factory":87,"../spinner":161,"./book_search_results":135,"classnames":"classnames","lodash":"lodash","react":"react","react-onclickoutside":"react-onclickoutside","reflux":"reflux"}],134:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _author_badge = require("../author/author_badge");

var _author_badge2 = _interopRequireDefault(_author_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookSearchResult",

  propTypes: {
    book: _gr_prop_types2.default.book({ qid: _react2.default.PropTypes.string, rank: _react2.default.PropTypes.number }).isRequired,
    onChooseResult: _react2.default.PropTypes.func.isRequired
  },

  render: function render() {
    var _this = this;

    var linkClasses = (0, _classnames2.default)("gr-mediaFlexbox", "gr-book--navbar", "gr-hyperlink", "gr-hyperlink--naked", "gr-hyperlink--noUnderline", "gr-bookSearchResults__result");
    // Note: We should be adding a url to the href attribute on these links elements, but we can't
    //       because there are JS handlers up and down this component chain that hijack normal link
    //       element behavior. That should not be - this whole thing should be re-engineered to make
    //       better use of default browser behavior.
    return _jsx("a", {
      className: linkClasses,
      href: "#",
      "aria-label": "Search result",
      onClick: function onClick() {
        _this.props.onChooseResult(_this.props.book);
      }
    }, void 0, _jsx("img", {
      className: "gr-mediaFlexbox__media",
      src: this.props.book.imageUrl,
      alt: ""
    }), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("div", {
      className: "gr-book__title gr-book__title--navbar u-defaultType"
    }, void 0, this.props.book.title), _jsx("div", {
      className: "gr-book__author gr-book__author--navbar"
    }, void 0, "by ", this.props.book.author.name, _react2.default.createElement(_author_badge2.default, this.props.book.author))));
  }
});

},{"../author/author_badge":60,"../gr_component_factory":87,"../shared/gr_prop_types":146,"classnames":"classnames","react":"react"}],135:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _drop_down_list = require("../drop_down_list");

var _drop_down_list2 = _interopRequireDefault(_drop_down_list);

var _book_search_result = require("./book_search_result");

var _book_search_result2 = _interopRequireDefault(_book_search_result);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "BookSearchResults",

  propTypes: {
    maxResults: _react2.default.PropTypes.number.isRequired,
    query: _react2.default.PropTypes.string,
    results: _react2.default.PropTypes.array.isRequired,
    shelfName: _react2.default.PropTypes.string,
    searchPath: _react2.default.PropTypes.string,
    onChooseResult: _react2.default.PropTypes.func.isRequired,
    mouseoverAction: _react2.default.PropTypes.func.isRequired,
    activeResult: _react2.default.PropTypes.shape({
      title: _react2.default.PropTypes.string.isRequired,
      bookId: _react2.default.PropTypes.string.isRequired
    }),
    signedIn: _react2.default.PropTypes.string,
    deviceType: _react2.default.PropTypes.string
  },

  componentDidMount: function componentDidMount() {
    $j.post("/track/track_click", { feature: "NavSearch:" + this.props.deviceType + ":" + (this.props.signedIn ? "SignedIn" : "SignedOut") + ":overlay_shown" });
  },
  renderLastSearchResultItem: function renderLastSearchResultItem(text) {
    var searchResultsLastItemClasses = (0, _classnames2.default)("gr-buttonAsLink", "gr-bookSearchResults__lastItem", this.withBemElement("gr-bookSearchResults", "lastItem"));

    return _jsx("button", {
      className: searchResultsLastItemClasses,
      type: "submit"
    }, void 0, text);
  },
  render: function render() {
    var _this = this;

    var searchResultsClasses = (0, _classnames2.default)(this.withBemModifiers("gr-bookSearchResults"), "gr-box", "gr-box--withShadow");

    return _jsx("div", {
      className: searchResultsClasses,
      id: "bookSearchResults" + this.props.query + this.props.results.length,
      "aria-live": "polite",
      "aria-label": "Book search results"
    }, void 0, _jsx(_drop_down_list2.default, {
      maxListItems: this.props.maxResults
    }, void 0, this.props.results.length > 0 ? _lodash2.default.map(_lodash2.default.slice(this.props.results, 0, this.props.maxResults), function (result) {
      return _jsx("div", {
        className: (0, _classnames2.default)("gr-bookSearchResults__item", { "gr-bookSearchResults__item--active": result === _this.props.activeResult }),
        onMouseOver: function onMouseOver() {
          _this.props.mouseoverAction(result.bookId);
        }
      }, result.bookId, _jsx(_book_search_result2.default, {
        book: result,
        onChooseResult: _this.props.onChooseResult
      }));
    }) : this.renderLastSearchResultItem("Search for \"" + this.props.query + "\"…"), this.props.results.length > 0 ? this.renderLastSearchResultItem("See all results for \"" + this.props.query + "\"") : null));
  }
});

},{"../drop_down_list":74,"../gr_component_factory":87,"./book_search_result":134,"classnames":"classnames","lodash":"lodash","react":"react"}],136:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _nav_search = require("../header/nav_search");

var _nav_search2 = _interopRequireDefault(_nav_search);

var _search_toggle = require("../search/search_toggle");

var _search_toggle2 = _interopRequireDefault(_search_toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SearchMobileNav",

  propTypes: {
    autocompleteUrl: _react2.default.PropTypes.string.isRequired,
    searchPath: _react2.default.PropTypes.string.isRequired
  },

  render: function render() {
    return _jsx("div", {
      className: "siteHeader__primaryNavSeparateLine siteHeader__primaryNavSeparateLine--search"
    }, void 0, _react2.default.createElement(_nav_search2.default, _extends({}, this.props, {
      autoFocus: true,
      bemModifiers: "primaryNavSeparateLine" })), _jsx(_search_toggle2.default, {
      toggleType: _search_toggle.SEARCH_TOGGLE_TYPES.CANCEL
    }));
  }
});

},{"../gr_component_factory":87,"../header/nav_search":98,"../search/search_toggle":137,"react":"react"}],137:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.component = exports.SEARCH_TOGGLE_TYPES = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _lodash = require("lodash");

var _search_actions = require("../../react_actions/header/search_actions");

var _touch_not_ready_helper = require("../../modules/shared/touch_not_ready_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEARCH_TOGGLE_TYPES = exports.SEARCH_TOGGLE_TYPES = {
  ICON: "icon",
  CANCEL: "Cancel"
};

var component = exports.component = _gr_component_factory2.default.createClass({
  displayName: "SearchToggle",

  propTypes: {
    searchIsActive: _react2.default.PropTypes.bool.isRequired,
    toggleType: _react2.default.PropTypes.oneOf((0, _lodash.values)(SEARCH_TOGGLE_TYPES)),
    onToggleSearch: _react2.default.PropTypes.func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return { searchIsActive: false };
  },
  toggleSearch: function toggleSearch(event) {
    (0, _touch_not_ready_helper.acknowledgeEvent)(event);
    return this.props.onToggleSearch(!this.props.searchIsActive);
  },
  hideSearch: function hideSearch() {
    return this.props.onToggleSearch(false);
  },
  render: function render() {
    switch (this.props.toggleType) {
      case SEARCH_TOGGLE_TYPES.ICON:
        return _jsx("button", {
          className: "siteHeader__searchIcon gr-iconButton",
          onClick: this.toggleSearch,
          "aria-label": "Toggle search",
          type: "button",
          "data-ux-click": true
        });
      case SEARCH_TOGGLE_TYPES.CANCEL:
        return _jsx("button", {
          className: "gr-buttonAsLink",
          onClick: this.hideSearch,
          "aria-label": "Hide search",
          type: "button"
        }, void 0, SEARCH_TOGGLE_TYPES.CANCEL);
      default:
        return null;
    }
  }
});

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
  return Object.assign({}, ownProps, state);
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onToggleSearch: function onToggleSearch(searchIsActive) {
      return dispatch((0, _search_actions.toggleSearch)(searchIsActive));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(component);

},{"../../modules/shared/touch_not_ready_helper":18,"../../react_actions/header/search_actions":29,"../gr_component_factory":87,"lodash":"lodash","react":"react","react-redux":"react-redux"}],138:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This component specifies options for a ResponsiveBook
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             that is rendered in a series context.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             The displayable book title is dependent on user's librarian status,
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             and CommunityRating options, description, and WTR button are included.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Ref: https://w.amazon.com/bin/view/Goodreads/Teams/Mobile_web/Responsive_SeriesList_Components_Refactor/
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _responsive_book = require("../responsive_book");

var _responsive_book2 = _interopRequireDefault(_responsive_book);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SeriesBook = function SeriesBook(_ref) {
  var book = _ref.book;
  var isLibrarianView = _ref.isLibrarianView;
  var readOnlyStars = _ref.readOnlyStars;

  var displayableTitle = isLibrarianView ? book.title : book.bookTitleBare;

  var communityRatingOptions = { displayRating: true,
    displayAvgRatingText: false,
    displayRatingsCount: true,
    displayTextReviewsCount: true,
    displayPublicationDate: true,
    displayEditionsCount: true };

  return _jsx(_responsive_book2.default, {
    book: book,
    communityRatingOptions: communityRatingOptions,
    displayableTitle: displayableTitle,
    includeDescription: true,
    includeWTRButton: true,
    readOnlyStars: readOnlyStars
  });
};

SeriesBook.propTypes = {
  book: _gr_prop_types2.default.book({
    avgRating: _react.PropTypes.number.isRequired,
    ratingsCount: _react.PropTypes.number.isRequired,
    textReviewsCount: _react.PropTypes.number.isRequired,
    toBePublished: _react.PropTypes.bool,
    publicationDate: _react.PropTypes.string.isRequired,
    editions: _react.PropTypes.string.isRequired,
    editionsUrl: _react.PropTypes.string.isRequired
  }).isRequired,
  isLibrarianView: _react.PropTypes.bool,
  readOnlyStars: _react.PropTypes.bool
};

SeriesBook.defaultProps = {
  isLibrarianView: false,
  readOnlyStars: false
};

exports.default = SeriesBook;

},{"../responsive_book":130,"../shared/gr_prop_types":146,"react":"react"}],139:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // React component for displaying responsive series header.

// import ShareDialog from "../share_dialog";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _expandable_html = require("../user_content/expandable_html");

var _expandable_html2 = _interopRequireDefault(_expandable_html);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _react = require("react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SeriesHeader",

  propTypes: {
    description: _react.PropTypes.shape(_gr_prop_types2.default.expandableHtml()).isRequired,
    editPath: _react.PropTypes.string,
    // shareDialog: PropTypes.shape(GrPropTypes.shareDialog()),
    subtitle: _react.PropTypes.string.isRequired,
    title: _react.PropTypes.string.isRequired
  },

  renderToggleSecondaryWorks: function renderToggleSecondaryWorks() {
    // soon™
  },
  renderWTRSeriesButton: function renderWTRSeriesButton() {
    // probably not soon™
  },
  render: function render() {
    return _jsx("div", {
      className: "responsiveSeriesHeader"
    }, void 0, _jsx("div", {
      className: "responsiveSeriesHeader__title"
    }, void 0, _jsx("h1", {
      className: "gr-h1 gr-h1--serif gr-h1--noMargin u-paddingBottomTiny"
    }, void 0, this.props.title), this.props.editPath && _jsx("a", {
      className: "responsiveSeriesHeader__editLink gr-hyperlink gr-hyperlink--quiet",
      href: this.props.editPath
    }, void 0, "Edit")), _jsx("div", {
      className: "responsiveSeriesHeader__subtitle u-paddingBottomSmall"
    }, void 0, this.props.subtitle), _jsx("div", {
      className: "u-paddingBottomSmall"
    }, void 0, React.createElement(_expandable_html2.default, this.props.description)));
  }
});

},{"../gr_component_factory":87,"../shared/gr_prop_types":146,"../user_content/expandable_html":169,"react":"react"}],140:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             This component renders a ListWithDividers, with SeriesBook items
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             and series position headers.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             Ref: https://w.amazon.com/bin/view/Goodreads/Teams/Mobile_web/Responsive_SeriesList_Components_Refactor/
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _list_with_dividers = require("../list_with_dividers");

var _list_with_dividers2 = _interopRequireDefault(_list_with_dividers);

var _series_book = require("./series_book");

var _series_book2 = _interopRequireDefault(_series_book);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SeriesList = function SeriesList(_ref) {
  var series = _ref.series;
  var seriesHeaders = _ref.seriesHeaders;
  return _jsx(_list_with_dividers2.default, {
    ItemComponentType: _series_book2.default,
    items: series,
    itemHeaders: seriesHeaders
  });
};

SeriesList.propTypes = {
  series: _react.PropTypes.array.isRequired,
  seriesHeaders: _react.PropTypes.array
};

exports.default = SeriesList;

},{"../list_with_dividers":111,"./series_book":138,"react":"react"}],141:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _shape_icon_values = require("../modules/shape_icon_values");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShapeIcon",

  propTypes: {
    imageUrl: _react2.default.PropTypes.string.isRequired,
    imageAlt: _react2.default.PropTypes.string.isRequired,
    includeLink: _react2.default.PropTypes.bool,
    linkUrl: _react2.default.PropTypes.string,
    size: _react2.default.PropTypes.oneOf((0, _lodash.values)(_shape_icon_values.ICON_SIZES)),
    shape: _react2.default.PropTypes.oneOf((0, _lodash.values)(_shape_icon_values.ICON_SHAPES)),
    border: _react2.default.PropTypes.bool
  },

  getShapeClass: function getShapeClass() {
    var modifier = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

    var name = this.props.shape + "Icon";
    if (modifier) {
      name += "--" + modifier;
    }
    return name;
  },
  getDefaultProps: function getDefaultProps() {
    return {
      includeLink: false,
      size: _shape_icon_values.ICON_SIZES.SMALL,
      shape: _shape_icon_values.ICON_SHAPES.CIRCLE,
      border: false
    };
  },
  render: function render() {
    var _classNames;

    var classes = (0, _classnames2.default)(this.props.className, (_classNames = {}, _defineProperty(_classNames, "" + this.getShapeClass(), true), _defineProperty(_classNames, "" + this.getShapeClass("medium"), this.props.size === _shape_icon_values.ICON_SIZES.MEDIUM), _defineProperty(_classNames, "" + this.getShapeClass("large"), this.props.size === _shape_icon_values.ICON_SIZES.LARGE), _defineProperty(_classNames, "" + this.getShapeClass("border"), this.props.border), _classNames));

    if (this.props.includeLink && this.props.linkUrl) {
      return _jsx("a", {
        href: this.props.linkUrl
      }, void 0, _jsx("img", {
        className: classes,
        src: this.props.imageUrl,
        alt: this.props.imageAlt
      }));
    } else {
      return _jsx("img", {
        className: classes,
        src: this.props.imageUrl,
        alt: this.props.imageAlt
      });
    }
  }
});

},{"../modules/shape_icon_values":16,"./gr_component_factory":87,"classnames":"classnames","lodash":"lodash","react":"react"}],142:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareButton",

  propTypes: {
    textLabel: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return { textLabel: "Share" };
  },
  render: function render() {
    return _jsx("button", {
      className: "gr-shareButton",
      type: "button"
    }, void 0, _jsx("span", {
      className: "gr-shareButton__innerWrapper"
    }, void 0, _jsx("span", {
      className: "gr-shareButton__icon"
    }), _jsx("span", {
      className: "gr-shareButton__textLabel"
    }, void 0, this.props.textLabel)));
  }
});

},{"./gr_component_factory":87,"react":"react"}],143:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

// Preview Components

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("./shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _modal_trigger = require("./modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _share_button = require("./share_button");

var _share_button2 = _interopRequireDefault(_share_button);

var _modal = require("./modal");

var _modal2 = _interopRequireDefault(_modal);

var _share_social = require("./share_social");

var _share_social2 = _interopRequireDefault(_share_social);

var _string_counter = require("./user_content/string_counter");

var _string_counter2 = _interopRequireDefault(_string_counter);

var _share_dialog_store = require("../react_stores/share_dialog_store");

var _share_dialog_store2 = _interopRequireDefault(_share_dialog_store);

var _share_dialog_actions = require("../react_actions/share_dialog_actions");

var _share_dialog_actions2 = _interopRequireDefault(_share_dialog_actions);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _flash_message = require("./flash_message");

var _flash_message2 = _interopRequireDefault(_flash_message);

var _share_dialog_book_preview = require("./sharing/previews/share_dialog_book_preview");

var _share_dialog_book_preview2 = _interopRequireDefault(_share_dialog_book_preview);

var _share_dialog_topic_preview = require("./sharing/previews/share_dialog_topic_preview");

var _share_dialog_topic_preview2 = _interopRequireDefault(_share_dialog_topic_preview);

var _share_dialog_blog_preview = require("./sharing/previews/share_dialog_blog_preview");

var _share_dialog_blog_preview2 = _interopRequireDefault(_share_dialog_blog_preview);

var _share_dialog_interview_preview = require("./sharing/previews/share_dialog_interview_preview");

var _share_dialog_interview_preview2 = _interopRequireDefault(_share_dialog_interview_preview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareDialog",

  mixins: [_reflux2.default.connect(_share_dialog_store2.default, "sharingDialog")],

  propTypes: _gr_prop_types2.default.shareDialog(),

  getDefaultProps: function getDefaultProps() {
    return {
      includePreview: false
    };
  },
  getInitialState: function getInitialState() {
    return {
      uniqueId: Math.random(1000000)
    };
  },
  getResourceTypeIdentifier: function getResourceTypeIdentifier() {
    return this.props.sharingData.resourceTypeFriendlyText.replace(/\s/g, "").toLowerCase();
  },
  getShareModalId: function getShareModalId() {
    return "share-" + this.getResourceTypeIdentifier() + "-modal" + this.state.uniqueId;
  },
  socialExists: function socialExists(location) {
    return this.props.social[location].facebook || this.props.social[location].twitter || this.props.social[location].pinterest || this.props.social[location].copyLink;
  },

  // Optional preview components go here
  renderPreview: function renderPreview() {
    if (this.props.includePreview) {
      var preview = undefined;
      var friendlyResourceName = this.props.sharingData.resourceTypeFriendlyText;

      // add a case for your resource's friendly name here
      switch (friendlyResourceName) {
        case "book":
          preview = React.createElement(_share_dialog_book_preview2.default, this.props.previewData);
          break;
        case "discussion":
          preview = React.createElement(_share_dialog_topic_preview2.default, this.props.previewData);
          break;
        case "blog":
          preview = React.createElement(_share_dialog_blog_preview2.default, this.props.previewData);
          break;
        case "interview":
          preview = React.createElement(_share_dialog_interview_preview2.default, this.props.previewData);
          break;
        default:
        // do nothing
      }

      if (preview) {
        return preview;
      }
    } else {
      return null;
    }
  },
  renderSocialInModal: function renderSocialInModal(socialPromptStart) {
    if (this.socialExists("inModal")) {
      var socialPrompt = socialPromptStart + " share on:";
      return _jsx("div", {
        className: "shareModal__socialContainer"
      }, void 0, _jsx("div", {
        className: "shareModal__socialPrompt"
      }, void 0, socialPrompt), React.createElement(_share_social2.default, _extends({}, this.props.social.inModal, {
        bemModifiers: "modal",
        fbOptions: this.props.social.fbOptions,
        twitterOptions: this.props.social.twitterOptions,
        pinterestOptions: this.props.social.pinterestOptions,
        metricName: this.getResourceTypeIdentifier() + "_sharingModal" })));
    } else {
      return null;
    }
  },
  renderCharacterCounter: function renderCharacterCounter() {
    var text = this.state.sharingDialog.sharingTextInputValue || "";

    return _jsx(_string_counter2.default, {
      counterType: "character",
      maxLength: _share_dialog_store.MAXIMUM_SHARING_TEXT_LENGTH,
      warnLength: _share_dialog_store.WARNING_SHARING_TEXT_LENGTH,
      text: text
    });
  },
  handleShare: function handleShare() {
    var data = this.props.sharingData;
    var value = this.state.sharingDialog.sharingTextInputValue;
    _share_dialog_actions2.default.submitShare(data, value);
  },
  renderSharePrompt: function renderSharePrompt() {
    var bottomClassNames = (0, _classnames2.default)("shareModal__bottomContainer", { "shareModal__bottomContainer--noSocial": !this.socialExists("inModal"),
      "shareModal__bottomContainer--social": this.socialExists("inModal") });
    return _jsx("span", {
      className: "shareModal"
    }, void 0, _jsx("h2", {
      className: "gr-h3 gr-h3--serif shareModal__heading"
    }, void 0, "Share this ", this.props.sharingData.resourceTypeFriendlyText, " on Goodreads"), this.renderShareError(), _jsx("textarea", {
      "aria-label": "Share text",
      placeholder: "Say something about this " + this.props.sharingData.resourceTypeFriendlyText + "...",
      value: this.state.sharingDialog.sharingTextInputValue,
      onChange: function onChange(e) {
        _share_dialog_actions2.default.updateSharingTextInputValue(e.target.value);
      },
      className: "gr-textInput shareModal__textInput"
    }), this.renderCharacterCounter(), this.renderPreview(), _jsx("button", {
      className: "gr-button gr-button--Large shareModal__button",
      onClick: this.handleShare,
      type: "button",
      disabled: this.state.sharingDialog.shareModalButtonDisabled
    }, void 0, "Share"), _jsx("div", {
      className: bottomClassNames
    }, void 0, this.renderSocialInModal("Or")));
  },
  renderShareSuccess: function renderShareSuccess() {
    return _jsx("span", {
      className: "shareModal"
    }, void 0, _jsx("h2", {
      className: "gr-h3 gr-h3--serif shareModal__heading"
    }, void 0, "Shared!"), _jsx("h3", {
      className: "gr-hyperlink shareModal__link"
    }, void 0, _jsx("a", {
      href: this.state.sharingDialog.sharingUrl,
      "aria-label": "Link to " + this.state.sharingDialog.sharingDisplayName
    }, void 0, "View post")), _jsx("div", {
      className: "shareModal__bottomContainer shareModal__bottomContainer--shared"
    }, void 0, this.renderSocialInModal("Also")));
  },
  renderShareError: function renderShareError() {
    if (this.state.sharingDialog.error) {
      var resourceType = this.props.sharingData.resourceTypeFriendlyText;
      var flashMessage = this.state.sharingDialog.errorText || "Something went wrong, and your " + resourceType + " wasn't shared. Please try again later.";
      return _jsx(_flash_message2.default, {
        category: "error",
        message: flashMessage
      });
    } else {
      return null;
    }
  },
  renderModalContent: function renderModalContent() {
    if (this.state.sharingDialog.shared) {
      return this.renderShareSuccess();
    } else {
      return this.renderSharePrompt();
    }
  },
  renderSocialOutsideModal: function renderSocialOutsideModal() {
    if (this.socialExists("outsideModal")) {
      return React.createElement(_share_social2.default, _extends({}, this.props.social.outsideModal, {
        fbOptions: this.props.social.fbOptions,
        twitterOptions: this.props.social.twitterOptions,
        pinterestOptions: this.props.social.pinterestOptions,
        metricName: this.getResourceTypeIdentifier() + "_shareModuleBar",
        bemModifiers: "shareBar" }));
    } else {
      return null;
    }
  },
  shouldRedirect: function shouldRedirect() {
    return this.props.signInUrl && !this.props.signedIn;
  },
  handleClick: function handleClick() {
    if (this.shouldRedirect()) {
      this.redirectToSignIn();
    } else {
      _share_dialog_actions2.default.openShareModal(this.getResourceTypeIdentifier());
    }
  },
  getSignInUrl: function getSignInUrl() {
    var currentPath = _env_utils2.default.getCurrentPath();
    return this.props.signInUrl + "?returnurl=" + currentPath;
  },
  redirectToSignIn: function redirectToSignIn() {
    _env_utils2.default.setLocationUrl(this.getSignInUrl());
  },

  // prevents modal from opening while redirecting to login if user is signed out
  renderModal: function renderModal() {
    if (this.shouldRedirect()) {
      return null;
    } else {
      return _jsx(_modal2.default, {
        id: this.getShareModalId(),
        bemModifiers: "share"
      }, void 0, this.renderModalContent());
    }
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.renderModal(), _jsx("div", {
      className: "shareModuleBar"
    }, void 0, _jsx(_modal_trigger2.default, {
      id: this.getShareModalId(),
      clickHandler: this.handleClick,
      bemModifiers: "shareModule"
    }, void 0, _jsx(_share_button2.default, {})), this.renderSocialOutsideModal()));
  }
});

},{"../modules/env_utils":13,"../react_actions/share_dialog_actions":34,"../react_stores/share_dialog_store":199,"./flash_message":84,"./gr_component_factory":87,"./modal":118,"./modal_trigger":119,"./share_button":142,"./share_social":144,"./shared/gr_prop_types":146,"./sharing/previews/share_dialog_blog_preview":151,"./sharing/previews/share_dialog_book_preview":152,"./sharing/previews/share_dialog_interview_preview":153,"./sharing/previews/share_dialog_topic_preview":155,"./user_content/string_counter":171,"classnames":"classnames","reflux":"reflux"}],144:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Share social
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: share_social
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays sharing buttons for external social platforms and a copy link button.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Platforms supported:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             - Facebook
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             - Twitter
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             - Pinterest
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             None
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `facebook` (bool): Inclusion/exclusion switch for Facebook sharing
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               default: false
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `twitter` (bool): Inclusion/exclusion switch for Twitter sharing
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               default: false
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `pinterest` (bool): Inclusion/exclusion switch for Pinterest sharing
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               default: false
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `copyLink` (bool): Inclusion/exclusion switch for copy link button
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               default: false
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `fbOptions` (object): Options for facebook share, generated with fb_feed_options
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `twitterOptions` (object): Options for twitter share (text, url)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `pinterestOptions` (object): Options for pinterest share (description, url, media)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `metricName` (string): Full name or modifier for metric name
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               default: ""
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

// TODO-GR-38350, add copy link functionality

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _facebook_share = require("./sharing/facebook_share");

var _facebook_share2 = _interopRequireDefault(_facebook_share);

var _twitter_share = require("./sharing/twitter_share");

var _twitter_share2 = _interopRequireDefault(_twitter_share);

var _pinterest_share = require("./sharing/pinterest_share");

var _pinterest_share2 = _interopRequireDefault(_pinterest_share);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareSocial",

  propTypes: {
    facebook: _react2.default.PropTypes.bool,
    twitter: _react2.default.PropTypes.bool,
    pinterest: _react2.default.PropTypes.bool,
    copyLink: _react2.default.PropTypes.bool,
    fbOptions: _react2.default.PropTypes.object,
    twitterOptions: _react2.default.PropTypes.object,
    pinterestOptions: _react2.default.PropTypes.object,
    metricName: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      facebook: false,
      twitter: false,
      pinterest: false,
      copyLink: false,
      metricName: ""
    };
  },
  renderSocialPlatform: function renderSocialPlatform(platform) {
    if (this.props[platform]) {
      var fullMetricName = "SocialSharing_" + this.props.metricName + "_" + platform;
      switch (platform) {
        case "facebook":
          return _jsx(_facebook_share2.default, {
            options: this.props.fbOptions,
            metricName: fullMetricName,
            bemModifiers: this.props.bemModifiers
          });
        case "twitter":
          return _jsx(_twitter_share2.default, {
            options: this.props.twitterOptions,
            metricName: fullMetricName,
            bemModifiers: this.props.bemModifiers
          });
        case "pinterest":
          return _jsx(_pinterest_share2.default, {
            options: this.props.pinterestOptions,
            metricName: fullMetricName,
            bemModifiers: this.props.bemModifiers
          });
      }
    } else {
      return null;
    }
  },
  render: function render() {
    var classes = (0, _classnames2.default)(this.withBemModifiers("shareSocialButtons"), this.props.className);
    return _jsx("div", {
      className: classes
    }, void 0, this.renderSocialPlatform("facebook"), this.renderSocialPlatform("twitter"), this.renderSocialPlatform("pinterest"));
  }
});

},{"./gr_component_factory":87,"./sharing/facebook_share":149,"./sharing/pinterest_share":150,"./sharing/twitter_share":156,"classnames":"classnames","react":"react"}],145:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Cookie manipulation functions. Originally copied from javascripts/shared_all
// formats/cookies with the intention to replace with the react-cookies package,
// but that never happened.

exports.default = {
  get: function get(name) {
    var value = null;
    var $j = window.$j;
    if ($j) {
      $j.each(document.cookie.split("; "), function (i, cookie) {
        var cookiePair = cookie.split("=");
        if (cookiePair[0] === name) {
          value = cookiePair[1];
        }
      });
    }
    return value;
  },
  set: function set(name, value, daysToExpire) {
    daysToExpire = daysToExpire || 365;

    var date = new Date();
    date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
    document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/";
  }
};

},{}],146:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateValidator = function dateValidator(props, propName, componentName) {
  var value = props[propName];
  var coercedValue = _lodash2.default.isString(value) ? new Date(value) : value;
  if (!_lodash2.default.isDate(coercedValue) || _lodash2.default.isNaN(coercedValue.getTime())) {
    return new Error("Property '" + propName + "' must be a Date. " + componentName + " was supplied: '" + value + "'.");
  }
};

var naturalNumberValidator = function naturalNumberValidator(props, propName, componentName) {
  var value = props[propName];
  if (value <= 0) {
    return new Error("Property '" + propName + "' must be > 0. " + componentName + " was supplied: '" + value + "'.");
  }
};

// adapted from ReactPropTypes.js since it's not exported publicly
function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName) {
    /* istanbul ignore next */
    if (!componentName) {
      componentName = "<<anonymous>>";
    }
    if (_lodash2.default.isNull(props[propName]) || _lodash2.default.isUndefined(props[propName])) {
      if (isRequired) {
        return new Error("Required property `" + propName + "` was not specified in " + ("`" + componentName + "`."));
      }
      return null;
    } else {
      return validate(props, propName, componentName);
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

var merge = function merge(oldValue, newValue) {
  return _lodash2.default.merge({}, oldValue, newValue);
};

var user = function user() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var defaultProps = {
    viewableName: _react2.default.PropTypes.string.isRequired,
    profileImage: _react2.default.PropTypes.string.isRequired,
    profileUrl: _react2.default.PropTypes.string,
    informalName: _react2.default.PropTypes.string
  };

  return _react2.default.PropTypes.shape(merge(defaultProps, props));
};

var book = function book() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var defaultProps = {
    bookId: _react2.default.PropTypes.string,
    workId: _react2.default.PropTypes.string,
    bookUrl: _react2.default.PropTypes.string,
    authorName: _react2.default.PropTypes.string,
    title: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    numPages: _react2.default.PropTypes.number
  };

  return _react2.default.PropTypes.shape(merge(defaultProps, props));
};

var bookDescription = function bookDescription() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var defaultProps = truncatedHtml();

  return _react2.default.PropTypes.shape(merge(defaultProps, props));
};

var author = function author() {
  return _react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.number.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    isGoodreadsAuthor: _react2.default.PropTypes.bool,
    profileImage: _react2.default.PropTypes.string,
    profileUrl: _react2.default.PropTypes.string.isRequired
  });
};

var expandableHtml = function expandableHtml() {
  return {
    html: _react2.default.PropTypes.string.isRequired,
    truncatedHtml: _react2.default.PropTypes.string
  };
};

var truncatedHtml = function truncatedHtml() {
  return {
    html: _react2.default.PropTypes.string,
    fullContentUrl: _react2.default.PropTypes.string,
    fullContentText: _react2.default.PropTypes.string,
    truncated: _react2.default.PropTypes.bool.isRequired,
    className: _react2.default.PropTypes.string,
    bookDescriptionTargetingData: _react2.default.PropTypes.object
  };
};

var friendNewsfeedResource = function friendNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    user: user().isRequired,
    friendUser: user().isRequired,
    isMyFriend: _react2.default.PropTypes.bool.isRequired,
    addFriendUrl: _react2.default.PropTypes.string,
    compareBooksUrl: _react2.default.PropTypes.string,
    ratingDetailsText: _react2.default.PropTypes.string,
    currentlyReadingBook: book()
  });
};

var userFollowingNewsfeedResource = function userFollowingNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    user: user().isRequired,
    followingUser: user().isRequired,
    ratingDetailsText: _react2.default.PropTypes.string,
    currentlyReadingBook: book()
  });
};

var commentSubject = function commentSubject() {
  return _react2.default.PropTypes.shape({
    type: _react2.default.PropTypes.string,
    id: _react2.default.PropTypes.number,
    uri: _react2.default.PropTypes.string
  });
};

var comment = function comment() {
  return _react2.default.PropTypes.shape({
    canComment: _react2.default.PropTypes.bool.isRequired,
    commentable: _react2.default.PropTypes.bool.isRequired,
    subjectKey: _react2.default.PropTypes.string.isRequired,
    subject: commentSubject(),
    subjectUrl: _react2.default.PropTypes.string
  });
};

var like = function like() {
  return _react2.default.PropTypes.shape({
    key: _react2.default.PropTypes.string.isRequired,
    label: _react2.default.PropTypes.string.isRequired,
    isLikeable: _react2.default.PropTypes.bool.isRequired
  });
};

var authorBlogPostNewsfeedResource = function authorBlogPostNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    author: author().isRequred,
    title: _react2.default.PropTypes.string,
    url: _react2.default.PropTypes.string
  });
};

var blogNewsfeedResource = function blogNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    title: _react2.default.PropTypes.string,
    body: _react2.default.PropTypes.object.isRequired,
    url: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    typeDisplayName: _react2.default.PropTypes.string
  });
};

var interviewNewsfeedResource = function interviewNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    title: _react2.default.PropTypes.string,
    body: _react2.default.PropTypes.object,
    url: _react2.default.PropTypes.string,
    imageUrl: _react2.default.PropTypes.string,
    authorImageUrl: _react2.default.PropTypes.string,
    author: _react2.default.PropTypes.string,
    bookImageUrl: _react2.default.PropTypes.string,
    bookTitle: _react2.default.PropTypes.string,
    typeDisplayName: _react2.default.PropTypes.string
  });
};

var authorFollowNewsfeedResource = function authorFollowNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    user: user().isRequired,
    author: author().isRequred,
    userAuthorFollowingsUrl: _react2.default.PropTypes.string
  });
};

var authorQaSettingNewsfeedResource = function authorQaSettingNewsfeedResource() {
  return _react2.default.PropTypes.shape({
    author: author().isRequired,
    message: _react2.default.PropTypes.string,
    url: _react2.default.PropTypes.string.isRequired
  });
};

var quote = function quote() {
  return _react2.default.PropTypes.shape({
    author: author().isRequired,
    body: _react2.default.PropTypes.object.isRequired,
    url: _react2.default.PropTypes.string.isRequired,
    quotesAuthorUrl: _react2.default.PropTypes.string.isRequired
  });
};

var group = function group() {
  return _react2.default.PropTypes.shape({
    allUnreadPostsUrl: _react2.default.PropTypes.string.isRequired,
    description: _react2.default.PropTypes.string.isRequired,
    iconUrl: _react2.default.PropTypes.string.isRequired,
    id: _react2.default.PropTypes.number.isRequired,
    lastActiveAt: createChainableTypeChecker(dateValidator),
    membersCount: _react2.default.PropTypes.number,
    name: _react2.default.PropTypes.string.isRequired,
    url: _react2.default.PropTypes.string.isRequired
  });
};

var topic = function topic() {
  return _react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.number.isRequired,
    title: _react2.default.PropTypes.string.isRequired,
    url: _react2.default.PropTypes.string.isRequired,
    totalPosts: _react2.default.PropTypes.string.isRequired,
    newPosts: _react2.default.PropTypes.string,
    newCommentsUrl: _react2.default.PropTypes.string,
    updatedAt: createChainableTypeChecker(dateValidator),
    folder: _react2.default.PropTypes.shape({
      name: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string
    })
  });
};

var defaultPollVoteProps = {
  user: user().isRequired,
  pollName: _react2.default.PropTypes.string.isRequired,
  answer: _react2.default.PropTypes.object.isRequired,
  url: _react2.default.PropTypes.string.isRequired,
  imageUrl: _react2.default.PropTypes.string.isRequired,
  isGroupPoll: _react2.default.PropTypes.bool.isRequired,
  isChoicePoll: _react2.default.PropTypes.bool.isRequired,
  groupName: _react2.default.PropTypes.string,
  groupUrl: _react2.default.PropTypes.string
};

var pollVoteNewsfeedResource = function pollVoteNewsfeedResource() {
  return _react2.default.PropTypes.shape(defaultPollVoteProps);
};

var choicePollVoteNewsfeedResource = function choicePollVoteNewsfeedResource() {
  return _react2.default.PropTypes.shape(merge(defaultPollVoteProps, {
    choiceYear: _react2.default.PropTypes.number.isRequired,
    choiceUrl: _react2.default.PropTypes.string.isRequired,
    badgeUrl: _react2.default.PropTypes.string.isRequired,
    votedBook: book().isRequired
  }));
};

var communityQuestion = function communityQuestion() {
  return {
    category: _react2.default.PropTypes.number.isRequired,
    questionText: _react2.default.PropTypes.string.isRequired,
    isSpoiler: _react2.default.PropTypes.bool.isRequired,
    questionUrl: _react2.default.PropTypes.string.isRequired,
    user: user().isRequired,
    authorQuestionsUrl: _react2.default.PropTypes.string,
    book: book()
  };
};

var communityAnswer = function communityAnswer() {
  return {
    user: user().isRequired,
    answerText: _react2.default.PropTypes.shape(truncatedHtml()),
    isSpoiler: _react2.default.PropTypes.bool.isRequired,
    communityQuestion: _react2.default.PropTypes.shape(communityQuestion()).isRequired
  };
};

var creative = function creative() {
  return _react2.default.PropTypes.shape({
    book: book(),
    customText: _react2.default.PropTypes.object,
    helpLink: _react2.default.PropTypes.string,
    defaultIcon: _react2.default.PropTypes.string,
    numAdditionalFriends: _react2.default.PropTypes.number,
    friendActionText: _react2.default.PropTypes.string,
    firstFriend: user(),
    customTextReview: _react2.default.PropTypes.object,
    similarBook: book(),
    similarBookShelf: _react2.default.PropTypes.string,
    similarBookShelfUrl: _react2.default.PropTypes.string,
    genres: _react2.default.PropTypes.array
  });
};

var notification = function notification() {
  var props = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  var defaultProps = {
    actor: _react2.default.PropTypes.shape({
      viewableName: _react2.default.PropTypes.string,
      profileImage: _react2.default.PropTypes.string,
      profileUrl: _react2.default.PropTypes.string
    }),
    actors: _react2.default.PropTypes.array,
    createdAt: _react2.default.PropTypes.string,
    body: _react2.default.PropTypes.string,
    resource: _react2.default.PropTypes.shape({
      text: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string
    }),
    viewed: _react2.default.PropTypes.boolean,
    moreActors: _react2.default.PropTypes.boolean
  };

  return _react2.default.PropTypes.shape(merge(defaultProps, props));
};

var searchResult = function searchResult(searchProp) {
  return _react2.default.PropTypes.shape({
    destination: _react2.default.PropTypes.string.isRequired,
    type: _react2.default.PropTypes.string.isRequired,
    object: searchProp
  });
};

var authorSearchResult = function authorSearchResult() {
  return searchResult(_react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.string.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    isGoodreadsAuthor: _react2.default.PropTypes.bool,
    profileImage: _react2.default.PropTypes.string
  }));
};

var bookSearchResult = function bookSearchResult() {
  return searchResult(_react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.string.isRequired,
    authorName: _react2.default.PropTypes.string.isRequired,
    isGoodreadsAuthor: _react2.default.PropTypes.bool,
    title: _react2.default.PropTypes.string.isRequired,
    imageUrl: _react2.default.PropTypes.string
  }));
};

var userSearchResult = function userSearchResult() {
  return searchResult(_react2.default.PropTypes.shape({
    id: _react2.default.PropTypes.string.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    profileImage: _react2.default.PropTypes.string
  }));
};

var readingNotesAnnotatedBookItem = function readingNotesAnnotatedBookItem() {
  return _react2.default.PropTypes.shape({
    asin: _react2.default.PropTypes.string.isRequired,
    imageUrl: _react2.default.PropTypes.string.isRequired,
    title: _react2.default.PropTypes.string.isRequired,
    authorName: _react2.default.PropTypes.string.isRequired,
    sharedCount: _react2.default.PropTypes.number.isRequired,
    highlightCount: _react2.default.PropTypes.number,
    noteCount: _react2.default.PropTypes.number,
    readingNotesUrl: _react2.default.PropTypes.string.isRequired,
    knhCta: _react2.default.PropTypes.string.isRequired,
    noSharedAnnotations: _react2.default.PropTypes.bool.isRequired
  });
};

var readingChallenge = function readingChallenge() {
  return _react2.default.PropTypes.shape({
    title: _react2.default.PropTypes.string.isRequired,
    url: _react2.default.PropTypes.string.isRequired,
    id: _react2.default.PropTypes.number.isRequired,
    year: _react2.default.PropTypes.number.isRequired,
    type: _react2.default.PropTypes.string.isRequired,
    maxGoal: _react2.default.PropTypes.number.isRequired,
    isFinished: _react2.default.PropTypes.bool,
    primaryColor: _react2.default.PropTypes.string.isRequired,
    secondaryColor: _react2.default.PropTypes.string.isRequired,
    images: _react2.default.PropTypes.shape({
      badge: _react2.default.PropTypes.string.isRequired,
      completed: _react2.default.PropTypes.string.isRequired
    })
  });
};

var shareDialog = function shareDialog() {
  return {
    signedIn: _react2.default.PropTypes.bool,
    signInUrl: _react2.default.PropTypes.string,

    social: _react2.default.PropTypes.shape({
      inModal: _react2.default.PropTypes.shape({
        facebook: _react2.default.PropTypes.bool.isRequired,
        twitter: _react2.default.PropTypes.bool.isRequired,
        pinterest: _react2.default.PropTypes.bool.isRequired,
        copyLink: _react2.default.PropTypes.bool.isRequired
      }).isRequired,

      outsideModal: _react2.default.PropTypes.shape({
        facebook: _react2.default.PropTypes.bool.isRequired,
        twitter: _react2.default.PropTypes.bool.isRequired,
        pinterest: _react2.default.PropTypes.bool.isRequired,
        copyLink: _react2.default.PropTypes.bool.isRequired
      }).isRequired,

      fbOptions: _react2.default.PropTypes.object,
      twitterOptions: _react2.default.PropTypes.object,
      pinterestOptions: _react2.default.PropTypes.object
    }).isRequired,

    sharingData: _react2.default.PropTypes.shape({
      resourceTypeFriendlyText: _react2.default.PropTypes.string.isRequired,
      resourceId: _react2.default.PropTypes.number.isRequired,
      sharerUserId: _react2.default.PropTypes.number
    }).isRequired,

    includePreview: _react2.default.PropTypes.bool,
    previewData: _react2.default.PropTypes.object
  };
};

var giveawayLogEntry = function giveawayLogEntry() {
  return _react2.default.PropTypes.shape({
    giveaway_uri: _react2.default.PropTypes.string,
    created_at: _react2.default.PropTypes.string,
    user_uri: _react2.default.PropTypes.string,
    start_at: _react2.default.PropTypes.string,
    end_at: _react2.default.PropTypes.string,
    release_at: _react2.default.PropTypes.string,
    book_uri: _react2.default.PropTypes.string,
    country_codes: _react2.default.PropTypes.string,
    book_count: _react2.default.PropTypes.string,
    adults_only_flag: _react2.default.PropTypes.string,
    description: _react2.default.PropTypes.string,
    primary_genre: _react2.default.PropTypes.string,
    secondary_genre: _react2.default.PropTypes.string,
    contact_info: _react2.default.PropTypes.string,
    nonwinner_message: _react2.default.PropTypes.string
  });
};

var reviewDraftItem = function reviewDraftItem() {
  return {
    reviewDraftUri: _react2.default.PropTypes.string.isRequired,
    book: book().isRequired,
    reviewEditPath: _react2.default.PropTypes.string.isRequired,
    reviewText: _react2.default.PropTypes.shape(expandableHtml()).isRequired
  };
};

exports.default = {
  user: user,
  author: author,
  blogNewsfeedResource: blogNewsfeedResource,
  interviewNewsfeedResource: interviewNewsfeedResource,
  book: book,
  bookDescription: bookDescription,
  quote: quote,
  commentSubject: commentSubject,
  comment: comment,
  like: like,
  group: group,
  topic: topic,
  authorBlogPostNewsfeedResource: authorBlogPostNewsfeedResource,
  authorFollowNewsfeedResource: authorFollowNewsfeedResource,
  authorQaSettingNewsfeedResource: authorQaSettingNewsfeedResource,
  communityQuestion: communityQuestion,
  communityAnswer: communityAnswer,
  friendNewsfeedResource: friendNewsfeedResource,
  userFollowingNewsfeedResource: userFollowingNewsfeedResource,
  pollVoteNewsfeedResource: pollVoteNewsfeedResource,
  expandableHtml: expandableHtml,
  truncatedHtml: truncatedHtml,
  choicePollVoteNewsfeedResource: choicePollVoteNewsfeedResource,
  date: createChainableTypeChecker(dateValidator),
  naturalNumber: createChainableTypeChecker(naturalNumberValidator),
  creative: creative,
  notification: notification,
  searchResults: {
    book: bookSearchResult,
    author: authorSearchResult,
    user: userSearchResult
  },
  readingNotesAnnotatedBookItem: readingNotesAnnotatedBookItem,
  readingChallenge: readingChallenge,
  reviewDraftItem: reviewDraftItem,
  shareDialog: shareDialog,
  giveawayLogEntry: giveawayLogEntry
};

},{"lodash":"lodash","react":"react"}],147:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _spoiler = require("../user_content/spoiler");

var _spoiler2 = _interopRequireDefault(_spoiler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Methods from our TextHelpers Ruby module can return text marked with <spoiler>
 * tags, possibly including inline JavaScript to show/hide their contents. This
 * library replaces that markup with the Spoiler React component.
 */
exports.default = {
  replaceSpoilerHTMLWithReactComponents: function replaceSpoilerHTMLWithReactComponents(rootDOMNode, jQuery) {
    /* istanbul ignore next */
    var $j = jQuery || window.$j;
    var spoilerLinks = $j(".jsShowSpoiler", rootDOMNode);

    _lodash2.default.each(spoilerLinks, function (spoilerLink) {
      var $spoilerLink = $j(spoilerLink);
      var spoilerContainer = $spoilerLink.next(".spoilerContainer");
      if (spoilerContainer) {
        var spoilerText = spoilerContainer.text().replace("(hide spoiler)", "");
        var spoiler = _react2.default.createElement(_spoiler2.default, { html: spoilerText });
        var placeholder = $j("<span></span>");
        $spoilerLink.replaceWith(placeholder);
        _reactDom2.default.render(spoiler, $j(placeholder)[0]);
      }
    });
  }
};

},{"../user_content/spoiler":170,"lodash":"lodash","react":"react","react-dom":"react-dom"}],148:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           React Component: ShareableLinkButton
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Modal with shareable link and description. Includes a copy link button
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           for copying shareable link to clipboard.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

var _flash_message = require("../flash_message");

var _flash_message2 = _interopRequireDefault(_flash_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareableLinkbutton",

  propTypes: {
    getShareableLinkURL: _react.PropTypes.string.isRequired,
    resourceType: _react.PropTypes.string.isRequired,
    buttonText: _react.PropTypes.string
  },

  getShareableLinkModalId: function getShareableLinkModalId() {
    return "shareableLinkModal";
  },
  getInitialState: function getInitialState() {
    return {
      error: false,
      fetching: false,
      copiedToClipboard: false,
      shareableLink: null,
      ttl: null
    };
  },

  // Expects a JSON response with a link(string) and a ttl(seconds)
  requestLink: function requestLink() {
    var _this = this;

    (0, _ajax_helper.httpRequest)(this.props.getShareableLinkURL, {
      method: "GET"
    }).done(function (_ref) {
      var link = _ref.link;
      var ttl = _ref.ttl;

      _this.setState({ shareableLink: link, ttl: ttl });
    }).fail(function () {
      _this.setState({ error: true });
    }).always(function () {
      _this.setState({ fetching: false });
    });
  },

  // Initially requests a link. Subsequent modal triggers keep fetched link.
  handleClick: function handleClick() {
    if (this.state.shareableLink) {
      return null;
    } else {
      return this.setState({ fetching: true, error: false }, this.requestLink);
    }
  },
  copyLinkToClipboard: function copyLinkToClipboard() {
    this.selectShareableLinkInput();
    document.execCommand("copy");
    return this.setState({ copiedToClipboard: true });
  },
  selectShareableLinkInput: function selectShareableLinkInput() {
    return this.shareableLinkInput.select();
  },
  getButtonText: function getButtonText() {
    return this.props.buttonText || "Get Link";
  },
  renderError: function renderError() {
    if (this.state.error) {
      var flashMessage = "Oops, something went wrong. Please try again.";
      return _jsx(_flash_message2.default, {
        category: "error",
        message: flashMessage
      });
    } else {
      return null;
    }
  },
  renderModal: function renderModal() {
    var _this2 = this;

    if (!this.state.shareableLink) {
      return null;
    } else {
      var expireTime = parseInt(this.state.ttl / 86400); // seconds to days
      return _jsx(_modal2.default, {
        id: this.getShareableLinkModalId(),
        centered: true,
        bemModifiers: "share"
      }, void 0, _jsx("div", {
        className: "shareableLinkModalContainer"
      }, void 0, _jsx("div", {
        className: "u-paddingBottomMedium"
      }, void 0, _jsx("h2", {
        className: "gr-h2"
      }, void 0, "Share this ", this.props.resourceType, " link with others")), _jsx("div", {
        className: "u-fullWidth u-paddingBottomTiny"
      }, void 0, _jsx("label", {
        htmlFor: "inviteUrl"
      }, void 0, "Invite Link:"), React.createElement("input", { className: "shareableLinkInput",
        ref: function ref(input) {
          _this2.shareableLinkInput = input;
        },
        readOnly: true,
        id: "inviteUrl",
        type: "text",
        value: this.state.shareableLink,
        onClick: this.selectShareableLinkInput })), _jsx("div", {
        className: "u-paddingBottomMedium"
      }, void 0, this.state.ttl && "This link will expire after " + expireTime + " days. ", this.state.copiedToClipboard && "Link copied to clipboard!"), _jsx("div", {}, void 0, _jsx("button", {
        type: "button",
        className: "gr-button",
        onClick: this.copyLinkToClipboard
      }, void 0, "Copy link to clipboard"))));
    }
  },
  renderModalTrigger: function renderModalTrigger() {
    if (this.state.fetching) {
      return _jsx(_spinner2.default, {
        isSmall: true
      });
    } else {
      return _jsx(_modal_trigger2.default, {
        id: "shareableLinkModal"
      }, void 0, _jsx("button", {
        type: "button",
        className: "gr-button",
        onClick: this.handleClick
      }, void 0, this.getButtonText()));
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "u-paddingTopBottomTiny"
    }, void 0, _jsx("div", {}, void 0, this.renderModalTrigger(), this.renderModal(), this.renderError()));
  }
});

},{"../../modules/ajax/ajax_helper":4,"../flash_message":84,"../gr_component_factory":87,"../modal":118,"../modal_trigger":119,"../spinner":161,"react":"react"}],149:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Facebook share
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: facebook_share
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the facebook share button that is used in the share module.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `options` (object): Options for facebook share, generated with fb_feed_options
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `metricName` (string): Full name or modifier for metric name
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "FacebookShare",

  propTypes: {
    options: _react2.default.PropTypes.shape({
      name: _react2.default.PropTypes.string,
      link: _react2.default.PropTypes.string,
      description: _react2.default.PropTypes.string,
      caption: _react2.default.PropTypes.string,
      picture: _react2.default.PropTypes.string,
      properties: _react2.default.PropTypes.object,
      action_link_text: _react2.default.PropTypes.string,
      resource_type: _react2.default.PropTypes.string
    }).isRequired,
    metricName: _react2.default.PropTypes.string
  },

  onFacebookButtonClick: function onFacebookButtonClick() {
    if (this.props.metricName) {
      (0, _ajax_helper.httpPost)("/track/track_click", {
        data: {
          feature: this.props.metricName
        }
      });
    }
    $grfb.feedDialog(this.props.options);
  },
  render: function render() {
    var _this = this;

    return _jsx("button", {
      className: this.withBemModifiers("shareSocialButtons__button") + " shareSocialButtons__button--facebook",
      "aria-label": "Share to Facebook",
      type: "button",
      onClick: function onClick() {
        return _this.onFacebookButtonClick();
      }
    });
  }
});

},{"../../modules/ajax/ajax_helper":4,"./../gr_component_factory":87,"react":"react"}],150:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Pinterest share
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: pinterest_share
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the pinterest share button that is used in the share module.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `options` (object): Options for pinterest share (description, url, media)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `metricName` (string): Full name or modifier for metric name
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `windowSpecs` (shape): Options for pinterest child window
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

var _child_window_helper = require("../../modules/child_window_helper");

var _child_window_helper2 = _interopRequireDefault(_child_window_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "PinterestShare",

  propTypes: {
    options: _react2.default.PropTypes.shape({
      desription: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string,
      media: _react2.default.PropTypes.string
    }).isRequired,
    metricName: _react2.default.PropTypes.string,
    windowSpecs: _react2.default.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      // default window specs hard-coded here - cannot access browser window on server-side for centering
      windowSpecs: { left: 400,
        top: 200,
        width: 700,
        height: 800 }
    };
  },
  onPinterestButtonClick: function onPinterestButtonClick() {
    if (this.props.metricName) {
      (0, _ajax_helper.httpPost)("/track/track_click", {
        data: {
          feature: this.props.metricName
        }
      });
    }
    _child_window_helper2.default.openSocialShareWindow("https://pinterest.com/pin/create/link/", this.props.options, this.props.windowSpecs);
  },
  render: function render() {
    var _this = this;

    return _jsx("button", {
      className: this.withBemModifiers("shareSocialButtons__button") + " shareSocialButtons__button--pinterest",
      "aria-label": "Share to Pinterest",
      type: "button",
      onClick: function onClick() {
        return _this.onPinterestButtonClick();
      }
    });
  }
});

},{"../../modules/ajax/ajax_helper":4,"../../modules/child_window_helper":7,"./../gr_component_factory":87,"react":"react"}],151:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // React Component for blog preview card in share dialog

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _truncated_html = require("../../user_content/truncated_html");

var _truncated_html2 = _interopRequireDefault(_truncated_html);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareDialogBlogPreview",

  propTypes: {
    title: _react.PropTypes.string.isRequired,
    imageUrl: _react.PropTypes.string,
    description: _react.PropTypes.string.isRequired
  },

  // Because of unique template, cannot reuse ShareDialogPreview
  render: function render() {
    return _jsx("div", {
      className: "gr-mediaFlexbox shareModal__previewContainer shareModal__previewContainer--blog"
    }, void 0, _jsx("div", {
      className: "gr-mediaFlexbox__media sharePreview__image sharePreview__image--blog"
    }, void 0, _jsx("img", {
      className: "gr-mediaFlexbox__media sharePreview__imageFullWidth",
      src: this.props.imageUrl,
      alt: this.props.title
    })), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("div", {
      className: "gr-h3 gr-h3--serif gr-h3--noMargin"
    }, void 0, this.props.title), _jsx("div", {
      className: "u-marginTopXSmall"
    }, void 0, _jsx("div", {
      className: "sharePreview__description"
    }, void 0, _jsx(_truncated_html2.default, {
      html: this.props.description,
      truncated: false
    })))));
  }
});

},{"../../gr_component_factory":87,"../../user_content/truncated_html":172,"react":"react"}],152:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // React Component for book preview card in share dialog. Similar to Book Component
// but display only (no links).

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _share_dialog_preview = require("./share_dialog_preview");

var _share_dialog_preview2 = _interopRequireDefault(_share_dialog_preview);

var _community_rating = require("../../community_rating");

var _community_rating2 = _interopRequireDefault(_community_rating);

var _author_badge = require("../../author/author_badge");

var _author_badge2 = _interopRequireDefault(_author_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareDialogBookPreview",

  propTypes: {
    author: _react.PropTypes.shape({
      name: _react.PropTypes.string.isRequired,
      isGoodreadsAuthor: _react.PropTypes.bool.isRequired
    }).isRequired,

    rating: _react.PropTypes.string.isRequired,
    title: _react.PropTypes.string.isRequired,
    imageUrl: _react.PropTypes.string.isRequired,
    ratingsCount: _react.PropTypes.number.isRequired,
    textReviewsCount: _react.PropTypes.number.isRequired
  },

  renderAuthorText: function renderAuthorText() {
    return _jsx("div", {}, void 0, "by ", this.props.author.name, _jsx(_author_badge2.default, {
      isGoodreadsAuthor: this.props.author.isGoodreadsAuthor
    }));
  },
  render: function render() {
    return _jsx(_share_dialog_preview2.default, {
      primaryText: this.props.title,
      secondaryText: this.renderAuthorText(),
      imageUrl: this.props.imageUrl
    }, void 0, _jsx("div", {
      className: "u-marginTopXSmall"
    }, void 0, _jsx(_community_rating2.default, {
      rating: parseFloat(this.props.rating),
      displayAvg: true,
      displayAvgRatingText: false,
      ratingsCount: this.props.ratingsCount,
      size: _community_rating2.default.ICON_SIZES.MEDIUM,
      textReviewsCount: this.props.textReviewsCount
    })));
  }
});

},{"../../author/author_badge":60,"../../community_rating":72,"../../gr_component_factory":87,"./share_dialog_preview":154,"react":"react"}],153:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // React Component for interview preview card in share dialog

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _truncated_html = require("../../user_content/truncated_html");

var _truncated_html2 = _interopRequireDefault(_truncated_html);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareDialogInterviewPreview",

  propTypes: {
    title: _react.PropTypes.string.isRequired,
    description: _react.PropTypes.string.isRequired,
    author: _react.PropTypes.string.isRequired,
    authorImageUrl: _react.PropTypes.string,
    bookImageUrl: _react.PropTypes.string,
    bookTitle: _react.PropTypes.string,
    imageUrl: _react.PropTypes.string
  },

  renderImage: function renderImage() {
    if (this.props.imageUrl) {
      return _jsx("img", {
        className: "gr-mediaFlexbox__media sharePreview__imageFullWidth",
        src: this.props.imageUrl,
        alt: this.props.title
      });
    } else if (this.props.authorImageUrl && this.props.bookImageUrl) {
      return _jsx("div", {
        className: "gr-mediaFlexbox__media sharePreview__image",
        style: { display: "contents" }
      }, void 0, _jsx("div", {
        className: "editorialCard__image--interview\n                          editorialCard__image--interviewAuthor",
        style: { backgroundImage: "url(" + this.props.authorImageUrl + ")" }
      }, void 0, _jsx("span", {
        className: "u-visuallyHidden"
      }, void 0, this.props.author)), _jsx("div", {
        className: "editorialCard__image--interview\n                          editorialCard__image--interviewBook",
        style: { backgroundImage: "url(" + this.props.bookImageUrl + ")" }
      }, void 0, _jsx("span", {
        className: "u-visuallyHidden"
      }, void 0, this.props.bookTitle)));
    } else {
      return null;
    }
  },

  // Because of unique image, cannot reuse ShareDialogPreview
  render: function render() {
    return _jsx("div", {}, void 0, _jsx("div", {
      className: "gr-mediaFlexbox shareModal__previewContainer",
      style: { display: "block" }
    }, void 0, this.renderImage(), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("div", {
      className: "gr-h3 gr-h3--serif gr-h3--noMargin"
    }, void 0, this.props.title), _jsx("div", {
      className: "u-marginTopXSmall"
    }, void 0, _jsx("div", {
      className: "sharePreview__description"
    }, void 0, _jsx(_truncated_html2.default, {
      html: this.props.description,
      truncated: false
    }))))));
  }
});

},{"../../gr_component_factory":87,"../../user_content/truncated_html":172,"react":"react"}],154:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Share Dialog Preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: share_dialog_preview
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           A generic container for a preview of your Sharing resource in the Share Dialog modal.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Use if your preview card follows media box format with a title and image. Children
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           are rendered under secondaryText.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `primaryText`: header of preview card
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `imageUrl`: url of image
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `secondaryText`: either string or element
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```rails_example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           <%= react_component 'ReactComponents.ShareDialogPreview',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 primaryText: 'This is the primaryText',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 imageUrl: 'https://d.gr-assets.com/books/1363934734s/1842.jpg',
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 secondaryText: 'This is the secondaryText'
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           %>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ```
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareDialogPreview",

  propTypes: {
    imageUrl: _react.PropTypes.string.isRequired,
    primaryText: _react.PropTypes.string.isRequired,
    secondaryText: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string])
  },

  renderSecondaryText: function renderSecondaryText() {
    if (this.props.secondaryText) {
      return _jsx("div", {
        className: "sharePreview__secondaryText"
      }, void 0, this.props.secondaryText);
    } else {
      return null;
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "gr-mediaFlexbox shareModal__previewContainer"
    }, void 0, _jsx("img", {
      className: "gr-mediaFlexbox__media sharePreview__image",
      src: this.props.imageUrl,
      alt: this.props.primaryText
    }), _jsx("div", {
      className: "gr-mediaFlexbox__desc"
    }, void 0, _jsx("div", {
      className: "gr-h3 gr-h3--serif gr-h3--noMargin"
    }, void 0, this.props.primaryText), this.renderSecondaryText(), _jsx("div", {
      className: "u-marginTopXSmall"
    }, void 0, this.props.children)));
  }
});

},{"../../gr_component_factory":87,"react":"react"}],155:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // Share Preview card for topics

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _share_dialog_preview = require("./share_dialog_preview");

var _share_dialog_preview2 = _interopRequireDefault(_share_dialog_preview);

var _react = require("react");

var _gr_component_factory = require("../../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _truncated_html = require("../../user_content/truncated_html");

var _truncated_html2 = _interopRequireDefault(_truncated_html);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ShareDialogTopicPreview",

  propTypes: {
    topicTitle: _react.PropTypes.string.isRequired,
    groupTitle: _react.PropTypes.string.isRequired,
    imageUrl: _react.PropTypes.string.isRequired,
    description: _react.PropTypes.string
  },

  render: function render() {
    var secondaryText = this.props.groupTitle + " - Discussion";
    return _jsx(_share_dialog_preview2.default, {
      primaryText: this.props.topicTitle,
      secondaryText: secondaryText,
      imageUrl: this.props.imageUrl
    }, void 0, _jsx("div", {
      className: "sharePreview__description"
    }, void 0, _jsx(_truncated_html2.default, {
      html: this.props.description,
      truncated: false
    })));
  }
});

},{"../../gr_component_factory":87,"../../user_content/truncated_html":172,"./share_dialog_preview":154,"react":"react"}],156:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*doc
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           title: Twitter share
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           name: twitter_share
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           category: React
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ---
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           This component displays the twitter share button that is used in the share module.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Required props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `options` (object): Options for twitter share (text, url)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Optional props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `metricName` (string): Full name or modifier for metric name
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * `windowSpecs` (shape): Options for twitter child window
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _ajax_helper = require("../../modules/ajax/ajax_helper");

var _child_window_helper = require("../../modules/child_window_helper");

var _child_window_helper2 = _interopRequireDefault(_child_window_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "TwitterShare",

  propTypes: {
    options: _react2.default.PropTypes.shape({
      text: _react2.default.PropTypes.string,
      url: _react2.default.PropTypes.string,
      via: _react2.default.PropTypes.string
    }).isRequired,
    metricName: _react2.default.PropTypes.string,
    windowSpecs: _react2.default.PropTypes.object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      // default window specs hard-coded here - cannot access browser window on server-side for centering
      windowSpecs: { left: 400,
        top: 200,
        width: 600,
        height: 500 }
    };
  },
  onTwitterButtonClick: function onTwitterButtonClick() {
    if (this.props.metricName) {
      (0, _ajax_helper.httpPost)("/track/track_click", {
        data: {
          feature: this.props.metricName
        }
      });
    }
    _child_window_helper2.default.openSocialShareWindow("https://twitter.com/intent/tweet/", this.props.options, this.props.windowSpecs);
  },
  render: function render() {
    var _this = this;

    return _jsx("button", {
      className: this.withBemModifiers("shareSocialButtons__button") + " shareSocialButtons__button--twitter",
      "aria-label": "Share to Twitter",
      type: "button",
      onClick: function onClick() {
        return _this.onTwitterButtonClick();
      }
    });
  }
});

},{"../../modules/ajax/ajax_helper":4,"../../modules/child_window_helper":7,"./../gr_component_factory":87,"react":"react"}],157:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ChoiceSiteAnnouncement",

  propTypes: {
    imageUrl: React.PropTypes.string.isRequired,
    announcementText: React.PropTypes.string.isRequired,
    description: React.PropTypes.string.isRequired,
    targetUrl: React.PropTypes.string,
    totalVotes: React.PropTypes.number.isRequired
  },

  getAriaLabel: function getAriaLabel() {
    return "Read more " + this.props.announcementText;
  },
  hasTargetUrl: function hasTargetUrl() {
    return !_lodash2.default.isEmpty(this.props.targetUrl);
  },
  renderAnnouncementTitle: function renderAnnouncementTitle() {
    var isLink = this.hasTargetUrl();
    var textClassName = "siteAnnouncement__title";
    if (isLink) {
      return _jsx("a", {
        className: (0, _classnames2.default)(textClassName, "gr-hyperlink"),
        "aria-label": this.getAriaLabel(),
        href: this.props.targetUrl
      }, void 0, this.props.announcementText);
    } else {
      return _jsx("span", {
        className: textClassName
      }, void 0, this.props.announcementText);
    }
  },
  render: function render() {
    return _jsx("div", {
      className: "siteAnnouncement gr-mediaFlexbox gr-mediaFlexbox--columnDirection"
    }, void 0, _jsx("a", {
      className: "gr-mediaFlexbox__media siteAnnouncement__masthead",
      href: this.props.targetUrl
    }, void 0, _jsx("img", {
      src: this.props.imageUrl,
      alt: this.props.imageAlt
    })), _jsx("div", {
      className: "gr-mediaFlexbox__desc siteAnnouncement__body"
    }, void 0, this.renderAnnouncementTitle(), _jsx("div", {
      className: "siteAnnouncement__description"
    }, void 0, this.props.description), _jsx("div", {
      className: "siteAnnouncement__choiceVoteCount"
    }, void 0, this.props.totalVotes.toLocaleString(), " votes")));
  }
});

},{"../gr_component_factory":87,"classnames":"classnames","lodash":"lodash"}],158:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _shape_icon = require("../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _shape_icon_values = require("../../modules/shape_icon_values");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SimpleSiteAnnouncement",

  propTypes: {
    imageUrl: React.PropTypes.string.isRequired,
    announcementText: React.PropTypes.string.isRequired,
    targetUrl: React.PropTypes.string
  },

  getAriaLabel: function getAriaLabel() {
    return "Read more " + this.props.announcementText;
  },
  hasTargetUrl: function hasTargetUrl() {
    return !_lodash2.default.isEmpty(this.props.targetUrl);
  },
  renderIcon: function renderIcon() {
    return _jsx(_shape_icon2.default, {
      imageUrl: this.props.imageUrl,
      size: _shape_icon_values.ICON_SIZES.MEDIUM,
      imageAlt: "Site Announcement",
      border: true
    });
  },
  renderAnnouncementText: function renderAnnouncementText() {
    var isLink = this.hasTargetUrl();
    var textClassName = "siteAnnouncement__simpleText";
    if (isLink) {
      return _jsx("a", {
        className: (0, _classnames2.default)(textClassName, "gr-hyperlink"),
        "aria-label": this.getAriaLabel(),
        href: this.props.targetUrl
      }, void 0, this.props.announcementText);
    } else {
      return _jsx("span", {
        className: textClassName
      }, void 0, this.props.announcementText);
    }
  },
  renderSecondaryLinkSection: function renderSecondaryLinkSection() {
    return this.hasTargetUrl() ? _jsx("span", {
      className: "siteAnnouncement__simpleSecondaryLinkSection"
    }, void 0, _jsx("a", {
      className: "gr-button gr-button--quiet",
      "aria-label": this.getAriaLabel(),
      href: this.props.targetUrl
    }, void 0, "Read more")) : null;
  },
  render: function render() {
    return _jsx("div", {
      className: "siteAnnouncement\n                      siteAnnouncement--simple\n                      gr-mediaFlexbox\n                      gr-mediaFlexbox--alignItemsCenter"
    }, void 0, _jsx("div", {
      className: "gr-mediaFlexbox__media"
    }, void 0, this.renderIcon()), _jsx("div", {
      className: "gr-mediaFlexbox__desc siteAnnouncement__simpleBody"
    }, void 0, _jsx("h5", {
      className: "gr-h5 gr-h5--noMargin siteAnnouncement__simpleHeader"
    }, void 0, "Goodreads news"), this.renderAnnouncementText()), this.renderSecondaryLinkSection());
  }
});

},{"../../modules/shape_icon_values":16,"../gr_component_factory":87,"../shape_icon":141,"classnames":"classnames","lodash":"lodash"}],159:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _simple_site_announcement = require("./simple_site_announcement");

var _simple_site_announcement2 = _interopRequireDefault(_simple_site_announcement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SiteAnnouncement",
  propTypes: {
    title: _react.PropTypes.string.isRequired,
    targetUrl: _react.PropTypes.string,
    displayData: _react.PropTypes.shape({
      description: _react.PropTypes.string,
      mastheadUrl: _react.PropTypes.string,
      imageUrl: _react.PropTypes.string
    }).isRequired
  },

  shouldRenderLargeAnnouncement: function shouldRenderLargeAnnouncement() {
    var largeAnnouncementData = this.props.displayData;
    return largeAnnouncementData && largeAnnouncementData.description && largeAnnouncementData.mastheadUrl;
  },
  renderLargeAnnouncement: function renderLargeAnnouncement() {
    return _jsx("div", {
      className: "siteAnnouncement gr-mediaFlexbox gr-mediaFlexbox--columnDirection"
    }, void 0, _jsx("a", {
      className: "gr-mediaFlexbox__media siteAnnouncement__masthead",
      href: this.props.targetUrl,
      "aria-label": this.props.title
    }, void 0, _jsx("img", {
      src: this.props.displayData.mastheadUrl,
      alt: this.props.title
    })), _jsx("div", {
      className: "gr-mediaFlexbox__desc siteAnnouncement__body"
    }, void 0, _jsx("a", {
      className: "siteAnnouncement__title gr-hyperlink",
      href: this.props.targetUrl
    }, void 0, this.props.title), _jsx("div", {
      className: "siteAnnouncement__description"
    }, void 0, this.props.displayData.description)));
  },
  render: function render() {
    if (this.shouldRenderLargeAnnouncement()) {
      return this.renderLargeAnnouncement();
    } else {
      return _jsx(_simple_site_announcement2.default, {
        imageUrl: this.props.displayData.imageUrl,
        announcementText: this.props.title,
        targetUrl: this.props.targetUrl
      });
    }
  }
});

},{"../gr_component_factory":87,"./simple_site_announcement":158,"react":"react"}],160:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _shape_icon = require("../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _shape_icon_values = require("../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WelcomeAnnouncement",

  propTypes: {
    imageUrl: React.PropTypes.string.isRequired
  },

  renderIcon: function renderIcon() {
    return _jsx(_shape_icon2.default, {
      imageUrl: this.props.imageUrl,
      size: _shape_icon_values.ICON_SIZES.MEDIUM,
      imageAlt: "Welcome to Goodreads",
      border: true
    });
  },
  render: function render() {
    return _jsx("div", {
      className: "siteAnnouncement siteAnnouncement--welcome"
    }, void 0, _jsx("div", {
      className: "siteAnnouncement__welcomeIcon"
    }, void 0, this.renderIcon()), _jsx("div", {
      className: "siteAnnouncement__welcomeBody"
    }, void 0, _jsx("h5", {
      className: "siteAnnouncement__announcementText"
    }, void 0, "Welcome to Goodreads"), _jsx("span", {}, void 0, "Meet your favorite book, find your reading community, and manage your reading life.")));
  }
});

},{"../../modules/shape_icon_values":16,"../gr_component_factory":87,"../shape_icon":141}],161:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Spinner",

  propTypes: {
    isSmall: React.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      isSmall: false
    };
  },
  render: function render() {
    var cx = (0, _classnames2.default)("spinnerContainer", this.props.className);
    var bemModifier = this.props.isSmall ? "small" : null;
    return _jsx("div", {
      className: cx
    }, void 0, _jsx("div", {
      className: this.withBemModifiers("spinner", bemModifier)
    }, void 0, _jsx("div", {
      className: this.withBemModifiers("spinner__mask", bemModifier)
    }, void 0, _jsx("div", {
      className: this.withBemModifiers("spinner__maskedCircle", bemModifier)
    }))), _jsx("div", {
      className: "spinnerFallbackText"
    }, void 0, "Loading…"));
  }
});

},{"./gr_component_factory":87,"classnames":"classnames"}],162:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "SponsoredFooter",

  propTypes: {
    sponsoredName: _react2.default.PropTypes.string
  },

  renderSponsoredName: function renderSponsoredName() {
    if (this.props.sponsoredName) {
      return _jsx("span", {
        className: "featuredContentModule__sponsoredName"
      }, void 0, this.props.sponsoredName);
    }
  },
  render: function render() {
    var footerClasses = "featuredContentModule__sponsoredFooter";
    var sponsoredLabel = this.props.sponsoredName ? "Sponsored by " : "Sponsored";
    return _jsx("div", {
      className: footerClasses
    }, void 0, _jsx("span", {
      className: "featuredContentModule__sponsoredBadgeIcon"
    }), _jsx("span", {
      className: "featuredContentModule__sponsoredLabel"
    }, void 0, sponsoredLabel), this.renderSponsoredName());
  }
});

},{"./gr_component_factory":87,"react":"react"}],163:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "StoresInitializer",

  render: function render() {
    return null;
  }
}); // This is a component used exlusively for initializing a store. Since that is
// its sole purpose, it renders nothing

},{"./gr_component_factory":87}],164:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _tab_actions = require("../react_actions/tab_actions");

var _tab_actions2 = _interopRequireDefault(_tab_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventTypes = {
  CLICK: "click",
  HOVER: "hover"
}; // See documentation on https://www.goodreads.com/style_guide

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Tab",

  propTypes: {
    group: _react2.default.PropTypes.string.isRequired,
    name: _react2.default.PropTypes.string.isRequired,
    initiallySelected: _react2.default.PropTypes.bool,
    triggerEventType: _react2.default.PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      initiallySelected: false,
      triggerEventType: eventTypes.CLICK
    };
  },
  componentDidMount: function componentDidMount() {
    if (this.props.initiallySelected) {
      this.selectTab();
    }
  },
  selectTab: function selectTab() {
    _tab_actions2.default.selectTab(this.props.name, this.props.group);
  },
  render: function render() {
    var tabAttrs = {};
    switch (this.props.triggerEventType) {
      case eventTypes.CLICK:
        tabAttrs.onClick = this.selectTab;
        break;
      case eventTypes.HOVER:
        tabAttrs.onMouseOver = this.selectTab;
        break;
    }
    return _react2.default.createElement(
      "span",
      tabAttrs,
      this.props.children
    );
  }
});

},{"../react_actions/tab_actions":36,"./gr_component_factory":87,"react":"react"}],165:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _tabs_store = require("../react_stores/tabs_store");

var _tabs_store2 = _interopRequireDefault(_tabs_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "TabContent",

  mixins: [_reflux2.default.connect(_tabs_store2.default, "tabsStore")],

  propTypes: {
    group: _react2.default.PropTypes.string.isRequired,
    name: _react2.default.PropTypes.string.isRequired
  },

  isActive: function isActive() {
    return this.props.name === this.state.tabsStore[this.props.group];
  },
  render: function render() {
    return _jsx("div", {}, void 0, this.isActive() ? this.props.children : null);
  }
});

},{"../react_stores/tabs_store":202,"./gr_component_factory":87,"react":"react","reflux":"reflux"}],166:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _date_utils = require("../../modules/date_utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "RelativeTime",

  propTypes: {
    time: _gr_prop_types2.default.date.isRequired,
    longFormat: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      longFormat: false
    };
  },
  getRelativeTime: function getRelativeTime() {
    if (this.props.longFormat) {
      return (0, _moment2.default)(new Date(this.props.time)).fromNow();
    } else {
      return (0, _date_utils.fromNow)(this.props.time);
    }
  },
  render: function render() {
    return _jsx("time", {
      dateTime: this.props.time,
      "aria-label": (0, _moment2.default)(new Date(this.props.time)).fromNow()
    }, void 0, this.getRelativeTime());
  }
});

},{"../../modules/date_utils":11,"../gr_component_factory":87,"../shared/gr_prop_types":146,"moment":"moment","react":"react"}],167:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _shape_icon = require("../shape_icon");

var _shape_icon2 = _interopRequireDefault(_shape_icon);

var _shape_icon_values = require("../../modules/shape_icon_values");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserIcon",

  propTypes: {
    user: _react2.default.PropTypes.shape({
      viewableName: _react2.default.PropTypes.string.isRequired,
      profileImage: _react2.default.PropTypes.string.isRequired,
      profileUrl: _react2.default.PropTypes.string
    }).isRequired,
    includeLink: _react2.default.PropTypes.bool,
    size: _react2.default.PropTypes.oneOf([_shape_icon_values.ICON_SIZES.SMALL, _shape_icon_values.ICON_SIZES.MEDIUM, _shape_icon_values.ICON_SIZES.LARGE])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      includeLink: true,
      size: _shape_icon_values.ICON_SIZES.SMALL
    };
  },
  render: function render() {
    var user = this.props.user;

    return _react2.default.createElement(_shape_icon2.default, _extends({ imageUrl: user.profileImage,
      imageAlt: user.viewableName,
      linkUrl: user.profileUrl,
      border: true
    }, this.props));
  }
});

},{"../../modules/shape_icon_values":16,"../gr_component_factory":87,"../shape_icon":141,"react":"react"}],168:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _click_tracking_wrapper = require("../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserProfileLink",

  propTypes: {
    user: _gr_prop_types2.default.user().isRequired,
    className: _react2.default.PropTypes.string
  },

  userName: function userName() {
    return { __html: this.props.user.viewableName };
  },
  render: function render() {
    var className = (0, _classnames2.default)("gr-hyperlink", "gr-hyperlink--bold", "gr-user__profileLink", this.props.className);
    var profileLink = _jsx("a", {
      className: className,
      href: this.props.user.profileUrl,
      dangerouslySetInnerHTML: this.userName()
    });
    if (this.props.user.profileUrl && this.props.user.viewableName) {
      return _jsx(_click_tracking_wrapper2.default, {
        children: profileLink,
        trackingOptions: _click_tracking_helper.TRACKED_CLASSES.user_profile
      });
    } else if (this.props.user.viewableName) {
      return _jsx("b", {}, void 0, this.props.user.viewableName);
    } else {
      return null;
    }
  }
});

},{"../../modules/ads/click_tracking_helper":2,"../click_tracking_wrapper":70,"../gr_component_factory":87,"../shared/gr_prop_types":146,"classnames":"classnames","react":"react"}],169:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _gr_spoiler_handler = require("../shared/gr_spoiler_handler");

var _gr_spoiler_handler2 = _interopRequireDefault(_gr_spoiler_handler);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "ExpandableHtml",

  propTypes: _gr_prop_types2.default.expandableHtml(),

  getInitialState: function getInitialState() {
    return {
      expanded: false
    };
  },
  collapse: function collapse() {
    this.setState({ expanded: false });
  },
  expand: function expand() {
    this.setState({ expanded: true });
  },
  expandable: function expandable() {
    return !_lodash2.default.isEmpty(this.props.truncatedHtml);
  },
  visibleHtml: function visibleHtml() {
    if (!this.expandable() || this.state.expanded === true) {
      return this.props.html;
    } else {
      return this.props.truncatedHtml;
    }
  },
  renderToggleButton: function renderToggleButton() {
    if (!this.expandable()) {
      return null;
    }

    var action = this.state.expanded ? this.collapse : this.expand;
    var label = this.state.expanded ? "Less" : "More";

    var cx = (0, _classnames2.default)("gr-buttonAsLink", "u-marginLeftTiny");

    return _jsx("button", {
      className: cx,
      onClick: action
    }, void 0, label);
  },
  componentDidMount: function componentDidMount() {
    if (this.refs.rootNode) {
      _gr_spoiler_handler2.default.replaceSpoilerHTMLWithReactComponents(this.refs.rootNode);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    if (this.refs.rootNode) {
      _gr_spoiler_handler2.default.replaceSpoilerHTMLWithReactComponents(this.refs.rootNode);
    }
  },
  render: function render() {
    if (_lodash2.default.isEmpty(this.props.html)) {
      return null;
    }

    var expandableClass = (0, _classnames2.default)("expandableHtml", this.props.className);
    return React.createElement(
      "div",
      { className: expandableClass, ref: "rootNode" },
      _jsx("span", {
        dangerouslySetInnerHTML: { __html: this.visibleHtml() }
      }),
      this.renderToggleButton()
    );
  }
});

},{"../gr_component_factory":87,"../shared/gr_prop_types":146,"../shared/gr_spoiler_handler":147,"classnames":"classnames","lodash":"lodash"}],170:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "Spoiler",

  propTypes: {
    html: _react2.default.PropTypes.string,
    spoilerWarning: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.element])
  },

  componentWillMount: function componentWillMount() {
    if (this.props.html === null && this.props.children === null) {
      throw new Error("props.children and props.html cannot both be null");
    }
  },
  getDefaultProps: function getDefaultProps() {
    return {
      html: null,
      spoilerWarning: null
    };
  },
  getInitialState: function getInitialState() {
    return {
      showSpoiler: false
    };
  },
  onClickShowSpoiler: function onClickShowSpoiler() {
    this.setState({
      showSpoiler: true
    });
  },
  onClickHideSpoiler: function onClickHideSpoiler() {
    this.setState({
      showSpoiler: false
    });
  },
  getSpoilerHtml: function getSpoilerHtml() {
    return {
      __html: this.props.html
    };
  },
  renderSpoiler: function renderSpoiler() {
    if (this.props.html) {
      return _jsx("span", {
        className: "spoiler__text u-marginRightTiny",
        dangerouslySetInnerHTML: this.getSpoilerHtml()
      });
    } else {
      return this.props.children;
    }
  },
  render: function render() {
    return _jsx("span", {}, void 0, this.state.showSpoiler ? _jsx("span", {
      className: "spoiler__textContainer"
    }, void 0, this.renderSpoiler(), _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.onClickHideSpoiler
    }, void 0, "(hide spoiler)")) : _jsx("span", {}, void 0, this.props.spoilerWarning, _jsx("button", {
      className: "gr-buttonAsLink",
      onClick: this.onClickShowSpoiler
    }, void 0, "(view spoiler)")));
  }
});

},{"../gr_component_factory":87,"react":"react"}],171:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           StringCounter React component
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           Props:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           counterType: count by "character" or by "word"
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           maxLength: max text length, inclusive
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           text: string to count
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           warnLength: number of elements remaining to display a counter
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             - ex. warnLength: 100 //displays at 100 elements remaining
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             - if omitted, will always show counter
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * becomes visible: maxLength - text.length <= warnLength
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           * becomes (red) alert: text.length > maxLength
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _string_helper = require("../../modules/string_helper");

var _pluralize = require("pluralize");

var _pluralize2 = _interopRequireDefault(_pluralize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "StringCounter",

  propTypes: {
    counterType: _react.PropTypes.oneOf(["character", "word"]).isRequired,
    maxLength: _react.PropTypes.number.isRequired,
    text: _react.PropTypes.string.isRequired,
    warnLength: _react.PropTypes.number
  },

  renderWarning: function renderWarning(diff) {
    var cname = undefined;
    if (diff < 0) {
      cname = "gr-smallAlert";
    }

    return _jsx("span", {
      className: cname,
      role: "alert"
    }, void 0, diff, " ", (0, _pluralize2.default)(this.props.counterType, diff), " left");
  },
  countType: function countType() {
    if (this.props.counterType === "character") {
      return (0, _string_helper.astralLength)(this.props.text);
    } else if (this.props.counterType === "word") {
      return (0, _string_helper.countWords)(this.props.text);
    } else {
      return null;
    }
  },
  render: function render() {
    var textLength = this.countType(this.props.text);

    var diff = this.props.maxLength - textLength;
    var shouldRender = this.props.warnLength ? diff <= this.props.warnLength : true;
    if (shouldRender) {
      return _jsx("div", {}, void 0, this.renderWarning(diff));
    } else {
      return null;
    }
  }
});

},{"../../modules/string_helper":19,"../gr_component_factory":87,"pluralize":"pluralize","react":"react"}],172:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_prop_types = require("../shared/gr_prop_types");

var _gr_prop_types2 = _interopRequireDefault(_gr_prop_types);

var _gr_spoiler_handler = require("../shared/gr_spoiler_handler");

var _gr_spoiler_handler2 = _interopRequireDefault(_gr_spoiler_handler);

var _click_tracking_wrapper = require("../click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _click_tracking_helper = require("../../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "TruncatedHtml",

  propTypes: _gr_prop_types2.default.truncatedHtml(),

  getDefaultProps: function getDefaultProps() {
    return {
      fullContentText: "More",
      bookDescriptionTargetingData: _click_tracking_helper.TRACKED_CLASSES.full_content_link
    };
  },
  componentDidMount: function componentDidMount() {
    _gr_spoiler_handler2.default.replaceSpoilerHTMLWithReactComponents(this.refs.rootNode);
  },
  render: function render() {
    var fullContentLink = _jsx("a", {
      className: "u-marginLeftTiny fullContentLink",
      href: this.props.fullContentUrl
    }, void 0, this.props.fullContentText);
    return React.createElement(
      "div",
      { ref: "rootNode", className: this.props.className },
      _jsx("span", {
        dangerouslySetInnerHTML: { __html: this.props.html }
      }),
      this.props.truncated ? _jsx(_click_tracking_wrapper2.default, {
        children: fullContentLink,
        trackingOptions: this.props.bookDescriptionTargetingData
      }) : null
    );
  }
});

},{"../../modules/ads/click_tracking_helper":2,"../click_tracking_wrapper":70,"../gr_component_factory":87,"../shared/gr_prop_types":146,"../shared/gr_spoiler_handler":147}],173:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); // See documentation on https://www.goodreads.com/style_guide

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STAR_SIZES = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("./gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _shelvings_store = require("../react_stores/shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

var _click_tracking_wrapper = require("./click_tracking_wrapper");

var _click_tracking_wrapper2 = _interopRequireDefault(_click_tracking_wrapper);

var _gr_reflux = require("../react_mixins/gr_reflux");

var _click_tracking_helper = require("../modules/ads/click_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STAR_SIZES = exports.STAR_SIZES = {
  SMALL: "smallStars",
  MEDIUM: "mediumStars",
  LARGE: "largeStars"
};

exports.default = _gr_component_factory2.default.createClass({
  displayName: "UserRating",

  mixins: [(0, _gr_reflux.connectToLazyStore)(_shelvings_store2.default, "bookId")],

  propTypes: {
    bookId: _react2.default.PropTypes.string.isRequired,
    bookTitle: _react2.default.PropTypes.string,
    starsTrackingOptions: _react2.default.PropTypes.object,
    starSize: _react2.default.PropTypes.string,
    displayLabel: _react2.default.PropTypes.bool,
    handleClick: _react2.default.PropTypes.func,
    clickstreamRef: _react2.default.PropTypes.string,
    isPreRelease: _react2.default.PropTypes.bool,
    readOnly: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      starsTrackingOptions: _click_tracking_helper.TRACKED_CLASSES.user_rating_star,
      displayLabel: true,
      starSize: STAR_SIZES.SMALL,
      readOnly: false
    };
  },
  setHoverRating: function setHoverRating(rating) {
    this.setState({ hoverRating: rating });
  },
  removeHoverRating: function removeHoverRating() {
    this.setState({ hoverRating: null });
  },
  isShelved: function isShelved() {
    return this.state.exclusiveShelfName !== null;
  },
  updateRating: function updateRating(starNum, ev) {
    ev.preventDefault();

    // Check for pre-release book and show confirmation dialog
    if (this.props.isPreRelease) {
      var message = "This edition has not yet been published. Only readers with advanced copies of this book can rate it. Go to the book's page to verify you have an advanced copy and rate this book?";

      if (confirm(message)) {
        // User confirmed, redirect to book page with rating parameters
        var bookId = this.isShelved() ? this.state.book.bookId : this.props.bookId;
        window.location.href = "/book/show/" + bookId + "?rating=" + starNum + "&preReleaseChallengeQuestion=true";
      }
      // If user cancels, do nothing (no page refresh)
      return false;
    } else {
      // Not a pre-release book, proceed normally
      if (this.isShelved()) {
        _shelvings_actions2.default.rateBook(this.state.book.bookId, starNum, this.state.book.title, this.props.clickstreamRef || null, this.refs.ratingContainer, this.props.handleClick);
      } else {
        _shelvings_actions2.default.rateBook(this.props.bookId, starNum, this.props.bookTitle, this.props.clickstreamRef || null, this.refs.ratingContainer, this.props.handleClick);
      }
    }
  },
  starLabel: function starLabel(starNum) {
    var starLabel = undefined;
    if (this.state.exclusiveShelfName !== null && this.state.rating > 0) {
      starLabel = "Change rating from " + this.state.rating + " to " + starNum + " ";
    } else {
      starLabel = "Rate " + starNum + " ";
    }
    starLabel += starNum === 1 ? "star" : "stars";
    return starLabel;
  },
  renderStar: function renderStar(starIndex) {
    var starNum = starIndex + 1;
    var savedRating = this.state.exclusiveShelfName !== null ? this.state.rating : 0;
    var currentRating = this.state.hoverRating ? this.state.hoverRating : savedRating;
    var starClass = (0, _classnames2.default)("userRating__star", { "userRating__star--selected": starNum <= currentRating }, "userRating__star--" + this.props.starSize, { "userRating__star--readOnly": this.props.readOnly });

    // If read-only render a span instead of a button
    if (this.props.readOnly) {
      return _jsx("span", {
        className: starClass
      }, starNum);
    }

    // If not read-only render interactive button
    var starButton = _jsx("button", {
      className: starClass,
      title: this.starLabel(starNum),
      onClick: this.updateRating.bind(this, starNum),
      onMouseEnter: this.setHoverRating.bind(this, starNum)
    });
    return _jsx(_click_tracking_wrapper2.default, {
      children: starButton,
      trackingOptions: this.props.starsTrackingOptions
    }, starNum);
  },
  renderTextLabel: function renderTextLabel() {
    if (this.props.displayLabel) {
      // In read-only mode, hide the label if the user hasn't rated
      if (this.props.readOnly && (this.state.exclusiveShelfName === null || this.state.rating === 0)) {
        return null;
      }
      var labelClass = (0, _classnames2.default)("userRating__label", "gr-metaText", { "userRating__label--largeStars": this.props.starSize === STAR_SIZES.LARGE });
      return _jsx("div", {
        className: labelClass
      }, void 0, this.state.exclusiveShelfName !== null && this.state.rating > 0 ? "Your rating:" : "Rate it:");
    }
  },
  render: function render() {
    // In read-only mode, hide entirely if the user hasn't rated
    if (this.props.readOnly && (this.state.exclusiveShelfName === null || this.state.rating === 0)) {
      return null;
    }
    var containerClass = (0, _classnames2.default)("userRating", { "userRating--largeStars": this.props.starSize === STAR_SIZES.LARGE });
    return _jsx("div", {
      className: containerClass
    }, void 0, this.renderTextLabel(), _react2.default.createElement(
      "div",
      { className: "userRating__starsWrapper",
        tabIndex: "0",
        ref: "ratingContainer",
        role: "group",
        onMouseLeave: this.removeHoverRating },
      _lodash2.default.times(5, function (starIndex) {
        return this.renderStar(starIndex);
      }, this)
    ));
  }
});

},{"../modules/ads/click_tracking_helper":2,"../react_actions/shelvings_actions":35,"../react_mixins/gr_reflux":185,"../react_stores/shelvings_store":201,"./click_tracking_wrapper":70,"./gr_component_factory":87,"classnames":"classnames","lodash":"lodash","react":"react"}],174:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALWAYS_DISPLAY_STARS_PROP = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _gr_reflux = require("../../react_mixins/gr_reflux");

var _click_tracking_helper = require("../../modules/ads/click_tracking_helper");

var _default_shelves = require("../../modules/default_shelves");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _shelvings_store = require("../../react_stores/shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

var _user_shelves_store = require("../../react_stores/user_shelves_store");

var _user_shelves_store2 = _interopRequireDefault(_user_shelves_store);

var _want_to_read_menu_store = require("../../react_stores/want_to_read_menu_store");

var _want_to_read_menu_store2 = _interopRequireDefault(_want_to_read_menu_store);

var _want_to_read_menu_actions = require("../../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

var _user_agent_capabilities_store = require("../../react_stores/user_agent_capabilities_store");

var _user_agent_capabilities_store2 = _interopRequireDefault(_user_agent_capabilities_store);

var _shelvings_actions = require("../../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _dropdown = require("../dropdown");

var _dropdown2 = _interopRequireDefault(_dropdown);

var _modal = require("../modal");

var _modal2 = _interopRequireDefault(_modal);

var _modal_trigger = require("../modal_trigger");

var _modal_trigger2 = _interopRequireDefault(_modal_trigger);

var _modal_actions = require("../../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

var _modal_store = require("../../react_stores/modal_store");

var _modal_store2 = _interopRequireDefault(_modal_store);

var _want_to_read_menu = require("../want_to_read/want_to_read_menu");

var _want_to_read_menu2 = _interopRequireDefault(_want_to_read_menu);

var _user_rating = require("../user_rating");

var _user_rating2 = _interopRequireDefault(_user_rating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SAVING_BUTTON_TEXT = "Saving…";
var BOOK_ALSO_MARKED_AS_READ_TEXT = "This book has also been marked as Read";
var ALWAYS_DISPLAY_STARS_PROP = exports.ALWAYS_DISPLAY_STARS_PROP = "ALWAYS_DISPLAY_STARS_PROP";

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadButton",

  propTypes: {
    bookId: _react2.default.PropTypes.string.isRequired,
    bookTitle: _react2.default.PropTypes.string.isRequired,
    uniqueId: _react2.default.PropTypes.string.isRequired,
    // Defaults to `display: none` for breakpoints under $large-site-width (1220px).
    // Set `showStars` to ALWAYS_DISPLAY_STARS_PROP to always display regardless of breakpoint
    showStars: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.bool, _react2.default.PropTypes.string]),
    showMenu: _react2.default.PropTypes.bool,
    origin: _react2.default.PropTypes.string,
    trackingOptions: _react2.default.PropTypes.object,
    starsTrackingOptions: _react2.default.PropTypes.object,
    withModalShelvingMenu: _react2.default.PropTypes.bool,
    readOnlyStars: _react2.default.PropTypes.bool
  },
  mixins: [(0, _gr_reflux.connectToLazyStore)(_shelvings_store2.default, "bookId", { stateKey: "shelvings" }), (0, _gr_reflux.connectToLazyStore)(_want_to_read_menu_store2.default, "uniqueId", { stateKey: "wantToReadMenu" }), _reflux2.default.connect(_user_shelves_store2.default, "userShelves"), _reflux2.default.connect(_user_agent_capabilities_store2.default, "userAgentCapabilities"), _reflux2.default.connect(_modal_store2.default, "modalStore")],

  getDefaultProps: function getDefaultProps() {
    return {
      showStars: false,
      showMenu: true,
      trackingOptions: _click_tracking_helper.TRACKED_CLASSES.want_to_read_button,
      withModalShelvingMenu: false,
      readOnlyStars: false
    };
  },
  shelveBook: function shelveBook() {
    _shelvings_actions2.default.shelveBook(this.props.bookId, _user_shelves_store2.default.defaultShelves().WANT_TO_READ, this.props.origin);
  },
  unshelveBook: function unshelveBook() {
    if (window.confirm("Removing a book deletes your rating, review, etc. Remove this book from all your shelves?")) {
      _shelvings_actions2.default.unshelveBook(this.state.shelvings.book.bookId);
    }
  },

  /*
    A note about this.restoreFocusOnUpdate:
     This was a bit tricky because we have to a) save which specific button was
    pressed to change a shelving, and b) refocus on the same button after
    multiple instances of the component updated. We needed some way to uniquely
    identify each button even if they have the same state, which ruled out
    adding another state variable to the store. Also, setting state would in
    turn cause the component to re-render, which made problems for us.
     This feels hacky, but it's the best solution we have at the time.
  */
  focusButton: function focusButton(button) {
    if (button && this.restoreFocusOnUpdate && !this.state.isShelvingInProgress) {
      this.forgetFocus();
      button.focus();
    }
  },
  rememberFocus: function rememberFocus() {
    this.restoreFocusOnUpdate = true;
  },
  forgetFocus: function forgetFocus() {
    this.restoreFocusOnUpdate = false;
  },
  checkmarkClass: function checkmarkClass() {
    return (0, _default_shelves.checkIconClassnames)(this.state.shelvings.exclusiveShelfName);
  },
  unshelved: function unshelved() {
    return this.state.shelvings.exclusiveShelfName === null;
  },
  getBookId: function getBookId() {
    return this.unshelved() ? this.props.bookId : this.state.shelvings.book.bookId;
  },
  getBookTitle: function getBookTitle() {
    return this.unshelved() ? this.props.bookTitle : this.state.shelvings.book.title;
  },
  renderWantToReadLeftUnshelved: function renderWantToReadLeftUnshelved() {
    var buttonText = this.state.shelvings.isShelvingInProgress ? SAVING_BUTTON_TEXT : "Want to Read";
    var wantToReadLeftClasses = (0, _classnames2.default)("wantToReadButton__leftUnshelvedButton", { "wantToReadButton__leftUnshelvedButton--noOutline": this.state.shelvings.isShelvingInProgress });
    var shelvingLabel = "Add " + this.props.bookTitle + " to your want to read shelf";
    return _react2.default.createElement(
      "button",
      { "aria-label": shelvingLabel,
        ref: this.focusButton,
        className: wantToReadLeftClasses,
        onClick: this.shelveBook,
        onFocus: this.rememberFocus,
        onBlur: this.forgetFocus },
      buttonText
    );
  },
  renderWantToReadLeftShelved: function renderWantToReadLeftShelved() {
    var buttonClasses = (0, _classnames2.default)("wantToReadButton__leftShelvedButton");
    var checkmarkClasses = (0, _classnames2.default)({ wantToReadButton__checkIcon: !this.state.shelvings.isShelvingInProgress }, this.checkmarkClass());
    var shelvingLabel = "Remove " + this.state.shelvings.book.title + " from my shelves";
    var buttonText = this.state.shelvings.isShelvingInProgress ? SAVING_BUTTON_TEXT : this.state.shelvings.exclusiveShelfDisplayName;
    if (this.state.userAgentCapabilities.touch) {
      return _react2.default.createElement(
        "button",
        { "aria-label": shelvingLabel,
          onClick: this.unshelveBook,
          onFocus: this.rememberFocus,
          onBlur: this.forgetFocus,
          ref: this.focusButton,
          className: buttonClasses },
        _jsx("span", {
          className: checkmarkClasses + " u-inlineBlock"
        }),
        _jsx("div", {
          className: "wantToReadButton__shelvedButtonText"
        }, void 0, buttonText)
      );
    } else {
      return _jsx("span", {}, void 0, _react2.default.createElement("button", { "aria-label": shelvingLabel,
        ref: this.focusButton,
        onClick: this.unshelveBook,
        onFocus: this.rememberFocus,
        onBlur: this.forgetFocus,
        className: buttonClasses + " " + checkmarkClasses }), _jsx("div", {
        className: "wantToReadButton__shelvedButtonText"
      }, void 0, buttonText));
    }
  },
  renderWantToReadRight: function renderWantToReadRight() {
    var bookId = this.getBookId();
    var bookTitle = this.getBookTitle();

    var dropdownModifiers = ["wantToReadMenu"];
    if (this.props.withModalShelvingMenu) {
      dropdownModifiers.push("wtrMenuToggleDropdown");
    }

    if (this.props.showMenu && !this.isWTRModalOpen()) {
      return _jsx(_dropdown2.default, {
        trigger: this.renderWantToReadRightButtonContents(),
        triggerEventType: _dropdown2.default.TriggerEventTypes.HOVER,
        bemModifiers: dropdownModifiers
      }, void 0, _jsx(_want_to_read_menu2.default, {
        uniqueId: this.props.uniqueId,
        bookId: bookId,
        bookTitle: bookTitle,
        userShelves: this.state.userShelves,
        shelvings: this.state.shelvings
      }));
    } else {
      return null;
    }
  },
  getModalId: function getModalId() {
    return "wtrModal" + this.getBookId();
  },
  isWTRModalOpen: function isWTRModalOpen() {
    return this.state.modalStore.currentActiveModal && this.state.modalStore.currentActiveModal === this.getModalId();
  },
  hideBookAlsoMarkedAsReadMessage: function hideBookAlsoMarkedAsReadMessage() {
    if (this.state.showBookAlsoMarkedAsReadMessage) {
      this.setState({ showBookAlsoMarkedAsReadMessage: false });
    }
  },
  handleWTRMenuNonExclusiveShelvingWithoutExclusive: function handleWTRMenuNonExclusiveShelvingWithoutExclusive() {
    this.setState({ showBookAlsoMarkedAsReadMessage: true });
  },
  handleModalClose: function handleModalClose() {
    _want_to_read_menu_actions2.default.closeAddShelfTextbox(this.props.uniqueId);
    this.hideBookAlsoMarkedAsReadMessage();
  },
  handleDoneClick: function handleDoneClick() {
    _modal_actions2.default.closeModal();
    this.hideBookAlsoMarkedAsReadMessage();
  },
  renderModal: function renderModal() {
    var bookId = this.getBookId();
    var bookTitle = this.getBookTitle();
    if (this.props.showMenu && this.props.withModalShelvingMenu) {
      // Class `wtrMenuToggleModal` sets display to none when window is past
      // sm breakpoint, which can lead to the Modal being in active
      // state while not being displayed (say, if user resizes the window).
      // This is no bueno because we stop body scroll when Modal is active,
      // so instead we check and make sure the modal is closed before adding the
      // toggle class.
      var cx = (0, _classnames2.default)("wtrModalContainer", {
        wtrMenuToggleModal: !this.isWTRModalOpen()
      });
      return _jsx("div", {
        className: cx
      }, void 0, _jsx(_modal_trigger2.default, {
        id: this.getModalId()
      }, void 0, _jsx("button", {
        type: "button",
        className: "wtrModalContainer__trigger"
      }, void 0, this.renderWantToReadRightButtonContents())), _jsx(_modal2.default, {
        id: this.getModalId(),
        centered: true,
        onCloseHandler: this.handleModalClose
      }, void 0, _jsx("div", {
        className: "wtrModal"
      }, void 0, _jsx("h3", {
        className: "gr-h3 gr-h3--serif gr-h3--noMargin u-paddingBottomXSmall"
      }, void 0, "Shelve ", this.props.bookTitle), _jsx(_want_to_read_menu2.default, {
        uniqueId: this.props.uniqueId,
        bookId: bookId,
        bookTitle: bookTitle,
        userShelves: this.state.userShelves,
        shelvings: this.state.shelvings,
        useModalView: true,
        bemModifiers: "modalView",
        onNonExclusiveShelvingWithoutExclusive: this.handleWTRMenuNonExclusiveShelvingWithoutExclusive,
        onExclusiveShelvingChange: this.hideBookAlsoMarkedAsReadMessage
      })),
      /* Done button gets replaced by add/cancel buttons when AddNewShelf
         is enabled */
      !this.state.wantToReadMenu.showAddShelfTextbox && _jsx("button", {
        type: "button",
        className: "gr-button wtrModal__closeButton",
        "aria-label": "Close want to read menu",
        onClick: this.handleDoneClick
      }, void 0, "Done"), this.state.showBookAlsoMarkedAsReadMessage && _jsx("div", {
        className: "wtrModal__alsoMarkedAsReadMessage"
      }, void 0, BOOK_ALSO_MARKED_AS_READ_TEXT)));
    } else {
      return null;
    }
  },
  renderWantToReadRightButtonContents: function renderWantToReadRightButtonContents() {
    return _jsx("div", {
      className: "wantToReadButton__right"
    }, void 0, _jsx("span", {
      className: "u-visuallyHidden"
    }, void 0, "Shelving menu"));
  },
  render: function render() {
    var wantToReadLeft = "";
    var wantToReadClassLeft = (0, _classnames2.default)("wantToReadButton__left", { "wantToReadButton__left--standalone": !this.props.showMenu }, { wantToReadButton__leftUnshelved: this.unshelved() }, { wantToReadButton__leftShelved: !this.unshelved() });

    if (this.unshelved()) {
      wantToReadLeft = this.renderWantToReadLeftUnshelved();
    } else {
      wantToReadLeft = this.renderWantToReadLeftShelved();
    }
    var starsCx = (0, _classnames2.default)("wtrStarsContainer", {
      "wtrStarsContainer--alwaysDisplay": this.props.showStars === ALWAYS_DISPLAY_STARS_PROP
    });
    return _jsx("div", {}, void 0, _jsx("div", {
      className: "wantToReadButton"
    }, void 0, _jsx("div", {
      className: wantToReadClassLeft
    }, void 0, wantToReadLeft), this.renderModal(), this.renderWantToReadRight()), this.props.showStars ? _jsx("div", {
      className: starsCx
    }, void 0, _jsx(_user_rating2.default, {
      bookId: this.props.bookId,
      starsTrackingOptions: this.props.starsTrackingOptions,
      readOnly: this.props.readOnlyStars
    })) : null);
  }
});

},{"../../modules/ads/click_tracking_helper":2,"../../modules/default_shelves":12,"../../react_actions/modal_actions":30,"../../react_actions/shelvings_actions":35,"../../react_actions/want_to_read_menu_actions":40,"../../react_mixins/gr_reflux":185,"../../react_stores/modal_store":197,"../../react_stores/shelvings_store":201,"../../react_stores/user_agent_capabilities_store":203,"../../react_stores/user_shelves_store":205,"../../react_stores/want_to_read_menu_store":206,"../dropdown":75,"../gr_component_factory":87,"../modal":118,"../modal_trigger":119,"../user_rating":173,"../want_to_read/want_to_read_menu":175,"classnames":"classnames","react":"react","reflux":"reflux"}],175:[function(require,module,exports){
"use strict";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            WantToReadMenu component is used only within the WantToReadButton component
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            right now. It generates a list of shelves, along with a filter box and 'add
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            new shelf' button.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _gr_reflux = require("../../react_mixins/gr_reflux");

var _default_shelves = require("../../modules/default_shelves");

var _want_to_read_menu_store = require("../../react_stores/want_to_read_menu_store");

var _want_to_read_menu_store2 = _interopRequireDefault(_want_to_read_menu_store);

var _want_to_read_menu_filter = require("./want_to_read_menu_filter");

var _want_to_read_menu_filter2 = _interopRequireDefault(_want_to_read_menu_filter);

var _shelvings_actions = require("../../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _want_to_read_menu_shelf_creator = require("./want_to_read_menu_shelf_creator");

var _want_to_read_menu_shelf_creator2 = _interopRequireDefault(_want_to_read_menu_shelf_creator);

var _spinner = require("../spinner");

var _spinner2 = _interopRequireDefault(_spinner);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIN_SHELVES_TO_SHOW_FILTER = 7;

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadMenu",

  mixins: [(0, _gr_reflux.connectToLazyStore)(_want_to_read_menu_store2.default, "uniqueId")],

  propTypes: {
    bookId: React.PropTypes.string.isRequired,
    bookTitle: React.PropTypes.string.isRequired,
    uniqueId: React.PropTypes.string.isRequired,
    userShelves: React.PropTypes.object.isRequired,
    shelvings: React.PropTypes.object.isRequired,
    useModalView: React.PropTypes.bool,
    onNonExclusiveShelvingWithoutExclusive: React.PropTypes.func,
    onExclusiveShelvingChange: React.PropTypes.func
  },

  defaultPropTypes: function defaultPropTypes() {
    return { useModalView: false };
  },
  shelveBook: function shelveBook(shelf) {
    _shelvings_actions2.default.shelveBook(this.props.bookId, shelf);
  },
  unshelveBook: function unshelveBook() {
    if (window.confirm("Removing a book deletes your rating, review, etc. Remove this book from all your shelves?")) {
      _shelvings_actions2.default.unshelveBook(this.props.bookId);
    }
  },
  modifyExclusiveShelving: function modifyExclusiveShelving(shelved, shelf) {
    if (this.props.onExclusiveShelvingChange && _lodash2.default.isFunction(this.props.onExclusiveShelvingChange)) {
      this.props.onExclusiveShelvingChange();
    }
    shelved ? this.unshelveBook() : this.shelveBook(shelf);
  },
  toggleNonExclusiveShelving: function toggleNonExclusiveShelving(shelf) {
    if (this.props.shelvings.exclusiveShelfName === null && this.props.onNonExclusiveShelvingWithoutExclusive && _lodash2.default.isFunction(this.props.onNonExclusiveShelvingWithoutExclusive)) {
      this.props.onNonExclusiveShelvingWithoutExclusive();
    }
    _shelvings_actions2.default.toggleNonExclusiveShelving(this.props.bookId, shelf, false, this.props.bookTitle);
  },
  renderFilter: function renderFilter() {
    var allShelves = this.props.userShelves.customExclusiveShelves.concat(this.props.userShelves.nonExclusiveShelves);
    var showFilterMenu = allShelves.length >= MIN_SHELVES_TO_SHOW_FILTER;
    if (showFilterMenu) {
      return _jsx(_want_to_read_menu_filter2.default, {
        bookId: this.props.bookId,
        uniqueId: this.props.uniqueId,
        shelvings: this.props.shelvings,
        wantToReadMenu: this.state,
        bemModifiers: this.props.bemModifiers
      });
    }
  },
  renderEmptyMessage: function renderEmptyMessage() {
    var displayableExclusiveShelves = this.state.displayableExclusiveShelves;
    var displayableNonExclusiveShelves = this.state.displayableNonExclusiveShelves;
    var displayedShelvesCount = displayableNonExclusiveShelves.concat(displayableExclusiveShelves).length;
    if (displayedShelvesCount === 0) {
      return _jsx("li", {
        className: "wantToReadMenu__genericItem"
      }, void 0, "No Matching Shelves");
    }
  },
  renderExclusiveShelves: function renderExclusiveShelves() {
    var _this = this;

    var displayableExclusiveShelves = this.state.displayableExclusiveShelves;
    return _lodash2.default.map(displayableExclusiveShelves, function (shelf) {
      var shelved = shelf.name === _this.props.shelvings.exclusiveShelfName;
      var humanShelfName = shelf.displayName;
      var shelvingLabel = shelved ? "Unshelve  " + _this.props.bookTitle : "Shelve " + _this.props.bookTitle + " as " + humanShelfName;
      var exclusiveShelfClassnames = (0, _classnames2.default)(_this.withBemModifiers("wantToReadMenu__exclusiveShelf"), { "wantToReadMenu__exclusiveShelf--shelved": shelved });
      var shelvingStatusIcon = _this.props.useModalView ? _this.renderExclusiveShelfStatusIcon(shelf) : null;
      return _jsx("li", {
        className: "wantToReadMenu__shelfItem"
      }, humanShelfName, _jsx("button", {
        className: exclusiveShelfClassnames,
        "aria-label": shelvingLabel,
        onClick: function onClick() {
          _this.modifyExclusiveShelving(shelved, shelf);
        }
      }, void 0, shelvingStatusIcon && _jsx("div", {
        className: "wantToReadMenu__shelfStatusContainer"
      }, void 0, shelvingStatusIcon), humanShelfName));
    });
  },
  renderExclusiveShelfStatusIcon: function renderExclusiveShelfStatusIcon(shelf) {
    // (1) if book is shelved and shelving not in progress, render check icon
    // if shelving in progress:
    // (2) if being unshelved (no target), render spinner on shelved exclusive shelf
    // (3) if being shelved (target == shelf.name), render spinner on target shelf
    var shelvingStatusIcon = null;
    var shelved = shelf.name === this.props.shelvings.exclusiveShelfName;
    if (shelved && !this.props.shelvings.isShelvingInProgress) {
      // (1)
      var checkIconCx = (0, _classnames2.default)("wantToReadButton__checkIcon", "wantToReadButton__checkIcon--modalView", (0, _default_shelves.checkIconClassnames)(this.props.shelvings.exclusiveShelfName));
      shelvingStatusIcon = _jsx("span", {
        className: checkIconCx
      });
    } else if (this.props.shelvings.isShelvingInProgress && (!this.props.shelvings.targetExclusiveShelfName && shelved || // (2)
    this.props.shelvings.targetExclusiveShelfName === shelf.name)) {
      // (3)
      shelvingStatusIcon = _jsx(_spinner2.default, {
        isSmall: true
      });
    }

    return shelvingStatusIcon;
  },
  renderNonExclusiveShelves: function renderNonExclusiveShelves() {
    var _this2 = this;

    var displayableNonExclusiveShelves = this.state.displayableNonExclusiveShelves;
    return _lodash2.default.map(displayableNonExclusiveShelves, function (shelf) {
      var shelfChecked = false;
      if (_this2.props.shelvings.exclusiveShelfName !== null && _lodash2.default.includes(_this2.props.shelvings.nonExclusiveShelfNames, shelf.name)) {
        shelfChecked = true;
      }
      var humanShelfName = shelf.displayName;
      var shelvingLabel = "Shelve " + _this2.props.bookTitle + " as " + humanShelfName;
      var nonExclusiveShelfClassnames = _this2.withBemModifiers("wantToReadMenu__nonExclusiveShelf");
      return _jsx("li", {
        className: "wantToReadMenu__shelfItem"
      }, humanShelfName, _jsx("label", {
        className: nonExclusiveShelfClassnames
      }, void 0, _jsx("input", {
        className: "wantToReadMenu__shelfCheckbox",
        checked: shelfChecked,
        type: "checkbox",
        name: "shelf[" + shelf.name + "]",
        "aria-label": shelvingLabel,
        onChange: function onChange() {
          _this2.toggleNonExclusiveShelving(shelf);
        }
      }), humanShelfName));
    });
  },
  renderAddNewShelfButton: function renderAddNewShelfButton() {
    var allShelves = this.props.userShelves.customExclusiveShelves.concat(this.props.userShelves.nonExclusiveShelves).concat(this.props.userShelves.defaultShelves);
    var shelfNames = _lodash2.default.map(allShelves, function (shelf) {
      return shelf.name;
    });
    var userCanAddShelf = !_lodash2.default.includes(shelfNames, this.state.shelfNameFilter);
    var newShelfClassnames = this.withBemModifiers("wantToReadMenu__newShelfButtonContainer");
    return _jsx("li", {
      className: newShelfClassnames
    }, void 0, React.createElement(_want_to_read_menu_shelf_creator2.default, _extends({
      shelfNameFilter: this.state.shelfNameFilter,
      userCanAddShelf: userCanAddShelf,
      uniqueId: this.props.uniqueId,
      bookId: this.props.bookId,
      bemModifiers: this.props.bemModifiers,
      useModalView: this.props.useModalView,
      bookTitle: this.props.bookTitle
    }, this.state)));
  },
  render: function render() {
    return _jsx("div", {
      className: "wantToReadMenu"
    }, void 0, this.props.useModalView && _jsx("div", {
      className: "wantToReadMenu__headerContainer"
    }, void 0, this.renderFilter()), _jsx("div", {
      className: "wantToReadMenu__scrollableContainer"
    }, void 0, !this.props.useModalView && this.renderFilter(), this.renderEmptyMessage(), this.renderExclusiveShelves(), this.renderNonExclusiveShelves()), this.renderAddNewShelfButton());
  }
});

},{"../../modules/default_shelves":12,"../../react_actions/shelvings_actions":35,"../../react_mixins/gr_reflux":185,"../../react_stores/want_to_read_menu_store":206,"../gr_component_factory":87,"../spinner":161,"./want_to_read_menu_filter":176,"./want_to_read_menu_shelf_creator":177,"classnames":"classnames","lodash":"lodash"}],176:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            WantToReadMenuFilter is used to filter shelf names within the Want to Read
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            button
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _want_to_read_menu_actions = require("../../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadMenuFilter",
  propTypes: {
    bookId: _react2.default.PropTypes.string.isRequired,
    uniqueId: _react2.default.PropTypes.string.isRequired,
    shelvings: _react2.default.PropTypes.object.isRequired,
    wantToReadMenu: _react2.default.PropTypes.object.isRequired
  },

  handleKeyPress: function handleKeyPress(event) {
    var exclusiveShelfName = null;
    if (this.props.shelvings.exclusiveShelfName !== null) {
      exclusiveShelfName = this.props.shelvings.exclusiveShelfName;
    }
    _want_to_read_menu_actions2.default.updateShelfNameFilter(event.target.value, this.props.uniqueId, exclusiveShelfName);
  },
  render: function render() {
    var classNames = this.withBemModifiers("wantToReadMenuFilter");
    return _jsx("form", {
      className: classNames,
      onSubmit: function onSubmit(ev) {
        return ev.preventDefault();
      }
    }, void 0, _jsx("input", {
      className: "gr-textInput\n                               gr-textInput--small\n                               wantToReadMenuFilter--textInput",
      type: "text",
      placeholder: "Filter Shelves",
      "aria-label": "Filter Shelf Names",
      value: this.props.wantToReadMenu.shelfNameFilter,
      onChange: this.handleKeyPress
    }));
  }
});

},{"../../react_actions/want_to_read_menu_actions":40,"../gr_component_factory":87,"react":"react"}],177:[function(require,module,exports){
"use strict";

var _jsx = (function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; })(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            WantToReadMenuShelfCreator is a component that lets you add a new shelf to your
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            UserShelves for the current user.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gr_component_factory = require("../gr_component_factory");

var _gr_component_factory2 = _interopRequireDefault(_gr_component_factory);

var _want_to_read_menu_actions = require("../../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

var _shelvings_actions = require("../../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gr_component_factory2.default.createClass({
  displayName: "WantToReadMenuShelfCreator",

  propTypes: {
    userCanAddShelf: _react2.default.PropTypes.bool.isRequired,
    shelfNameFilter: _react2.default.PropTypes.string,
    uniqueId: _react2.default.PropTypes.string.isRequired,
    bookId: _react2.default.PropTypes.string.isRequired,
    bookTitle: _react2.default.PropTypes.string.isRequired,
    useModalView: _react2.default.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return { useModalView: false };
  },
  getInitialState: function getInitialState() {
    return {
      unsavedShelfName: ""
    };
  },
  openAddShelfTextbox: function openAddShelfTextbox() {
    _want_to_read_menu_actions2.default.openAddShelfTextbox(this.props.uniqueId);
  },
  closeAddShelfTextbox: function closeAddShelfTextbox() {
    _want_to_read_menu_actions2.default.closeAddShelfTextbox(this.props.uniqueId);
  },
  checkIfCommentIsEmpty: function checkIfCommentIsEmpty(event) {
    this.setState({ unsavedShelfName: event.target.value });
  },
  shelveAsNewShelfName: function shelveAsNewShelfName(shelfName, event) {
    event.preventDefault();
    _want_to_read_menu_actions2.default.updateShelfNameFilter("", this.props.uniqueId);
    _shelvings_actions2.default.toggleNonExclusiveShelving(this.props.bookId, { name: shelfName }, true, this.props.bookTitle);
  },
  render: function render() {
    var _this = this;

    if (this.props.shelfNameFilter !== "" && this.props.userCanAddShelf) {
      var buttonClassnames = this.withBemModifiers("wantToReadShelfCreator__addNamedShelfButton");
      return _jsx("span", {
        className: "wantToReadShelfCreator"
      }, void 0, _jsx("button", {
        className: buttonClassnames,
        "aria-label": "Add new " + this.props.shelfNameFilter + " shelf",
        onClick: function onClick(event) {
          _this.shelveAsNewShelfName(_this.props.shelfNameFilter, event);
        }
      }, void 0, "Add new “", _jsx("span", {
        className: "wantToReadShelfCreator__addShelfButtonShelfName"
      }, void 0, this.props.shelfNameFilter), "” shelf"));
    } else if (this.props.showAddShelfTextbox) {
      var containerCx = (0, _classnames2.default)(this.withBemModifiers("wantToReadShelfCreator"), "wantToReadShelfCreator--wrap");

      var textInputCx = (0, _classnames2.default)("gr-textInput", this.withBemModifiers("wantToReadShelfCreator__textInput"), {
        "gr-textInput--small": !this.props.useModalView
      });

      var submitCx = (0, _classnames2.default)(this.withBemModifiers("wantToReadShelfCreator__addShelfButton"), "gr-button", { "gr-button--small": !this.props.useModalView,
        "gr-button--dark gr-button--fullWidth": this.props.useModalView });

      return _jsx("form", {
        className: containerCx,
        onSubmit: function onSubmit(event) {
          _this.shelveAsNewShelfName(_this.state.unsavedShelfName, event);
        }
      }, void 0, _jsx("input", {
        className: textInputCx,
        type: "text",
        placeholder: "New Shelf Name",
        "aria-label": "Add new shelf name",
        autoFocus: true,
        onChange: this.checkIfCommentIsEmpty
      }), _jsx("div", {
        className: "wantToReadShelfCreator__buttonContainer"
      }, void 0, _jsx("input", {
        type: "submit",
        className: submitCx,
        disabled: _lodash2.default.isEmpty(_lodash2.default.trim(this.state.unsavedShelfName)),
        value: "Add"
      }), this.props.useModalView && _jsx("button", {
        type: "button",
        className: "gr-button gr-button--fullWidth wantToReadShelfCreator__cancelButton",
        onClick: this.closeAddShelfTextbox,
        "aria-label": "Close add new shelf form"
      }, void 0, "Cancel")));
    } else if (!this.props.userCanAddShelf) {
      // User cannot create a new shelf if they have typed in the name
      return null;
    } else {
      var buttonClassnames = this.withBemModifiers("wantToReadShelfCreator__showAddShelfTextboxButton");
      return _jsx("span", {
        className: "wantToReadShelfCreator"
      }, void 0, _jsx("button", {
        className: buttonClassnames,
        "aria-label": "Add new shelf",
        onClick: this.openAddShelfTextbox
      }, void 0, "Add New Shelf"));
    }
  }
});

},{"../../react_actions/shelvings_actions":35,"../../react_actions/want_to_read_menu_actions":40,"../gr_component_factory":87,"classnames":"classnames","lodash":"lodash","react":"react"}],178:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalComponents = exports.GlobalStores = undefined;

var _google_ads_store = require("../react_stores/google_ads_store");

var _google_ads_store2 = _interopRequireDefault(_google_ads_store);

var _login_interstitial = require("../react_components/login/interstitial/login_interstitial");

var _login_interstitial2 = _interopRequireDefault(_login_interstitial);

var _stores_initializer = require("../react_components/stores_initializer");

var _stores_initializer2 = _interopRequireDefault(_stores_initializer);

var _get_a_copy_button = require("../react_components/buy_buttons/get_a_copy_button");

var _get_a_copy_button2 = _interopRequireDefault(_get_a_copy_button);

var _get_a_copy_interstitial = require("../react_components/buy_buttons/get_a_copy_interstitial");

var _get_a_copy_interstitial2 = _interopRequireDefault(_get_a_copy_interstitial);

var _get_a_copy_interstitial_wrapper = require("../react_components/buy_buttons/get_a_copy_interstitial_wrapper");

var _get_a_copy_interstitial_wrapper2 = _interopRequireDefault(_get_a_copy_interstitial_wrapper);

var _qualtrics_survey = require("../react_components/qualtrics/qualtrics_survey");

var _qualtrics_survey2 = _interopRequireDefault(_qualtrics_survey);

var _review_cta = require("../react_components/book/review_cta");

var _review_cta2 = _interopRequireDefault(_review_cta);

var _user_icon = require("../react_components/user/user_icon");

var _user_icon2 = _interopRequireDefault(_user_icon);

var _user_not_interested_store = require("../react_stores/user_not_interested_store");

var _user_not_interested_store2 = _interopRequireDefault(_user_not_interested_store);

var _user_shelves_store = require("../react_stores/user_shelves_store");

var _user_shelves_store2 = _interopRequireDefault(_user_shelves_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GlobalStores = exports.GlobalStores = {
  GoogleAdsStore: _google_ads_store2.default,
  UserNotInterestedStore: _user_not_interested_store2.default,
  UserShelvesStore: _user_shelves_store2.default
}; // This holds the stores and components that should be accessible site-wide.
// This file should be included in all React bundles.

var GlobalComponents = exports.GlobalComponents = {
  LoginInterstitial: _login_interstitial2.default,
  StoresInitializer: _stores_initializer2.default,
  GetACopyButton: _get_a_copy_button2.default,
  GetACopyInterstitial: _get_a_copy_interstitial2.default,
  GetACopyInterstitialWrapper: _get_a_copy_interstitial_wrapper2.default,
  QualtricsSurvey: _qualtrics_survey2.default,
  ReviewCta: _review_cta2.default,
  UserIcon: _user_icon2.default
};

},{"../react_components/book/review_cta":62,"../react_components/buy_buttons/get_a_copy_button":65,"../react_components/buy_buttons/get_a_copy_interstitial":66,"../react_components/buy_buttons/get_a_copy_interstitial_wrapper":67,"../react_components/login/interstitial/login_interstitial":114,"../react_components/qualtrics/qualtrics_survey":128,"../react_components/stores_initializer":163,"../react_components/user/user_icon":167,"../react_stores/google_ads_store":196,"../react_stores/user_not_interested_store":204,"../react_stores/user_shelves_store":205}],179:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SeriesShowComponents = undefined;

var _full_page_pagination_controls = require("../react_components/full_page_pagination_controls");

var _full_page_pagination_controls2 = _interopRequireDefault(_full_page_pagination_controls);

var _responsive_page_ad_container = require("../react_components/ads/responsive_page_ad_container");

var _responsive_page_ad_container2 = _interopRequireDefault(_responsive_page_ad_container);

var _series_list = require("../react_components/series/series_list");

var _series_list2 = _interopRequireDefault(_series_list);

var _series_header = require("../react_components/series/series_header");

var _series_header2 = _interopRequireDefault(_series_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SeriesShowComponents = exports.SeriesShowComponents = {
  FullPagePaginationControls: _full_page_pagination_controls2.default,
  ResponsivePageAdContainer: _responsive_page_ad_container2.default,
  SeriesList: _series_list2.default,
  SeriesHeader: _series_header2.default
};

},{"../react_components/ads/responsive_page_ad_container":59,"../react_components/full_page_pagination_controls":85,"../react_components/series/series_header":139,"../react_components/series/series_list":140}],180:[function(require,module,exports){
"use strict";

var _arrayPrototype = require("array.prototype.find");

var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_arrayPrototype2.default.shim();

},{"array.prototype.find":"array.prototype.find"}],181:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderComponents = exports.HeaderStores = undefined;

var _current_user_store = require("../react_stores/current_user_store");

var _current_user_store2 = _interopRequireDefault(_current_user_store);

var _favorite_genres_store = require("../react_stores/favorite_genres_store");

var _favorite_genres_store2 = _interopRequireDefault(_favorite_genres_store);

var _notifications_store = require("../react_stores/notifications_store");

var _notifications_store2 = _interopRequireDefault(_notifications_store);

var _shelvings_store = require("../react_stores/shelvings_store");

var _shelvings_store2 = _interopRequireDefault(_shelvings_store);

var _tabs_store = require("../react_stores/tabs_store");

var _tabs_store2 = _interopRequireDefault(_tabs_store);

var _flash_message = require("../react_components/flash_message");

var _flash_message2 = _interopRequireDefault(_flash_message);

var _featured_content_module = require("../react_components/featured_content_module");

var _featured_content_module2 = _interopRequireDefault(_featured_content_module);

var _page_skin = require("../react_components/page_skin");

var _page_skin2 = _interopRequireDefault(_page_skin);

var _google_banner_ad = require("../react_components/ads/google_banner_ad");

var _google_banner_ad2 = _interopRequireDefault(_google_banner_ad);

var _native_ad = require("../react_components/ads/native_ads/native_ad");

var _native_ad2 = _interopRequireDefault(_native_ad);

var _google_page_skin = require("../react_components/ads/google_page_skin");

var _google_page_skin2 = _interopRequireDefault(_google_page_skin);

var _google_featured_content_module = require("../react_components/ads/google_featured_content_module");

var _google_featured_content_module2 = _interopRequireDefault(_google_featured_content_module);

var _scroll_tracker = require("../react_components/scroll_tracker");

var _scroll_tracker2 = _interopRequireDefault(_scroll_tracker);

var _header_store_connector = require("../react_components/header/header_store_connector");

var _header_store_connector2 = _interopRequireDefault(_header_store_connector);

var _site_announcement = require("../react_components/site_announcement/site_announcement");

var _site_announcement2 = _interopRequireDefault(_site_announcement);

var _choice_site_announcement = require("../react_components/site_announcement/choice_site_announcement");

var _choice_site_announcement2 = _interopRequireDefault(_choice_site_announcement);

var _welcome_announcement = require("../react_components/site_announcement/welcome_announcement");

var _welcome_announcement2 = _interopRequireDefault(_welcome_announcement);

var _preview_broadcast = require("../react_components/group/preview_broadcast");

var _preview_broadcast2 = _interopRequireDefault(_preview_broadcast);

var _jobs_list = require("../react_components/jobs_list");

var _jobs_list2 = _interopRequireDefault(_jobs_list);

var _shareable_link_button = require("../react_components/shared/shareable_link_button");

var _shareable_link_button2 = _interopRequireDefault(_shareable_link_button);

var _quiz = require("../react_components/librarian_quiz/quiz");

var _quiz2 = _interopRequireDefault(_quiz);

var _editorial_blog_thumbnail = require("../react_components/home_page/editorial_blog_thumbnail");

var _editorial_blog_thumbnail2 = _interopRequireDefault(_editorial_blog_thumbnail);

var _share_dialog = require("../react_components/share_dialog");

var _share_dialog2 = _interopRequireDefault(_share_dialog);

var _share_social = require("../react_components/share_social");

var _share_social2 = _interopRequireDefault(_share_social);

var _share_dialog_store = require("../react_stores/share_dialog_store");

var _share_dialog_store2 = _interopRequireDefault(_share_dialog_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderStores = exports.HeaderStores = {
  CurrentUserStore: _current_user_store2.default,
  FavoriteGenresStore: _favorite_genres_store2.default,
  NotificationsStore: _notifications_store2.default,
  ShareDialogStore: _share_dialog_store2.default,
  ShelvingsStore: _shelvings_store2.default,
  TabsStore: _tabs_store2.default
};

// Temp placement of share dialog component and store

var HeaderComponents = exports.HeaderComponents = {
  FlashMessage: _flash_message2.default,
  HeaderStoreConnector: _header_store_connector2.default,
  PageSkin: _page_skin2.default,
  FeaturedContentModule: _featured_content_module2.default,
  GoogleBannerAd: _google_banner_ad2.default,
  GooglePageSkin: _google_page_skin2.default,
  GoogleFeaturedContentModule: _google_featured_content_module2.default,
  ScrollTracker: _scroll_tracker2.default,
  SiteAnnouncement: _site_announcement2.default,
  ChoiceSiteAnnouncement: _choice_site_announcement2.default,
  WelcomeAnnouncement: _welcome_announcement2.default,
  ShareDialog: _share_dialog2.default,
  ShareSocial: _share_social2.default,
  PreviewBroadcast: _preview_broadcast2.default,
  NativeAd: _native_ad2.default,
  JobsList: _jobs_list2.default,
  ShareableLinkButton: _shareable_link_button2.default,
  LibrarianQuiz: _quiz2.default,
  EditorialBlogThumbnail: _editorial_blog_thumbnail2.default
};

},{"../react_components/ads/google_banner_ad":46,"../react_components/ads/google_featured_content_module":47,"../react_components/ads/google_page_skin":48,"../react_components/ads/native_ads/native_ad":50,"../react_components/featured_content_module":83,"../react_components/flash_message":84,"../react_components/group/preview_broadcast":88,"../react_components/header/header_store_connector":97,"../react_components/home_page/editorial_blog_thumbnail":108,"../react_components/jobs_list":109,"../react_components/librarian_quiz/quiz":110,"../react_components/page_skin":120,"../react_components/scroll_tracker":132,"../react_components/share_dialog":143,"../react_components/share_social":144,"../react_components/shared/shareable_link_button":148,"../react_components/site_announcement/choice_site_announcement":157,"../react_components/site_announcement/site_announcement":159,"../react_components/site_announcement/welcome_announcement":160,"../react_stores/current_user_store":192,"../react_stores/favorite_genres_store":194,"../react_stores/notifications_store":198,"../react_stores/share_dialog_store":199,"../react_stores/shelvings_store":201,"../react_stores/tabs_store":202}],182:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  propTypes: {
    bemModifiers: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string)])
  },
  // Expects `cls` to be a string holding a CSS class name. Returns string
  // holding that class, plus that class with the BEM modifier suffix(es)
  // (supplied as `bemModifiers` prop) appended.
  withBemModifiers: function withBemModifiers(cls) {
    var modifiers = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

    if (modifiers === null) {
      modifiers = this.props.bemModifiers;
    }
    if (modifiers) {
      if (_lodash2.default.isString(modifiers)) {
        return cls + " " + cls + "--" + modifiers;
      } else if (_lodash2.default.isArray(modifiers)) {
        var retval = (0, _classnames2.default)(cls, _lodash2.default.map(modifiers, function (mod) {
          return cls + "--" + mod;
        }));
        return retval;
      }
    } else {
      return cls;
    }
  },
  withBemElement: function withBemElement(cls, elem) {
    if (this.props.bemModifiers) {
      if (_lodash2.default.isString(this.props.bemModifiers)) {
        return cls + "--" + this.props.bemModifiers + "__" + elem;
      } else if (_lodash2.default.isArray(this.props.bemModifiers)) {
        return (0, _classnames2.default)(_lodash2.default.map(this.props.bemModifiers, function (mod) {
          return cls + "--" + mod + "__" + elem;
        }));
      }
    } else {
      return cls + "__" + elem;
    }
  }
}; /*
     Bem modifiers allows class modifiers to be passed in from parent components
     to child components to change styling based on the parent component.
   */

},{"classnames":"classnames","lodash":"lodash","react":"react"}],183:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Interface to check state of frontend Deploy Services.
*/
exports.default = {
  propTypes: {
    deployServices: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string)
  },

  isFeatureEnabled: function isFeatureEnabled(featureCode) {
    return _lodash2.default.indexOf(this.deployServices(), featureCode) >= 0;
  },
  deployServices: function deployServices() {
    if (this.props.deployServices === undefined) {
      throw "trying to access Deploy Services from component, but component does not contain deployServices prop (" + this.constructor.displayName + ")";
    }
    return this.props.deployServices;
  }
};

},{"lodash":"lodash","react":"react"}],184:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (storeFactory) {
  return {
    getInitialState: function getInitialState() {
      this.store = storeFactory();
      return this.store.getInitialState();
    },
    componentWillMount: function componentWillMount() {
      this.actions = this.store.actions;
      this.unsubscribe = this.store.listen(this.onStoreChange);
    },
    componentWillUnmount: function componentWillUnmount() {
      this.unsubscribe();
    },
    onStoreChange: function onStoreChange(state) {
      this.setState(state);
    }
  };
};

},{}],185:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectToLazyStore = connectToLazyStore;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /*
                                                                                                                                                                                                                  A lazy store manages data partitioned by keys, where each key has a
                                                                                                                                                                                                                  sensible starting value that does not need an external source to initialize
                                                                                                                                                                                                                  it prior to use, e.g. a form would have default values before any user input.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  Another important use case is for the absence of values. For example, instead
                                                                                                                                                                                                                  of requiring external code to initialize the starting value for all keys, a lazy
                                                                                                                                                                                                                  store only requires external code to initialize the non-absent values. For
                                                                                                                                                                                                                  example, if storing data about Likes or Comments, the external code would only
                                                                                                                                                                                                                  need to initialize the store with data for keys that have at least one Like
                                                                                                                                                                                                                  or Comment, leaving the rest to be lazily created in their empty state when needed.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  If a store's data is not partitioned by keys, then it can just create its
                                                                                                                                                                                                                  state to the sensible starting value at creation time, and consumers do not
                                                                                                                                                                                                                  need to care about whether or not the store initialized itself or an external
                                                                                                                                                                                                                  call did. The fact that the keys are dynamic and unknown at initialization time
                                                                                                                                                                                                                  is why this extra layer is needed.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  If the data for a particular key needs external information to initialize it,
                                                                                                                                                                                                                  then such initialization should be done eagerly before any components try to
                                                                                                                                                                                                                  connect to the store, removing the need for the store to be lazy.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  Usage in a component:
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  ...
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  propTypes: {
                                                                                                                                                                                                                    keyToUse: React.PropTypes.string.isRequired,
                                                                                                                                                                                                                  },
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  mixins: [connectToLazyStore(MyStore, "keyToUse")]
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  ...
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  The lazy store should handle calls to getInitialState that include a single
                                                                                                                                                                                                                  param representing the key. If the key is not present in its data, it should
                                                                                                                                                                                                                  be set and returned. This set should not cause a trigger to any existing
                                                                                                                                                                                                                  listeners.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  You can also namespace the state from the store under a different key so that
                                                                                                                                                                                                                  store state can more easily coexist in the same component.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  mixins: [connectToLazyStore(MyStore, "uniqueId", {stateKey: "stateKey"})]
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  If you want to only listen to a specific value of the state, add a filterValue
                                                                                                                                                                                                                  param that will act as a filter for the substate you want to listen to.
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  mixins: [connectToLazyStore(MyStore,
                                                                                                                                                                                                                                              "uniqueId",
                                                                                                                                                                                                                                              {stateKey: "stateKey", filterValue: "specificStateValue"})]
                                                                                                                                                                                                                  
                                                                                                                                                                                                                  */

function connectToLazyStore(store, keyPropName) {
  var _ref = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

  var _ref$stateKey = _ref.stateKey;
  var stateKey = _ref$stateKey === undefined ? null : _ref$stateKey;
  var _ref$filterValue = _ref.filterValue;
  var filterValue = _ref$filterValue === undefined ? null : _ref$filterValue;

  return {
    getInitialState: function getInitialState() {
      var value = store.getInitialState(_lodash2.default.get(this.props, keyPropName));
      if (filterValue) {
        value = value[filterValue];
      }
      if (!_lodash2.default.isNull(stateKey)) {
        value = _defineProperty({}, stateKey, value);
      }
      return value;
    },
    componentDidMount: function componentDidMount() {
      var _this = this;

      // This provides this.listenTo, which we need to use so
      // Reflux.ListenerMixin will cleanup on unmount
      _reflux2.default.utils.extend(this, _reflux2.default.ListenerMethods);

      this.listenTo(store, function (newState) {
        var incomingValue = newState[_lodash2.default.get(_this.props, keyPropName)];
        if (filterValue) {
          incomingValue = incomingValue[filterValue];
        }
        if (!_lodash2.default.isNull(stateKey)) {
          incomingValue = _defineProperty({}, stateKey, incomingValue);
        }
        _this.setState(incomingValue);
      });
    },

    componentWillUnmount: _reflux2.default.ListenerMixin.componentWillUnmount
  };
}

},{"lodash":"lodash","reflux":"reflux"}],186:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultHoverDelay = 250; /*
                             * Delayed hover behavior
                             * This is the react mixin version of the HoverIntent within shared_all_formats/
                             * hover_intent.js
                             */

exports.default = {
  onEnterIntent: function onEnterIntent(fn, delay) {
    if (!delay) {
      delay = defaultHoverDelay;
    }

    // Cancel any pending mouseleave action
    try {
      clearTimeout(this.leaveTimeout);
    } catch (e) {} /* Do nothing */

    // Set up a delayed call to the mouseenter callback
    this.hoverTimeout = _lodash2.default.delay(fn, delay);
  },
  onLeaveIntent: function onLeaveIntent(fn, delay) {
    if (!delay) {
      delay = defaultHoverDelay;
    }

    // Cancel any pending mouseenter action
    try {
      clearTimeout(this.hoverTimeout);
    } catch (e) {} /* Do nothing */

    // Set up a delayed call to the mouseleave callback
    this.leaveTimeout = _lodash2.default.delay(fn, delay);
  }
};

},{"lodash":"lodash"}],187:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _lodash = require("lodash");

var _data_tracking_helper = require("../modules/data_tracking/data_tracking_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This function is called on every component when it mounts and attaches 
 * click tracking data attributes that are provided by the trackingOptions props. 
 * The event listener is added to the top most element, that has enabledTracking = true
 */

exports.default = {
  componentDidMount: function componentDidMount() {
    var _this = this;

    var trackingOptions = this.props.trackingOptions;
    if (trackingOptions) {
      (function () {
        var node = _reactDom2.default.findDOMNode(_this);
        if (node) {
          // Store specified tracking values as data attributes on the component's DOM node
          (0, _lodash.each)((0, _lodash.keys)(trackingOptions), function (key) {
            var value = trackingOptions[key];
            if (!(0, _lodash.isUndefined)(value)) {
              node.setAttribute("data-tracking-" + key, JSON.stringify(value));
            }
          });

          if (trackingOptions.enableTracking === true) {
            // register click tracking for requested components
            node.addEventListener("click", _data_tracking_helper.handleDataTracking);
          }
        }
      })();
    }
  }
};

},{"../modules/data_tracking/data_tracking_helper":10,"lodash":"lodash","react-dom":"react-dom"}],188:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get_a_copy_actions = require("../../react_actions/buy_buttons/get_a_copy_actions");

var reducer = function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var action = arguments[1];

  switch (action.type) {
    case _get_a_copy_actions.GET_A_COPY_ACTIONS.LOADED_SUCCESS:
      return Object.assign({}, state, {
        activeGetACopyInterstitial: action.data
      });
    case _get_a_copy_actions.GET_A_COPY_ACTIONS.INTERSTITIAL_CLOSED:
      return Object.assign({}, state, {
        activeGetACopyInterstitial: null
      });
    default:
      return state;
  }
};

exports.default = reducer;

},{"../../react_actions/buy_buttons/get_a_copy_actions":22}],189:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _search_actions = require("../../react_actions/header/search_actions");

exports.default = function () {
  var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var action = arguments[1];

  switch (action.type) {
    case _search_actions.TOGGLE_SEARCH:
      return Object.assign({}, state, { searchIsActive: action.searchIsActive });
    default:
      return state;
  }
};

},{"../../react_actions/header/search_actions":29}],190:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _book_search_actions_factory = require("../react_actions/book_search_actions_factory");

var _book_search_actions_factory2 = _interopRequireDefault(_book_search_actions_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var factory = function factory() {
  var state = new _freezerJs2.default({ showLoadingSpinner: false,
    showResultsContainer: false,
    results: [],
    query: "",
    activeResult: null
  });
  var actions = (0, _book_search_actions_factory2.default)();

  var updateState = function updateState(results) {
    var values = state.get();
    values.results.reset(results);
  };

  var store = _reflux2.default.createStore({
    listenables: actions,
    getInitialState: state.get,
    getState: state.get,
    actions: actions,

    initializeWith: function initializeWith(data) {
      state.get().set("showLoadingSpinner", data.showLoadingSpinner).set("showResultsContainer", data.showResultsContainer).set("query", data.query).set("activeResult", data.activeResult).results.reset(data.results);
    },
    reset: function reset() {
      state.get().reset({});
    },
    setValue: function setValue(key, value) {
      var stateValues = state.get();
      stateValues.set(key, value);
    },
    onSelectSpecificResult: function onSelectSpecificResult(bookId) {
      var newActiveResult = _lodash2.default.find(this.getState().results, function (result) {
        return result.bookId === bookId;
      });
      this.setValue("activeResult", newActiveResult);
      this.trigger(this.getState());
    },
    onSetShowResultsContainer: function onSetShowResultsContainer(value) {
      this.setValue("showResultsContainer", value);
      this.setValue("activeResult", null);
      this.trigger(this.getState());
    },
    onSelectNextResult: function onSelectNextResult(maxResults) {
      var results = this.getState().results;
      var currentIndex = _lodash2.default.indexOf(results, this.getState().activeResult);
      this.setValue("activeResult", results[(currentIndex + 1) % maxResults]);
      this.trigger(this.getState());
    },
    onSelectPreviousResult: function onSelectPreviousResult(maxResults) {
      var results = this.getState().results;
      var activeResult = this.getState().activeResult;
      var currentIndex = _lodash2.default.indexOf(results, activeResult);
      if (currentIndex === 0 || activeResult === null) {
        this.setValue("activeResult", results[maxResults - 1]);
      } else {
        this.setValue("activeResult", results[(currentIndex - 1) % maxResults]);
      }
      this.trigger(this.getState());
    },
    onSearchResultsFound: function onSearchResultsFound(query, results) {
      updateState(results);
      this.setValue("query", query);
      this.setValue("showLoadingSpinner", false);
      this.setValue("activeResult", null);
      this.setValue("showResultsContainer", true);
      this.trigger(this.getState());
    },
    onSearch: function onSearch(searchValue, searchUrl) {
      this.setValue("showLoadingSpinner", true);
      this.trigger(this.getState());
      $j.ajax({
        url: searchUrl,
        data: { format: "json",
          q: searchValue },
        success: function success(resp) {
          actions.searchResultsFound(searchValue, resp);
        }
      });
    }
  });

  return store;
};
// ACTIONS

exports.default = factory;

},{"../react_actions/book_search_actions_factory":21,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],191:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require("redux");

var _reduxLogger = require("redux-logger");

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _env_utils = require("../../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

var _reduxThunk = require("redux-thunk");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _get_a_copy_reducer = require("../../react_reducers/buy_buttons/get_a_copy_reducer");

var _get_a_copy_reducer2 = _interopRequireDefault(_get_a_copy_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var middlewares = [_reduxThunk2.default]; /*
                                           This should be merged into a page-wide store.
                                           */

if (_env_utils2.default.isDevelopment() && _env_utils2.default.hasDom()) {
  middlewares.push((0, _reduxLogger2.default)());
}

var store = (0, _redux.createStore)(_get_a_copy_reducer2.default, {}, _redux.applyMiddleware.apply(undefined, middlewares));

exports.default = store;

},{"../../modules/env_utils":13,"../../react_reducers/buy_buttons/get_a_copy_reducer":188,"redux":"redux","redux-logger":"redux-logger","redux-thunk":"redux-thunk"}],192:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _current_user_actions = require("../react_actions/current_user_actions");

var _current_user_actions2 = _interopRequireDefault(_current_user_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = { currentUser: {} };
var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var resetTo = function resetTo(data) {
  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

exports.default = _reflux2.default.createStore({
  listenables: [_current_user_actions2.default],

  initializeWith: function initializeWith(data) {
    _lodash2.default.each(_lodash2.default.keys(data), function (key) {
      if (!_lodash2.default.has(defaultState, key)) {
        throw new Error("Unexpected key passed to initializeWith. Received " + key + " Expected one of " + _lodash2.default.keys(defaultState));
      }
    });
    resetTo(data);
  },

  getState: getState,
  getInitialState: getState,

  onUpdatePreference: function onUpdatePreference(prefName, newValue) {
    $j.post("/user/update_preferences", {
      user: _defineProperty({}, prefName, newValue)
    });
  },
  reset: function reset() {
    resetTo({});
  }
});

},{"../react_actions/current_user_actions":23,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],193:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _favorite_genres_actions = require("../react_actions/favorite_genres_actions");

var _favorite_genres_actions2 = _interopRequireDefault(_favorite_genres_actions);

var _favorite_genres_form_actions = require("../react_actions/favorite_genres_form_actions");

var _favorite_genres_form_actions2 = _interopRequireDefault(_favorite_genres_form_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({ selectedGenres: [] });

var getState = function getState() {
  return state.get();
};

var _reset = function _reset() {
  var data = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

  getState().selectedGenres.reset(data);
};

var store = _reflux2.default.createStore({
  listenables: _favorite_genres_form_actions2.default,

  getInitialState: getState,

  getState: getState,

  // selectedGenres should be an array of genre names
  // e.g. ['Art', 'Fiction']
  initializeWith: function initializeWith() {
    for (var _len = arguments.length, selectedGenres = Array(_len), _key = 0; _key < _len; _key++) {
      selectedGenres[_key] = arguments[_key];
    }

    _reset(selectedGenres);
  },
  onSubmitSelectedGenres: function onSubmitSelectedGenres() {
    _favorite_genres_actions2.default.changeFavoriteGenres(getState().selectedGenres);
  },
  onSelectFavoriteGenre: function onSelectFavoriteGenre(selectedGenre) {
    if (_lodash2.default.includes(getState().selectedGenres, selectedGenre)) {
      return;
    }
    getState().selectedGenres.push(selectedGenre);
    this.notifyListeners();
  },
  onDeselectFavoriteGenre: function onDeselectFavoriteGenre(deselectedGenre) {
    getState().selectedGenres.shift(deselectedGenre);
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    _reset();
  }
});

exports.default = store;

},{"../react_actions/favorite_genres_actions":25,"../react_actions/favorite_genres_form_actions":26,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],194:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _favorite_genres_actions = require("../react_actions/favorite_genres_actions");

var _favorite_genres_actions2 = _interopRequireDefault(_favorite_genres_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = { allGenres: [], favoriteGenres: [] };
var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var _reset = function _reset(data) {
  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

var serializeGenres = function serializeGenres(favoritedGenres) {
  return _lodash2.default.inject(getState().allGenres, function (data, genre) {
    var name = genre.name;
    data.favorites[name] = _lodash2.default.includes(favoritedGenres, name);
    return data;
  }, { favorites: {} });
};

exports.default = _reflux2.default.createStore({
  listenables: [_favorite_genres_actions2.default],

  initializeWith: function initializeWith(data) {
    _lodash2.default.each(_lodash2.default.keys(data), function (key) {
      if (!_lodash2.default.has(defaultState, key)) {
        throw new Error("Unexpected key passed to initializeWith. Received " + key + ". Expected one of " + _lodash2.default.keys(defaultState));
      }
    });
    _reset(data);
  },
  updateWith: function updateWith(data) {
    getState().set(data);
  },

  getState: getState,
  getInitialState: getState,

  reset: function reset() {
    _reset();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  onChangeFavoriteGenres: function onChangeFavoriteGenres(favoritedGenres) {
    var _this = this;

    var afterChangesPersisted = function afterChangesPersisted() {
      getState().favoriteGenres.reset(favoritedGenres);
      _this.notifyListeners();
    };
    $j.post("/user/edit_fav_genres", _lodash2.default.merge(serializeGenres(favoritedGenres), { format: "json" }), afterChangesPersisted);
  }
});

},{"../react_actions/favorite_genres_actions":25,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],195:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _featured_genres_actions = require("../react_actions/featured_genres_actions");

var _featured_genres_actions2 = _interopRequireDefault(_featured_genres_actions);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _favorite_genres_store = require("../react_stores/favorite_genres_store");

var _favorite_genres_store2 = _interopRequireDefault(_favorite_genres_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var store = _reflux2.default.createStore({
  listenables: _featured_genres_actions2.default,

  init: function init() {
    _favorite_genres_store2.default.listen(function () {
      _featured_genres_actions2.default.requestFeaturedBooks();
    });
  },
  initializeWith: function initializeWith(featuredGenreBookInfo) {
    state.get().reset({ featuredGenreBookInfo: featuredGenreBookInfo });
  },

  getInitialState: getState,

  getState: getState,

  onRequestFeaturedBooks: function onRequestFeaturedBooks() {
    var _this = this;

    if (_lodash2.default.isEmpty(_favorite_genres_store2.default.getState().favoriteGenres)) {
      this.saveNewFeaturedBooks([]);
      return;
    }
    if (!getState().requestedFeaturedBooksBefore) {
      $j.get("/genres/featured_books").done(function (resp) {
        _this.saveNewFeaturedBooks(resp.genres);
        _shelvings_actions2.default.addShelvings(resp.shelvings);
      }).fail(function (resp) {
        _featured_genres_actions2.default.displayError(resp);
      });
      getState().set("requestedFeaturedBooksBefore", true);
    }
  },
  onTrackMenuImpression: function onTrackMenuImpression() {
    $j.get("/dfp/browse_menu_impression");
  },
  saveNewFeaturedBooks: function saveNewFeaturedBooks(featuredGenreBookInfo) {
    getState().set("featuredGenreBookInfo", featuredGenreBookInfo);
    this.notifyListeners();
  },
  onDisplayError: function onDisplayError() {
    getState().set("errorMessage", "Error loading featured books in genre.");
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    getState().reset({});
  }
});

exports.default = store;

},{"../react_actions/featured_genres_actions":27,"../react_actions/shelvings_actions":35,"../react_stores/favorite_genres_store":194,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],196:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSA_ELEMENT_TYPE = exports.ImpressionCode = undefined;

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _data_tracking_actions = require("../react_actions/data_tracking/data_tracking_actions");

var _data_tracking_actions2 = _interopRequireDefault(_data_tracking_actions);

var _google_ads_actions = require("../react_actions/google_ads_actions");

var _google_ads_actions2 = _interopRequireDefault(_google_ads_actions);

var _newsfeed_actions = require("../react_actions/newsfeed_actions");

var _newsfeed_actions2 = _interopRequireDefault(_newsfeed_actions);

var _google_ad_helper = require("../modules/ads/google_ad_helper");

var _env_utils = require("../modules/env_utils");

var _env_utils2 = _interopRequireDefault(_env_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = {
  targeting: {},
  ads: {},
  nativeAds: {},
  device_type: null
}; // eslint-disable-line camelcase
var state = new _freezerJs2.default(defaultState);

var ImpressionCode = exports.ImpressionCode = {
  success: "0",
  dfpError: "1",
  monolithError: "2",
  empty: "3"
};

/** When adding, updating or removing attribute(s), please notify the Data Engineering team 
so that they can update the CSA query on their end. **/
var CSAElementAttributes = {
  adUnit: "ad",
  lineItemId: "l_id",
  campaignId: "c_id",
  type: "type",
  requestId: "r_id",
  sessionId: "s_id",
  slotId: "slot-id"
};

var CSA_ELEMENT_TYPE = exports.CSA_ELEMENT_TYPE = "DFP";

var getState = function getState() {
  return state.get();
};

var _resetTo = function _resetTo() {
  var data = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState().ads, key)) {
    //throw error
    if (!_lodash2.default.has(getState().nativeAds, key)) {
      throw new ReferenceError("No such product existing for key " + key);
    }
    return getState().nativeAds[key];
  }
  return getState().ads[key];
};

var setDataForKey = function setDataForKey(key, data) {
  getStateForKey(key).set(data);
};

var adUnit = function adUnit(currentSlotIdState) {
  return currentSlotIdState.path.split("/", 3)[2];
};

/* eslint-disable camelcase */
var dfpTrackingInfo = function dfpTrackingInfo(currentSlotIdState) {
  return {
    ad_unit: adUnit(currentSlotIdState),
    line_item_id: currentSlotIdState.lineItemId,
    campaign_id: currentSlotIdState.campaignId,
    ad_device_type: currentSlotIdState.adDeviceType
  };
};
/* eslint-enable camelcase */

var ajaxTrackingCall = function ajaxTrackingCall(url, currentSlotIdState, additionalParams) {
  var data = _lodash2.default.merge(dfpTrackingInfo(currentSlotIdState), additionalParams);

  $j.ajax({
    url: url,
    type: "GET",
    data: data
  });
};

var setImpressionLogged = function setImpressionLogged(slotId) {
  setDataForKey(slotId, { impressionLogged: true });
};

/**
 * Tracks an element in DFP, Clickstream and CSA
 * @param {string} slotId Ad id.
 * @param {object} impressionCode Impression code to log in DFP.
 * @param {DOMNode} impressionElement The element to track in CSA.
 */
var trackImpression = function trackImpression(_ref) {
  var slotId = _ref.slotId;
  var impressionCode = _ref.impressionCode;
  var impressionElement = _ref.impressionElement;

  if (!slotId) {
    return;
  }

  var currentSlotIdState = getStateForKey(slotId);

  if (currentSlotIdState && !currentSlotIdState.impressionLogged) {
    ajaxTrackingCall(currentSlotIdState.pmetImpressionTrackUrl, currentSlotIdState, { impression_output: impressionCode } // eslint-disable-line camelcase
    );

    // CSA Impression
    trackImpressionInCSA({ currentSlotIdState: currentSlotIdState, impressionElement: impressionElement });

    setImpressionLogged(slotId);
  }
};

/**
 * Returns metadata object, which is used to set metadata attributes on
 * an element
 *
 * @param {object} currentSlotIdState The object which contains metadata.
 */
var getCSATrackingInfo = function getCSATrackingInfo(currentSlotIdState) {
  var _ref3;

  var _ref2 = window && window.ue || {};

  var id = _ref2.id;
  var sid = _ref2.sid;

  return _ref3 = {}, _defineProperty(_ref3, CSAElementAttributes.adUnit, adUnit(currentSlotIdState)), _defineProperty(_ref3, CSAElementAttributes.lineItemId, currentSlotIdState.lineItemId), _defineProperty(_ref3, CSAElementAttributes.campaignId, currentSlotIdState.campaignId), _defineProperty(_ref3, CSAElementAttributes.type, CSA_ELEMENT_TYPE), _defineProperty(_ref3, CSAElementAttributes.requestId, id), _defineProperty(_ref3, CSAElementAttributes.sessionId, sid), _defineProperty(_ref3, CSAElementAttributes.slotId, CSA_ELEMENT_TYPE), _ref3;
};

/**
 * Sets metadata attribute on the impression element and tracks it in CSA
 *
 * @param {object} currentSlotIdState The object which contains metadata.
 * @param {DOMNode} impressionElement The element to track in CSA.
 */
var trackImpressionInCSA = function trackImpressionInCSA(_ref4) {
  var currentSlotIdState = _ref4.currentSlotIdState;
  var impressionElement = _ref4.impressionElement;

  if (!impressionElement || !currentSlotIdState) {
    return;
  }

  if (window.csa) {
    (function () {

      var csaTrackingInfo = getCSATrackingInfo(currentSlotIdState);

      // setting impression attributes on the element
      Object.values(CSAElementAttributes).forEach(function (attribute) {
        if (csaTrackingInfo[attribute]) {
          impressionElement.setAttribute("data-csa-c-" + attribute, csaTrackingInfo[attribute]);
        }
      });

      // registering the element using CSA's programmatic API
      // For more details: https://info.analytics.a2z.com/#/docs/data_collection/csa/content_whitelisting
      window.csa("Content", { element: impressionElement });
    })();
  }
};

var handleClickTracker = function handleClickTracker(currentSlotIdState) {
  ajaxTrackingCall(currentSlotIdState.pmetClickTrackUrl, currentSlotIdState, {
    click_type: "click"
  }); // eslint-disable-line camelcase
};

var nativeAdGetUrl = function nativeAdGetUrl(resourceType) {
  switch (resourceType) {
    case "NewsfeedAd":
      return "/dfp/ajax_native_ad";
    case "PageSkin":
      return "/dfp/ajax_premium_campaign_page_skin";
    case "FeaturedContent":
      return "/dfp/ajax_premium_campaign_featured_content";
  }
};

exports.default = _reflux2.default.createStore({
  listenables: [_google_ads_actions2.default, { trackClickEvent: _data_tracking_actions2.default.trackClickEvent }],

  initializeWith: function initializeWith(data) {
    var _this = this;

    (0, _google_ad_helper.lazyLoadInit)();
    data = _lodash2.default.merge({}, { callbacksAttached: [] }, data);
    _resetTo(data);
    var gptSlots = [];
    var apsSlots = [];
    var a9Sizes = undefined;
    if (_env_utils2.default.hasDom() && !(0, _google_ad_helper.adSlotsDefined)()) {
      var ads = _lodash2.default.merge({}, this.getState().ads, this.getState().nativeAds);
      _lodash2.default.map(ads, function (ad, adId) {
        if (!ad.isLazyLoaded) {
          var isNativeAd = _lodash2.default.has(_this.getState().nativeAds, adId);
          (0, _google_ad_helper.defineSlot)(adId, ad.path, ad.dimensions, ad.adSizeMapping, isNativeAd);
          gptSlots.push((0, _google_ad_helper.slotToHash)(ad, adId));
          a9Sizes = (0, _google_ad_helper.getA9Sizes)(ad.dimensions);
          if (!_lodash2.default.isEmpty(a9Sizes)) {
            apsSlots.push((0, _google_ad_helper.slotToHash)(ad, adId, a9Sizes));
          }
        }
      });
      (0, _google_ad_helper.enableServices)();
      (0, _google_ad_helper.fetchApstagBids)(gptSlots, _lodash2.default.compact(apsSlots));
    }
  },
  resetTo: function resetTo(data) {
    _resetTo(data);
  },
  updateWith: function updateWith(data) {
    getState().set(_lodash2.default.merge({}, getState(), data));
  },
  onTrackClickEvent: function onTrackClickEvent(event, source) {
    var target = event.target;
    var dfp = undefined,
        pmet = undefined,
        dfpData = undefined,
        pmetData = undefined;
    var regex = /news/;
    var adId = JSON.parse(source.getAttribute("data-tracking-adId"));
    adId = adId ? adId : _lodash2.default.findKey(getState().nativeAds, function (ad) {
      return ad.path.match(regex);
    });

    //crawl up the source tree until you find the dfp and pmet tracking data
    if (adId) {
      while (target !== source) {
        if (target.getAttribute("data-tracking-dfp") && !dfp) {
          dfp = target.getAttribute("data-tracking-dfp");
          dfpData = JSON.parse(dfp);
          if (dfpData) {
            this.trackDfpClick(adId);
          }
        }
        if (target.getAttribute("data-tracking-pmet") && !pmet) {
          pmet = target.getAttribute("data-tracking-pmet");
          pmetData = JSON.parse(pmet);
          this.trackPmetClick(adId, pmetData);
        }
        target = target.parentNode;
      }
    }
  },
  mergeWith: function mergeWith(data) {
    getState().set(_lodash2.default.merge({}, getState(), data));
  },
  onHasAttachedDfpCallbackForSlot: function onHasAttachedDfpCallbackForSlot(adId) {
    this.getState().set("callbacksAttached", [].concat(_toConsumableArray(this.getState().callbacksAttached), [adId]));
  },
  onCheckCallbacksAttached: function onCheckCallbacksAttached(resolve, reject, slotsToCheck) {
    var result = _lodash2.default.reduce(["ads", "nativeAds"], function (result, adType) {
      var perAdType = _lodash2.default.reduce(_lodash2.default.keys(getState()[adType]), function (result, adId) {
        var intermediate = undefined;
        if (_lodash2.default.includes(slotsToCheck, adId)) {
          intermediate = getStateForKey(adId).isLazyLoaded || _lodash2.default.includes(getState().callbacksAttached, adId);
        } else {
          intermediate = true;
        }
        return result && intermediate;
      }, true);
      return result && perAdType;
    }, true);
    result ? resolve(true) : setTimeout(function () {
      return resolve(false);
    }, 500);
  },
  onRequestCreativeForSlot: function onRequestCreativeForSlot(slotId, paramsForCreative) {
    if (window.googletag && window.googletag.cmd) {
      window.googletag.cmd.push(function () {
        (0, _google_ad_helper.requestCreative)(slotId, paramsForCreative);
      });
    }
  },
  onRemoveAdSlot: function onRemoveAdSlot(slotId) {
    setDataForKey(slotId, {
      empty: true
    });
    this.notifyListeners();
  },
  onTrackImpression: function onTrackImpression(_ref5) {
    var slotId = _ref5.slotId;
    var impressionCode = _ref5.impressionCode;
    var impressionElement = _ref5.impressionElement;

    trackImpression({ slotId: slotId, impressionCode: impressionCode, impressionElement: impressionElement });
  },
  onAttachServedBannerAdAttributesAndTracking: function onAttachServedBannerAdAttributesAndTracking(_ref6) {
    var slotId = _ref6.slotId;
    var campaignId = _ref6.campaignId;
    var lineItemId = _ref6.lineItemId;
    var creative = _ref6.creative;
    var impressionCode = _ref6.impressionCode;
    var delayImpressionTracking = _ref6.delayImpressionTracking;
    var impressionElement = _ref6.impressionElement;

    setDataForKey(slotId, {
      campaignId: campaignId,
      lineItemId: lineItemId,
      creative: creative,
      impressionCode: impressionCode
    });
    this.notifyListeners();
    var currentSlotIdState = getStateForKey(slotId);
    if (!creative) {
      trackImpression({ slotId: slotId, impressionCode: ImpressionCode.dfpError });
      return;
    }

    if (!delayImpressionTracking) {
      //Track impression on pmet
      trackImpression({ slotId: slotId, impressionCode: impressionCode, impressionElement: impressionElement });
    }

    //ad click tracker to creative DOM object
    currentSlotIdState.creative.on("click", "a", function () {
      currentSlotIdState.creative.context.click();
      handleClickTracker(currentSlotIdState);
    });
  },
  onAttachServedNativeAdAttributesAndTracking: function onAttachServedNativeAdAttributesAndTracking(_ref7) {
    var slotId = _ref7.slotId;
    var campaignId = _ref7.campaignId;
    var lineItemId = _ref7.lineItemId;
    var creative = _ref7.creative;
    var sponsoredId = _ref7.sponsoredId;
    var impressionCode = _ref7.impressionCode;
    var dfpUrl = _ref7.dfpUrl;
    var adUnit = _ref7.adUnit;
    var impressionElement = _ref7.impressionElement;

    setDataForKey(slotId, { campaignId: campaignId, lineItemId: lineItemId, url: dfpUrl });
    var currentSlotIdState = getStateForKey(slotId);
    var resourceType = currentSlotIdState.resourceType;
    var url = nativeAdGetUrl(resourceType);
    if (!creative) {
      trackImpression({ slotId: slotId, impressionCode: ImpressionCode.dfpError });
      return;
    }

    if (currentSlotIdState.resourceType === "NewsfeedAd") {
      this.ajaxNewsfeedAd(slotId, lineItemId, sponsoredId, impressionCode, dfpUrl, adUnit, url, impressionElement);
    } else {
      this.ajaxPremiumCampaign(slotId, lineItemId, sponsoredId, impressionCode, dfpUrl, adUnit, url, impressionElement);
    }
  },
  ajaxNewsfeedAd: function ajaxNewsfeedAd(slotId, lineItemId, sponsoredId, impressionCode, dfpUrl, adUnit, url, impressionElement) {
    var _this2 = this;

    $j.ajax({
      type: "GET",
      url: url,
      /* eslint-disable camelcase */
      data: {
        format: "json",
        id: sponsoredId,
        line_item_id: lineItemId,
        ad_unit: adUnit,
        ad_device_type: "desktop",
        react: true
      }
    }). /* eslint-enable camelcase */
    done(function (json) {
      if (json.ok) {
        setDataForKey(slotId, json);
        _newsfeed_actions2.default.updateNativeAdSlot(getStateForKey(slotId).id, getStateForKey(slotId));
        _this2.notifyListeners();
        trackImpression({ slotId: slotId, impressionCode: impressionCode, impressionElement: impressionElement });
      } else {
        trackImpression({
          slotId: slotId,
          impressionCode: ImpressionCode.monolithError
        });
      }
    });
  },
  ajaxPremiumCampaign: function ajaxPremiumCampaign(slotId, lineItemId, sponsoredId, impressionCode, dfpUrl, adUnit, url, impressionElement) {
    var _this3 = this;

    $j.ajax({
      type: "GET",
      url: url,
      /* eslint-disable camelcase */
      data: {
        format: "json",
        id: sponsoredId,
        line_item_id: lineItemId,
        ad_unit: adUnit,
        ad_device_type: "desktop"
      }
    }). /* eslint-enable camelcase */
    done(function (json) {
      if (json.ok) {
        setDataForKey(slotId, json);
        _this3.notifyListeners(getState());

        //Track impression on pmet
        trackImpression({ slotId: slotId, impressionCode: impressionCode, impressionElement: impressionElement });
      } else {
        trackImpression({
          slotId: slotId,
          impressionCode: ImpressionCode.monolithError
        });
      }
    });
  },
  trackDfpClick: function trackDfpClick(slotId) {
    var currentSlotIdState = getStateForKey(slotId);
    var dfpClickUrl = currentSlotIdState.url;
    var queryParams = _lodash2.default.merge(dfpTrackingInfo(currentSlotIdState), {
      click_type: "click"
    }); // eslint-disable-line camelcase
    var encodedQueryParams = encodeURIComponent("?" + $j.param(queryParams));

    $j.ajax({
      type: "GET",
      url: dfpClickUrl + currentSlotIdState.pmetClickTrackUrl + encodedQueryParams
    });
  },
  trackPmetClick: function trackPmetClick(slotId, additionalParams) {
    var currentSlotIdState = getStateForKey(slotId);
    var queryParams = _lodash2.default.merge(dfpTrackingInfo(currentSlotIdState), additionalParams);

    $j.ajax({
      type: "GET",
      url: currentSlotIdState.pmetClickTrackUrl,
      data: queryParams
    });
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },

  getInitialStateForKey: getStateForKey,

  getState: getState,

  reset: _resetTo
});

},{"../modules/ads/google_ad_helper":3,"../modules/env_utils":13,"../react_actions/data_tracking/data_tracking_actions":24,"../react_actions/google_ads_actions":28,"../react_actions/newsfeed_actions":31,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],197:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _modal_actions = require("../react_actions/modal_actions");

var _modal_actions2 = _interopRequireDefault(_modal_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var store = _reflux2.default.createStore({
  listenables: _modal_actions2.default,

  getInitialState: getState,

  getState: getState,

  initializeWith: function initializeWith(data) {
    state.get().reset(data);
  },
  onOpenModal: function onOpenModal(modalId) {
    state.get().set("currentActiveModal", modalId);
    this.notifyListeners();
  },
  onCloseModal: function onCloseModal() {
    state.get().set("currentActiveModal", null);
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    state.get().reset({});
  }
});

exports.default = store;

},{"../react_actions/modal_actions":30,"freezer-js":"freezer-js","reflux":"reflux"}],198:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _notifications_actions = require("../react_actions/notifications_actions");

var _notifications_actions2 = _interopRequireDefault(_notifications_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var store = _reflux2.default.createStore({
  listenables: _notifications_actions2.default,

  getInitialState: getState,

  getState: getState,

  initializeWith: function initializeWith(data) {
    state.get().reset(data);
  },
  updateWith: function updateWith(data) {
    this.initializeWith(data);
  },
  onLoadNotifications: function onLoadNotifications(notifications) {
    state.get().set("notifications", notifications);
    state.get().set("unreadCount", 0);
    state.get().set("unreadCountMore", false);
    this.notifyListeners();
  },
  onLoadError: function onLoadError() {
    state.get().set("errorOccurred", true);
    this.notifyListeners();
  },
  onRequestNotifications: function onRequestNotifications() {
    if (!state.get().hasRequestedBefore) {
      $j.ajax({
        url: "/notifications/",
        type: "GET",
        success: function success(resp) {
          _notifications_actions2.default.loadNotifications(resp);
        },
        error: function error() {
          _notifications_actions2.default.loadError();
        }
      });
    }
    state.get().set("hasRequestedBefore", true);
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    state.get().reset({});
  }
});

exports.default = store;

},{"../react_actions/notifications_actions":32,"freezer-js":"freezer-js","reflux":"reflux"}],199:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WARNING_SHARING_TEXT_LENGTH = exports.MAXIMUM_SHARING_TEXT_LENGTH = undefined;

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _share_dialog_actions = require("../react_actions/share_dialog_actions");

var _share_dialog_actions2 = _interopRequireDefault(_share_dialog_actions);

var _ajax_helper = require("../modules/ajax/ajax_helper");

var _string_helper = require("../modules/string_helper");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var MAXIMUM_SHARING_TEXT_LENGTH = exports.MAXIMUM_SHARING_TEXT_LENGTH = 420;
var WARNING_SHARING_TEXT_LENGTH = exports.WARNING_SHARING_TEXT_LENGTH = 100;

exports.default = _reflux2.default.createStore({

  listenables: [_share_dialog_actions2.default],

  getState: getState,

  getInitialState: function getInitialState() {
    return getState();
  },
  initializeWith: function initializeWith(data) {
    getState().reset(data);
  },
  onUpdateSharingTextInputValue: function onUpdateSharingTextInputValue(val) {
    var textTooLong = (0, _string_helper.astralLength)(val) > MAXIMUM_SHARING_TEXT_LENGTH;
    var disableShareModalButton = textTooLong;

    getState().set({
      sharingTextInputValue: val,
      shareModalButtonDisabled: disableShareModalButton,
      textTooLong: textTooLong
    });
    this.trigger(getState());
  },
  onSubmitShare: function onSubmitShare(sharingData, sharingTextInputValue) {
    var _this = this;

    getState().set({ shareModalButtonDisabled: true, error: false });
    this.trigger(getState());
    var sharingCreateData = {
      resource_id: sharingData.resourceId,
      resource_type: sharingData.resourceTypeFriendlyText,
      sharing_text: sharingTextInputValue
    };

    if (sharingData.sharerUserId) {
      sharingCreateData.sharer_user_id = sharingData.sharerUserId;
    }

    (0, _ajax_helper.httpPost)("/sharings", {
      format: "json",
      data: {
        sharing: sharingCreateData
      }
    }).done(function (response) {
      getState().set({
        shared: true,
        sharingTextInputValue: "",
        sharingUrl: response.sharingUrl,
        sharingDisplayName: response.sharingDisplayName
      });
    }).fail(function (error) {
      var errorText = (0, _lodash.get)(error, ["responseJSON", "message"]);
      getState().set({ error: true, errorText: errorText });
    }).always(function () {
      getState().set({ shareModalButtonDisabled: false });
      _this.trigger(getState());
    });
  },
  onOpenShareModal: function onOpenShareModal(resourceTypeIdentifier) {
    getState().set({ shared: false, error: false });
    this.trigger(getState());
    var openModalMetricByResourceType = "OpenSharingModal_" + resourceTypeIdentifier;
    (0, _ajax_helper.httpPost)("/track/track_click", {
      data: {
        feature: openModalMetricByResourceType
      }
    });
  },
  reset: function reset() {
    getState().reset({});
  }
});

},{"../modules/ajax/ajax_helper":4,"../modules/string_helper":19,"../react_actions/share_dialog_actions":34,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],200:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NEWSFEED_DEPENDENT_STORE_KEYS = undefined;

var _newsfeed_actions = require("../../react_actions/newsfeed_actions");

var _newsfeed_actions2 = _interopRequireDefault(_newsfeed_actions);

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
This mixin provides a reusable hook for stores to update when the newsfeed has
loaded additional updates. Example usage can be seen in any of the stores in
NEWSFEED_DEPENDENT_STORE_KEYS.

To add a new store, add the appropriate key/value in NEWSFEED_DEPENDENT_STORE_KEYS,
make sure the corresponding data is returned in newsfeed/all_stores_update_data
with the same value as the one defined in NEWSFEED_DEPENDENT_STORE_KEYS, and make
sure your store has an updateWith() method.
*/

var factory = function factory(dependentStoreKey) {
  var mixin = {
    init: function init() {
      if ((0, _lodash.includes)((0, _lodash.values)(NEWSFEED_DEPENDENT_STORE_KEYS), dependentStoreKey)) {
        this.listenTo(_newsfeed_actions2.default.newsfeedItemsLoaded, this.onNewsfeedItemsLoaded);
      }
    },
    onNewsfeedItemsLoaded: function onNewsfeedItemsLoaded(dependentStoreData) {
      if (dependentStoreKey && dependentStoreData[dependentStoreKey]) {
        this.updateWith(dependentStoreData[dependentStoreKey]);
        this.trigger(this.getState());
      }
    }
  };
  return mixin;
};

exports.default = factory;
var NEWSFEED_DEPENDENT_STORE_KEYS = exports.NEWSFEED_DEPENDENT_STORE_KEYS = {
  COMMENTS: "comments",
  LIKES: "likes",
  SHELVINGS: "shelvings",
  AUTHOR_FOLLOWS: "authorFollows"
};

},{"../../react_actions/newsfeed_actions":31,"lodash":"lodash"}],201:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _reading_session_actions = require("../react_actions/reading_session_actions");

var _reading_session_actions2 = _interopRequireDefault(_reading_session_actions);

var _user_shelves_actions = require("../react_actions/user_shelves_actions");

var _user_shelves_actions2 = _interopRequireDefault(_user_shelves_actions);

var _newsfeed_updates_mixin = require("./shared/newsfeed_updates_mixin");

var _newsfeed_updates_mixin2 = _interopRequireDefault(_newsfeed_updates_mixin);

var _default_shelves = require("../modules/default_shelves");

var _book_origins = require("../modules/book_origins");

var _ajax_helper = require("../modules/ajax/ajax_helper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  This store maps book IDs to the current user's shelving data for that book.

  The same shelving could appear in ShelvingsStore multiple times. For example,
  if a user has shelved book ID 1, and book ID 2 is another edition of the same
  Work as book ID 1, ShelvingsStore might contain keys for 1, 2, or both:

  {1: {…,
       book: {
         bookId: 1,
         …
       }},
   2: {…,
       book: {
         bookId: 1,
         …
       }},
  }
*/

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState(), key)) {
    getState().set(key, {
      exclusiveShelfName: null,
      nonExclusiveShelfNames: null,
      exclusiveShelfDisplayName: null,
      isShelvingInProgress: false,
      targetExclusiveShelfName: null
    });
  }
  return getState()[key];
};

// Update all states with a given book id included in them
var setStateForBookId = function setStateForBookId(bookId, data) {
  // merges with existing data
  getStateForKey(bookId).set(data);

  _lodash2.default.each(getState(), function (shelvingState, key) {
    if (shelvingState.book && shelvingState.book.bookId === bookId) {
      getStateForKey(key).set(data);
    }
  });
};

var addToExclusiveShelf = function addToExclusiveShelf(bookId, shelf, responseData) {
  setStateForBookId(bookId, { exclusiveShelfName: shelf.name,
    exclusiveShelfDisplayName: shelf.displayName });
  if (typeof responseData !== "undefined") {
    setStateForBookId(bookId, { book: responseData.book,
      updatedAt: Date.parse(responseData.updatedAt) });
  }
  _reading_session_actions2.default.refreshReadingSessions();
};

var deleteShelving = function deleteShelving(bookId, shelf, newShelf) {
  setStateForBookId(bookId, { exclusiveShelfName: null,
    exclusiveShelfDisplayName: null,
    rating: 0,
    nonExclusiveShelfNames: null });
  if (newShelf) {
    _user_shelves_actions2.default.removeNonExclusiveShelf(shelf.name);
  }
};

var unsetRating = function unsetRating(bookId) {
  setStateForBookId(bookId, { rating: 0 });
};

var setRating = function setRating(bookId, value) {
  var bookData = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  addToReadShelfIfUnshelved(bookId, bookData);
  setStateForBookId(bookId, { rating: value });
};

var addToNonExclusiveShelf = function addToNonExclusiveShelf(bookId, shelf) {
  var bookData = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var state = getStateForKey(bookId);
  var shelfNames = _lodash2.default.clone(state.nonExclusiveShelfNames) || [];
  shelfNames.push(shelf.name);
  setStateForBookId(bookId, { nonExclusiveShelfNames: shelfNames });
  addToReadShelfIfUnshelved(bookId, bookData);
  _user_shelves_actions2.default.addNonExclusiveShelf(shelf.name);
};

var removeFromNonExclusiveShelf = function removeFromNonExclusiveShelf(bookId, shelf, newShelf) {
  var state = getStateForKey(bookId);
  var shelfNames = _lodash2.default.clone(state.nonExclusiveShelfNames);
  shelfNames = _lodash2.default.without(shelfNames, shelf.name);
  if (newShelf) {
    _user_shelves_actions2.default.removeNonExclusiveShelf(shelf.name);
  }
  setStateForBookId(bookId, { nonExclusiveShelfNames: shelfNames });
};

var addToReadShelfIfUnshelved = function addToReadShelfIfUnshelved(bookId) {
  var bookData = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

  var state = getStateForKey(bookId);
  if (state.exclusiveShelfName === null) {
    addToExclusiveShelf(bookId, _default_shelves.DEFAULT_SHELVES.READ, bookData);
  }
};

var addToShelfRequest = function addToShelfRequest(data) {
  var origin = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
  var progress_update_text = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var args = data;
  if (origin) {
    args = _lodash2.default.merge({}, data, {
      book_origin: origin
    });
  }
  if (progress_update_text) {
    args = _lodash2.default.merge({}, args, {
      progress_update_text: progress_update_text
    });
  }
  args = _lodash2.default.merge({}, args, { v: 2 });
  return (0, _ajax_helper.httpPost)("/shelf/add_to_shelf.json", { data: args });
};

exports.default = _reflux2.default.createStore({
  listenables: _shelvings_actions2.default,
  mixins: [(0, _newsfeed_updates_mixin2.default)(_newsfeed_updates_mixin.NEWSFEED_DEPENDENT_STORE_KEYS.SHELVINGS)],

  getState: getState,

  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },
  initializeWith: function initializeWith(data) {
    state.get().reset(data);
    this.notifyListeners();
  },
  reset: function reset() {
    state.get().reset({});
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  updateWith: function updateWith(shelvings) {
    var shelvingData = _lodash2.default.transform(shelvings, function (result, shelving, key) {
      result[key].isShelvingInProgress = false;
      result[key].updatedAt = Date.parse(shelving.updatedAt);
      return result;
    }, shelvings);

    this.getState().set(shelvingData);
    this.notifyListeners();
  },
  onShelveBook: function onShelveBook(bookId, shelf) {
    var _this = this;

    var origin = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
    var progress_update_text = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

    var currentCustomExclusiveShelf = getStateForKey(bookId).exclusiveShelfName;
    setStateForBookId(bookId, { isShelvingInProgress: true, targetExclusiveShelfName: shelf.name });
    var data = { book_id: bookId, name: shelf.name };
    this.notifyListeners();
    addToShelfRequest(data, origin, progress_update_text).done(function (responseData) {
      addToExclusiveShelf(bookId, shelf, responseData);
      responseData = responseData || {};
      responseData.shelves = {};
      responseData.shelves[(0, _default_shelves.getExclusiveShelfType)(shelf.name)] = [shelf.name];
      _shelvings_actions2.default.bookShelved(responseData);

      // if moving book to another exclusive shelf, remove it from the previous one
      if (currentCustomExclusiveShelf) {
        var shelves = {};
        shelves[(0, _default_shelves.getExclusiveShelfType)(currentCustomExclusiveShelf)] = [currentCustomExclusiveShelf];
        _shelvings_actions2.default.bookUnshelved({ shelves: shelves });
      }

      if (origin === _book_origins.BOOK_ORIGINS.CURRENTLY_READING_WIDGET) {
        _reading_session_actions2.default.shelveBookSuccess();
      }
    }).fail(function () {
      window.alert("There was an error adding the book to your shelf, please try again.");
    }).always(function () {
      setStateForBookId(bookId, { isShelvingInProgress: false, targetExclusiveShelfName: null });
      _this.notifyListeners();
    });
  },
  onUnshelveBook: function onUnshelveBook(bookId) {
    var _this2 = this;

    setStateForBookId(bookId, { isShelvingInProgress: true });
    this.notifyListeners();
    (0, _ajax_helper.httpPost)("/review/destroy", {
      data: {
        id: bookId
      }
    }).done(function () {
      var shelves = {};
      shelves[(0, _default_shelves.getExclusiveShelfType)(getStateForKey(bookId).exclusiveShelfName)] = [getStateForKey(bookId).exclusiveShelfName];
      shelves[_default_shelves.SHELF_TYPES.NONEXCLUSIVE] = getStateForKey(bookId).nonExclusiveShelfNames || [];
      _shelvings_actions2.default.bookUnshelved({ shelves: shelves });

      deleteShelving(bookId);
    }).fail(function (response) {
      if (response.status === 403 && response.getResponseHeader("errorType") === "frozen") {
        window.alert("Something went wrong with your request. Please try again later.");
      } else {
        window.alert("There was an error removing the book from your shelves, please try again.");
      }
    }).always(function () {
      setStateForBookId(bookId, { isShelvingInProgress: false });
      _this2.notifyListeners();
    });
  },
  onToggleNonExclusiveShelving: function onToggleNonExclusiveShelving(bookId, shelf, newShelf, title) {
    var _this3 = this;

    var exclusiveShelfName = getStateForKey(bookId).exclusiveShelfName;
    var nonExclusiveShelfNames = getStateForKey(bookId).nonExclusiveShelfNames;
    var isAddingToShelf = !_lodash2.default.includes(nonExclusiveShelfNames, shelf.name);
    var isBookShelved = getState()[bookId] && getStateForKey(bookId).exclusiveShelfName !== null;
    var bookData = { book: { bookId: bookId, title: title } };

    if (isAddingToShelf) {
      addToReadShelfIfUnshelved(bookId, bookData);
      addToNonExclusiveShelf(bookId, shelf, bookData);
    } else {
      removeFromNonExclusiveShelf(bookId, shelf, false);
    }
    this.notifyListeners();

    var data = {
      book_id: bookId,
      name: shelf.name,
      a: isAddingToShelf ? "" : "remove"
    };

    addToShelfRequest(data).done(function () {
      var shelves = {};
      if (isAddingToShelf) {
        // if book is not on an exclusive shelf already, also add it to the READ shelf
        shelves[_default_shelves.SHELF_TYPES.DEFAULT] = !exclusiveShelfName ? [_default_shelves.DEFAULT_SHELVES.READ.name] : [];
        shelves[_default_shelves.SHELF_TYPES.NONEXCLUSIVE] = [shelf.name];
        _shelvings_actions2.default.bookShelved({ shelves: shelves });
      } else {
        shelves[_default_shelves.SHELF_TYPES.NONEXCLUSIVE] = [shelf.name];
        _shelvings_actions2.default.bookUnshelved({ shelves: shelves });
      }
    }).fail(function () {
      window.alert("There was an error adding the book to your shelf, please try again.");
      if (!isBookShelved) {
        deleteShelving(bookId, shelf, newShelf);
      } else if (isAddingToShelf) {
        removeFromNonExclusiveShelf(bookId, shelf, newShelf);
      } else {
        addToNonExclusiveShelf(bookId, shelf, bookData);
      }
      _this3.notifyListeners();
    });
  },
  onRateBook: function onRateBook(bookId, rating, title) {
    var clickstreamRef = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];

    var _this4 = this;

    var ratingContainer = arguments[4];
    var handleClick = arguments[5];

    var prevRating = 0;
    var isBookShelved = false;
    var bookData = { book: { bookId: bookId, title: title } };
    if (getState()[bookId]) {
      prevRating = getStateForKey(bookId).rating;
      isBookShelved = getStateForKey(bookId).exclusiveShelfName !== null;
      if (prevRating === 0) {
        _shelvings_actions2.default.rateBook.newBook();
      }
    }
    setRating(bookId, rating, bookData);
    this.notifyListeners();

    var ratePostUrl = "/review/rate";
    var ratePostData = {
      format: "json",
      id: bookId,
      rating: rating,
      stars_click: true
    };
    if (clickstreamRef) {
      var clickstreamRefNumRating = clickstreamRef.replace("str", "st" + rating);
      ratePostUrl += "?ref=" + clickstreamRefNumRating;
    }
    var store = this;
    (0, _ajax_helper.httpPost)(ratePostUrl, {
      data: ratePostData,
      error: function error(xhr, aja_xOptions, thrownError) {
        if (xhr.status === 403 && xhr.getResponseHeader("errorType") === "frozen") {
          window.alert("This book has temporary limitations on submitting ratings and reviews. This may be because we've detected unusual behavior that doesn't follow our review guidelines.");
        } else if (xhr.status !== 403) {
          window.alert("There was an error saving your rating, please try again.");
        }
        if (prevRating > 0) {
          setRating(bookId, prevRating, bookData);
        } else if (isBookShelved) {
          unsetRating(bookId);
          _shelvings_actions2.default.rateBook.failed();
        } else {
          deleteShelving(bookId, null, false);
          _shelvings_actions2.default.rateBook.failed();
        }
        store.notifyListeners();
      },
      success: function success(response) {
        ratingContainer.focus();
        if (handleClick) {
          handleClick();
        }
        store.notifyListeners();
      }
    }).fail(function () {
      window.alert("There was an error saving your rating, please try again.");
      if (prevRating > 0) {
        setRating(bookId, prevRating, bookData);
      } else if (isBookShelved) {
        unsetRating(bookId);
        _shelvings_actions2.default.rateBook.failed();
      } else {
        deleteShelving(bookId, null, false);
        _shelvings_actions2.default.rateBook.failed();
      }
      _this4.notifyListeners();
    });
  },
  onAddShelvings: function onAddShelvings(shelvings) {
    this.updateWith(shelvings);
    this.notifyListeners();
  }
});

},{"../modules/ajax/ajax_helper":4,"../modules/book_origins":6,"../modules/default_shelves":12,"../react_actions/reading_session_actions":33,"../react_actions/shelvings_actions":35,"../react_actions/user_shelves_actions":39,"./shared/newsfeed_updates_mixin":200,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],202:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _tab_actions = require("../react_actions/tab_actions");

var _tab_actions2 = _interopRequireDefault(_tab_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = new _freezerJs2.default({});

var getState = function getState() {
  return state.get();
};

var store = _reflux2.default.createStore({
  listenables: _tab_actions2.default,

  getInitialState: getState,

  getState: getState,

  initializeWith: function initializeWith(groupsToActiveNames) {
    state.get().reset(groupsToActiveNames);
  },
  updateWith: function updateWith(data) {
    getState().set(data);
  },
  onDeselectTab: function onDeselectTab(tabName, tabGroupName) {
    if (state.get()[tabGroupName] === tabName) {
      state.get().set(tabGroupName, null);
      this.notifyListeners();
    }
  },
  onSelectTab: function onSelectTab(tabName, tabGroupName) {
    state.get().set(tabGroupName, tabName);
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  reset: function reset() {
    state.get().reset({});
  }
});

exports.default = store;

},{"../react_actions/tab_actions":36,"freezer-js":"freezer-js","reflux":"reflux"}],203:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _user_agent_capabilities_actions = require("../react_actions/user_agent_capabilities_actions");

var _user_agent_capabilities_actions2 = _interopRequireDefault(_user_agent_capabilities_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = { touch: false };
var state = new _freezerJs2.default(defaultState);

exports.default = _reflux2.default.createStore({
  listenables: [_user_agent_capabilities_actions2.default],

  initializeWith: function initializeWith(data) {
    state.get().reset(data);
  },
  reset: function reset() {
    state.get().reset(defaultState);
  },
  getInitialState: function getInitialState() {
    return state.get();
  },
  onUserAgentGainsTouch: function onUserAgentGainsTouch() {
    state.get().set("touch", true);
    this.trigger(state.get());
  },
  onUserAgentLosesTouch: function onUserAgentLosesTouch() {
    state.get().set("touch", false);
    this.trigger(state.get());
  }
});

},{"../react_actions/user_agent_capabilities_actions":37,"freezer-js":"freezer-js","reflux":"reflux"}],204:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _ajax_helper = require("../modules/ajax/ajax_helper");

var _user_not_interested_actions = require("../react_actions/user_not_interested_actions");

var _user_not_interested_actions2 = _interopRequireDefault(_user_not_interested_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  A book with ID 0 is used to set default state. This book is never modified, it
  is only used to created other books with individual states as creatives appear
  from dfp.
*/
var DEFAULT_STATE = { default: { isFlashMessage: false, isClosed: false } }; /*
                                                                               This store allows users to make books as not interested. Not interested
                                                                               books will not show up in native ad slots
                                                                             */

var state = new _freezerJs2.default(DEFAULT_STATE);

var getState = function getState() {
  return state.get();
};

var _reset = function _reset(data) {
  getState().reset((0, _lodash.merge)({}, DEFAULT_STATE, data));
};

exports.default = _reflux2.default.createStore({
  listenables: [_user_not_interested_actions2.default],

  getState: getState,
  getInitialState: getState,

  reset: function reset() {
    _reset({});
  },
  setDataForKey: function setDataForKey(bookId, data) {
    var newState = {};
    newState[bookId] = data;
    getState().set((0, _lodash.merge)({}, getState(), newState));
  },
  onAddBookIDToState: function onAddBookIDToState(bookId) {
    this.setDataForKey(bookId, getState().default);
    this.trigger(getState());
  },
  onIsFlashMessageForBook: function onIsFlashMessageForBook(bookId) {
    getState()[bookId].isFlashMessage;
  },
  onCloseFlashMessage: function onCloseFlashMessage(bookId) {
    this.setDataForKey(bookId, { isClosed: true });
    this.trigger(getState());
  },
  userNotInterestedHttpPost: function userNotInterestedHttpPost(bookId) {
    return (0, _ajax_helper.httpPost)("/user_not_interested_works", {
      data: {
        user_not_interested_work: {
          book_id: bookId,
          source: "react"
        }
      }
    });
  },
  onUserNotInterested: function onUserNotInterested(bookId) {
    var _this = this;

    this.userNotInterestedHttpPost(bookId).done(function () {
      _this.setDataForKey(bookId, { isFlashMessage: true });
      _this.trigger(getState());
    }).fail(function () {
      window.alert("There was an error marking this book as not interested, please try again.");
    });
  },
  undoUserNotInterestedHttpDelete: function undoUserNotInterestedHttpDelete(bookId) {
    return (0, _ajax_helper.httpDelete)("/user_not_interested_works/undo", {
      data: {
        user_not_interested_work: { book_id: bookId }
      }
    });
  },
  onUndoUserNotInterested: function onUndoUserNotInterested(bookId) {
    var _this2 = this;

    this.undoUserNotInterestedHttpDelete(bookId).done(function () {
      _this2.setDataForKey(bookId, { isFlashMessage: false });
      _this2.trigger(getState());
    }).fail(function () {
      window.alert("There was an error undoing this action, please try again.");
    });
  }
});

},{"../modules/ajax/ajax_helper":4,"../react_actions/user_not_interested_actions":38,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],205:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _shelvings_actions = require("../react_actions/shelvings_actions");

var _shelvings_actions2 = _interopRequireDefault(_shelvings_actions);

var _user_shelves_actions = require("../react_actions/user_shelves_actions");

var _user_shelves_actions2 = _interopRequireDefault(_user_shelves_actions);

var _want_to_read_menu_actions = require("../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

var _default_shelves = require("../modules/default_shelves");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultState = { defaultShelves: [],
  customExclusiveShelves: [],
  nonExclusiveShelves: [] };
var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var updateCount = function updateCount(shelfName, shelfType, countDelta) {
  var shelf = _lodash2.default.find(getState()[shelfType], { name: shelfName });
  if (shelf) {
    shelf.set("bookCount", shelf.bookCount + countDelta);
  }
};

exports.default = _reflux2.default.createStore({
  listenables: [_user_shelves_actions2.default, { bookShelved: _shelvings_actions2.default.bookShelved,
    bookUnshelved: _shelvings_actions2.default.bookUnshelved }],

  getInitialState: state.get,
  getState: getState,

  defaultShelves: function defaultShelves() {
    var shelves = getState().defaultShelves;
    if (shelves.length === 0) {
      return _default_shelves.DEFAULT_SHELVES;
    } else {
      return { READ: _lodash2.default.find(shelves, "name", "read"),
        CURRENTLY_READING: _lodash2.default.find(shelves, "name", "currently-reading"),
        WANT_TO_READ: _lodash2.default.find(shelves, "name", "to-read") };
    }
  },
  initializeWith: function initializeWith(shelves) {
    state.get().reset(shelves);
  },
  reset: function reset() {
    state.get().reset(defaultState);
  },
  updateWith: function updateWith(shelves) {
    state.get().reset(shelves);
  },
  onAddNonExclusiveShelf: function onAddNonExclusiveShelf(newShelfName) {
    var currentNonExclusiveShelves = _lodash2.default.clone(state.get().nonExclusiveShelves) || [];
    var shelfNames = _lodash2.default.map(currentNonExclusiveShelves, function (shelf) {
      return shelf.name;
    });
    if (!_lodash2.default.includes(shelfNames, newShelfName)) {
      currentNonExclusiveShelves.unshift({ name: newShelfName,
        url: "",
        displayName: newShelfName,
        bookCount: 0 });
      state.get().set("nonExclusiveShelves", currentNonExclusiveShelves);
      _want_to_read_menu_actions2.default.updateShelves();
      this.trigger(getState());
    }
  },
  onRemoveNonExclusiveShelf: function onRemoveNonExclusiveShelf(shelfNameToRemove) {
    var currentNonExclusiveShelves = _lodash2.default.clone(state.get().nonExclusiveShelves) || [];
    var shelfNames = _lodash2.default.map(currentNonExclusiveShelves, function (shelf) {
      return shelf.name;
    });
    if (_lodash2.default.includes(shelfNames, shelfNameToRemove)) {
      _lodash2.default.remove(currentNonExclusiveShelves, function (shelf) {
        return shelf.name === shelfNameToRemove;
      });
      state.get().set("nonExclusiveShelves", currentNonExclusiveShelves);
      _want_to_read_menu_actions2.default.updateShelves();
      this.trigger(getState());
    }
  },
  onBookShelved: function onBookShelved(options) {
    var shelves = options.shelves || {};
    _lodash2.default.each(shelves, function (shelfNames, shelfType) {
      _lodash2.default.each(shelfNames, function (shelfName) {
        updateCount(shelfName, shelfType, 1);
      });
    });
    this.trigger(getState());
  },
  onBookUnshelved: function onBookUnshelved(options) {
    var shelves = options.shelves || {};
    _lodash2.default.each(shelves, function (shelfNames, shelfType) {
      _lodash2.default.each(shelfNames, function (shelfName) {
        updateCount(shelfName, shelfType, -1);
      });
    });
    this.trigger(getState());
  }
});

},{"../modules/default_shelves":12,"../react_actions/shelvings_actions":35,"../react_actions/user_shelves_actions":39,"../react_actions/want_to_read_menu_actions":40,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],206:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

var _reflux = require("reflux");

var _reflux2 = _interopRequireDefault(_reflux);

var _freezerJs = require("freezer-js");

var _freezerJs2 = _interopRequireDefault(_freezerJs);

var _want_to_read_menu_actions = require("../react_actions/want_to_read_menu_actions");

var _want_to_read_menu_actions2 = _interopRequireDefault(_want_to_read_menu_actions);

var _user_shelves_store = require("./user_shelves_store");

var _user_shelves_store2 = _interopRequireDefault(_user_shelves_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW_ADD_SHELF_TEXTBOX_KEY = "showAddShelfTextbox";

var defaultState = {};
var state = new _freezerJs2.default(defaultState);

var getState = function getState() {
  return state.get();
};

var getDisplayableExclusiveShelves = function getDisplayableExclusiveShelves(shelfNameFilter, userShelvesStoreState) {
  var displayableExclusiveShelves = [];
  var unselectedExclusiveShelves = userShelvesStoreState.defaultShelves.concat(userShelvesStoreState.customExclusiveShelves || []);

  if (!_lodash2.default.isEmpty(shelfNameFilter)) {
    displayableExclusiveShelves = _lodash2.default.filter(unselectedExclusiveShelves, function (shelf) {
      return shelf.name.match(new RegExp(shelfNameFilter, "i"));
    });
  } else {
    displayableExclusiveShelves = unselectedExclusiveShelves;
  }
  return displayableExclusiveShelves;
};

var getDisplayableNonExclusiveShelves = function getDisplayableNonExclusiveShelves(shelfNameFilter, userShelvesStoreState) {
  var displayableNonExclusiveShelves = [];
  if (!_lodash2.default.isEmpty(shelfNameFilter)) {
    displayableNonExclusiveShelves = _lodash2.default.filter(userShelvesStoreState.nonExclusiveShelves, function (shelf) {
      return shelf.name.match(new RegExp(shelfNameFilter, "i"));
    });
  } else {
    displayableNonExclusiveShelves = userShelvesStoreState.nonExclusiveShelves;
  }
  return displayableNonExclusiveShelves;
};

var getFilteredShelves = function getFilteredShelves(shelfNameFilter) {
  var userShelvesStoreState = _user_shelves_store2.default.getState();
  var displayableExclusiveShelves = getDisplayableExclusiveShelves(shelfNameFilter, userShelvesStoreState);
  var displayableNonExclusiveShelves = getDisplayableNonExclusiveShelves(shelfNameFilter, userShelvesStoreState);

  return {
    displayableExclusiveShelves: displayableExclusiveShelves,
    displayableNonExclusiveShelves: displayableNonExclusiveShelves,
    shelfNameFilter: shelfNameFilter
  };
};

var updateStateWithFilter = function updateStateWithFilter(shelfNameFilter, uniqueWTRButtonId) {
  getState().set(uniqueWTRButtonId, getFilteredShelves(shelfNameFilter));
};

var updateShelvesWithoutFilterChange = function updateShelvesWithoutFilterChange(uniqueWTRButtonId) {
  var shelfNameFilter = getState()[uniqueWTRButtonId].shelfNameFilter;
  getState().set(uniqueWTRButtonId, getFilteredShelves(shelfNameFilter));
};

var getStateForKey = function getStateForKey(key) {
  if (!_lodash2.default.has(getState(), key)) {
    updateStateWithFilter("", key);
  }
  return getState()[key];
};

var resetTo = function resetTo(data) {
  getState().reset(_lodash2.default.merge({}, defaultState, data));
};

exports.default = _reflux2.default.createStore({
  listenables: [_want_to_read_menu_actions2.default],
  getInitialState: function getInitialState(key) {
    if (!_lodash2.default.isUndefined(key)) {
      return getStateForKey(key);
    } else {
      return getState();
    }
  },

  getState: getState,

  initializeWith: function initializeWith(data) {
    resetTo(data);
  },
  reset: function reset() {
    resetTo(defaultState);
  },
  updateWith: function updateWith(data) {
    _lodash2.default.each(_lodash2.default.keys(data), function (key) {
      getState().set(key, data[key]);
    });
    this.notifyListeners();
  },
  notifyListeners: function notifyListeners() {
    this.trigger(getState());
  },
  onUpdateShelfNameFilter: function onUpdateShelfNameFilter(shelfNameFilter, uniqueWTRButtonId) {
    updateStateWithFilter(shelfNameFilter, uniqueWTRButtonId);
    getStateForKey(uniqueWTRButtonId).set(SHOW_ADD_SHELF_TEXTBOX_KEY, false);
    this.notifyListeners();
  },
  onOpenAddShelfTextbox: function onOpenAddShelfTextbox(uniqueWTRButtonId) {
    getStateForKey(uniqueWTRButtonId).set(SHOW_ADD_SHELF_TEXTBOX_KEY, true);
    this.notifyListeners();
  },
  onCloseAddShelfTextbox: function onCloseAddShelfTextbox(uniqueWTRButtonId) {
    getStateForKey(uniqueWTRButtonId).set(SHOW_ADD_SHELF_TEXTBOX_KEY, false);
    this.notifyListeners();
  },
  onUpdateShelves: function onUpdateShelves() {
    _lodash2.default.each(_lodash2.default.keys(getState()), function (uniqueWTRButtonId) {
      updateShelvesWithoutFilterChange(uniqueWTRButtonId);
    });
    this.notifyListeners();
  }
});

},{"../react_actions/want_to_read_menu_actions":40,"./user_shelves_store":205,"freezer-js":"freezer-js","lodash":"lodash","reflux":"reflux"}],207:[function(require,module,exports){
"use strict";

exports.__esModule = true;
exports.loopAsync = loopAsync;
exports.mapAsync = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}
},{}],208:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.ContextProvider = ContextProvider;
exports.ContextSubscriber = ContextSubscriber;

var _react = require('react');

// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = _react.PropTypes.shape({
  subscribe: _react.PropTypes.func.isRequired,
  eventIndex: _react.PropTypes.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}
},{"react":"react"}],209:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
exports.falsy = falsy;

var _react = require('react');

var func = _react.PropTypes.func,
    object = _react.PropTypes.object,
    arrayOf = _react.PropTypes.arrayOf,
    oneOfType = _react.PropTypes.oneOfType,
    element = _react.PropTypes.element,
    shape = _react.PropTypes.shape,
    string = _react.PropTypes.string;
function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = exports.history = shape({
  listen: func.isRequired,
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired
});

var component = exports.component = oneOfType([func, string]);
var components = exports.components = oneOfType([component, object]);
var route = exports.route = oneOfType([object, element]);
var routes = exports.routes = oneOfType([route, arrayOf(route)]);
},{"react":"react"}],210:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _PropTypes = require('./PropTypes');

var _ContextUtils = require('./ContextUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _React$PropTypes = _react2.default.PropTypes,
    bool = _React$PropTypes.bool,
    object = _React$PropTypes.object,
    string = _React$PropTypes.string,
    func = _React$PropTypes.func,
    oneOfType = _React$PropTypes.oneOfType;


function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 *
 * Links may pass along location state and/or query string parameters
 * in the state/query props, respectively.
 *
 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
 */
var Link = _react2.default.createClass({
  displayName: 'Link',


  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],

  contextTypes: {
    router: _PropTypes.routerShape
  },

  propTypes: {
    to: oneOfType([string, object, func]),
    query: object,
    hash: string,
    state: object,
    activeStyle: object,
    activeClassName: string,
    onlyActiveOnIndex: bool.isRequired,
    onClick: func,
    target: string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ? "production" !== 'production' ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (to == null) {
        return _react2.default.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

exports.default = Link;
module.exports = exports['default'];
},{"./ContextUtils":208,"./PropTypes":213,"invariant":247,"react":"react"}],211:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.compilePattern = compilePattern;
exports.matchPattern = matchPattern;
exports.getParamNames = getParamNames;
exports.getParams = getParams;
exports.formatPattern = formatPattern;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}
},{"invariant":247}],212:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.isPromise = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}
},{}],213:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.locationShape = exports.routerShape = undefined;

var _react = require('react');

var func = _react.PropTypes.func,
    object = _react.PropTypes.object,
    shape = _react.PropTypes.shape,
    string = _react.PropTypes.string;
var routerShape = exports.routerShape = shape({
  push: func.isRequired,
  replace: func.isRequired,
  go: func.isRequired,
  goBack: func.isRequired,
  goForward: func.isRequired,
  setRouteLeaveHook: func.isRequired,
  isActive: func.isRequired
});

var locationShape = exports.locationShape = shape({
  pathname: string.isRequired,
  search: string.isRequired,
  state: object,
  action: string.isRequired,
  key: string
});
},{"react":"react"}],214:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _RouteUtils = require('./RouteUtils');

var _InternalPropTypes = require('./InternalPropTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes,
    string = _React$PropTypes.string,
    func = _React$PropTypes.func;

/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */

var Route = _react2.default.createClass({
  displayName: 'Route',


  statics: {
    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
  },

  propTypes: {
    path: string,
    component: _InternalPropTypes.component,
    components: _InternalPropTypes.components,
    getComponent: func,
    getComponents: func
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
    !false ? "production" !== 'production' ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
  }
});

exports.default = Route;
module.exports = exports['default'];
},{"./InternalPropTypes":209,"./RouteUtils":215,"invariant":247,"react":"react"}],215:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isReactChildren = isReactChildren;
exports.createRouteFromReactElement = createRouteFromReactElement;
exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
exports.createRoutes = createRoutes;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidChild(object) {
  return object == null || _react2.default.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  _react2.default.Children.forEach(children, function (element) {
    if (_react2.default.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}
},{"react":"react"}],216:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createTransitionManager2 = require('./createTransitionManager');

var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);

var _InternalPropTypes = require('./InternalPropTypes');

var _RouterContext = require('./RouterContext');

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _RouteUtils = require('./RouteUtils');

var _RouterUtils = require('./RouterUtils');

var _routerWarning = require('./routerWarning');

var _routerWarning2 = _interopRequireDefault(_routerWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _React$PropTypes = _react2.default.PropTypes,
    func = _React$PropTypes.func,
    object = _React$PropTypes.object;

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */

var Router = _react2.default.createClass({
  displayName: 'Router',


  propTypes: {
    history: object,
    children: _InternalPropTypes.routes,
    routes: _InternalPropTypes.routes, // alias for children
    render: func,
    createElement: func,
    onError: func,
    onUpdate: func,

    // PRIVATE: For client-side rehydration of server match.
    matchContext: object
  },

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return _react2.default.createElement(_RouterContext2.default, props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ? "production" !== 'production' ? (0, _invariant2.default)(false, 'You have provided a history object created with history v2.x or ' + 'earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please upgrade to history v3.x.') : (0, _invariant2.default)(false) : void 0;

    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        (0, _RouterUtils.assignRouterState)(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    "production" !== 'production' ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

    "production" !== 'production' ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(Router.propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

exports.default = Router;
module.exports = exports['default'];
},{"./InternalPropTypes":209,"./RouteUtils":215,"./RouterContext":217,"./RouterUtils":218,"./createTransitionManager":224,"./routerWarning":230,"invariant":247,"react":"react"}],217:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getRouteParams = require('./getRouteParams');

var _getRouteParams2 = _interopRequireDefault(_getRouteParams);

var _ContextUtils = require('./ContextUtils');

var _RouteUtils = require('./RouteUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$PropTypes = _react2.default.PropTypes,
    array = _React$PropTypes.array,
    func = _React$PropTypes.func,
    object = _React$PropTypes.object;

/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */

var RouterContext = _react2.default.createClass({
  displayName: 'RouterContext',


  mixins: [(0, _ContextUtils.ContextProvider)('router')],

  propTypes: {
    router: object.isRequired,
    location: object.isRequired,
    routes: array.isRequired,
    params: object.isRequired,
    components: array.isRequired,
    createElement: func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: _react2.default.createElement
    };
  },


  childContextTypes: {
    router: object.isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = (0, _getRouteParams2.default)(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if ((0, _RouteUtils.isReactChildren)(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || _react2.default.isValidElement(element)) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;

    return element;
  }
});

exports.default = RouterContext;
module.exports = exports['default'];
},{"./ContextUtils":208,"./RouteUtils":215,"./getRouteParams":226,"invariant":247,"react":"react"}],218:[function(require,module,exports){
"use strict";

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createRouterObject = createRouterObject;
exports.assignRouterState = assignRouterState;
function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}
},{}],219:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.runEnterHooks = runEnterHooks;
exports.runChangeHooks = runChangeHooks;
exports.runLeaveHooks = runLeaveHooks;

var _AsyncUtils = require('./AsyncUtils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

var enterHooks = new PendingHooks();
var changeHooks = new PendingHooks();

function createTransitionHook(hook, route, asyncArity, pendingHooks) {
  var isSync = hook.length < asyncArity;

  var transitionHook = function transitionHook() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    hook.apply(route, args);

    if (isSync) {
      var callback = args[args.length - 1];
      // Assume hook executes synchronously and
      // automatically call the callback.
      callback();
    }
  };

  pendingHooks.add(transitionHook);

  return transitionHook;
}

function getEnterHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
    return hooks;
  }, []);
}

function getChangeHooks(routes) {
  return routes.reduce(function (hooks, route) {
    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
    return hooks;
  }, []);
}

function runTransitionHooks(length, iter, callback) {
  if (!length) {
    callback();
    return;
  }

  var redirectInfo = void 0;
  function replace(location) {
    redirectInfo = location;
  }

  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
    iter(index, replace, function (error) {
      if (error || redirectInfo) {
        done(error, redirectInfo); // No need to continue.
      } else {
        next();
      }
    });
  }, callback);
}

/**
 * Runs all onEnter hooks in the given array of routes in order
 * with onEnter(nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runEnterHooks(routes, nextState, callback) {
  enterHooks.clear();
  var hooks = getEnterHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    var wrappedNext = function wrappedNext() {
      if (enterHooks.has(hooks[index])) {
        next();
        enterHooks.remove(hooks[index]);
      }
    };
    hooks[index](nextState, replace, wrappedNext);
  }, callback);
}

/**
 * Runs all onChange hooks in the given array of routes in order
 * with onChange(prevState, nextState, replace, callback) and calls
 * callback(error, redirectInfo) when finished. The first hook
 * to use replace short-circuits the loop.
 *
 * If a hook needs to run asynchronously, it may use the callback
 * function. However, doing so will cause the transition to pause,
 * which could lead to a non-responsive UI if the hook is slow.
 */
function runChangeHooks(routes, state, nextState, callback) {
  changeHooks.clear();
  var hooks = getChangeHooks(routes);
  return runTransitionHooks(hooks.length, function (index, replace, next) {
    var wrappedNext = function wrappedNext() {
      if (changeHooks.has(hooks[index])) {
        next();
        changeHooks.remove(hooks[index]);
      }
    };
    hooks[index](state, nextState, replace, wrappedNext);
  }, callback);
}

/**
 * Runs all onLeave hooks in the given array of routes in order.
 */
function runLeaveHooks(routes, prevState) {
  for (var i = 0, len = routes.length; i < len; ++i) {
    if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
  }
}
},{"./AsyncUtils":207}],220:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _createBrowserHistory = require('history/lib/createBrowserHistory');

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createRouterHistory = require('./createRouterHistory');

var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
module.exports = exports['default'];
},{"./createRouterHistory":223,"history/lib/createBrowserHistory":241}],221:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _PatternUtils = require('./PatternUtils');

function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = (0, _PatternUtils.getParamNames)(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    (function () {
      var parentIsLeaving = false;
      leaveRoutes = prevRoutes.filter(function (route) {
        if (parentIsLeaving) {
          return true;
        } else {
          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
          if (isLeaving) parentIsLeaving = true;
          return isLeaving;
        }
      });

      // onLeave hooks start at the leaf route.
      leaveRoutes.reverse();

      enterRoutes = [];
      changeRoutes = [];

      nextRoutes.forEach(function (route) {
        var isNew = prevRoutes.indexOf(route) === -1;
        var paramsChanged = leaveRoutes.indexOf(route) !== -1;

        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
      });
    })();
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

exports.default = computeChangedRoutes;
module.exports = exports['default'];
},{"./PatternUtils":211}],222:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.default = createMemoryHistory;

var _useQueries = require('history/lib/useQueries');

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = require('history/lib/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

var _createMemoryHistory = require('history/lib/createMemoryHistory');

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = (0, _createMemoryHistory2.default)(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
  return history;
}
module.exports = exports['default'];
},{"history/lib/createMemoryHistory":243,"history/lib/useBasename":245,"history/lib/useQueries":246}],223:[function(require,module,exports){
'use strict';

exports.__esModule = true;

exports.default = function (createHistory) {
  var history = void 0;
  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
  return history;
};

var _useRouterHistory = require('./useRouterHistory');

var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

module.exports = exports['default'];
},{"./useRouterHistory":231}],224:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createTransitionManager;

var _routerWarning = require('./routerWarning');

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _computeChangedRoutes2 = require('./computeChangedRoutes');

var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);

var _TransitionUtils = require('./TransitionUtils');

var _isActive2 = require('./isActive');

var _isActive3 = _interopRequireDefault(_isActive2);

var _getComponents = require('./getComponents');

var _getComponents2 = _interopRequireDefault(_getComponents);

var _matchRoutes = require('./matchRoutes');

var _matchRoutes2 = _interopRequireDefault(_matchRoutes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)
  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      (0, _getComponents2.default)(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
            "production" !== 'production' ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}
module.exports = exports['default'];
},{"./TransitionUtils":219,"./computeChangedRoutes":221,"./getComponents":225,"./isActive":227,"./matchRoutes":229,"./routerWarning":230}],225:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _AsyncUtils = require('./AsyncUtils');

var _PromiseUtils = require('./PromiseUtils');

function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

exports.default = getComponents;
module.exports = exports['default'];
},{"./AsyncUtils":207,"./PromiseUtils":212}],226:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _PatternUtils = require('./PatternUtils');

/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

exports.default = getRouteParams;
module.exports = exports['default'];
},{"./PatternUtils":211}],227:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isActive;

var _PatternUtils = require('./PatternUtils');

function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}
module.exports = exports['default'];
},{"./PatternUtils":211}],228:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Actions = require('history/lib/Actions');

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _createMemoryHistory = require('./createMemoryHistory');

var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);

var _createTransitionManager = require('./createTransitionManager');

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _RouteUtils = require('./RouteUtils');

var _RouterUtils = require('./RouterUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;

  history = history ? history : (0, _createMemoryHistory2.default)(options);
  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
  });
}

exports.default = match;
module.exports = exports['default'];
},{"./RouteUtils":215,"./RouterUtils":218,"./createMemoryHistory":222,"./createTransitionManager":224,"history/lib/Actions":232,"invariant":247}],229:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = matchRoutes;

var _AsyncUtils = require('./AsyncUtils');

var _PromiseUtils = require('./PromiseUtils');

var _PatternUtils = require('./PatternUtils');

var _routerWarning = require('./routerWarning');

var _routerWarning2 = _interopRequireDefault(_routerWarning);

var _RouteUtils = require('./RouteUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
    });

    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes) {
    (function () {
      var pathless = route.childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    })();
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var _ret2 = function () {
        var match = {
          routes: [route],
          params: createParams(paramNames, paramValues)
        };

        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
          if (error) {
            callback(error);
          } else {
            if (Array.isArray(indexRoute)) {
              var _match$routes;

              "production" !== 'production' ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
                return !route.path;
              }), 'Index routes should not have paths') : void 0;
              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
            } else if (indexRoute) {
              "production" !== 'production' ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
              match.routes.push(indexRoute);
            }

            callback(null, match);
          }
        });

        return {
          v: void 0
        };
      }();

      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}
module.exports = exports['default'];
},{"./AsyncUtils":207,"./PatternUtils":211,"./PromiseUtils":212,"./RouteUtils":215,"./routerWarning":230}],230:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.default = routerWarning;
exports._resetWarned = _resetWarned;

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}
},{"warning":250}],231:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.default = useRouterHistory;

var _useQueries = require('history/lib/useQueries');

var _useQueries2 = _interopRequireDefault(_useQueries);

var _useBasename = require('history/lib/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useRouterHistory(createHistory) {
  return function (options) {
    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
    return history;
  };
}
module.exports = exports['default'];
},{"history/lib/useBasename":245,"history/lib/useQueries":246}],232:[function(require,module,exports){
'use strict';

exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';
},{}],233:[function(require,module,exports){
"use strict";

exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};
},{}],234:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = require('./LocationUtils');

var _DOMUtils = require('./DOMUtils');

var _DOMStateStorage = require('./DOMStateStorage');

var _PathUtils = require('./PathUtils');

var _ExecutionEnvironment = require('./ExecutionEnvironment');

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if (event.state !== undefined) // Ignore extraneous popstate events in WebKit
      listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state;
  var key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};
},{"./DOMStateStorage":235,"./DOMUtils":236,"./ExecutionEnvironment":237,"./LocationUtils":238,"./PathUtils":239}],235:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
    "production" !== 'production' ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
      "production" !== 'production' ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
      "production" !== 'production' ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
      "production" !== 'production' ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};
},{"warning":250}],236:[function(require,module,exports){
'use strict';

exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};
},{}],237:[function(require,module,exports){
'use strict';

exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
},{}],238:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = require('./PathUtils');

var _Actions = require('./Actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

  "production" !== 'production' ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ? "production" !== 'production' ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};
},{"./Actions":232,"./PathUtils":239,"invariant":247,"warning":250}],239:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path);

  var pathname = _parsePath.pathname;
  var search = _parsePath.search;
  var hash = _parsePath.hash;


  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path);

  var pathname = _parsePath2.pathname;
  var search = _parsePath2.search;
  var hash = _parsePath2.hash;


  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path);

  var search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

  "production" !== 'production' ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename;
  var pathname = location.pathname;
  var search = location.search;
  var hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};
},{"warning":250}],240:[function(require,module,exports){
'use strict';

exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = require('./BrowserProtocol');

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = require('./LocationUtils');

var _PathUtils = require('./PathUtils');

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};
},{"./BrowserProtocol":234,"./LocationUtils":238,"./PathUtils":239}],241:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = require('./ExecutionEnvironment');

var _BrowserProtocol = require('./BrowserProtocol');

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = require('./RefreshProtocol');

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = require('./DOMUtils');

var _createHistory = require('./createHistory');

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  !_ExecutionEnvironment.canUseDOM ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation;
  var getCurrentLocation = Protocol.getCurrentLocation;
  var pushLocation = Protocol.pushLocation;
  var replaceLocation = Protocol.replaceLocation;
  var go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;
},{"./BrowserProtocol":234,"./DOMUtils":236,"./ExecutionEnvironment":237,"./RefreshProtocol":240,"./createHistory":242,"invariant":247}],242:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _AsyncUtils = require('./AsyncUtils');

var _PathUtils = require('./PathUtils');

var _runTransitionHook = require('./runTransitionHook');

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = require('./Actions');

var _LocationUtils = require('./LocationUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var getCurrentLocation = options.getCurrentLocation;
  var getUserConfirmation = options.getUserConfirmation;
  var pushLocation = options.pushLocation;
  var replaceLocation = options.replaceLocation;
  var go = options.go;
  var keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;
},{"./Actions":232,"./AsyncUtils":233,"./LocationUtils":238,"./PathUtils":239,"./runTransitionHook":244}],243:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = require('./LocationUtils');

var _PathUtils = require('./PathUtils');

var _createHistory = require('./createHistory');

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = require('./Actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
      "production" !== 'production' ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options;
  var entries = _options.entries;
  var current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ? "production" !== 'production' ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;
},{"./Actions":232,"./LocationUtils":238,"./PathUtils":239,"./createHistory":242,"invariant":247,"warning":250}],244:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
    "production" !== 'production' ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;
},{"warning":250}],245:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = require('./runTransitionHook');

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = require('./PathUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.indexOf(basename) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;
},{"./PathUtils":239,"./runTransitionHook":244}],246:[function(require,module,exports){
'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = require('query-string');

var _runTransitionHook = require('./runTransitionHook');

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = require('./LocationUtils');

var _PathUtils = require('./PathUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery;
    var parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;
},{"./LocationUtils":238,"./PathUtils":239,"./runTransitionHook":244,"query-string":248}],247:[function(require,module,exports){
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if ("production" !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

},{}],248:[function(require,module,exports){
'use strict';
var strictUriEncode = require('strict-uri-encode');
var objectAssign = require('object-assign');

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

},{"object-assign":"object-assign","strict-uri-encode":249}],249:[function(require,module,exports){
'use strict';
module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};

},{}],250:[function(require,module,exports){
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

'use strict';

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if ("production" !== 'production') {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;

},{}]},{},[45])

